export const CR_PROVINCES = {
    '1': 'San José',
    '2': 'Alajuela',
    '3': 'Cartago',
    '4': 'Heredia',
    '5': 'Guanacaste',
    '6': 'Puntarenas',
    '7': 'Limón'
}


export const CR_CANTONS = [
    {
        "canton_id": "1",
        "province_id": "1",
        "code": "01",
        "name": "San José"
    },
    {
        "canton_id": "2",
        "province_id": "1",
        "code": "02",
        "name": "Escazú"
    },
    {
        "canton_id": "3",
        "province_id": "1",
        "code": "03",
        "name": "Desamparados"
    },
    {
        "canton_id": "4",
        "province_id": "1",
        "code": "04",
        "name": "Puriscal"
    },
    {
        "canton_id": "5",
        "province_id": "1",
        "code": "05",
        "name": "Tarrazu"
    },
    {
        "canton_id": "6",
        "province_id": "1",
        "code": "06",
        "name": "Aserri"
    },
    {
        "canton_id": "7",
        "province_id": "1",
        "code": "07",
        "name": "Mora"
    },
    {
        "canton_id": "8",
        "province_id": "1",
        "code": "08",
        "name": "Goicoechea"
    },
    {
        "canton_id": "9",
        "province_id": "1",
        "code": "09",
        "name": "Santa Ana"
    },
    {
        "canton_id": "10",
        "province_id": "1",
        "code": "10",
        "name": "Alajuelita"
    },
    {
        "canton_id": "11",
        "province_id": "1",
        "code": "11",
        "name": "Vasquez de Coronado"
    },
    {
        "canton_id": "12",
        "province_id": "1",
        "code": "12",
        "name": "Acosta"
    },
    {
        "canton_id": "13",
        "province_id": "1",
        "code": "13",
        "name": "Tibas"
    },
    {
        "canton_id": "14",
        "province_id": "1",
        "code": "14",
        "name": "Moravia"
    },
    {
        "canton_id": "15",
        "province_id": "1",
        "code": "15",
        "name": "Montes de Oca"
    },
    {
        "canton_id": "16",
        "province_id": "1",
        "code": "16",
        "name": "Turrubares"
    },
    {
        "canton_id": "17",
        "province_id": "1",
        "code": "17",
        "name": "Dota"
    },
    {
        "canton_id": "18",
        "province_id": "1",
        "code": "18",
        "name": "Curridabat"
    },
    {
        "canton_id": "19",
        "province_id": "1",
        "code": "19",
        "name": "Perez Zeledon"
    },
    {
        "canton_id": "20",
        "province_id": "1",
        "code": "20",
        "name": "Leon Cortez Castro"
    },
    {
        "canton_id": "21",
        "province_id": "2",
        "code": "01",
        "name": "Alajuela"
    },
    {
        "canton_id": "22",
        "province_id": "2",
        "code": "02",
        "name": "San Ramon"
    },
    {
        "canton_id": "23",
        "province_id": "2",
        "code": "03",
        "name": "Grecia"
    },
    {
        "canton_id": "24",
        "province_id": "2",
        "code": "04",
        "name": "San Mateo"
    },
    {
        "canton_id": "25",
        "province_id": "2",
        "code": "05",
        "name": "Atenas"
    },
    {
        "canton_id": "26",
        "province_id": "2",
        "code": "06",
        "name": "Naranjo"
    },
    {
        "canton_id": "27",
        "province_id": "2",
        "code": "07",
        "name": "Palmares"
    },
    {
        "canton_id": "28",
        "province_id": "2",
        "code": "08",
        "name": "Poas"
    },
    {
        "canton_id": "29",
        "province_id": "2",
        "code": "09",
        "name": "Orotina"
    },
    {
        "canton_id": "30",
        "province_id": "2",
        "code": "10",
        "name": "San Carlos"
    },
    {
        "canton_id": "31",
        "province_id": "2",
        "code": "11",
        "name": "Zarcero"
    },
    {
        "canton_id": "32",
        "province_id": "2",
        "code": "12",
        "name": "Valverde Vega"
    },
    {
        "canton_id": "33",
        "province_id": "2",
        "code": "13",
        "name": "Upala"
    },
    {
        "canton_id": "34",
        "province_id": "2",
        "code": "14",
        "name": "Los Chiles"
    },
    {
        "canton_id": "35",
        "province_id": "2",
        "code": "15",
        "name": "Guatuso"
    },
    {
        "canton_id": "36",
        "province_id": "3",
        "code": "01",
        "name": "Cartago"
    },
    {
        "canton_id": "37",
        "province_id": "3",
        "code": "02",
        "name": "Paraiso"
    },
    {
        "canton_id": "38",
        "province_id": "3",
        "code": "03",
        "name": "La Union"
    },
    {
        "canton_id": "39",
        "province_id": "3",
        "code": "04",
        "name": "Jimenez"
    },
    {
        "canton_id": "40",
        "province_id": "3",
        "code": "05",
        "name": "Turrialba"
    },
    {
        "canton_id": "41",
        "province_id": "3",
        "code": "06",
        "name": "Alvarado"
    },
    {
        "canton_id": "42",
        "province_id": "3",
        "code": "07",
        "name": "Oreamuno"
    },
    {
        "canton_id": "43",
        "province_id": "3",
        "code": "08",
        "name": "El Guarco"
    },
    {
        "canton_id": "44",
        "province_id": "4",
        "code": "01",
        "name": "Heredia"
    },
    {
        "canton_id": "45",
        "province_id": "4",
        "code": "02",
        "name": "Barva"
    },
    {
        "canton_id": "46",
        "province_id": "4",
        "code": "03",
        "name": "Santo Domingo"
    },
    {
        "canton_id": "47",
        "province_id": "4",
        "code": "04",
        "name": "Santa Barbara"
    },
    {
        "canton_id": "48",
        "province_id": "4",
        "code": "05",
        "name": "San Rafael"
    },
    {
        "canton_id": "49",
        "province_id": "4",
        "code": "06",
        "name": "San Isidro"
    },
    {
        "canton_id": "50",
        "province_id": "4",
        "code": "07",
        "name": "Belen"
    },
    {
        "canton_id": "51",
        "province_id": "4",
        "code": "08",
        "name": "Flores"
    },
    {
        "canton_id": "52",
        "province_id": "4",
        "code": "09",
        "name": "San Pablo"
    },
    {
        "canton_id": "53",
        "province_id": "4",
        "code": "10",
        "name": "Sarapiqui"
    },
    {
        "canton_id": "54",
        "province_id": "5",
        "code": "01",
        "name": "Liberia"
    },
    {
        "canton_id": "55",
        "province_id": "5",
        "code": "02",
        "name": "Nicoya"
    },
    {
        "canton_id": "56",
        "province_id": "5",
        "code": "03",
        "name": "Santa Cruz"
    },
    {
        "canton_id": "57",
        "province_id": "5",
        "code": "04",
        "name": "Bagaces"
    },
    {
        "canton_id": "58",
        "province_id": "5",
        "code": "05",
        "name": "Carrillo"
    },
    {
        "canton_id": "59",
        "province_id": "5",
        "code": "06",
        "name": "Cañas"
    },
    {
        "canton_id": "60",
        "province_id": "5",
        "code": "07",
        "name": "Abangares"
    },
    {
        "canton_id": "61",
        "province_id": "5",
        "code": "08",
        "name": "Tilaran"
    },
    {
        "canton_id": "62",
        "province_id": "5",
        "code": "09",
        "name": "Nandayure"
    },
    {
        "canton_id": "63",
        "province_id": "5",
        "code": "10",
        "name": "La Cruz"
    },
    {
        "canton_id": "64",
        "province_id": "5",
        "code": "11",
        "name": "Hojancha"
    },
    {
        "canton_id": "65",
        "province_id": "6",
        "code": "01",
        "name": "Puntarenas"
    },
    {
        "canton_id": "66",
        "province_id": "6",
        "code": "02",
        "name": "Esparza"
    },
    {
        "canton_id": "67",
        "province_id": "6",
        "code": "03",
        "name": "Buenos Aires"
    },
    {
        "canton_id": "68",
        "province_id": "6",
        "code": "04",
        "name": "Montes de Oro"
    },
    {
        "canton_id": "69",
        "province_id": "6",
        "code": "05",
        "name": "Osa"
    },
    {
        "canton_id": "70",
        "province_id": "6",
        "code": "06",
        "name": "Aguirre"
    },
    {
        "canton_id": "71",
        "province_id": "6",
        "code": "07",
        "name": "Golfito"
    },
    {
        "canton_id": "72",
        "province_id": "6",
        "code": "08",
        "name": "Coto Brus"
    },
    {
        "canton_id": "73",
        "province_id": "6",
        "code": "09",
        "name": "Parrita"
    },
    {
        "canton_id": "74",
        "province_id": "6",
        "code": "10",
        "name": "Corredores"
    },
    {
        "canton_id": "75",
        "province_id": "6",
        "code": "11",
        "name": "Garabito"
    },
    {
        "canton_id": "76",
        "province_id": "7",
        "code": "01",
        "name": "Limon"
    },
    {
        "canton_id": "77",
        "province_id": "7",
        "code": "02",
        "name": "Pococi"
    },
    {
        "canton_id": "78",
        "province_id": "7",
        "code": "03",
        "name": "Siquirres"
    },
    {
        "canton_id": "79",
        "province_id": "7",
        "code": "04",
        "name": "Talamanca"
    },
    {
        "canton_id": "80",
        "province_id": "7",
        "code": "05",
        "name": "Matina"
    },
    {
        "canton_id": "81",
        "province_id": "7",
        "code": "06",
        "name": "Guacimo"
    }
]

export const CR_DISTRICTS = [
    {
        "district_id": "1",
        "canton_id": "1",
        "code": "01",
        "name": "Carmen"
    },
    {
        "district_id": "2",
        "canton_id": "1",
        "code": "02",
        "name": "Merced"
    },
    {
        "district_id": "3",
        "canton_id": "1",
        "code": "03",
        "name": "Hospital"
    },
    {
        "district_id": "4",
        "canton_id": "1",
        "code": "04",
        "name": "Catedral"
    },
    {
        "district_id": "5",
        "canton_id": "1",
        "code": "05",
        "name": "Zapote"
    },
    {
        "district_id": "6",
        "canton_id": "1",
        "code": "06",
        "name": "San Francisco De Dos Rios"
    },
    {
        "district_id": "7",
        "canton_id": "1",
        "code": "07",
        "name": "Uruca"
    },
    {
        "district_id": "8",
        "canton_id": "1",
        "code": "08",
        "name": "Mata Redonda"
    },
    {
        "district_id": "9",
        "canton_id": "1",
        "code": "09",
        "name": "Pavas"
    },
    {
        "district_id": "10",
        "canton_id": "1",
        "code": "10",
        "name": "Hatillo"
    },
    {
        "district_id": "11",
        "canton_id": "1",
        "code": "11",
        "name": "San Sebastian"
    },
    {
        "district_id": "12",
        "canton_id": "2",
        "code": "01",
        "name": "Escazu"
    },
    {
        "district_id": "13",
        "canton_id": "2",
        "code": "02",
        "name": "San Antonio"
    },
    {
        "district_id": "14",
        "canton_id": "2",
        "code": "03",
        "name": "San Rafael"
    },
    {
        "district_id": "15",
        "canton_id": "3",
        "code": "01",
        "name": "Desamparados"
    },
    {
        "district_id": "16",
        "canton_id": "3",
        "code": "02",
        "name": "San Miguel"
    },
    {
        "district_id": "17",
        "canton_id": "3",
        "code": "03",
        "name": "San Juan De Dios"
    },
    {
        "district_id": "18",
        "canton_id": "3",
        "code": "04",
        "name": "San Rafael Arriba"
    },
    {
        "district_id": "19",
        "canton_id": "3",
        "code": "05",
        "name": "San Antonio"
    },
    {
        "district_id": "20",
        "canton_id": "3",
        "code": "06",
        "name": "Frailes"
    },
    {
        "district_id": "21",
        "canton_id": "3",
        "code": "07",
        "name": "Patarra"
    },
    {
        "district_id": "22",
        "canton_id": "3",
        "code": "08",
        "name": "San Cristobal"
    },
    {
        "district_id": "23",
        "canton_id": "3",
        "code": "09",
        "name": "Rosario"
    },
    {
        "district_id": "24",
        "canton_id": "3",
        "code": "10",
        "name": "Damas"
    },
    {
        "district_id": "25",
        "canton_id": "3",
        "code": "11",
        "name": "San Rafael Abajo"
    },
    {
        "district_id": "26",
        "canton_id": "3",
        "code": "12",
        "name": "Gravilias"
    },
    {
        "district_id": "27",
        "canton_id": "3",
        "code": "13",
        "name": "Los Guido"
    },
    {
        "district_id": "28",
        "canton_id": "4",
        "code": "01",
        "name": "Santiago"
    },
    {
        "district_id": "29",
        "canton_id": "4",
        "code": "02",
        "name": "Mercedes Sur"
    },
    {
        "district_id": "30",
        "canton_id": "4",
        "code": "03",
        "name": "Barbacoas"
    },
    {
        "district_id": "31",
        "canton_id": "4",
        "code": "04",
        "name": "Grifo Alto"
    },
    {
        "district_id": "32",
        "canton_id": "4",
        "code": "05",
        "name": "San Rafael"
    },
    {
        "district_id": "33",
        "canton_id": "4",
        "code": "06",
        "name": "Candelarita"
    },
    {
        "district_id": "34",
        "canton_id": "4",
        "code": "07",
        "name": "Desamparaditos"
    },
    {
        "district_id": "35",
        "canton_id": "4",
        "code": "08",
        "name": "San Antonio"
    },
    {
        "district_id": "36",
        "canton_id": "4",
        "code": "09",
        "name": "Chires"
    },
    {
        "district_id": "37",
        "canton_id": "5",
        "code": "01",
        "name": "San Marcos"
    },
    {
        "district_id": "38",
        "canton_id": "5",
        "code": "02",
        "name": "San Lorenzo"
    },
    {
        "district_id": "39",
        "canton_id": "5",
        "code": "03",
        "name": "San Carlos"
    },
    {
        "district_id": "40",
        "canton_id": "6",
        "code": "01",
        "name": "Aserri"
    },
    {
        "district_id": "41",
        "canton_id": "6",
        "code": "02",
        "name": "Tarbaca"
    },
    {
        "district_id": "42",
        "canton_id": "6",
        "code": "03",
        "name": "Vuelta De Jorco"
    },
    {
        "district_id": "43",
        "canton_id": "6",
        "code": "04",
        "name": "San Gabriel"
    },
    {
        "district_id": "44",
        "canton_id": "6",
        "code": "05",
        "name": "Legua"
    },
    {
        "district_id": "45",
        "canton_id": "6",
        "code": "06",
        "name": "Monterrey"
    },
    {
        "district_id": "46",
        "canton_id": "6",
        "code": "07",
        "name": "Salitrillos"
    },
    {
        "district_id": "47",
        "canton_id": "7",
        "code": "01",
        "name": "Colon"
    },
    {
        "district_id": "48",
        "canton_id": "7",
        "code": "02",
        "name": "Guayabo"
    },
    {
        "district_id": "49",
        "canton_id": "7",
        "code": "03",
        "name": "Tabarcia"
    },
    {
        "district_id": "50",
        "canton_id": "7",
        "code": "04",
        "name": "Piedras Negras"
    },
    {
        "district_id": "51",
        "canton_id": "7",
        "code": "05",
        "name": "Picagres"
    },
    {
        "district_id": "52",
        "canton_id": "7",
        "code": "06",
        "name": "Jaris"
    },
    {
        "district_id": "53",
        "canton_id": "7",
        "code": "07",
        "name": "Quitirrisi"
    },
    {
        "district_id": "54",
        "canton_id": "8",
        "code": "01",
        "name": "Guadalupe"
    },
    {
        "district_id": "55",
        "canton_id": "8",
        "code": "02",
        "name": "San Francisco"
    },
    {
        "district_id": "56",
        "canton_id": "8",
        "code": "03",
        "name": "Calle Blancos"
    },
    {
        "district_id": "57",
        "canton_id": "8",
        "code": "04",
        "name": "Mata De Plaatano"
    },
    {
        "district_id": "58",
        "canton_id": "8",
        "code": "05",
        "name": "Ipis"
    },
    {
        "district_id": "59",
        "canton_id": "8",
        "code": "06",
        "name": "Rancho Redondo"
    },
    {
        "district_id": "60",
        "canton_id": "8",
        "code": "07",
        "name": "Purral"
    },
    {
        "district_id": "61",
        "canton_id": "9",
        "code": "01",
        "name": "Santa Ana"
    },
    {
        "district_id": "62",
        "canton_id": "9",
        "code": "02",
        "name": "Salitral"
    },
    {
        "district_id": "63",
        "canton_id": "9",
        "code": "03",
        "name": "Pozos"
    },
    {
        "district_id": "64",
        "canton_id": "9",
        "code": "04",
        "name": "Uruca"
    },
    {
        "district_id": "65",
        "canton_id": "9",
        "code": "05",
        "name": "Piedades"
    },
    {
        "district_id": "66",
        "canton_id": "9",
        "code": "06",
        "name": "Brasil"
    },
    {
        "district_id": "67",
        "canton_id": "10",
        "code": "01",
        "name": "Alajuelita"
    },
    {
        "district_id": "68",
        "canton_id": "10",
        "code": "02",
        "name": "San Josecito"
    },
    {
        "district_id": "69",
        "canton_id": "10",
        "code": "03",
        "name": "San Antonio"
    },
    {
        "district_id": "70",
        "canton_id": "10",
        "code": "04",
        "name": "Concepcion"
    },
    {
        "district_id": "71",
        "canton_id": "10",
        "code": "05",
        "name": "San Felipe"
    },
    {
        "district_id": "72",
        "canton_id": "11",
        "code": "01",
        "name": "San Isidro"
    },
    {
        "district_id": "73",
        "canton_id": "11",
        "code": "02",
        "name": "San Rafael"
    },
    {
        "district_id": "74",
        "canton_id": "11",
        "code": "03",
        "name": "Dulce Nombre De Jesus"
    },
    {
        "district_id": "75",
        "canton_id": "11",
        "code": "04",
        "name": "Patalillo"
    },
    {
        "district_id": "76",
        "canton_id": "11",
        "code": "05",
        "name": "Cascajal"
    },
    {
        "district_id": "77",
        "canton_id": "12",
        "code": "01",
        "name": "San Ignacio"
    },
    {
        "district_id": "78",
        "canton_id": "12",
        "code": "02",
        "name": "Guaitil Villa"
    },
    {
        "district_id": "79",
        "canton_id": "12",
        "code": "03",
        "name": "Palmichal"
    },
    {
        "district_id": "80",
        "canton_id": "12",
        "code": "04",
        "name": "Cangrejal"
    },
    {
        "district_id": "81",
        "canton_id": "12",
        "code": "05",
        "name": "Sabanillas"
    },
    {
        "district_id": "82",
        "canton_id": "13",
        "code": "01",
        "name": "San Juan"
    },
    {
        "district_id": "83",
        "canton_id": "13",
        "code": "02",
        "name": "Cinco Esquinas"
    },
    {
        "district_id": "84",
        "canton_id": "13",
        "code": "03",
        "name": "Anselmo Llorente"
    },
    {
        "district_id": "85",
        "canton_id": "13",
        "code": "04",
        "name": "Leon Xiii"
    },
    {
        "district_id": "86",
        "canton_id": "13",
        "code": "05",
        "name": "Colima"
    },
    {
        "district_id": "87",
        "canton_id": "14",
        "code": "01",
        "name": "San Vicente"
    },
    {
        "district_id": "88",
        "canton_id": "14",
        "code": "02",
        "name": "San Jeronimo"
    },
    {
        "district_id": "89",
        "canton_id": "14",
        "code": "03",
        "name": "La Trinidad"
    },
    {
        "district_id": "90",
        "canton_id": "15",
        "code": "01",
        "name": "San Pedro"
    },
    {
        "district_id": "91",
        "canton_id": "15",
        "code": "02",
        "name": "Sabanilla"
    },
    {
        "district_id": "92",
        "canton_id": "15",
        "code": "03",
        "name": "Mercedes"
    },
    {
        "district_id": "93",
        "canton_id": "15",
        "code": "04",
        "name": "San Rafael"
    },
    {
        "district_id": "94",
        "canton_id": "16",
        "code": "01",
        "name": "San Pablo"
    },
    {
        "district_id": "95",
        "canton_id": "16",
        "code": "02",
        "name": "San Pedro"
    },
    {
        "district_id": "96",
        "canton_id": "16",
        "code": "03",
        "name": "San Juan De Mata"
    },
    {
        "district_id": "97",
        "canton_id": "16",
        "code": "04",
        "name": "San Luis"
    },
    {
        "district_id": "98",
        "canton_id": "16",
        "code": "05",
        "name": "Carara"
    },
    {
        "district_id": "99",
        "canton_id": "17",
        "code": "01",
        "name": "Santa Maria"
    },
    {
        "district_id": "100",
        "canton_id": "17",
        "code": "02",
        "name": "Jardin"
    },
    {
        "district_id": "101",
        "canton_id": "17",
        "code": "03",
        "name": "Copey"
    },
    {
        "district_id": "102",
        "canton_id": "18",
        "code": "01",
        "name": "Curridabat"
    },
    {
        "district_id": "103",
        "canton_id": "18",
        "code": "02",
        "name": "Granadilla"
    },
    {
        "district_id": "104",
        "canton_id": "18",
        "code": "03",
        "name": "Sanchez"
    },
    {
        "district_id": "105",
        "canton_id": "18",
        "code": "04",
        "name": "Tirrases"
    },
    {
        "district_id": "106",
        "canton_id": "19",
        "code": "01",
        "name": "San Isidro De El General"
    },
    {
        "district_id": "107",
        "canton_id": "19",
        "code": "02",
        "name": "El General"
    },
    {
        "district_id": "108",
        "canton_id": "19",
        "code": "03",
        "name": "Daniel Flores"
    },
    {
        "district_id": "109",
        "canton_id": "19",
        "code": "04",
        "name": "Rivas"
    },
    {
        "district_id": "110",
        "canton_id": "19",
        "code": "05",
        "name": "San Pedro"
    },
    {
        "district_id": "111",
        "canton_id": "19",
        "code": "06",
        "name": "Platanares"
    },
    {
        "district_id": "112",
        "canton_id": "19",
        "code": "07",
        "name": "Pejibaye"
    },
    {
        "district_id": "113",
        "canton_id": "19",
        "code": "08",
        "name": "Cajon"
    },
    {
        "district_id": "114",
        "canton_id": "19",
        "code": "09",
        "name": "Baru"
    },
    {
        "district_id": "115",
        "canton_id": "19",
        "code": "10",
        "name": "Rio Nuevo"
    },
    {
        "district_id": "116",
        "canton_id": "19",
        "code": "11",
        "name": "Paramo"
    },
    {
        "district_id": "117",
        "canton_id": "20",
        "code": "01",
        "name": "San Pablo"
    },
    {
        "district_id": "118",
        "canton_id": "20",
        "code": "02",
        "name": "San Andraas"
    },
    {
        "district_id": "119",
        "canton_id": "20",
        "code": "03",
        "name": "Llano Bonito"
    },
    {
        "district_id": "120",
        "canton_id": "20",
        "code": "04",
        "name": "San Isidro"
    },
    {
        "district_id": "121",
        "canton_id": "20",
        "code": "05",
        "name": "Santa Cruz"
    },
    {
        "district_id": "122",
        "canton_id": "20",
        "code": "06",
        "name": "San Antonio"
    },
    {
        "district_id": "123",
        "canton_id": "21",
        "code": "01",
        "name": "Alajuela"
    },
    {
        "district_id": "124",
        "canton_id": "21",
        "code": "02",
        "name": "San Jose"
    },
    {
        "district_id": "125",
        "canton_id": "21",
        "code": "03",
        "name": "Carrizal"
    },
    {
        "district_id": "126",
        "canton_id": "21",
        "code": "04",
        "name": "San Antonio"
    },
    {
        "district_id": "127",
        "canton_id": "21",
        "code": "05",
        "name": "Guaacima"
    },
    {
        "district_id": "128",
        "canton_id": "21",
        "code": "06",
        "name": "San Isidro"
    },
    {
        "district_id": "129",
        "canton_id": "21",
        "code": "07",
        "name": "Sabanilla"
    },
    {
        "district_id": "130",
        "canton_id": "21",
        "code": "08",
        "name": "San Rafael"
    },
    {
        "district_id": "131",
        "canton_id": "21",
        "code": "09",
        "name": "Rio Segundo"
    },
    {
        "district_id": "132",
        "canton_id": "21",
        "code": "10",
        "name": "Desamparados"
    },
    {
        "district_id": "133",
        "canton_id": "21",
        "code": "11",
        "name": "Turrucares"
    },
    {
        "district_id": "134",
        "canton_id": "21",
        "code": "12",
        "name": "Tambor"
    },
    {
        "district_id": "135",
        "canton_id": "21",
        "code": "13",
        "name": "Garita"
    },
    {
        "district_id": "136",
        "canton_id": "21",
        "code": "14",
        "name": "Sarapiqui"
    },
    {
        "district_id": "137",
        "canton_id": "22",
        "code": "01",
        "name": "San Ramon"
    },
    {
        "district_id": "138",
        "canton_id": "22",
        "code": "02",
        "name": "Santiago"
    },
    {
        "district_id": "139",
        "canton_id": "22",
        "code": "03",
        "name": "San Juan"
    },
    {
        "district_id": "140",
        "canton_id": "22",
        "code": "04",
        "name": "Piedades Norte"
    },
    {
        "district_id": "141",
        "canton_id": "22",
        "code": "05",
        "name": "Piedades Sur"
    },
    {
        "district_id": "142",
        "canton_id": "22",
        "code": "06",
        "name": "San Rafael"
    },
    {
        "district_id": "143",
        "canton_id": "22",
        "code": "07",
        "name": "San Isidro"
    },
    {
        "district_id": "144",
        "canton_id": "22",
        "code": "08",
        "name": "Aangeles"
    },
    {
        "district_id": "145",
        "canton_id": "22",
        "code": "09",
        "name": "Alfaro"
    },
    {
        "district_id": "146",
        "canton_id": "22",
        "code": "10",
        "name": "Volio"
    },
    {
        "district_id": "147",
        "canton_id": "22",
        "code": "11",
        "name": "Concepcion"
    },
    {
        "district_id": "148",
        "canton_id": "22",
        "code": "12",
        "name": "Zapotal"
    },
    {
        "district_id": "149",
        "canton_id": "22",
        "code": "13",
        "name": "Peñas Blancas"
    },
    {
        "district_id": "150",
        "canton_id": "23",
        "code": "01",
        "name": "Grecia"
    },
    {
        "district_id": "151",
        "canton_id": "23",
        "code": "02",
        "name": "San Isidro"
    },
    {
        "district_id": "152",
        "canton_id": "23",
        "code": "03",
        "name": "San Jose"
    },
    {
        "district_id": "153",
        "canton_id": "23",
        "code": "04",
        "name": "San Roque"
    },
    {
        "district_id": "154",
        "canton_id": "23",
        "code": "05",
        "name": "Tacares"
    },
    {
        "district_id": "155",
        "canton_id": "23",
        "code": "06",
        "name": "Rio Cuarto"
    },
    {
        "district_id": "156",
        "canton_id": "23",
        "code": "07",
        "name": "Puente De Piedra"
    },
    {
        "district_id": "157",
        "canton_id": "23",
        "code": "08",
        "name": "Bolivar"
    },
    {
        "district_id": "158",
        "canton_id": "24",
        "code": "01",
        "name": "San Mateo"
    },
    {
        "district_id": "159",
        "canton_id": "24",
        "code": "02",
        "name": "Desmonte"
    },
    {
        "district_id": "160",
        "canton_id": "24",
        "code": "03",
        "name": "Jesus Maria"
    },
    {
        "district_id": "161",
        "canton_id": "24",
        "code": "04",
        "name": "Labrador"
    },
    {
        "district_id": "162",
        "canton_id": "25",
        "code": "01",
        "name": "Atenas"
    },
    {
        "district_id": "163",
        "canton_id": "25",
        "code": "02",
        "name": "Jesus"
    },
    {
        "district_id": "164",
        "canton_id": "25",
        "code": "03",
        "name": "Mercedes"
    },
    {
        "district_id": "165",
        "canton_id": "25",
        "code": "04",
        "name": "San Isidro"
    },
    {
        "district_id": "166",
        "canton_id": "25",
        "code": "05",
        "name": "Concepcion"
    },
    {
        "district_id": "167",
        "canton_id": "25",
        "code": "06",
        "name": "San Jose"
    },
    {
        "district_id": "168",
        "canton_id": "25",
        "code": "07",
        "name": "Santa Eulalia"
    },
    {
        "district_id": "169",
        "canton_id": "25",
        "code": "08",
        "name": "Escobal"
    },
    {
        "district_id": "170",
        "canton_id": "26",
        "code": "01",
        "name": "Naranjo"
    },
    {
        "district_id": "171",
        "canton_id": "26",
        "code": "02",
        "name": "San Miguel"
    },
    {
        "district_id": "172",
        "canton_id": "26",
        "code": "03",
        "name": "San Jose"
    },
    {
        "district_id": "173",
        "canton_id": "26",
        "code": "04",
        "name": "Cirri Sur"
    },
    {
        "district_id": "174",
        "canton_id": "26",
        "code": "05",
        "name": "San Jeronimo"
    },
    {
        "district_id": "175",
        "canton_id": "26",
        "code": "06",
        "name": "San Juan"
    },
    {
        "district_id": "176",
        "canton_id": "26",
        "code": "07",
        "name": "El Rosario"
    },
    {
        "district_id": "177",
        "canton_id": "26",
        "code": "08",
        "name": "Palmitos"
    },
    {
        "district_id": "178",
        "canton_id": "27",
        "code": "01",
        "name": "Palmares"
    },
    {
        "district_id": "179",
        "canton_id": "27",
        "code": "02",
        "name": "Zaragoza"
    },
    {
        "district_id": "180",
        "canton_id": "27",
        "code": "03",
        "name": "Buenos Aires"
    },
    {
        "district_id": "181",
        "canton_id": "27",
        "code": "04",
        "name": "Santiago"
    },
    {
        "district_id": "182",
        "canton_id": "27",
        "code": "05",
        "name": "Candelaria"
    },
    {
        "district_id": "183",
        "canton_id": "27",
        "code": "06",
        "name": "Esquipulas"
    },
    {
        "district_id": "184",
        "canton_id": "27",
        "code": "07",
        "name": "La Granja"
    },
    {
        "district_id": "185",
        "canton_id": "28",
        "code": "01",
        "name": "San Pedro"
    },
    {
        "district_id": "186",
        "canton_id": "28",
        "code": "02",
        "name": "San Juan"
    },
    {
        "district_id": "187",
        "canton_id": "28",
        "code": "03",
        "name": "San Rafael"
    },
    {
        "district_id": "188",
        "canton_id": "28",
        "code": "04",
        "name": "Carrillos"
    },
    {
        "district_id": "189",
        "canton_id": "28",
        "code": "05",
        "name": "Sabana Redonda"
    },
    {
        "district_id": "190",
        "canton_id": "29",
        "code": "01",
        "name": "Orotina"
    },
    {
        "district_id": "191",
        "canton_id": "29",
        "code": "02",
        "name": "El Mastate"
    },
    {
        "district_id": "192",
        "canton_id": "29",
        "code": "03",
        "name": "Hacienda Vieja"
    },
    {
        "district_id": "193",
        "canton_id": "29",
        "code": "04",
        "name": "Coyolar"
    },
    {
        "district_id": "194",
        "canton_id": "29",
        "code": "05",
        "name": "La Ceiba"
    },
    {
        "district_id": "195",
        "canton_id": "30",
        "code": "01",
        "name": "Quesada"
    },
    {
        "district_id": "196",
        "canton_id": "30",
        "code": "02",
        "name": "Florencia"
    },
    {
        "district_id": "197",
        "canton_id": "30",
        "code": "03",
        "name": "Buenavista"
    },
    {
        "district_id": "198",
        "canton_id": "30",
        "code": "04",
        "name": "Aguas Zarcas"
    },
    {
        "district_id": "199",
        "canton_id": "30",
        "code": "05",
        "name": "Venecia"
    },
    {
        "district_id": "200",
        "canton_id": "30",
        "code": "06",
        "name": "Pital"
    },
    {
        "district_id": "201",
        "canton_id": "30",
        "code": "07",
        "name": "La Fortuna"
    },
    {
        "district_id": "202",
        "canton_id": "30",
        "code": "08",
        "name": "La Tigra"
    },
    {
        "district_id": "203",
        "canton_id": "30",
        "code": "09",
        "name": "La Palmera"
    },
    {
        "district_id": "204",
        "canton_id": "30",
        "code": "10",
        "name": "Venado"
    },
    {
        "district_id": "205",
        "canton_id": "30",
        "code": "11",
        "name": "Cutris"
    },
    {
        "district_id": "206",
        "canton_id": "30",
        "code": "12",
        "name": "Monterrey"
    },
    {
        "district_id": "207",
        "canton_id": "30",
        "code": "13",
        "name": "Pocosol"
    },
    {
        "district_id": "208",
        "canton_id": "31",
        "code": "01",
        "name": "Zarcero"
    },
    {
        "district_id": "209",
        "canton_id": "31",
        "code": "02",
        "name": "Laguna"
    },
    {
        "district_id": "210",
        "canton_id": "31",
        "code": "04",
        "name": "Guadalupe"
    },
    {
        "district_id": "211",
        "canton_id": "31",
        "code": "05",
        "name": "Palmira"
    },
    {
        "district_id": "212",
        "canton_id": "31",
        "code": "06",
        "name": "Zapote"
    },
    {
        "district_id": "213",
        "canton_id": "31",
        "code": "07",
        "name": "Brisas"
    },
    {
        "district_id": "214",
        "canton_id": "32",
        "code": "01",
        "name": "Sarchi Norte"
    },
    {
        "district_id": "215",
        "canton_id": "32",
        "code": "02",
        "name": "Sarchi Sur"
    },
    {
        "district_id": "216",
        "canton_id": "32",
        "code": "03",
        "name": "Toro Amarillo"
    },
    {
        "district_id": "217",
        "canton_id": "32",
        "code": "04",
        "name": "San Pedro"
    },
    {
        "district_id": "218",
        "canton_id": "32",
        "code": "05",
        "name": "Rodriguez"
    },
    {
        "district_id": "219",
        "canton_id": "33",
        "code": "01",
        "name": "Upala"
    },
    {
        "district_id": "220",
        "canton_id": "33",
        "code": "02",
        "name": "Aguas Claras"
    },
    {
        "district_id": "221",
        "canton_id": "33",
        "code": "03",
        "name": "San Jose O Pizote"
    },
    {
        "district_id": "222",
        "canton_id": "33",
        "code": "04",
        "name": "Bijagua"
    },
    {
        "district_id": "223",
        "canton_id": "33",
        "code": "05",
        "name": "Delicias"
    },
    {
        "district_id": "224",
        "canton_id": "33",
        "code": "06",
        "name": "Dos Rios"
    },
    {
        "district_id": "225",
        "canton_id": "33",
        "code": "07",
        "name": "Yolillal"
    },
    {
        "district_id": "226",
        "canton_id": "33",
        "code": "08",
        "name": "Canalete"
    },
    {
        "district_id": "227",
        "canton_id": "34",
        "code": "01",
        "name": "Los Chiles"
    },
    {
        "district_id": "228",
        "canton_id": "34",
        "code": "02",
        "name": "Caño Negro"
    },
    {
        "district_id": "229",
        "canton_id": "34",
        "code": "03",
        "name": "El Amparo"
    },
    {
        "district_id": "230",
        "canton_id": "34",
        "code": "04",
        "name": "San Jorge"
    },
    {
        "district_id": "231",
        "canton_id": "35",
        "code": "02",
        "name": "Buenavista"
    },
    {
        "district_id": "232",
        "canton_id": "35",
        "code": "03",
        "name": "Cote"
    },
    {
        "district_id": "233",
        "canton_id": "35",
        "code": "04",
        "name": "Katira"
    },
    {
        "district_id": "234",
        "canton_id": "36",
        "code": "01",
        "name": "Oriental"
    },
    {
        "district_id": "235",
        "canton_id": "36",
        "code": "02",
        "name": "Occidental"
    },
    {
        "district_id": "236",
        "canton_id": "36",
        "code": "03",
        "name": "Carmen"
    },
    {
        "district_id": "237",
        "canton_id": "36",
        "code": "04",
        "name": "San Nicolas"
    },
    {
        "district_id": "238",
        "canton_id": "36",
        "code": "05",
        "name": "Aguacaliente O San Francisco"
    },
    {
        "district_id": "239",
        "canton_id": "36",
        "code": "06",
        "name": "Guadalupe O Arenilla"
    },
    {
        "district_id": "240",
        "canton_id": "36",
        "code": "07",
        "name": "Corralillo"
    },
    {
        "district_id": "241",
        "canton_id": "36",
        "code": "08",
        "name": "Tierra Blanca"
    },
    {
        "district_id": "242",
        "canton_id": "36",
        "code": "09",
        "name": "Dulce Nombre"
    },
    {
        "district_id": "243",
        "canton_id": "36",
        "code": "10",
        "name": "Llano Grande"
    },
    {
        "district_id": "244",
        "canton_id": "36",
        "code": "11",
        "name": "Quebradilla"
    },
    {
        "district_id": "245",
        "canton_id": "37",
        "code": "01",
        "name": "Paraiso"
    },
    {
        "district_id": "246",
        "canton_id": "37",
        "code": "02",
        "name": "Santiago"
    },
    {
        "district_id": "247",
        "canton_id": "37",
        "code": "03",
        "name": "Orosi"
    },
    {
        "district_id": "248",
        "canton_id": "37",
        "code": "04",
        "name": "Cachi"
    },
    {
        "district_id": "249",
        "canton_id": "37",
        "code": "05",
        "name": "Llanos De Santa Lucia"
    },
    {
        "district_id": "250",
        "canton_id": "38",
        "code": "01",
        "name": "Tres Rios"
    },
    {
        "district_id": "251",
        "canton_id": "38",
        "code": "02",
        "name": "San Diego"
    },
    {
        "district_id": "252",
        "canton_id": "38",
        "code": "03",
        "name": "San Juan"
    },
    {
        "district_id": "253",
        "canton_id": "38",
        "code": "04",
        "name": "San Rafael"
    },
    {
        "district_id": "254",
        "canton_id": "38",
        "code": "05",
        "name": "Concepcion"
    },
    {
        "district_id": "255",
        "canton_id": "38",
        "code": "06",
        "name": "Dulce Nombre"
    },
    {
        "district_id": "256",
        "canton_id": "38",
        "code": "07",
        "name": "San Ramon"
    },
    {
        "district_id": "257",
        "canton_id": "38",
        "code": "08",
        "name": "Rio Azul"
    },
    {
        "district_id": "258",
        "canton_id": "39",
        "code": "01",
        "name": "Juan Viñas"
    },
    {
        "district_id": "259",
        "canton_id": "39",
        "code": "02",
        "name": "Tucurrique"
    },
    {
        "district_id": "260",
        "canton_id": "39",
        "code": "03",
        "name": "Pejibaye"
    },
    {
        "district_id": "261",
        "canton_id": "40",
        "code": "01",
        "name": "Turrialba"
    },
    {
        "district_id": "262",
        "canton_id": "40",
        "code": "02",
        "name": "La Suiza"
    },
    {
        "district_id": "263",
        "canton_id": "40",
        "code": "03",
        "name": "Peralta"
    },
    {
        "district_id": "264",
        "canton_id": "40",
        "code": "04",
        "name": "Santa Cruz"
    },
    {
        "district_id": "265",
        "canton_id": "40",
        "code": "05",
        "name": "Santa Teresita"
    },
    {
        "district_id": "266",
        "canton_id": "40",
        "code": "06",
        "name": "Pavones"
    },
    {
        "district_id": "267",
        "canton_id": "40",
        "code": "07",
        "name": "Tuis"
    },
    {
        "district_id": "268",
        "canton_id": "40",
        "code": "08",
        "name": "Tayutic"
    },
    {
        "district_id": "269",
        "canton_id": "40",
        "code": "09",
        "name": "Santa Rosa"
    },
    {
        "district_id": "270",
        "canton_id": "40",
        "code": "10",
        "name": "Tres Equis"
    },
    {
        "district_id": "271",
        "canton_id": "40",
        "code": "11",
        "name": "La Isabel"
    },
    {
        "district_id": "272",
        "canton_id": "40",
        "code": "12",
        "name": "Chirripo"
    },
    {
        "district_id": "273",
        "canton_id": "41",
        "code": "01",
        "name": "Pacayas"
    },
    {
        "district_id": "274",
        "canton_id": "41",
        "code": "02",
        "name": "Cervantes"
    },
    {
        "district_id": "275",
        "canton_id": "41",
        "code": "03",
        "name": "Capellades"
    },
    {
        "district_id": "276",
        "canton_id": "42",
        "code": "01",
        "name": "San Rafael"
    },
    {
        "district_id": "277",
        "canton_id": "42",
        "code": "02",
        "name": "Cot"
    },
    {
        "district_id": "278",
        "canton_id": "42",
        "code": "03",
        "name": "Potrero Cerrado"
    },
    {
        "district_id": "279",
        "canton_id": "42",
        "code": "04",
        "name": "Cipreses"
    },
    {
        "district_id": "280",
        "canton_id": "42",
        "code": "05",
        "name": "Santa Rosa"
    },
    {
        "district_id": "281",
        "canton_id": "43",
        "code": "01",
        "name": "El Tejar"
    },
    {
        "district_id": "282",
        "canton_id": "43",
        "code": "02",
        "name": "San Isidro"
    },
    {
        "district_id": "283",
        "canton_id": "43",
        "code": "03",
        "name": "Tobosi"
    },
    {
        "district_id": "284",
        "canton_id": "43",
        "code": "04",
        "name": "Patio De Agua"
    },
    {
        "district_id": "285",
        "canton_id": "44",
        "code": "01",
        "name": "Heredia"
    },
    {
        "district_id": "286",
        "canton_id": "44",
        "code": "02",
        "name": "Mercedes"
    },
    {
        "district_id": "287",
        "canton_id": "44",
        "code": "03",
        "name": "San Francisco"
    },
    {
        "district_id": "288",
        "canton_id": "44",
        "code": "04",
        "name": "Ulloa"
    },
    {
        "district_id": "289",
        "canton_id": "44",
        "code": "05",
        "name": "Varablanca"
    },
    {
        "district_id": "290",
        "canton_id": "45",
        "code": "01",
        "name": "Barva"
    },
    {
        "district_id": "291",
        "canton_id": "45",
        "code": "02",
        "name": "San Pedro"
    },
    {
        "district_id": "292",
        "canton_id": "45",
        "code": "03",
        "name": "San Pablo"
    },
    {
        "district_id": "293",
        "canton_id": "45",
        "code": "04",
        "name": "San Roque"
    },
    {
        "district_id": "294",
        "canton_id": "45",
        "code": "05",
        "name": "Santa Lucia"
    },
    {
        "district_id": "295",
        "canton_id": "45",
        "code": "06",
        "name": "San Jose De La Montaña"
    },
    {
        "district_id": "296",
        "canton_id": "46",
        "code": "02",
        "name": "San Vicente"
    },
    {
        "district_id": "297",
        "canton_id": "46",
        "code": "03",
        "name": "San Miguel"
    },
    {
        "district_id": "298",
        "canton_id": "46",
        "code": "04",
        "name": "Paracito"
    },
    {
        "district_id": "299",
        "canton_id": "46",
        "code": "05",
        "name": "Santo Tomas"
    },
    {
        "district_id": "300",
        "canton_id": "46",
        "code": "06",
        "name": "Santa Rosa"
    },
    {
        "district_id": "301",
        "canton_id": "46",
        "code": "07",
        "name": "Tures"
    },
    {
        "district_id": "302",
        "canton_id": "46",
        "code": "08",
        "name": "Para"
    },
    {
        "district_id": "303",
        "canton_id": "47",
        "code": "01",
        "name": "Santa Barbara"
    },
    {
        "district_id": "304",
        "canton_id": "47",
        "code": "02",
        "name": "San Pedro"
    },
    {
        "district_id": "305",
        "canton_id": "47",
        "code": "03",
        "name": "San Juan"
    },
    {
        "district_id": "306",
        "canton_id": "47",
        "code": "04",
        "name": "Jesus"
    },
    {
        "district_id": "307",
        "canton_id": "47",
        "code": "05",
        "name": "Santo Domingo"
    },
    {
        "district_id": "308",
        "canton_id": "47",
        "code": "06",
        "name": "Puraba"
    },
    {
        "district_id": "309",
        "canton_id": "48",
        "code": "01",
        "name": "San Rafael"
    },
    {
        "district_id": "310",
        "canton_id": "48",
        "code": "02",
        "name": "San Josecito"
    },
    {
        "district_id": "311",
        "canton_id": "48",
        "code": "03",
        "name": "Santiago"
    },
    {
        "district_id": "312",
        "canton_id": "48",
        "code": "04",
        "name": "Angeles"
    },
    {
        "district_id": "313",
        "canton_id": "48",
        "code": "05",
        "name": "Concepcion"
    },
    {
        "district_id": "314",
        "canton_id": "49",
        "code": "01",
        "name": "San Isidro"
    },
    {
        "district_id": "315",
        "canton_id": "49",
        "code": "02",
        "name": "San Jose"
    },
    {
        "district_id": "316",
        "canton_id": "49",
        "code": "03",
        "name": "Concepcion"
    },
    {
        "district_id": "317",
        "canton_id": "49",
        "code": "04",
        "name": "San Francisco"
    },
    {
        "district_id": "318",
        "canton_id": "50",
        "code": "01",
        "name": "San Antonio"
    },
    {
        "district_id": "319",
        "canton_id": "50",
        "code": "02",
        "name": "La Ribera"
    },
    {
        "district_id": "320",
        "canton_id": "50",
        "code": "03",
        "name": "La Asuncion"
    },
    {
        "district_id": "321",
        "canton_id": "51",
        "code": "01",
        "name": "San Joaquin"
    },
    {
        "district_id": "322",
        "canton_id": "51",
        "code": "02",
        "name": "Barrantes"
    },
    {
        "district_id": "323",
        "canton_id": "51",
        "code": "03",
        "name": "Llorente"
    },
    {
        "district_id": "324",
        "canton_id": "52",
        "code": "01",
        "name": "San Pablo"
    },
    {
        "district_id": "325",
        "canton_id": "53",
        "code": "01",
        "name": "Puerto Viejo"
    },
    {
        "district_id": "326",
        "canton_id": "53",
        "code": "02",
        "name": "La Virgen"
    },
    {
        "district_id": "327",
        "canton_id": "53",
        "code": "03",
        "name": "Las Horquetas"
    },
    {
        "district_id": "328",
        "canton_id": "53",
        "code": "04",
        "name": "Llanuras Del Gaspar"
    },
    {
        "district_id": "329",
        "canton_id": "53",
        "code": "05",
        "name": "Cureña"
    },
    {
        "district_id": "330",
        "canton_id": "54",
        "code": "01",
        "name": "Liberia"
    },
    {
        "district_id": "331",
        "canton_id": "54",
        "code": "02",
        "name": "Cañas Dulces"
    },
    {
        "district_id": "332",
        "canton_id": "54",
        "code": "03",
        "name": "Mayorga"
    },
    {
        "district_id": "333",
        "canton_id": "54",
        "code": "04",
        "name": "Nacascolo"
    },
    {
        "district_id": "334",
        "canton_id": "54",
        "code": "05",
        "name": "Curubande"
    },
    {
        "district_id": "335",
        "canton_id": "55",
        "code": "01",
        "name": "Nicoya"
    },
    {
        "district_id": "336",
        "canton_id": "55",
        "code": "02",
        "name": "Mansion"
    },
    {
        "district_id": "337",
        "canton_id": "55",
        "code": "03",
        "name": "San Antonio"
    },
    {
        "district_id": "338",
        "canton_id": "55",
        "code": "04",
        "name": "Quebrada Honda"
    },
    {
        "district_id": "339",
        "canton_id": "55",
        "code": "05",
        "name": "Samara"
    },
    {
        "district_id": "340",
        "canton_id": "55",
        "code": "06",
        "name": "Nosara"
    },
    {
        "district_id": "341",
        "canton_id": "55",
        "code": "07",
        "name": "Belen De Nosarita"
    },
    {
        "district_id": "342",
        "canton_id": "56",
        "code": "01",
        "name": "Santa Cruz"
    },
    {
        "district_id": "343",
        "canton_id": "56",
        "code": "02",
        "name": "Bolson"
    },
    {
        "district_id": "344",
        "canton_id": "56",
        "code": "03",
        "name": "Veintisiete De Abril"
    },
    {
        "district_id": "345",
        "canton_id": "56",
        "code": "04",
        "name": "Tempate"
    },
    {
        "district_id": "346",
        "canton_id": "56",
        "code": "05",
        "name": "Cartagena"
    },
    {
        "district_id": "347",
        "canton_id": "56",
        "code": "06",
        "name": "Cuajiniquil"
    },
    {
        "district_id": "348",
        "canton_id": "56",
        "code": "07",
        "name": "Diria"
    },
    {
        "district_id": "349",
        "canton_id": "56",
        "code": "08",
        "name": "Cabo Velas"
    },
    {
        "district_id": "350",
        "canton_id": "56",
        "code": "09",
        "name": "Tamarindo"
    },
    {
        "district_id": "351",
        "canton_id": "57",
        "code": "01",
        "name": "Bagaces"
    },
    {
        "district_id": "352",
        "canton_id": "57",
        "code": "02",
        "name": "La Fortuna"
    },
    {
        "district_id": "353",
        "canton_id": "57",
        "code": "03",
        "name": "Mogote"
    },
    {
        "district_id": "354",
        "canton_id": "57",
        "code": "04",
        "name": "Rio Naranjo"
    },
    {
        "district_id": "355",
        "canton_id": "58",
        "code": "01",
        "name": "Filadelfia"
    },
    {
        "district_id": "356",
        "canton_id": "58",
        "code": "02",
        "name": "Palmira"
    },
    {
        "district_id": "357",
        "canton_id": "58",
        "code": "03",
        "name": "Sardinal"
    },
    {
        "district_id": "358",
        "canton_id": "58",
        "code": "04",
        "name": "Belen"
    },
    {
        "district_id": "359",
        "canton_id": "59",
        "code": "01",
        "name": "Cañas"
    },
    {
        "district_id": "360",
        "canton_id": "59",
        "code": "02",
        "name": "Palmira"
    },
    {
        "district_id": "361",
        "canton_id": "59",
        "code": "03",
        "name": "San Miguel"
    },
    {
        "district_id": "362",
        "canton_id": "59",
        "code": "04",
        "name": "Bebedero"
    },
    {
        "district_id": "363",
        "canton_id": "59",
        "code": "05",
        "name": "Porozal"
    },
    {
        "district_id": "364",
        "canton_id": "60",
        "code": "01",
        "name": "Las Juntas"
    },
    {
        "district_id": "365",
        "canton_id": "60",
        "code": "02",
        "name": "Sierra"
    },
    {
        "district_id": "366",
        "canton_id": "60",
        "code": "03",
        "name": "San Juan"
    },
    {
        "district_id": "367",
        "canton_id": "60",
        "code": "04",
        "name": "Colorado"
    },
    {
        "district_id": "368",
        "canton_id": "61",
        "code": "01",
        "name": "Tilaran"
    },
    {
        "district_id": "369",
        "canton_id": "61",
        "code": "02",
        "name": "Quebrada Grande"
    },
    {
        "district_id": "370",
        "canton_id": "61",
        "code": "03",
        "name": "Tronadora"
    },
    {
        "district_id": "371",
        "canton_id": "61",
        "code": "04",
        "name": "Santa Rosa"
    },
    {
        "district_id": "372",
        "canton_id": "61",
        "code": "05",
        "name": "Libano"
    },
    {
        "district_id": "373",
        "canton_id": "61",
        "code": "06",
        "name": "Tierras Morenas"
    },
    {
        "district_id": "374",
        "canton_id": "61",
        "code": "07",
        "name": "Arenal"
    },
    {
        "district_id": "375",
        "canton_id": "62",
        "code": "01",
        "name": "Carmona"
    },
    {
        "district_id": "376",
        "canton_id": "62",
        "code": "02",
        "name": "Santa Rita"
    },
    {
        "district_id": "377",
        "canton_id": "62",
        "code": "03",
        "name": "Zapotal"
    },
    {
        "district_id": "378",
        "canton_id": "62",
        "code": "04",
        "name": "San Pablo"
    },
    {
        "district_id": "379",
        "canton_id": "62",
        "code": "05",
        "name": "Porvenir"
    },
    {
        "district_id": "380",
        "canton_id": "62",
        "code": "06",
        "name": "Bejuco"
    },
    {
        "district_id": "381",
        "canton_id": "63",
        "code": "01",
        "name": "La Cruz"
    },
    {
        "district_id": "382",
        "canton_id": "63",
        "code": "02",
        "name": "Santa Cecilia"
    },
    {
        "district_id": "383",
        "canton_id": "63",
        "code": "03",
        "name": "La Garita"
    },
    {
        "district_id": "384",
        "canton_id": "63",
        "code": "04",
        "name": "Santa Elena"
    },
    {
        "district_id": "385",
        "canton_id": "64",
        "code": "01",
        "name": "Hojancha"
    },
    {
        "district_id": "386",
        "canton_id": "64",
        "code": "02",
        "name": "Monte Romo"
    },
    {
        "district_id": "387",
        "canton_id": "64",
        "code": "03",
        "name": "Puerto Carrillo"
    },
    {
        "district_id": "388",
        "canton_id": "64",
        "code": "04",
        "name": "Huacas"
    },
    {
        "district_id": "389",
        "canton_id": "65",
        "code": "01",
        "name": "Puntarenas"
    },
    {
        "district_id": "390",
        "canton_id": "65",
        "code": "02",
        "name": "Pitahaya"
    },
    {
        "district_id": "391",
        "canton_id": "65",
        "code": "03",
        "name": "Chomes"
    },
    {
        "district_id": "392",
        "canton_id": "65",
        "code": "04",
        "name": "Lepanto"
    },
    {
        "district_id": "393",
        "canton_id": "65",
        "code": "05",
        "name": "Paquera"
    },
    {
        "district_id": "394",
        "canton_id": "65",
        "code": "06",
        "name": "Manzanillo"
    },
    {
        "district_id": "395",
        "canton_id": "65",
        "code": "07",
        "name": "Guacimal"
    },
    {
        "district_id": "396",
        "canton_id": "65",
        "code": "08",
        "name": "Barranca"
    },
    {
        "district_id": "397",
        "canton_id": "65",
        "code": "09",
        "name": "Monte Verde"
    },
    {
        "district_id": "398",
        "canton_id": "65",
        "code": "11",
        "name": "Cobano"
    },
    {
        "district_id": "399",
        "canton_id": "65",
        "code": "12",
        "name": "Chacarita"
    },
    {
        "district_id": "400",
        "canton_id": "65",
        "code": "13",
        "name": "Chira"
    },
    {
        "district_id": "401",
        "canton_id": "65",
        "code": "14",
        "name": "Acapulco"
    },
    {
        "district_id": "402",
        "canton_id": "65",
        "code": "15",
        "name": "El Roble"
    },
    {
        "district_id": "403",
        "canton_id": "65",
        "code": "16",
        "name": "Arancibia"
    },
    {
        "district_id": "404",
        "canton_id": "66",
        "code": "01",
        "name": "Espiritu Santo"
    },
    {
        "district_id": "405",
        "canton_id": "66",
        "code": "02",
        "name": "San Juan Grande"
    },
    {
        "district_id": "406",
        "canton_id": "66",
        "code": "03",
        "name": "Macacona"
    },
    {
        "district_id": "407",
        "canton_id": "66",
        "code": "04",
        "name": "San Rafael"
    },
    {
        "district_id": "408",
        "canton_id": "66",
        "code": "05",
        "name": "San Jeronimo"
    },
    {
        "district_id": "409",
        "canton_id": "66",
        "code": "06",
        "name": "Caldera"
    },
    {
        "district_id": "410",
        "canton_id": "67",
        "code": "01",
        "name": "Buenos Aires"
    },
    {
        "district_id": "411",
        "canton_id": "67",
        "code": "02",
        "name": "Volcan"
    },
    {
        "district_id": "412",
        "canton_id": "67",
        "code": "03",
        "name": "Potrero Grande"
    },
    {
        "district_id": "413",
        "canton_id": "67",
        "code": "04",
        "name": "Boruca"
    },
    {
        "district_id": "414",
        "canton_id": "67",
        "code": "05",
        "name": "Pilas"
    },
    {
        "district_id": "415",
        "canton_id": "67",
        "code": "06",
        "name": "Colinas"
    },
    {
        "district_id": "416",
        "canton_id": "67",
        "code": "07",
        "name": "Changuena"
    },
    {
        "district_id": "417",
        "canton_id": "67",
        "code": "08",
        "name": "Biolley"
    },
    {
        "district_id": "418",
        "canton_id": "67",
        "code": "09",
        "name": "Brunka"
    },
    {
        "district_id": "419",
        "canton_id": "68",
        "code": "01",
        "name": "Miramar"
    },
    {
        "district_id": "420",
        "canton_id": "68",
        "code": "02",
        "name": "La Union"
    },
    {
        "district_id": "421",
        "canton_id": "68",
        "code": "03",
        "name": "San Isidro"
    },
    {
        "district_id": "422",
        "canton_id": "69",
        "code": "01",
        "name": "Puerto Cortes"
    },
    {
        "district_id": "423",
        "canton_id": "69",
        "code": "02",
        "name": "Palmar"
    },
    {
        "district_id": "424",
        "canton_id": "69",
        "code": "03",
        "name": "Sierpe"
    },
    {
        "district_id": "425",
        "canton_id": "69",
        "code": "04",
        "name": "Bahia Ballena"
    },
    {
        "district_id": "426",
        "canton_id": "69",
        "code": "05",
        "name": "Piedras Blancas"
    },
    {
        "district_id": "427",
        "canton_id": "69",
        "code": "06",
        "name": "Bahia Drake"
    },
    {
        "district_id": "428",
        "canton_id": "70",
        "code": "01",
        "name": "Quepos"
    },
    {
        "district_id": "429",
        "canton_id": "70",
        "code": "02",
        "name": "Savegre"
    },
    {
        "district_id": "430",
        "canton_id": "70",
        "code": "03",
        "name": "Naranjito"
    },
    {
        "district_id": "431",
        "canton_id": "71",
        "code": "01",
        "name": "Golfito"
    },
    {
        "district_id": "432",
        "canton_id": "71",
        "code": "02",
        "name": "Puerto Jimenez"
    },
    {
        "district_id": "433",
        "canton_id": "71",
        "code": "03",
        "name": "Guaycara"
    },
    {
        "district_id": "434",
        "canton_id": "71",
        "code": "04",
        "name": "Pavon"
    },
    {
        "district_id": "435",
        "canton_id": "72",
        "code": "01",
        "name": "San Vito"
    },
    {
        "district_id": "436",
        "canton_id": "72",
        "code": "02",
        "name": "Sabalito"
    },
    {
        "district_id": "437",
        "canton_id": "72",
        "code": "03",
        "name": "Aguabuena"
    },
    {
        "district_id": "438",
        "canton_id": "72",
        "code": "04",
        "name": "Limoncito"
    },
    {
        "district_id": "439",
        "canton_id": "72",
        "code": "05",
        "name": "Pittier"
    },
    {
        "district_id": "440",
        "canton_id": "72",
        "code": "06",
        "name": "Gutierrez Braun"
    },
    {
        "district_id": "441",
        "canton_id": "73",
        "code": "01",
        "name": "Parrita"
    },
    {
        "district_id": "442",
        "canton_id": "74",
        "code": "01",
        "name": "Corredor"
    },
    {
        "district_id": "443",
        "canton_id": "74",
        "code": "02",
        "name": "La Cuesta"
    },
    {
        "district_id": "444",
        "canton_id": "74",
        "code": "03",
        "name": "Canoas"
    },
    {
        "district_id": "445",
        "canton_id": "74",
        "code": "04",
        "name": "Laurel"
    },
    {
        "district_id": "446",
        "canton_id": "75",
        "code": "01",
        "name": "Jaco"
    },
    {
        "district_id": "447",
        "canton_id": "75",
        "code": "02",
        "name": "Tarcoles"
    },
    {
        "district_id": "448",
        "canton_id": "76",
        "code": "01",
        "name": "Limon"
    },
    {
        "district_id": "449",
        "canton_id": "76",
        "code": "02",
        "name": "Valle La Estrella"
    },
    {
        "district_id": "450",
        "canton_id": "76",
        "code": "04",
        "name": "Matama"
    },
    {
        "district_id": "451",
        "canton_id": "77",
        "code": "01",
        "name": "Guapiles"
    },
    {
        "district_id": "452",
        "canton_id": "77",
        "code": "02",
        "name": "Jimenez"
    },
    {
        "district_id": "453",
        "canton_id": "77",
        "code": "03",
        "name": "Rita"
    },
    {
        "district_id": "454",
        "canton_id": "77",
        "code": "04",
        "name": "Roxana"
    },
    {
        "district_id": "455",
        "canton_id": "77",
        "code": "05",
        "name": "Cariari"
    },
    {
        "district_id": "456",
        "canton_id": "77",
        "code": "06",
        "name": "Colorado"
    },
    {
        "district_id": "457",
        "canton_id": "77",
        "code": "07",
        "name": "La Colonia"
    },
    {
        "district_id": "458",
        "canton_id": "78",
        "code": "01",
        "name": "Siquirres"
    },
    {
        "district_id": "459",
        "canton_id": "78",
        "code": "02",
        "name": "Pacuarito"
    },
    {
        "district_id": "460",
        "canton_id": "78",
        "code": "03",
        "name": "Florida"
    },
    {
        "district_id": "461",
        "canton_id": "78",
        "code": "04",
        "name": "Germania"
    },
    {
        "district_id": "462",
        "canton_id": "78",
        "code": "05",
        "name": "El Cairo"
    },
    {
        "district_id": "463",
        "canton_id": "78",
        "code": "06",
        "name": "Alegria"
    },
    {
        "district_id": "464",
        "canton_id": "79",
        "code": "01",
        "name": "Bratsi"
    },
    {
        "district_id": "465",
        "canton_id": "79",
        "code": "02",
        "name": "Sixaola"
    },
    {
        "district_id": "466",
        "canton_id": "79",
        "code": "03",
        "name": "Cahuita"
    },
    {
        "district_id": "467",
        "canton_id": "79",
        "code": "04",
        "name": "Telire"
    },
    {
        "district_id": "468",
        "canton_id": "80",
        "code": "01",
        "name": "Matina"
    },
    {
        "district_id": "469",
        "canton_id": "80",
        "code": "02",
        "name": "Batan"
    },
    {
        "district_id": "470",
        "canton_id": "80",
        "code": "03",
        "name": "Carrandi"
    },
    {
        "district_id": "471",
        "canton_id": "81",
        "code": "01",
        "name": "Guacimo"
    },
    {
        "district_id": "472",
        "canton_id": "81",
        "code": "02",
        "name": "Mercedes"
    },
    {
        "district_id": "473",
        "canton_id": "81",
        "code": "03",
        "name": "Pocora"
    },
    {
        "district_id": "474",
        "canton_id": "81",
        "code": "04",
        "name": "Rio Jimenez"
    },
    {
        "district_id": "475",
        "canton_id": "81",
        "code": "05",
        "name": "Duacari"
    }
]

export const CR_NEIBOARD = [
    {
        "neabord_id": "1",
        "district_id": "1",
        "code": "01",
        "name": "Amón"
    },
    {
        "neabord_id": "2",
        "district_id": "1",
        "code": "02",
        "name": "Aranjuez"
    },
    {
        "neabord_id": "3",
        "district_id": "1",
        "code": "03",
        "name": "California (parte)"
    },
    {
        "neabord_id": "4",
        "district_id": "1",
        "code": "04",
        "name": "Carmen"
    },
    {
        "neabord_id": "5",
        "district_id": "1",
        "code": "05",
        "name": "Empalme"
    },
    {
        "neabord_id": "6",
        "district_id": "1",
        "code": "06",
        "name": "Escalante"
    },
    {
        "neabord_id": "7",
        "district_id": "1",
        "code": "07",
        "name": "Otoya."
    },
    {
        "neabord_id": "8",
        "district_id": "2",
        "code": "01",
        "name": "Bajos de la Unión"
    },
    {
        "neabord_id": "9",
        "district_id": "2",
        "code": "02",
        "name": "Claret"
    },
    {
        "neabord_id": "10",
        "district_id": "2",
        "code": "03",
        "name": "Cocacola"
    },
    {
        "neabord_id": "11",
        "district_id": "2",
        "code": "04",
        "name": "Iglesias Flores"
    },
    {
        "neabord_id": "12",
        "district_id": "2",
        "code": "05",
        "name": "Mantica"
    },
    {
        "neabord_id": "13",
        "district_id": "2",
        "code": "06",
        "name": "Mexico"
    },
    {
        "neabord_id": "14",
        "district_id": "2",
        "code": "07",
        "name": "Paso de la Vaca"
    },
    {
        "neabord_id": "15",
        "district_id": "2",
        "code": "08",
        "name": "Pitahaya."
    },
    {
        "neabord_id": "16",
        "district_id": "3",
        "code": "01",
        "name": "Almendares"
    },
    {
        "neabord_id": "17",
        "district_id": "3",
        "code": "02",
        "name": "angeles"
    },
    {
        "neabord_id": "18",
        "district_id": "3",
        "code": "03",
        "name": "Boli­var"
    },
    {
        "neabord_id": "19",
        "district_id": "3",
        "code": "04",
        "name": "Carit"
    },
    {
        "neabord_id": "20",
        "district_id": "3",
        "code": "05",
        "name": "Colón (parte)"
    },
    {
        "neabord_id": "21",
        "district_id": "3",
        "code": "06",
        "name": "Corazón de Jesus"
    },
    {
        "neabord_id": "22",
        "district_id": "3",
        "code": "07",
        "name": "Cristo Rey"
    },
    {
        "neabord_id": "23",
        "district_id": "3",
        "code": "08",
        "name": "Cuba"
    },
    {
        "neabord_id": "24",
        "district_id": "3",
        "code": "09",
        "name": "Dolorosa (parte)"
    },
    {
        "neabord_id": "25",
        "district_id": "3",
        "code": "10",
        "name": "Merced"
    },
    {
        "neabord_id": "26",
        "district_id": "3",
        "code": "11",
        "name": "Paci­fico (parte)"
    },
    {
        "neabord_id": "27",
        "district_id": "3",
        "code": "12",
        "name": "Pinos"
    },
    {
        "neabord_id": "28",
        "district_id": "3",
        "code": "13",
        "name": "Salubridad"
    },
    {
        "neabord_id": "29",
        "district_id": "3",
        "code": "14",
        "name": "San Bosco"
    },
    {
        "neabord_id": "30",
        "district_id": "3",
        "code": "15",
        "name": "San Francisco"
    },
    {
        "neabord_id": "31",
        "district_id": "3",
        "code": "16",
        "name": "Santa Luci­a"
    },
    {
        "neabord_id": "32",
        "district_id": "3",
        "code": "17",
        "name": "Silos."
    },
    {
        "neabord_id": "33",
        "district_id": "4",
        "code": "01",
        "name": "Bellavista"
    },
    {
        "neabord_id": "34",
        "district_id": "4",
        "code": "02",
        "name": "California (parte)"
    },
    {
        "neabord_id": "35",
        "district_id": "4",
        "code": "03",
        "name": "Carlos Mari­a Jimenez"
    },
    {
        "neabord_id": "36",
        "district_id": "4",
        "code": "04",
        "name": "Dolorosa (parte)"
    },
    {
        "neabord_id": "37",
        "district_id": "4",
        "code": "05",
        "name": "Dos Pinos"
    },
    {
        "neabord_id": "38",
        "district_id": "4",
        "code": "06",
        "name": "Francisco Peralta (parte)"
    },
    {
        "neabord_id": "39",
        "district_id": "4",
        "code": "07",
        "name": "Gonzalez Lahmann"
    },
    {
        "neabord_id": "40",
        "district_id": "4",
        "code": "08",
        "name": "Gonzalez Vi­quez"
    },
    {
        "neabord_id": "41",
        "district_id": "4",
        "code": "09",
        "name": "Güell"
    },
    {
        "neabord_id": "42",
        "district_id": "4",
        "code": "10",
        "name": "La Cruz"
    },
    {
        "neabord_id": "43",
        "district_id": "4",
        "code": "11",
        "name": "Lomas de Ocloro"
    },
    {
        "neabord_id": "44",
        "district_id": "4",
        "code": "12",
        "name": "Lujan"
    },
    {
        "neabord_id": "45",
        "district_id": "4",
        "code": "13",
        "name": "Milflor"
    },
    {
        "neabord_id": "46",
        "district_id": "4",
        "code": "14",
        "name": "Naciones Unidas"
    },
    {
        "neabord_id": "47",
        "district_id": "4",
        "code": "15",
        "name": "Paci­fico (parte)"
    },
    {
        "neabord_id": "48",
        "district_id": "4",
        "code": "16",
        "name": "San Cayetano (parte)"
    },
    {
        "neabord_id": "49",
        "district_id": "4",
        "code": "17",
        "name": "Soledad"
    },
    {
        "neabord_id": "50",
        "district_id": "4",
        "code": "18",
        "name": "Tabacalera"
    },
    {
        "neabord_id": "51",
        "district_id": "4",
        "code": "19",
        "name": "Vasconia."
    },
    {
        "neabord_id": "52",
        "district_id": "5",
        "code": "01",
        "name": "Alborada"
    },
    {
        "neabord_id": "53",
        "district_id": "5",
        "code": "02",
        "name": "Calderón Muñoz"
    },
    {
        "neabord_id": "54",
        "district_id": "5",
        "code": "03",
        "name": "Cerrito"
    },
    {
        "neabord_id": "55",
        "district_id": "5",
        "code": "04",
        "name": "Córdoba"
    },
    {
        "neabord_id": "56",
        "district_id": "5",
        "code": "05",
        "name": "Gloria"
    },
    {
        "neabord_id": "57",
        "district_id": "5",
        "code": "06",
        "name": "Jardi­n"
    },
    {
        "neabord_id": "58",
        "district_id": "5",
        "code": "07",
        "name": "Luisas"
    },
    {
        "neabord_id": "59",
        "district_id": "5",
        "code": "08",
        "name": "Mangos"
    },
    {
        "neabord_id": "60",
        "district_id": "5",
        "code": "09",
        "name": "Montealegre"
    },
    {
        "neabord_id": "61",
        "district_id": "5",
        "code": "10",
        "name": "Moreno Cañas"
    },
    {
        "neabord_id": "62",
        "district_id": "5",
        "code": "11",
        "name": "Quesada Duran"
    },
    {
        "neabord_id": "63",
        "district_id": "5",
        "code": "12",
        "name": "San Dimas"
    },
    {
        "neabord_id": "64",
        "district_id": "5",
        "code": "13",
        "name": "San Gerardo (parte)"
    },
    {
        "neabord_id": "65",
        "district_id": "5",
        "code": "14",
        "name": "Trebol"
    },
    {
        "neabord_id": "66",
        "district_id": "5",
        "code": "15",
        "name": "Ujarras"
    },
    {
        "neabord_id": "67",
        "district_id": "5",
        "code": "16",
        "name": "Vista Hermosa"
    },
    {
        "neabord_id": "68",
        "district_id": "5",
        "code": "17",
        "name": "Yoses Sur"
    },
    {
        "neabord_id": "69",
        "district_id": "5",
        "code": "18",
        "name": "Zapote (centro)."
    },
    {
        "neabord_id": "70",
        "district_id": "6",
        "code": "01",
        "name": "Ahogados (parte)"
    },
    {
        "neabord_id": "71",
        "district_id": "6",
        "code": "02",
        "name": "Bosque"
    },
    {
        "neabord_id": "72",
        "district_id": "6",
        "code": "03",
        "name": "Cabañas"
    },
    {
        "neabord_id": "73",
        "district_id": "6",
        "code": "04",
        "name": "Camelias"
    },
    {
        "neabord_id": "74",
        "district_id": "6",
        "code": "05",
        "name": "Coopeguaria"
    },
    {
        "neabord_id": "75",
        "district_id": "6",
        "code": "06",
        "name": "Faro"
    },
    {
        "neabord_id": "76",
        "district_id": "6",
        "code": "07",
        "name": "Fatima"
    },
    {
        "neabord_id": "77",
        "district_id": "6",
        "code": "08",
        "name": "Hispano"
    },
    {
        "neabord_id": "78",
        "district_id": "6",
        "code": "09",
        "name": "I Griega"
    },
    {
        "neabord_id": "79",
        "district_id": "6",
        "code": "10",
        "name": "Lincoln"
    },
    {
        "neabord_id": "80",
        "district_id": "6",
        "code": "11",
        "name": "Lomas de San Francisco"
    },
    {
        "neabord_id": "81",
        "district_id": "6",
        "code": "12",
        "name": "Maalot"
    },
    {
        "neabord_id": "82",
        "district_id": "6",
        "code": "13",
        "name": "Mendez"
    },
    {
        "neabord_id": "83",
        "district_id": "6",
        "code": "14",
        "name": "Paci­fica"
    },
    {
        "neabord_id": "84",
        "district_id": "6",
        "code": "15",
        "name": "San Francisco de Dos Ri­os (centro)"
    },
    {
        "neabord_id": "85",
        "district_id": "6",
        "code": "16",
        "name": "Sauces"
    },
    {
        "neabord_id": "86",
        "district_id": "6",
        "code": "17",
        "name": "Saucitos"
    },
    {
        "neabord_id": "87",
        "district_id": "6",
        "code": "18",
        "name": "Zurqui­."
    },
    {
        "neabord_id": "88",
        "district_id": "7",
        "code": "01",
        "name": "Alborada"
    },
    {
        "neabord_id": "89",
        "district_id": "7",
        "code": "02",
        "name": "animas"
    },
    {
        "neabord_id": "90",
        "district_id": "7",
        "code": "03",
        "name": "arboles"
    },
    {
        "neabord_id": "91",
        "district_id": "7",
        "code": "04",
        "name": "Bajos del Torres"
    },
    {
        "neabord_id": "92",
        "district_id": "7",
        "code": "05",
        "name": "Carranza"
    },
    {
        "neabord_id": "93",
        "district_id": "7",
        "code": "06",
        "name": "Corazón de Jesus"
    },
    {
        "neabord_id": "94",
        "district_id": "7",
        "code": "07",
        "name": "Cristal"
    },
    {
        "neabord_id": "95",
        "district_id": "7",
        "code": "08",
        "name": "Carvajal Castro"
    },
    {
        "neabord_id": "96",
        "district_id": "7",
        "code": "09",
        "name": "Jardines de Autopista"
    },
    {
        "neabord_id": "97",
        "district_id": "7",
        "code": "10",
        "name": "La Caja"
    },
    {
        "neabord_id": "98",
        "district_id": "7",
        "code": "11",
        "name": "La Carpio"
    },
    {
        "neabord_id": "99",
        "district_id": "7",
        "code": "12",
        "name": "Magnolia"
    },
    {
        "neabord_id": "100",
        "district_id": "7",
        "code": "13",
        "name": "Marimil"
    },
    {
        "neabord_id": "101",
        "district_id": "7",
        "code": "14",
        "name": "Monserrat"
    },
    {
        "neabord_id": "102",
        "district_id": "7",
        "code": "15",
        "name": "Peregrina"
    },
    {
        "neabord_id": "103",
        "district_id": "7",
        "code": "16",
        "name": "Robledal"
    },
    {
        "neabord_id": "104",
        "district_id": "7",
        "code": "17",
        "name": "Rossiter Carballo"
    },
    {
        "neabord_id": "105",
        "district_id": "7",
        "code": "18",
        "name": "Santander"
    },
    {
        "neabord_id": "106",
        "district_id": "7",
        "code": "19",
        "name": "Saturno"
    },
    {
        "neabord_id": "107",
        "district_id": "7",
        "code": "20",
        "name": "Uruca (centro)"
    },
    {
        "neabord_id": "108",
        "district_id": "7",
        "code": "21",
        "name": "Vuelta del Virilla."
    },
    {
        "neabord_id": "109",
        "district_id": "8",
        "code": "01",
        "name": "Americas"
    },
    {
        "neabord_id": "110",
        "district_id": "8",
        "code": "02",
        "name": "Bajo Cañada (parte)"
    },
    {
        "neabord_id": "111",
        "district_id": "8",
        "code": "03",
        "name": "Balcón Verde"
    },
    {
        "neabord_id": "112",
        "district_id": "8",
        "code": "04",
        "name": "Colón (parte)"
    },
    {
        "neabord_id": "113",
        "district_id": "8",
        "code": "05",
        "name": "Del Pino"
    },
    {
        "neabord_id": "114",
        "district_id": "8",
        "code": "06",
        "name": "Holanda"
    },
    {
        "neabord_id": "115",
        "district_id": "8",
        "code": "07",
        "name": "La Luisa"
    },
    {
        "neabord_id": "116",
        "district_id": "8",
        "code": "08",
        "name": "La Salle"
    },
    {
        "neabord_id": "117",
        "district_id": "8",
        "code": "09",
        "name": "Lomalinda"
    },
    {
        "neabord_id": "118",
        "district_id": "8",
        "code": "10",
        "name": "Morenos"
    },
    {
        "neabord_id": "119",
        "district_id": "8",
        "code": "11",
        "name": "Niza"
    },
    {
        "neabord_id": "120",
        "district_id": "8",
        "code": "12",
        "name": "Rancho Luna"
    },
    {
        "neabord_id": "121",
        "district_id": "8",
        "code": "13",
        "name": "Rohrmoser (parte)"
    },
    {
        "neabord_id": "122",
        "district_id": "8",
        "code": "14",
        "name": "Roma"
    },
    {
        "neabord_id": "123",
        "district_id": "8",
        "code": "15",
        "name": "Sabana"
    },
    {
        "neabord_id": "124",
        "district_id": "8",
        "code": "16",
        "name": "Tovar."
    },
    {
        "neabord_id": "125",
        "district_id": "9",
        "code": "01",
        "name": "Alfa"
    },
    {
        "neabord_id": "126",
        "district_id": "9",
        "code": "02",
        "name": "Asturias"
    },
    {
        "neabord_id": "127",
        "district_id": "9",
        "code": "03",
        "name": "Asunción"
    },
    {
        "neabord_id": "128",
        "district_id": "9",
        "code": "04",
        "name": "Bribri­"
    },
    {
        "neabord_id": "129",
        "district_id": "9",
        "code": "05",
        "name": "Favorita Norte"
    },
    {
        "neabord_id": "130",
        "district_id": "9",
        "code": "06",
        "name": "Favorita Sur"
    },
    {
        "neabord_id": "131",
        "district_id": "9",
        "code": "07",
        "name": "Galicia"
    },
    {
        "neabord_id": "132",
        "district_id": "9",
        "code": "08",
        "name": "Geroma"
    },
    {
        "neabord_id": "133",
        "district_id": "9",
        "code": "09",
        "name": "Hispania"
    },
    {
        "neabord_id": "134",
        "district_id": "9",
        "code": "10",
        "name": "Libertad"
    },
    {
        "neabord_id": "135",
        "district_id": "9",
        "code": "11",
        "name": "Lomas del Ri­o"
    },
    {
        "neabord_id": "136",
        "district_id": "9",
        "code": "12",
        "name": "Llanos del Sol"
    },
    {
        "neabord_id": "137",
        "district_id": "9",
        "code": "13",
        "name": "Mari­a Reina"
    },
    {
        "neabord_id": "138",
        "district_id": "9",
        "code": "14",
        "name": "Metrópolis"
    },
    {
        "neabord_id": "139",
        "district_id": "9",
        "code": "15",
        "name": "Navarra"
    },
    {
        "neabord_id": "140",
        "district_id": "9",
        "code": "16",
        "name": "Pavas (centro)"
    },
    {
        "neabord_id": "141",
        "district_id": "9",
        "code": "17",
        "name": "Pueblo Nuevo"
    },
    {
        "neabord_id": "142",
        "district_id": "9",
        "code": "18",
        "name": "Residencial del Oeste"
    },
    {
        "neabord_id": "143",
        "district_id": "9",
        "code": "19",
        "name": "Rincón Grande"
    },
    {
        "neabord_id": "144",
        "district_id": "9",
        "code": "20",
        "name": "Rohrmoser (parte)"
    },
    {
        "neabord_id": "145",
        "district_id": "9",
        "code": "21",
        "name": "Rotonda"
    },
    {
        "neabord_id": "146",
        "district_id": "9",
        "code": "22",
        "name": "San Pedro"
    },
    {
        "neabord_id": "147",
        "district_id": "9",
        "code": "23",
        "name": "Santa Barbara"
    },
    {
        "neabord_id": "148",
        "district_id": "9",
        "code": "24",
        "name": "Santa Catalina"
    },
    {
        "neabord_id": "149",
        "district_id": "9",
        "code": "25",
        "name": "Santa Fe"
    },
    {
        "neabord_id": "150",
        "district_id": "9",
        "code": "26",
        "name": "Triangulo"
    },
    {
        "neabord_id": "151",
        "district_id": "9",
        "code": "27",
        "name": "Villa Esperanza."
    },
    {
        "neabord_id": "152",
        "district_id": "10",
        "code": "01",
        "name": "Bajo Cañada (parte)"
    },
    {
        "neabord_id": "153",
        "district_id": "10",
        "code": "02",
        "name": "Belgrano"
    },
    {
        "neabord_id": "154",
        "district_id": "10",
        "code": "03",
        "name": "Hatillo Centro"
    },
    {
        "neabord_id": "155",
        "district_id": "10",
        "code": "04",
        "name": "Hatillo 1"
    },
    {
        "neabord_id": "156",
        "district_id": "10",
        "code": "05",
        "name": "Hatillo 2"
    },
    {
        "neabord_id": "157",
        "district_id": "10",
        "code": "06",
        "name": "Hatillo 3"
    },
    {
        "neabord_id": "158",
        "district_id": "10",
        "code": "07",
        "name": "Hatillo 4"
    },
    {
        "neabord_id": "159",
        "district_id": "10",
        "code": "08",
        "name": "Hatillo 5"
    },
    {
        "neabord_id": "160",
        "district_id": "10",
        "code": "09",
        "name": "Hatillo 6"
    },
    {
        "neabord_id": "161",
        "district_id": "10",
        "code": "10",
        "name": "Hatillo 7"
    },
    {
        "neabord_id": "162",
        "district_id": "10",
        "code": "11",
        "name": "Hatillo 8"
    },
    {
        "neabord_id": "163",
        "district_id": "10",
        "code": "12",
        "name": "Quince de Setiembre"
    },
    {
        "neabord_id": "164",
        "district_id": "10",
        "code": "13",
        "name": "Sagrada Familia"
    },
    {
        "neabord_id": "165",
        "district_id": "10",
        "code": "14",
        "name": "Tiribi­"
    },
    {
        "neabord_id": "166",
        "district_id": "10",
        "code": "15",
        "name": "Topacio"
    },
    {
        "neabord_id": "167",
        "district_id": "10",
        "code": "16",
        "name": "Veinticinco de Julio"
    },
    {
        "neabord_id": "168",
        "district_id": "10",
        "code": "17",
        "name": "Vivienda en Marcha."
    },
    {
        "neabord_id": "169",
        "district_id": "11",
        "code": "01",
        "name": "Bengala"
    },
    {
        "neabord_id": "170",
        "district_id": "11",
        "code": "02",
        "name": "Bilbao"
    },
    {
        "neabord_id": "171",
        "district_id": "11",
        "code": "03",
        "name": "Cañada del Sur"
    },
    {
        "neabord_id": "172",
        "district_id": "11",
        "code": "04",
        "name": "Carmen"
    },
    {
        "neabord_id": "173",
        "district_id": "11",
        "code": "05",
        "name": "Cascajal"
    },
    {
        "neabord_id": "174",
        "district_id": "11",
        "code": "06",
        "name": "Cerro Azul"
    },
    {
        "neabord_id": "175",
        "district_id": "11",
        "code": "07",
        "name": "Colombari"
    },
    {
        "neabord_id": "176",
        "district_id": "11",
        "code": "08",
        "name": "Domingo Savio"
    },
    {
        "neabord_id": "177",
        "district_id": "11",
        "code": "09",
        "name": "Guacamaya"
    },
    {
        "neabord_id": "178",
        "district_id": "11",
        "code": "10",
        "name": "Jazmi­n"
    },
    {
        "neabord_id": "179",
        "district_id": "11",
        "code": "11",
        "name": "Hogar Propio"
    },
    {
        "neabord_id": "180",
        "district_id": "11",
        "code": "12",
        "name": "Kennedy"
    },
    {
        "neabord_id": "181",
        "district_id": "11",
        "code": "13",
        "name": "López Mateos"
    },
    {
        "neabord_id": "182",
        "district_id": "11",
        "code": "14",
        "name": "Luna Park"
    },
    {
        "neabord_id": "183",
        "district_id": "11",
        "code": "15",
        "name": "Marti­nez"
    },
    {
        "neabord_id": "184",
        "district_id": "11",
        "code": "16",
        "name": "Mojados"
    },
    {
        "neabord_id": "185",
        "district_id": "11",
        "code": "17",
        "name": "Mongito"
    },
    {
        "neabord_id": "186",
        "district_id": "11",
        "code": "18",
        "name": "Monte Azul"
    },
    {
        "neabord_id": "187",
        "district_id": "11",
        "code": "19",
        "name": "Musmanni"
    },
    {
        "neabord_id": "188",
        "district_id": "11",
        "code": "20",
        "name": "Paso Ancho"
    },
    {
        "neabord_id": "189",
        "district_id": "11",
        "code": "21",
        "name": "Presidentes"
    },
    {
        "neabord_id": "190",
        "district_id": "11",
        "code": "22",
        "name": "San Cayetano (parte)"
    },
    {
        "neabord_id": "191",
        "district_id": "11",
        "code": "23",
        "name": "San Marti­n"
    },
    {
        "neabord_id": "192",
        "district_id": "11",
        "code": "24",
        "name": "San Sebastian (centro)"
    },
    {
        "neabord_id": "193",
        "district_id": "11",
        "code": "25",
        "name": "Santa Rosa"
    },
    {
        "neabord_id": "194",
        "district_id": "11",
        "code": "26",
        "name": "Seminario"
    },
    {
        "neabord_id": "195",
        "district_id": "11",
        "code": "27",
        "name": "Sorobaru."
    },
    {
        "neabord_id": "196",
        "district_id": "12",
        "code": "01",
        "name": "Alto Carrizal"
    },
    {
        "neabord_id": "197",
        "district_id": "12",
        "code": "02",
        "name": "Carrizal (parte)"
    },
    {
        "neabord_id": "198",
        "district_id": "12",
        "code": "03",
        "name": "Faroles"
    },
    {
        "neabord_id": "199",
        "district_id": "12",
        "code": "04",
        "name": "Guapinol"
    },
    {
        "neabord_id": "200",
        "district_id": "12",
        "code": "05",
        "name": "Hulera"
    },
    {
        "neabord_id": "201",
        "district_id": "12",
        "code": "06",
        "name": "Itabas"
    },
    {
        "neabord_id": "202",
        "district_id": "12",
        "code": "07",
        "name": "Jaboncillo"
    },
    {
        "neabord_id": "203",
        "district_id": "12",
        "code": "08",
        "name": "Profesores (parte)."
    },
    {
        "neabord_id": "204",
        "district_id": "13",
        "code": "01",
        "name": "Avellana"
    },
    {
        "neabord_id": "205",
        "district_id": "13",
        "code": "02",
        "name": "Bebedero"
    },
    {
        "neabord_id": "206",
        "district_id": "13",
        "code": "03",
        "name": "Belo Horizonte (parte)"
    },
    {
        "neabord_id": "207",
        "district_id": "13",
        "code": "04",
        "name": "Carrizal (parte)"
    },
    {
        "neabord_id": "208",
        "district_id": "13",
        "code": "05",
        "name": "Curi­o"
    },
    {
        "neabord_id": "209",
        "district_id": "13",
        "code": "06",
        "name": "Chirca"
    },
    {
        "neabord_id": "210",
        "district_id": "13",
        "code": "07",
        "name": "Chiverral"
    },
    {
        "neabord_id": "211",
        "district_id": "13",
        "code": "08",
        "name": "Entierrillo"
    },
    {
        "neabord_id": "212",
        "district_id": "13",
        "code": "09",
        "name": "Filtros"
    },
    {
        "neabord_id": "213",
        "district_id": "13",
        "code": "10",
        "name": "Guayabos"
    },
    {
        "neabord_id": "214",
        "district_id": "13",
        "code": "11",
        "name": "Hojablanca"
    },
    {
        "neabord_id": "215",
        "district_id": "13",
        "code": "12",
        "name": "Juan Santana"
    },
    {
        "neabord_id": "216",
        "district_id": "13",
        "code": "13",
        "name": "Lajas"
    },
    {
        "neabord_id": "217",
        "district_id": "13",
        "code": "14",
        "name": "Masilla"
    },
    {
        "neabord_id": "218",
        "district_id": "13",
        "code": "15",
        "name": "Muta"
    },
    {
        "neabord_id": "219",
        "district_id": "13",
        "code": "16",
        "name": "Pedrero"
    },
    {
        "neabord_id": "220",
        "district_id": "13",
        "code": "17",
        "name": "Peru"
    },
    {
        "neabord_id": "221",
        "district_id": "13",
        "code": "18",
        "name": "Profesores (parte)"
    },
    {
        "neabord_id": "222",
        "district_id": "13",
        "code": "19",
        "name": "Sabanillas"
    },
    {
        "neabord_id": "223",
        "district_id": "13",
        "code": "20",
        "name": "Salitrillos"
    },
    {
        "neabord_id": "224",
        "district_id": "13",
        "code": "21",
        "name": "Santa Eduvigis"
    },
    {
        "neabord_id": "225",
        "district_id": "13",
        "code": "22",
        "name": "Santa Teresa"
    },
    {
        "neabord_id": "226",
        "district_id": "13",
        "code": "23",
        "name": "Tejarcillos"
    },
    {
        "neabord_id": "227",
        "district_id": "13",
        "code": "24",
        "name": "Torrotillo"
    },
    {
        "neabord_id": "228",
        "district_id": "13",
        "code": "25",
        "name": "Vista de Oro."
    },
    {
        "neabord_id": "229",
        "district_id": "14",
        "code": "01",
        "name": "Anonos"
    },
    {
        "neabord_id": "230",
        "district_id": "14",
        "code": "02",
        "name": "Ayala"
    },
    {
        "neabord_id": "231",
        "district_id": "14",
        "code": "03",
        "name": "Bajo Anonos"
    },
    {
        "neabord_id": "232",
        "district_id": "14",
        "code": "04",
        "name": "Bajo Palomas"
    },
    {
        "neabord_id": "233",
        "district_id": "14",
        "code": "05",
        "name": "Belo Horizonte (parte)"
    },
    {
        "neabord_id": "234",
        "district_id": "14",
        "code": "06",
        "name": "Betina"
    },
    {
        "neabord_id": "235",
        "district_id": "14",
        "code": "07",
        "name": "Ceiba"
    },
    {
        "neabord_id": "236",
        "district_id": "14",
        "code": "08",
        "name": "Facio Castro"
    },
    {
        "neabord_id": "237",
        "district_id": "14",
        "code": "09",
        "name": "Guachipeli­n"
    },
    {
        "neabord_id": "238",
        "district_id": "14",
        "code": "10",
        "name": "Herrera"
    },
    {
        "neabord_id": "239",
        "district_id": "14",
        "code": "11",
        "name": "Laureles"
    },
    {
        "neabord_id": "240",
        "district_id": "14",
        "code": "12",
        "name": "León"
    },
    {
        "neabord_id": "241",
        "district_id": "14",
        "code": "13",
        "name": "Loma Real"
    },
    {
        "neabord_id": "242",
        "district_id": "14",
        "code": "14",
        "name": "Matapalo"
    },
    {
        "neabord_id": "243",
        "district_id": "14",
        "code": "15",
        "name": "Maynard"
    },
    {
        "neabord_id": "244",
        "district_id": "14",
        "code": "16",
        "name": "Mirador"
    },
    {
        "neabord_id": "245",
        "district_id": "14",
        "code": "17",
        "name": "Miravalles"
    },
    {
        "neabord_id": "246",
        "district_id": "14",
        "code": "18",
        "name": "Palermo"
    },
    {
        "neabord_id": "247",
        "district_id": "14",
        "code": "19",
        "name": "Palma de Mallorca"
    },
    {
        "neabord_id": "248",
        "district_id": "14",
        "code": "20",
        "name": "Pinar"
    },
    {
        "neabord_id": "249",
        "district_id": "14",
        "code": "21",
        "name": "Primavera"
    },
    {
        "neabord_id": "250",
        "district_id": "14",
        "code": "22",
        "name": "Quesada"
    },
    {
        "neabord_id": "251",
        "district_id": "14",
        "code": "23",
        "name": "Real de Pereira (parte)"
    },
    {
        "neabord_id": "252",
        "district_id": "14",
        "code": "24",
        "name": "Santa Marta"
    },
    {
        "neabord_id": "253",
        "district_id": "14",
        "code": "25",
        "name": "Tena"
    },
    {
        "neabord_id": "254",
        "district_id": "14",
        "code": "26",
        "name": "Trejos Montealegre"
    },
    {
        "neabord_id": "255",
        "district_id": "14",
        "code": "27",
        "name": "Vista Alegre."
    },
    {
        "neabord_id": "256",
        "district_id": "15",
        "code": "01",
        "name": "Altamira"
    },
    {
        "neabord_id": "257",
        "district_id": "15",
        "code": "02",
        "name": "Bellavista"
    },
    {
        "neabord_id": "258",
        "district_id": "15",
        "code": "03",
        "name": "Calle Fallas"
    },
    {
        "neabord_id": "259",
        "district_id": "15",
        "code": "04",
        "name": "Camaquiri­"
    },
    {
        "neabord_id": "260",
        "district_id": "15",
        "code": "05",
        "name": "Capilla"
    },
    {
        "neabord_id": "261",
        "district_id": "15",
        "code": "06",
        "name": "Centro de Amigos"
    },
    {
        "neabord_id": "262",
        "district_id": "15",
        "code": "07",
        "name": "Ceramica"
    },
    {
        "neabord_id": "263",
        "district_id": "15",
        "code": "08",
        "name": "Colonia del Sur"
    },
    {
        "neabord_id": "264",
        "district_id": "15",
        "code": "09",
        "name": "Contadores"
    },
    {
        "neabord_id": "265",
        "district_id": "15",
        "code": "10",
        "name": "Cruce"
    },
    {
        "neabord_id": "266",
        "district_id": "15",
        "code": "11",
        "name": "Cucubres"
    },
    {
        "neabord_id": "267",
        "district_id": "15",
        "code": "12",
        "name": "Dorados"
    },
    {
        "neabord_id": "268",
        "district_id": "15",
        "code": "13",
        "name": "Florita"
    },
    {
        "neabord_id": "269",
        "district_id": "15",
        "code": "14",
        "name": "Fortuna"
    },
    {
        "neabord_id": "270",
        "district_id": "15",
        "code": "15",
        "name": "Jardi­n"
    },
    {
        "neabord_id": "271",
        "district_id": "15",
        "code": "16",
        "name": "Loto"
    },
    {
        "neabord_id": "272",
        "district_id": "15",
        "code": "17",
        "name": "Metrópoli"
    },
    {
        "neabord_id": "273",
        "district_id": "15",
        "code": "18",
        "name": "Monseñor Sanabria"
    },
    {
        "neabord_id": "274",
        "district_id": "15",
        "code": "19",
        "name": "Monteclaro"
    },
    {
        "neabord_id": "275",
        "district_id": "15",
        "code": "20",
        "name": "Palogrande"
    },
    {
        "neabord_id": "276",
        "district_id": "15",
        "code": "21",
        "name": "Pinos"
    },
    {
        "neabord_id": "277",
        "district_id": "15",
        "code": "22",
        "name": "Retoños"
    },
    {
        "neabord_id": "278",
        "district_id": "15",
        "code": "23",
        "name": "Ri­o Jorco"
    },
    {
        "neabord_id": "279",
        "district_id": "15",
        "code": "24",
        "name": "Sabara"
    },
    {
        "neabord_id": "280",
        "district_id": "15",
        "code": "25",
        "name": "San Esteban Rey"
    },
    {
        "neabord_id": "281",
        "district_id": "15",
        "code": "26",
        "name": "San Jerónimo"
    },
    {
        "neabord_id": "282",
        "district_id": "15",
        "code": "27",
        "name": "San Jose"
    },
    {
        "neabord_id": "283",
        "district_id": "15",
        "code": "28",
        "name": "San Roque"
    },
    {
        "neabord_id": "284",
        "district_id": "15",
        "code": "29",
        "name": "Tauros"
    },
    {
        "neabord_id": "285",
        "district_id": "15",
        "code": "30",
        "name": "Torremolinos"
    },
    {
        "neabord_id": "286",
        "district_id": "15",
        "code": "31",
        "name": "Venecia"
    },
    {
        "neabord_id": "287",
        "district_id": "15",
        "code": "32",
        "name": "Vista Verde."
    },
    {
        "neabord_id": "288",
        "district_id": "16",
        "code": "01",
        "name": "angeles"
    },
    {
        "neabord_id": "289",
        "district_id": "16",
        "code": "02",
        "name": "Capri"
    },
    {
        "neabord_id": "290",
        "district_id": "16",
        "code": "03",
        "name": "Damas Israelitas"
    },
    {
        "neabord_id": "291",
        "district_id": "16",
        "code": "04",
        "name": "Girasol"
    },
    {
        "neabord_id": "292",
        "district_id": "16",
        "code": "05",
        "name": "Higuito"
    },
    {
        "neabord_id": "293",
        "district_id": "16",
        "code": "06",
        "name": "Lindavista"
    },
    {
        "neabord_id": "294",
        "district_id": "16",
        "code": "07",
        "name": "Lomas de Jorco"
    },
    {
        "neabord_id": "295",
        "district_id": "16",
        "code": "08",
        "name": "Llano"
    },
    {
        "neabord_id": "296",
        "district_id": "16",
        "code": "09",
        "name": "Meseguer"
    },
    {
        "neabord_id": "297",
        "district_id": "16",
        "code": "10",
        "name": "Olivos"
    },
    {
        "neabord_id": "298",
        "district_id": "16",
        "code": "11",
        "name": "Orqui­deas"
    },
    {
        "neabord_id": "299",
        "district_id": "16",
        "code": "12",
        "name": "Peñascal"
    },
    {
        "neabord_id": "300",
        "district_id": "16",
        "code": "13",
        "name": "Rinconada"
    },
    {
        "neabord_id": "301",
        "district_id": "16",
        "code": "14",
        "name": "Rodillal"
    },
    {
        "neabord_id": "302",
        "district_id": "16",
        "code": "15",
        "name": "Sabanilla"
    },
    {
        "neabord_id": "303",
        "district_id": "16",
        "code": "16",
        "name": "San Marti­n"
    },
    {
        "neabord_id": "304",
        "district_id": "16",
        "code": "17",
        "name": "Santa Eduvigis"
    },
    {
        "neabord_id": "305",
        "district_id": "16",
        "code": "18",
        "name": "Valverde."
    },
    {
        "neabord_id": "306",
        "district_id": "16",
        "code": "19",
        "name": "Alto Alumbre"
    },
    {
        "neabord_id": "307",
        "district_id": "16",
        "code": "20",
        "name": "Hoyo"
    },
    {
        "neabord_id": "308",
        "district_id": "16",
        "code": "21",
        "name": "Jericó"
    },
    {
        "neabord_id": "309",
        "district_id": "16",
        "code": "22",
        "name": "Manzano"
    },
    {
        "neabord_id": "310",
        "district_id": "16",
        "code": "23",
        "name": "Pacaya"
    },
    {
        "neabord_id": "311",
        "district_id": "16",
        "code": "24",
        "name": "Roblar"
    },
    {
        "neabord_id": "312",
        "district_id": "16",
        "code": "25",
        "name": "Ticalpes (parte)"
    },
    {
        "neabord_id": "313",
        "district_id": "16",
        "code": "26",
        "name": "Calle Naranjos."
    },
    {
        "neabord_id": "314",
        "district_id": "17",
        "code": "01",
        "name": "Calabacitas"
    },
    {
        "neabord_id": "315",
        "district_id": "17",
        "code": "02",
        "name": "Calle Comun"
    },
    {
        "neabord_id": "316",
        "district_id": "17",
        "code": "03",
        "name": "Cruz Roja"
    },
    {
        "neabord_id": "317",
        "district_id": "17",
        "code": "04",
        "name": "Itaipu"
    },
    {
        "neabord_id": "318",
        "district_id": "17",
        "code": "05",
        "name": "Maquinas"
    },
    {
        "neabord_id": "319",
        "district_id": "17",
        "code": "06",
        "name": "Mota"
    },
    {
        "neabord_id": "320",
        "district_id": "17",
        "code": "07",
        "name": "Novedades"
    },
    {
        "neabord_id": "321",
        "district_id": "17",
        "code": "08",
        "name": "Pedrito Monge"
    },
    {
        "neabord_id": "322",
        "district_id": "17",
        "code": "09",
        "name": "Ri­o"
    },
    {
        "neabord_id": "323",
        "district_id": "17",
        "code": "10",
        "name": "Robles."
    },
    {
        "neabord_id": "324",
        "district_id": "18",
        "code": "01",
        "name": "Alpino"
    },
    {
        "neabord_id": "325",
        "district_id": "18",
        "code": "02",
        "name": "Arco Iris"
    },
    {
        "neabord_id": "326",
        "district_id": "18",
        "code": "03",
        "name": "Bambu"
    },
    {
        "neabord_id": "327",
        "district_id": "18",
        "code": "04",
        "name": "Berlay"
    },
    {
        "neabord_id": "328",
        "district_id": "18",
        "code": "05",
        "name": "Guaria"
    },
    {
        "neabord_id": "329",
        "district_id": "18",
        "code": "06",
        "name": "Huaso (parte)"
    },
    {
        "neabord_id": "330",
        "district_id": "18",
        "code": "07",
        "name": "Juncales"
    },
    {
        "neabord_id": "331",
        "district_id": "18",
        "code": "08",
        "name": "Lajas"
    },
    {
        "neabord_id": "332",
        "district_id": "18",
        "code": "09",
        "name": "Macarena"
    },
    {
        "neabord_id": "333",
        "district_id": "18",
        "code": "10",
        "name": "Maiqueti­a"
    },
    {
        "neabord_id": "334",
        "district_id": "18",
        "code": "11",
        "name": "Mendez."
    },
    {
        "neabord_id": "335",
        "district_id": "19",
        "code": "01",
        "name": "Acacias"
    },
    {
        "neabord_id": "336",
        "district_id": "19",
        "code": "02",
        "name": "Calle Amador"
    },
    {
        "neabord_id": "337",
        "district_id": "19",
        "code": "03",
        "name": "Constancia"
    },
    {
        "neabord_id": "338",
        "district_id": "19",
        "code": "04",
        "name": "Churuca"
    },
    {
        "neabord_id": "339",
        "district_id": "19",
        "code": "05",
        "name": "Huetares"
    },
    {
        "neabord_id": "340",
        "district_id": "19",
        "code": "06",
        "name": "Plazoleta"
    },
    {
        "neabord_id": "341",
        "district_id": "19",
        "code": "07",
        "name": "Pueblo Nuevo"
    },
    {
        "neabord_id": "342",
        "district_id": "19",
        "code": "08",
        "name": "Ri­o Damas"
    },
    {
        "neabord_id": "343",
        "district_id": "19",
        "code": "09",
        "name": "Rotondas"
    },
    {
        "neabord_id": "344",
        "district_id": "19",
        "code": "10",
        "name": "Solar."
    },
    {
        "neabord_id": "345",
        "district_id": "20",
        "code": "01",
        "name": "Bajos de Tarrazu"
    },
    {
        "neabord_id": "346",
        "district_id": "20",
        "code": "02",
        "name": "Bustamante"
    },
    {
        "neabord_id": "347",
        "district_id": "20",
        "code": "03",
        "name": "Santa Elena (parte)"
    },
    {
        "neabord_id": "348",
        "district_id": "20",
        "code": "04",
        "name": "Violeta."
    },
    {
        "neabord_id": "349",
        "district_id": "21",
        "code": "01",
        "name": "Aguacate"
    },
    {
        "neabord_id": "350",
        "district_id": "21",
        "code": "02",
        "name": "Balneario"
    },
    {
        "neabord_id": "351",
        "district_id": "21",
        "code": "03",
        "name": "Don Bosco"
    },
    {
        "neabord_id": "352",
        "district_id": "21",
        "code": "04",
        "name": "Guatuso"
    },
    {
        "neabord_id": "353",
        "district_id": "21",
        "code": "05",
        "name": "Güi­zaro"
    },
    {
        "neabord_id": "354",
        "district_id": "21",
        "code": "06",
        "name": "Jerusalen"
    },
    {
        "neabord_id": "355",
        "district_id": "21",
        "code": "07",
        "name": "Lince"
    },
    {
        "neabord_id": "356",
        "district_id": "21",
        "code": "08",
        "name": "Mesas"
    },
    {
        "neabord_id": "357",
        "district_id": "21",
        "code": "09",
        "name": "Quebrada Honda"
    },
    {
        "neabord_id": "358",
        "district_id": "21",
        "code": "10",
        "name": "Ticalpes (parte)."
    },
    {
        "neabord_id": "359",
        "district_id": "22",
        "code": "01",
        "name": "Empalme (parte)"
    },
    {
        "neabord_id": "360",
        "district_id": "22",
        "code": "02",
        "name": "Lucha (parte)"
    },
    {
        "neabord_id": "361",
        "district_id": "22",
        "code": "03",
        "name": "San Cristóbal Sur"
    },
    {
        "neabord_id": "362",
        "district_id": "22",
        "code": "04",
        "name": "Sierra."
    },
    {
        "neabord_id": "363",
        "district_id": "23",
        "code": "01",
        "name": "Bajo Tigre"
    },
    {
        "neabord_id": "364",
        "district_id": "23",
        "code": "02",
        "name": "Chirogres"
    },
    {
        "neabord_id": "365",
        "district_id": "23",
        "code": "03",
        "name": "Guadarrama"
    },
    {
        "neabord_id": "366",
        "district_id": "23",
        "code": "04",
        "name": "Joya"
    },
    {
        "neabord_id": "367",
        "district_id": "23",
        "code": "05",
        "name": "La Fila (parte)"
    },
    {
        "neabord_id": "368",
        "district_id": "23",
        "code": "06",
        "name": "Llano bonito"
    },
    {
        "neabord_id": "369",
        "district_id": "23",
        "code": "07",
        "name": "Quebrada Honda"
    },
    {
        "neabord_id": "370",
        "district_id": "23",
        "code": "08",
        "name": "Trinidad (parte)."
    },
    {
        "neabord_id": "371",
        "district_id": "24",
        "code": "01",
        "name": "Cajita"
    },
    {
        "neabord_id": "372",
        "district_id": "24",
        "code": "02",
        "name": "Dorado"
    },
    {
        "neabord_id": "373",
        "district_id": "24",
        "code": "03",
        "name": "Dos Cercas"
    },
    {
        "neabord_id": "374",
        "district_id": "24",
        "code": "04",
        "name": "Fomentera"
    },
    {
        "neabord_id": "375",
        "district_id": "24",
        "code": "05",
        "name": "Nuestra Señora de la Esperanza"
    },
    {
        "neabord_id": "376",
        "district_id": "24",
        "code": "06",
        "name": "San Lorenzo."
    },
    {
        "neabord_id": "377",
        "district_id": "25",
        "code": "01",
        "name": "angeles"
    },
    {
        "neabord_id": "378",
        "district_id": "25",
        "code": "02",
        "name": "Autofores"
    },
    {
        "neabord_id": "379",
        "district_id": "25",
        "code": "03",
        "name": "Balboa"
    },
    {
        "neabord_id": "380",
        "district_id": "25",
        "code": "04",
        "name": "Coopelot"
    },
    {
        "neabord_id": "381",
        "district_id": "25",
        "code": "05",
        "name": "Gardenia"
    },
    {
        "neabord_id": "382",
        "district_id": "25",
        "code": "06",
        "name": "Higuerones"
    },
    {
        "neabord_id": "383",
        "district_id": "25",
        "code": "07",
        "name": "Leo"
    },
    {
        "neabord_id": "384",
        "district_id": "25",
        "code": "08",
        "name": "Mónaco"
    },
    {
        "neabord_id": "385",
        "district_id": "25",
        "code": "09",
        "name": "Sagitario"
    },
    {
        "neabord_id": "386",
        "district_id": "25",
        "code": "10",
        "name": "Santa Cecilia"
    },
    {
        "neabord_id": "387",
        "district_id": "25",
        "code": "11",
        "name": "Tejar (parte)"
    },
    {
        "neabord_id": "388",
        "district_id": "25",
        "code": "12",
        "name": "Treviso"
    },
    {
        "neabord_id": "389",
        "district_id": "25",
        "code": "13",
        "name": "Unidas"
    },
    {
        "neabord_id": "390",
        "district_id": "25",
        "code": "14",
        "name": "Valencia"
    },
    {
        "neabord_id": "391",
        "district_id": "25",
        "code": "15",
        "name": "Vizcaya."
    },
    {
        "neabord_id": "392",
        "district_id": "26",
        "code": "01",
        "name": "Cartonera"
    },
    {
        "neabord_id": "393",
        "district_id": "26",
        "code": "02",
        "name": "Claveles"
    },
    {
        "neabord_id": "394",
        "district_id": "26",
        "code": "03",
        "name": "Damasco"
    },
    {
        "neabord_id": "395",
        "district_id": "26",
        "code": "04",
        "name": "Diamante"
    },
    {
        "neabord_id": "396",
        "district_id": "26",
        "code": "05",
        "name": "Esmeraldas"
    },
    {
        "neabord_id": "397",
        "district_id": "26",
        "code": "06",
        "name": "Fortuna"
    },
    {
        "neabord_id": "398",
        "district_id": "26",
        "code": "07",
        "name": "Fortunita"
    },
    {
        "neabord_id": "399",
        "district_id": "26",
        "code": "08",
        "name": "Porvenir"
    },
    {
        "neabord_id": "400",
        "district_id": "26",
        "code": "09",
        "name": "Raya"
    },
    {
        "neabord_id": "401",
        "district_id": "26",
        "code": "10",
        "name": "Riberalta"
    },
    {
        "neabord_id": "402",
        "district_id": "26",
        "code": "11",
        "name": "Villanueva."
    },
    {
        "neabord_id": "403",
        "district_id": "27",
        "code": "01",
        "name": "Letras"
    },
    {
        "neabord_id": "404",
        "district_id": "27",
        "code": "02",
        "name": "Balcón Verde."
    },
    {
        "neabord_id": "405",
        "district_id": "28",
        "code": "01",
        "name": "angeles"
    },
    {
        "neabord_id": "406",
        "district_id": "28",
        "code": "00",
        "name": "Bajo Badilla"
    },
    {
        "neabord_id": "407",
        "district_id": "28",
        "code": "02",
        "name": "Bajo Moras"
    },
    {
        "neabord_id": "408",
        "district_id": "28",
        "code": "00",
        "name": "Buenos Aires"
    },
    {
        "neabord_id": "409",
        "district_id": "28",
        "code": "03",
        "name": "Cañales Abajo"
    },
    {
        "neabord_id": "410",
        "district_id": "28",
        "code": "00",
        "name": "Corazón de Mari­a"
    },
    {
        "neabord_id": "411",
        "district_id": "28",
        "code": "04",
        "name": "Cañales Arriba"
    },
    {
        "neabord_id": "412",
        "district_id": "28",
        "code": "00",
        "name": "Jarasal"
    },
    {
        "neabord_id": "413",
        "district_id": "28",
        "code": "05",
        "name": "Carit"
    },
    {
        "neabord_id": "414",
        "district_id": "28",
        "code": "00",
        "name": "Junquillo Arriba"
    },
    {
        "neabord_id": "415",
        "district_id": "28",
        "code": "06",
        "name": "Charcón (parte)"
    },
    {
        "neabord_id": "416",
        "district_id": "28",
        "code": "00",
        "name": "Pueblo Nuevo"
    },
    {
        "neabord_id": "417",
        "district_id": "28",
        "code": "07",
        "name": "Cirri­"
    },
    {
        "neabord_id": "418",
        "district_id": "28",
        "code": "00",
        "name": "San Isidro."
    },
    {
        "neabord_id": "419",
        "district_id": "28",
        "code": "08",
        "name": "Junquillo Abajo"
    },
    {
        "neabord_id": "420",
        "district_id": "28",
        "code": "09",
        "name": "Pozos"
    },
    {
        "neabord_id": "421",
        "district_id": "28",
        "code": "10",
        "name": "San Francisco"
    },
    {
        "neabord_id": "422",
        "district_id": "28",
        "code": "11",
        "name": "San Marti­n"
    },
    {
        "neabord_id": "423",
        "district_id": "28",
        "code": "12",
        "name": "Zapote."
    },
    {
        "neabord_id": "424",
        "district_id": "29",
        "code": "01",
        "name": "Alto Palma"
    },
    {
        "neabord_id": "425",
        "district_id": "29",
        "code": "02",
        "name": "Bajo Lanas"
    },
    {
        "neabord_id": "426",
        "district_id": "29",
        "code": "03",
        "name": "Bajo Legua"
    },
    {
        "neabord_id": "427",
        "district_id": "29",
        "code": "04",
        "name": "Bajo Legüita"
    },
    {
        "neabord_id": "428",
        "district_id": "29",
        "code": "05",
        "name": "Bajo Quesada"
    },
    {
        "neabord_id": "429",
        "district_id": "29",
        "code": "06",
        "name": "Bocana"
    },
    {
        "neabord_id": "430",
        "district_id": "29",
        "code": "07",
        "name": "Carmona"
    },
    {
        "neabord_id": "431",
        "district_id": "29",
        "code": "08",
        "name": "Cerbatana"
    },
    {
        "neabord_id": "432",
        "district_id": "29",
        "code": "09",
        "name": "Charquillos"
    },
    {
        "neabord_id": "433",
        "district_id": "29",
        "code": "10",
        "name": "Jilgueral"
    },
    {
        "neabord_id": "434",
        "district_id": "29",
        "code": "11",
        "name": "Llano Grande"
    },
    {
        "neabord_id": "435",
        "district_id": "29",
        "code": "12",
        "name": "Mercedes Norte"
    },
    {
        "neabord_id": "436",
        "district_id": "29",
        "code": "13",
        "name": "Potenciana"
    },
    {
        "neabord_id": "437",
        "district_id": "29",
        "code": "14",
        "name": "Quebrada Honda"
    },
    {
        "neabord_id": "438",
        "district_id": "29",
        "code": "15",
        "name": "Quivel"
    },
    {
        "neabord_id": "439",
        "district_id": "29",
        "code": "16",
        "name": "Rancho Largo"
    },
    {
        "neabord_id": "440",
        "district_id": "29",
        "code": "17",
        "name": "Salitrales"
    },
    {
        "neabord_id": "441",
        "district_id": "29",
        "code": "18",
        "name": "Santa Marta"
    },
    {
        "neabord_id": "442",
        "district_id": "29",
        "code": "19",
        "name": "Tufares"
    },
    {
        "neabord_id": "443",
        "district_id": "29",
        "code": "20",
        "name": "Tuli­n"
    },
    {
        "neabord_id": "444",
        "district_id": "29",
        "code": "21",
        "name": "Vi­bora"
    },
    {
        "neabord_id": "445",
        "district_id": "29",
        "code": "22",
        "name": "Zapotal."
    },
    {
        "neabord_id": "446",
        "district_id": "30",
        "code": "01",
        "name": "Alto Barbacoas"
    },
    {
        "neabord_id": "447",
        "district_id": "30",
        "code": "02",
        "name": "Bajo Burgos"
    },
    {
        "neabord_id": "448",
        "district_id": "30",
        "code": "03",
        "name": "Cortezal"
    },
    {
        "neabord_id": "449",
        "district_id": "30",
        "code": "04",
        "name": "Guatuso"
    },
    {
        "neabord_id": "450",
        "district_id": "30",
        "code": "05",
        "name": "Piedades"
    },
    {
        "neabord_id": "451",
        "district_id": "30",
        "code": "06",
        "name": "San Juan."
    },
    {
        "neabord_id": "452",
        "district_id": "31",
        "code": "01",
        "name": "Cacao"
    },
    {
        "neabord_id": "453",
        "district_id": "31",
        "code": "02",
        "name": "Cuesta Mora"
    },
    {
        "neabord_id": "454",
        "district_id": "31",
        "code": "03",
        "name": "Grifo Bajo"
    },
    {
        "neabord_id": "455",
        "district_id": "31",
        "code": "04",
        "name": "Poró"
    },
    {
        "neabord_id": "456",
        "district_id": "31",
        "code": "05",
        "name": "Pueblo Nuevo"
    },
    {
        "neabord_id": "457",
        "district_id": "31",
        "code": "06",
        "name": "Salitrillo."
    },
    {
        "neabord_id": "458",
        "district_id": "32",
        "code": "01",
        "name": "Bijagual"
    },
    {
        "neabord_id": "459",
        "district_id": "32",
        "code": "02",
        "name": "Floralia"
    },
    {
        "neabord_id": "460",
        "district_id": "32",
        "code": "03",
        "name": "Punta de Lanza"
    },
    {
        "neabord_id": "461",
        "district_id": "32",
        "code": "04",
        "name": "San Rafael Abajo."
    },
    {
        "neabord_id": "462",
        "district_id": "33",
        "code": "01",
        "name": "Alto Cebadilla"
    },
    {
        "neabord_id": "463",
        "district_id": "33",
        "code": "02",
        "name": "Bajo Chacones"
    },
    {
        "neabord_id": "464",
        "district_id": "33",
        "code": "03",
        "name": "Copalar"
    },
    {
        "neabord_id": "465",
        "district_id": "33",
        "code": "04",
        "name": "Pedernal"
    },
    {
        "neabord_id": "466",
        "district_id": "33",
        "code": "05",
        "name": "Polca"
    },
    {
        "neabord_id": "467",
        "district_id": "33",
        "code": "06",
        "name": "Sabanas."
    },
    {
        "neabord_id": "468",
        "district_id": "34",
        "code": "01",
        "name": "Bajo Guevara"
    },
    {
        "neabord_id": "469",
        "district_id": "34",
        "code": "02",
        "name": "Planta"
    },
    {
        "neabord_id": "470",
        "district_id": "34",
        "code": "03",
        "name": "Rinconada."
    },
    {
        "neabord_id": "471",
        "district_id": "35",
        "code": "01",
        "name": "Bajo Herrera"
    },
    {
        "neabord_id": "472",
        "district_id": "35",
        "code": "02",
        "name": "Calle Herrera"
    },
    {
        "neabord_id": "473",
        "district_id": "35",
        "code": "03",
        "name": "Cruce Guanacaste"
    },
    {
        "neabord_id": "474",
        "district_id": "35",
        "code": "04",
        "name": "Charcón (parte)"
    },
    {
        "neabord_id": "475",
        "district_id": "35",
        "code": "05",
        "name": "Estero"
    },
    {
        "neabord_id": "476",
        "district_id": "35",
        "code": "06",
        "name": "Ri­o Viejo"
    },
    {
        "neabord_id": "477",
        "district_id": "35",
        "code": "07",
        "name": "Salitral"
    },
    {
        "neabord_id": "478",
        "district_id": "35",
        "code": "08",
        "name": "Tinamaste."
    },
    {
        "neabord_id": "479",
        "district_id": "36",
        "code": "01",
        "name": "Alto Concepción"
    },
    {
        "neabord_id": "480",
        "district_id": "36",
        "code": "02",
        "name": "Alto Perez Astua"
    },
    {
        "neabord_id": "481",
        "district_id": "36",
        "code": "03",
        "name": "angeles"
    },
    {
        "neabord_id": "482",
        "district_id": "36",
        "code": "04",
        "name": "Angostura (parte)"
    },
    {
        "neabord_id": "483",
        "district_id": "36",
        "code": "05",
        "name": "Arenal"
    },
    {
        "neabord_id": "484",
        "district_id": "36",
        "code": "06",
        "name": "Bajo Chires"
    },
    {
        "neabord_id": "485",
        "district_id": "36",
        "code": "07",
        "name": "Bajo de Guarumal"
    },
    {
        "neabord_id": "486",
        "district_id": "36",
        "code": "08",
        "name": "Bajo el Rey"
    },
    {
        "neabord_id": "487",
        "district_id": "36",
        "code": "09",
        "name": "Bajo Vega"
    },
    {
        "neabord_id": "488",
        "district_id": "36",
        "code": "10",
        "name": "Cerdas"
    },
    {
        "neabord_id": "489",
        "district_id": "36",
        "code": "11",
        "name": "Fila Aguacate"
    },
    {
        "neabord_id": "490",
        "district_id": "36",
        "code": "12",
        "name": "Gamalotillo 1 (Colonia)"
    },
    {
        "neabord_id": "491",
        "district_id": "36",
        "code": "13",
        "name": "Gamalotillo 2 (Gamalotillo)"
    },
    {
        "neabord_id": "492",
        "district_id": "36",
        "code": "14",
        "name": "Gamalotillo 3 (Tierra Fertil)"
    },
    {
        "neabord_id": "493",
        "district_id": "36",
        "code": "15",
        "name": "Gloria"
    },
    {
        "neabord_id": "494",
        "district_id": "36",
        "code": "16",
        "name": "Guarumal"
    },
    {
        "neabord_id": "495",
        "district_id": "36",
        "code": "17",
        "name": "Guarumalito"
    },
    {
        "neabord_id": "496",
        "district_id": "36",
        "code": "18",
        "name": "Mastatal"
    },
    {
        "neabord_id": "497",
        "district_id": "36",
        "code": "19",
        "name": "Pericos"
    },
    {
        "neabord_id": "498",
        "district_id": "36",
        "code": "20",
        "name": "Ri­o Negro (parte)"
    },
    {
        "neabord_id": "499",
        "district_id": "36",
        "code": "21",
        "name": "San Miguel"
    },
    {
        "neabord_id": "500",
        "district_id": "36",
        "code": "22",
        "name": "San Vicente"
    },
    {
        "neabord_id": "501",
        "district_id": "36",
        "code": "23",
        "name": "Santa Rosa"
    },
    {
        "neabord_id": "502",
        "district_id": "36",
        "code": "24",
        "name": "Vista de Mar"
    },
    {
        "neabord_id": "503",
        "district_id": "36",
        "code": "25",
        "name": "Zapatón."
    },
    {
        "neabord_id": "504",
        "district_id": "37",
        "code": "01",
        "name": "Corea"
    },
    {
        "neabord_id": "505",
        "district_id": "37",
        "code": "02",
        "name": "I Griega"
    },
    {
        "neabord_id": "506",
        "district_id": "37",
        "code": "03",
        "name": "Las Tres Mari­as"
    },
    {
        "neabord_id": "507",
        "district_id": "37",
        "code": "04",
        "name": "Santa Cecilia"
    },
    {
        "neabord_id": "508",
        "district_id": "37",
        "code": "05",
        "name": "Rodeo"
    },
    {
        "neabord_id": "509",
        "district_id": "37",
        "code": "06",
        "name": "Sitio."
    },
    {
        "neabord_id": "510",
        "district_id": "37",
        "code": "07",
        "name": "Alto Pastora"
    },
    {
        "neabord_id": "511",
        "district_id": "37",
        "code": "08",
        "name": "Bajo Canet"
    },
    {
        "neabord_id": "512",
        "district_id": "37",
        "code": "09",
        "name": "Bajo San Juan"
    },
    {
        "neabord_id": "513",
        "district_id": "37",
        "code": "10",
        "name": "Canet"
    },
    {
        "neabord_id": "514",
        "district_id": "37",
        "code": "11",
        "name": "Cedral (parte)"
    },
    {
        "neabord_id": "515",
        "district_id": "37",
        "code": "12",
        "name": "Guadalupe"
    },
    {
        "neabord_id": "516",
        "district_id": "37",
        "code": "13",
        "name": "Llano Piedra"
    },
    {
        "neabord_id": "517",
        "district_id": "37",
        "code": "14",
        "name": "San Cayetano"
    },
    {
        "neabord_id": "518",
        "district_id": "37",
        "code": "15",
        "name": "San Guillermo"
    },
    {
        "neabord_id": "519",
        "district_id": "37",
        "code": "16",
        "name": "Sabana (parte)"
    },
    {
        "neabord_id": "520",
        "district_id": "37",
        "code": "17",
        "name": "San Pedro."
    },
    {
        "neabord_id": "521",
        "district_id": "38",
        "code": "01",
        "name": "Alto Guarumal"
    },
    {
        "neabord_id": "522",
        "district_id": "38",
        "code": "02",
        "name": "Alto Portal"
    },
    {
        "neabord_id": "523",
        "district_id": "38",
        "code": "03",
        "name": "Alto Zapotal"
    },
    {
        "neabord_id": "524",
        "district_id": "38",
        "code": "04",
        "name": "Ardilla"
    },
    {
        "neabord_id": "525",
        "district_id": "38",
        "code": "05",
        "name": "Bajo Quebrada Honda"
    },
    {
        "neabord_id": "526",
        "district_id": "38",
        "code": "06",
        "name": "Bajo Reyes"
    },
    {
        "neabord_id": "527",
        "district_id": "38",
        "code": "07",
        "name": "Bajo Zapotal"
    },
    {
        "neabord_id": "528",
        "district_id": "38",
        "code": "08",
        "name": "Cerro Nara"
    },
    {
        "neabord_id": "529",
        "district_id": "38",
        "code": "09",
        "name": "Concepción"
    },
    {
        "neabord_id": "530",
        "district_id": "38",
        "code": "10",
        "name": "Chilamate"
    },
    {
        "neabord_id": "531",
        "district_id": "38",
        "code": "11",
        "name": "Delicias"
    },
    {
        "neabord_id": "532",
        "district_id": "38",
        "code": "12",
        "name": "Esperanza"
    },
    {
        "neabord_id": "533",
        "district_id": "38",
        "code": "13",
        "name": "Esquipulas"
    },
    {
        "neabord_id": "534",
        "district_id": "38",
        "code": "14",
        "name": "La Pacaya"
    },
    {
        "neabord_id": "535",
        "district_id": "38",
        "code": "15",
        "name": "Las Pavas"
    },
    {
        "neabord_id": "536",
        "district_id": "38",
        "code": "16",
        "name": "Mata de Caña"
    },
    {
        "neabord_id": "537",
        "district_id": "38",
        "code": "17",
        "name": "Miramar"
    },
    {
        "neabord_id": "538",
        "district_id": "38",
        "code": "18",
        "name": "Napoles"
    },
    {
        "neabord_id": "539",
        "district_id": "38",
        "code": "19",
        "name": "Naranjillo"
    },
    {
        "neabord_id": "540",
        "district_id": "38",
        "code": "20",
        "name": "Palma"
    },
    {
        "neabord_id": "541",
        "district_id": "38",
        "code": "21",
        "name": "Quebrada Arroyo"
    },
    {
        "neabord_id": "542",
        "district_id": "38",
        "code": "22",
        "name": "Rodeo"
    },
    {
        "neabord_id": "543",
        "district_id": "38",
        "code": "23",
        "name": "Sabana (parte)"
    },
    {
        "neabord_id": "544",
        "district_id": "38",
        "code": "24",
        "name": "Salado"
    },
    {
        "neabord_id": "545",
        "district_id": "38",
        "code": "25",
        "name": "San Bernardo"
    },
    {
        "neabord_id": "546",
        "district_id": "38",
        "code": "26",
        "name": "San Francisco"
    },
    {
        "neabord_id": "547",
        "district_id": "38",
        "code": "27",
        "name": "San Marti­n"
    },
    {
        "neabord_id": "548",
        "district_id": "38",
        "code": "28",
        "name": "Santa Cecilia"
    },
    {
        "neabord_id": "549",
        "district_id": "38",
        "code": "29",
        "name": "Santa Marta"
    },
    {
        "neabord_id": "550",
        "district_id": "38",
        "code": "30",
        "name": "Santa Rosa"
    },
    {
        "neabord_id": "551",
        "district_id": "38",
        "code": "31",
        "name": "Zapotal."
    },
    {
        "neabord_id": "552",
        "district_id": "39",
        "code": "01",
        "name": "Alto Chiral"
    },
    {
        "neabord_id": "553",
        "district_id": "39",
        "code": "02",
        "name": "San Juan (Alto San Juan)"
    },
    {
        "neabord_id": "554",
        "district_id": "39",
        "code": "03",
        "name": "Bajo Jenaro"
    },
    {
        "neabord_id": "555",
        "district_id": "39",
        "code": "04",
        "name": "Bajo San Jose"
    },
    {
        "neabord_id": "556",
        "district_id": "39",
        "code": "05",
        "name": "Jamaica"
    },
    {
        "neabord_id": "557",
        "district_id": "39",
        "code": "06",
        "name": "Quebrada Seca (Santa Ana)"
    },
    {
        "neabord_id": "558",
        "district_id": "39",
        "code": "07",
        "name": "San Jerónimo"
    },
    {
        "neabord_id": "559",
        "district_id": "39",
        "code": "08",
        "name": "San Josecito."
    },
    {
        "neabord_id": "560",
        "district_id": "40",
        "code": "01",
        "name": "Guatuso"
    },
    {
        "neabord_id": "561",
        "district_id": "40",
        "code": "02",
        "name": "Mirador."
    },
    {
        "neabord_id": "562",
        "district_id": "40",
        "code": "03",
        "name": "Alfonso XIII"
    },
    {
        "neabord_id": "563",
        "district_id": "40",
        "code": "04",
        "name": "Barro"
    },
    {
        "neabord_id": "564",
        "district_id": "40",
        "code": "05",
        "name": "Cinco Esquinas (parte)"
    },
    {
        "neabord_id": "565",
        "district_id": "40",
        "code": "06",
        "name": "Corazón de Jesus"
    },
    {
        "neabord_id": "566",
        "district_id": "40",
        "code": "07",
        "name": "Guapinol"
    },
    {
        "neabord_id": "567",
        "district_id": "40",
        "code": "08",
        "name": "Las Mercedes"
    },
    {
        "neabord_id": "568",
        "district_id": "40",
        "code": "09",
        "name": "Lomas de Aserri­"
    },
    {
        "neabord_id": "569",
        "district_id": "40",
        "code": "10",
        "name": "Lourdes"
    },
    {
        "neabord_id": "570",
        "district_id": "40",
        "code": "11",
        "name": "Mari­a Auxiliadora"
    },
    {
        "neabord_id": "571",
        "district_id": "40",
        "code": "12",
        "name": "Mesas"
    },
    {
        "neabord_id": "572",
        "district_id": "40",
        "code": "13",
        "name": "Poas"
    },
    {
        "neabord_id": "573",
        "district_id": "40",
        "code": "14",
        "name": "Santa Rita"
    },
    {
        "neabord_id": "574",
        "district_id": "40",
        "code": "15",
        "name": "Saurez"
    },
    {
        "neabord_id": "575",
        "district_id": "40",
        "code": "16",
        "name": "Tres Mari­as"
    },
    {
        "neabord_id": "576",
        "district_id": "40",
        "code": "17",
        "name": "Vereda."
    },
    {
        "neabord_id": "577",
        "district_id": "41",
        "code": "01",
        "name": "Bajos de Praga"
    },
    {
        "neabord_id": "578",
        "district_id": "41",
        "code": "02",
        "name": "Maquina Vieja"
    },
    {
        "neabord_id": "579",
        "district_id": "41",
        "code": "03",
        "name": "Tigre."
    },
    {
        "neabord_id": "580",
        "district_id": "42",
        "code": "01",
        "name": "Calvario"
    },
    {
        "neabord_id": "581",
        "district_id": "42",
        "code": "02",
        "name": "Ceiba Alta (parte)"
    },
    {
        "neabord_id": "582",
        "district_id": "42",
        "code": "03",
        "name": "Jocotal"
    },
    {
        "neabord_id": "583",
        "district_id": "42",
        "code": "04",
        "name": "Legua de Naranjo"
    },
    {
        "neabord_id": "584",
        "district_id": "42",
        "code": "05",
        "name": "Mangos"
    },
    {
        "neabord_id": "585",
        "district_id": "42",
        "code": "06",
        "name": "Meseta"
    },
    {
        "neabord_id": "586",
        "district_id": "42",
        "code": "07",
        "name": "Monte Redondo"
    },
    {
        "neabord_id": "587",
        "district_id": "42",
        "code": "08",
        "name": "Ojo de Agua"
    },
    {
        "neabord_id": "588",
        "district_id": "42",
        "code": "09",
        "name": "Rosali­a"
    },
    {
        "neabord_id": "589",
        "district_id": "42",
        "code": "10",
        "name": "Uruca."
    },
    {
        "neabord_id": "590",
        "district_id": "43",
        "code": "01",
        "name": "La Fila (parte)"
    },
    {
        "neabord_id": "591",
        "district_id": "43",
        "code": "00",
        "name": "Pueblo Nuevo."
    },
    {
        "neabord_id": "592",
        "district_id": "43",
        "code": "02",
        "name": "Limonal"
    },
    {
        "neabord_id": "593",
        "district_id": "43",
        "code": "03",
        "name": "Los Solano"
    },
    {
        "neabord_id": "594",
        "district_id": "43",
        "code": "04",
        "name": "Rancho Grande"
    },
    {
        "neabord_id": "595",
        "district_id": "43",
        "code": "05",
        "name": "Salitral"
    },
    {
        "neabord_id": "596",
        "district_id": "43",
        "code": "06",
        "name": "Tranquerillas"
    },
    {
        "neabord_id": "597",
        "district_id": "43",
        "code": "07",
        "name": "Trinidad (parte)"
    },
    {
        "neabord_id": "598",
        "district_id": "43",
        "code": "08",
        "name": "Villanueva."
    },
    {
        "neabord_id": "599",
        "district_id": "44",
        "code": "01",
        "name": "Alto Buenavista"
    },
    {
        "neabord_id": "600",
        "district_id": "44",
        "code": "02",
        "name": "Altos del Aguacate"
    },
    {
        "neabord_id": "601",
        "district_id": "44",
        "code": "03",
        "name": "Bajo Bijagual"
    },
    {
        "neabord_id": "602",
        "district_id": "44",
        "code": "04",
        "name": "Bajo Maquinas"
    },
    {
        "neabord_id": "603",
        "district_id": "44",
        "code": "05",
        "name": "Bajo Venegas (parte)"
    },
    {
        "neabord_id": "604",
        "district_id": "44",
        "code": "06",
        "name": "Carmen (parte)."
    },
    {
        "neabord_id": "605",
        "district_id": "45",
        "code": "01",
        "name": "Ojo de Agua (parte)"
    },
    {
        "neabord_id": "606",
        "district_id": "45",
        "code": "02",
        "name": "Portuguez."
    },
    {
        "neabord_id": "607",
        "district_id": "46",
        "code": "01",
        "name": "Cinco Esquinas (parte)"
    },
    {
        "neabord_id": "608",
        "district_id": "46",
        "code": "02",
        "name": "Santa Teresita."
    },
    {
        "neabord_id": "609",
        "district_id": "46",
        "code": "03",
        "name": "Cerro"
    },
    {
        "neabord_id": "610",
        "district_id": "46",
        "code": "04",
        "name": "Cuesta Grande"
    },
    {
        "neabord_id": "611",
        "district_id": "46",
        "code": "05",
        "name": "Guinealillo"
    },
    {
        "neabord_id": "612",
        "district_id": "46",
        "code": "06",
        "name": "Huaso (parte)"
    },
    {
        "neabord_id": "613",
        "district_id": "46",
        "code": "07",
        "name": "Lagunillas"
    },
    {
        "neabord_id": "614",
        "district_id": "46",
        "code": "08",
        "name": "Palo Blanco"
    },
    {
        "neabord_id": "615",
        "district_id": "46",
        "code": "09",
        "name": "Quebradas"
    },
    {
        "neabord_id": "616",
        "district_id": "46",
        "code": "10",
        "name": "Rincón."
    },
    {
        "neabord_id": "617",
        "district_id": "47",
        "code": "01",
        "name": "Alhambra"
    },
    {
        "neabord_id": "618",
        "district_id": "47",
        "code": "00",
        "name": "Cabriola"
    },
    {
        "neabord_id": "619",
        "district_id": "47",
        "code": "02",
        "name": "Brasil"
    },
    {
        "neabord_id": "620",
        "district_id": "47",
        "code": "00",
        "name": "Cedral"
    },
    {
        "neabord_id": "621",
        "district_id": "47",
        "code": "03",
        "name": "Carreras"
    },
    {
        "neabord_id": "622",
        "district_id": "47",
        "code": "00",
        "name": "Cuesta Achiotal"
    },
    {
        "neabord_id": "623",
        "district_id": "47",
        "code": "04",
        "name": "Colonia del Prado"
    },
    {
        "neabord_id": "624",
        "district_id": "47",
        "code": "00",
        "name": "Llano León"
    },
    {
        "neabord_id": "625",
        "district_id": "47",
        "code": "05",
        "name": "Llano Limón"
    },
    {
        "neabord_id": "626",
        "district_id": "47",
        "code": "00",
        "name": "Michoacan"
    },
    {
        "neabord_id": "627",
        "district_id": "47",
        "code": "06",
        "name": "Nuevo Brasil"
    },
    {
        "neabord_id": "628",
        "district_id": "47",
        "code": "00",
        "name": "Quebrada Honda"
    },
    {
        "neabord_id": "629",
        "district_id": "47",
        "code": "07",
        "name": "Piñal"
    },
    {
        "neabord_id": "630",
        "district_id": "47",
        "code": "00",
        "name": "Rodeo"
    },
    {
        "neabord_id": "631",
        "district_id": "47",
        "code": "08",
        "name": "San Bosco"
    },
    {
        "neabord_id": "632",
        "district_id": "47",
        "code": "00",
        "name": "Santi­sima Trinidad"
    },
    {
        "neabord_id": "633",
        "district_id": "47",
        "code": "09",
        "name": "San Vicente"
    },
    {
        "neabord_id": "634",
        "district_id": "47",
        "code": "00",
        "name": "Ticufres."
    },
    {
        "neabord_id": "635",
        "district_id": "47",
        "code": "10",
        "name": "Tablera."
    },
    {
        "neabord_id": "636",
        "district_id": "48",
        "code": "01",
        "name": "Bajo Claras"
    },
    {
        "neabord_id": "637",
        "district_id": "48",
        "code": "02",
        "name": "Bajo Morado"
    },
    {
        "neabord_id": "638",
        "district_id": "48",
        "code": "03",
        "name": "Corrogres"
    },
    {
        "neabord_id": "639",
        "district_id": "48",
        "code": "04",
        "name": "Monte Negro."
    },
    {
        "neabord_id": "640",
        "district_id": "49",
        "code": "01",
        "name": "Bajo Bustamante"
    },
    {
        "neabord_id": "641",
        "district_id": "49",
        "code": "02",
        "name": "Bajo Lima"
    },
    {
        "neabord_id": "642",
        "district_id": "49",
        "code": "03",
        "name": "Bajo Loaiza"
    },
    {
        "neabord_id": "643",
        "district_id": "49",
        "code": "04",
        "name": "Cañas"
    },
    {
        "neabord_id": "644",
        "district_id": "49",
        "code": "05",
        "name": "Corralar"
    },
    {
        "neabord_id": "645",
        "district_id": "49",
        "code": "06",
        "name": "Morado"
    },
    {
        "neabord_id": "646",
        "district_id": "49",
        "code": "07",
        "name": "Piedras Blancas"
    },
    {
        "neabord_id": "647",
        "district_id": "49",
        "code": "08",
        "name": "Salto."
    },
    {
        "neabord_id": "648",
        "district_id": "50",
        "code": "01",
        "name": "Chile"
    },
    {
        "neabord_id": "649",
        "district_id": "50",
        "code": "02",
        "name": "Danta"
    },
    {
        "neabord_id": "650",
        "district_id": "50",
        "code": "03",
        "name": "Palma"
    },
    {
        "neabord_id": "651",
        "district_id": "50",
        "code": "04",
        "name": "Quebrada Grande."
    },
    {
        "neabord_id": "652",
        "district_id": "51",
        "code": "01",
        "name": "Cordel"
    },
    {
        "neabord_id": "653",
        "district_id": "51",
        "code": "02",
        "name": "Chucas"
    },
    {
        "neabord_id": "654",
        "district_id": "51",
        "code": "03",
        "name": "Jateo"
    },
    {
        "neabord_id": "655",
        "district_id": "51",
        "code": "04",
        "name": "Llano Grande"
    },
    {
        "neabord_id": "656",
        "district_id": "51",
        "code": "05",
        "name": "Monte Fri­o (Potrerillos)."
    },
    {
        "neabord_id": "657",
        "district_id": "52",
        "code": "01",
        "name": "Pito."
    },
    {
        "neabord_id": "658",
        "district_id": "53",
        "code": "01",
        "name": "San Juan"
    },
    {
        "neabord_id": "659",
        "district_id": "53",
        "code": "02",
        "name": "San Marti­n"
    },
    {
        "neabord_id": "660",
        "district_id": "53",
        "code": "03",
        "name": "Quebrada Honda."
    },
    {
        "neabord_id": "661",
        "district_id": "54",
        "code": "01",
        "name": "arboles"
    },
    {
        "neabord_id": "662",
        "district_id": "54",
        "code": "02",
        "name": "Colonia del Ri­o"
    },
    {
        "neabord_id": "663",
        "district_id": "54",
        "code": "03",
        "name": "El Alto (parte)"
    },
    {
        "neabord_id": "664",
        "district_id": "54",
        "code": "04",
        "name": "Fatima"
    },
    {
        "neabord_id": "665",
        "district_id": "54",
        "code": "05",
        "name": "Independencia"
    },
    {
        "neabord_id": "666",
        "district_id": "54",
        "code": "06",
        "name": "Jardi­n"
    },
    {
        "neabord_id": "667",
        "district_id": "54",
        "code": "07",
        "name": "Magnolia"
    },
    {
        "neabord_id": "668",
        "district_id": "54",
        "code": "08",
        "name": "Maravilla"
    },
    {
        "neabord_id": "669",
        "district_id": "54",
        "code": "09",
        "name": "Margarita"
    },
    {
        "neabord_id": "670",
        "district_id": "54",
        "code": "10",
        "name": "Minerva"
    },
    {
        "neabord_id": "671",
        "district_id": "54",
        "code": "11",
        "name": "Moreno Cañas"
    },
    {
        "neabord_id": "672",
        "district_id": "54",
        "code": "12",
        "name": "Orqui­dea"
    },
    {
        "neabord_id": "673",
        "district_id": "54",
        "code": "13",
        "name": "Pilar Jimenez"
    },
    {
        "neabord_id": "674",
        "district_id": "54",
        "code": "14",
        "name": "Rothe"
    },
    {
        "neabord_id": "675",
        "district_id": "54",
        "code": "15",
        "name": "San Gerardo"
    },
    {
        "neabord_id": "676",
        "district_id": "54",
        "code": "16",
        "name": "Santa Cecilia"
    },
    {
        "neabord_id": "677",
        "district_id": "54",
        "code": "17",
        "name": "Santa Eduvigis"
    },
    {
        "neabord_id": "678",
        "district_id": "54",
        "code": "18",
        "name": "Santo Cristo"
    },
    {
        "neabord_id": "679",
        "district_id": "54",
        "code": "19",
        "name": "Unión"
    },
    {
        "neabord_id": "680",
        "district_id": "54",
        "code": "20",
        "name": "Yurusti."
    },
    {
        "neabord_id": "681",
        "district_id": "55",
        "code": "01",
        "name": "Carlos Mari­a Ulloa"
    },
    {
        "neabord_id": "682",
        "district_id": "55",
        "code": "02",
        "name": "San Francisco (centro)"
    },
    {
        "neabord_id": "683",
        "district_id": "55",
        "code": "03",
        "name": "Tournón."
    },
    {
        "neabord_id": "684",
        "district_id": "56",
        "code": "01",
        "name": "Calle Blancos (centro)"
    },
    {
        "neabord_id": "685",
        "district_id": "56",
        "code": "02",
        "name": "Cipres"
    },
    {
        "neabord_id": "686",
        "district_id": "56",
        "code": "03",
        "name": "Encanto"
    },
    {
        "neabord_id": "687",
        "district_id": "56",
        "code": "04",
        "name": "Esquivel Bonilla"
    },
    {
        "neabord_id": "688",
        "district_id": "56",
        "code": "05",
        "name": "Montelimar"
    },
    {
        "neabord_id": "689",
        "district_id": "56",
        "code": "06",
        "name": "Pinos"
    },
    {
        "neabord_id": "690",
        "district_id": "56",
        "code": "07",
        "name": "San Antonio"
    },
    {
        "neabord_id": "691",
        "district_id": "56",
        "code": "08",
        "name": "San Gabriel"
    },
    {
        "neabord_id": "692",
        "district_id": "56",
        "code": "09",
        "name": "Santo Tomas"
    },
    {
        "neabord_id": "693",
        "district_id": "56",
        "code": "10",
        "name": "Volio."
    },
    {
        "neabord_id": "694",
        "district_id": "57",
        "code": "01",
        "name": "Bruncas"
    },
    {
        "neabord_id": "695",
        "district_id": "57",
        "code": "02",
        "name": "Carmen"
    },
    {
        "neabord_id": "696",
        "district_id": "57",
        "code": "03",
        "name": "Claraval"
    },
    {
        "neabord_id": "697",
        "district_id": "57",
        "code": "04",
        "name": "Cruz"
    },
    {
        "neabord_id": "698",
        "district_id": "57",
        "code": "05",
        "name": "Cuesta Grande (parte)"
    },
    {
        "neabord_id": "699",
        "district_id": "57",
        "code": "06",
        "name": "Estefana (parte)"
    },
    {
        "neabord_id": "700",
        "district_id": "57",
        "code": "07",
        "name": "Hortensias"
    },
    {
        "neabord_id": "701",
        "district_id": "57",
        "code": "08",
        "name": "Jaboncillal"
    },
    {
        "neabord_id": "702",
        "district_id": "57",
        "code": "09",
        "name": "Jardines de la Paz"
    },
    {
        "neabord_id": "703",
        "district_id": "57",
        "code": "10",
        "name": "Lourdes"
    },
    {
        "neabord_id": "704",
        "district_id": "57",
        "code": "11",
        "name": "Praderas"
    },
    {
        "neabord_id": "705",
        "district_id": "57",
        "code": "12",
        "name": "Tepeyac"
    },
    {
        "neabord_id": "706",
        "district_id": "57",
        "code": "13",
        "name": "Terraba"
    },
    {
        "neabord_id": "707",
        "district_id": "57",
        "code": "14",
        "name": "Villalta"
    },
    {
        "neabord_id": "708",
        "district_id": "57",
        "code": "15",
        "name": "Villaverde"
    },
    {
        "neabord_id": "709",
        "district_id": "57",
        "code": "16",
        "name": "Vista del Valle."
    },
    {
        "neabord_id": "710",
        "district_id": "58",
        "code": "01",
        "name": "angeles"
    },
    {
        "neabord_id": "711",
        "district_id": "58",
        "code": "02",
        "name": "El Alto (parte)"
    },
    {
        "neabord_id": "712",
        "district_id": "58",
        "code": "03",
        "name": "Floresta"
    },
    {
        "neabord_id": "713",
        "district_id": "58",
        "code": "04",
        "name": "Korobó"
    },
    {
        "neabord_id": "714",
        "district_id": "58",
        "code": "05",
        "name": "La Mora"
    },
    {
        "neabord_id": "715",
        "district_id": "58",
        "code": "06",
        "name": "Morita"
    },
    {
        "neabord_id": "716",
        "district_id": "58",
        "code": "07",
        "name": "Mozotal"
    },
    {
        "neabord_id": "717",
        "district_id": "58",
        "code": "08",
        "name": "Nazareno"
    },
    {
        "neabord_id": "718",
        "district_id": "58",
        "code": "09",
        "name": "Orqui­dea"
    },
    {
        "neabord_id": "719",
        "district_id": "58",
        "code": "10",
        "name": "Rodrigo Facio"
    },
    {
        "neabord_id": "720",
        "district_id": "58",
        "code": "11",
        "name": "Santa Clara (parte)"
    },
    {
        "neabord_id": "721",
        "district_id": "58",
        "code": "12",
        "name": "Setillal"
    },
    {
        "neabord_id": "722",
        "district_id": "58",
        "code": "13",
        "name": "Vista del Monte."
    },
    {
        "neabord_id": "723",
        "district_id": "59",
        "code": "01",
        "name": "Mirador."
    },
    {
        "neabord_id": "724",
        "district_id": "59",
        "code": "02",
        "name": "Corralillo"
    },
    {
        "neabord_id": "725",
        "district_id": "59",
        "code": "03",
        "name": "Guayabillos"
    },
    {
        "neabord_id": "726",
        "district_id": "59",
        "code": "04",
        "name": "Isla"
    },
    {
        "neabord_id": "727",
        "district_id": "59",
        "code": "05",
        "name": "San Miguel"
    },
    {
        "neabord_id": "728",
        "district_id": "59",
        "code": "00",
        "name": "Vista de Mar."
    },
    {
        "neabord_id": "729",
        "district_id": "60",
        "code": "01",
        "name": "Ana Frank"
    },
    {
        "neabord_id": "730",
        "district_id": "60",
        "code": "02",
        "name": "Castores"
    },
    {
        "neabord_id": "731",
        "district_id": "60",
        "code": "03",
        "name": "Cuadros"
    },
    {
        "neabord_id": "732",
        "district_id": "60",
        "code": "04",
        "name": "Don Carlos"
    },
    {
        "neabord_id": "733",
        "district_id": "60",
        "code": "05",
        "name": "El Alto (parte)"
    },
    {
        "neabord_id": "734",
        "district_id": "60",
        "code": "06",
        "name": "Flor de Liz"
    },
    {
        "neabord_id": "735",
        "district_id": "60",
        "code": "07",
        "name": "Kuru"
    },
    {
        "neabord_id": "736",
        "district_id": "60",
        "code": "08",
        "name": "Lomas de Tepeyac"
    },
    {
        "neabord_id": "737",
        "district_id": "60",
        "code": "09",
        "name": "Lupita"
    },
    {
        "neabord_id": "738",
        "district_id": "60",
        "code": "10",
        "name": "Montesol"
    },
    {
        "neabord_id": "739",
        "district_id": "60",
        "code": "11",
        "name": "Nogales"
    },
    {
        "neabord_id": "740",
        "district_id": "60",
        "code": "12",
        "name": "Pueblo"
    },
    {
        "neabord_id": "741",
        "district_id": "60",
        "code": "13",
        "name": "Violetas."
    },
    {
        "neabord_id": "742",
        "district_id": "61",
        "code": "01",
        "name": "Aguas Lindas"
    },
    {
        "neabord_id": "743",
        "district_id": "61",
        "code": "02",
        "name": "Cabañas"
    },
    {
        "neabord_id": "744",
        "district_id": "61",
        "code": "03",
        "name": "Casa Blanca"
    },
    {
        "neabord_id": "745",
        "district_id": "61",
        "code": "04",
        "name": "Lajas (parte)"
    },
    {
        "neabord_id": "746",
        "district_id": "61",
        "code": "05",
        "name": "Obando"
    },
    {
        "neabord_id": "747",
        "district_id": "61",
        "code": "06",
        "name": "Paso Machete (parte)"
    },
    {
        "neabord_id": "748",
        "district_id": "61",
        "code": "07",
        "name": "San Rafael."
    },
    {
        "neabord_id": "749",
        "district_id": "61",
        "code": "08",
        "name": "Corrogres"
    },
    {
        "neabord_id": "750",
        "district_id": "61",
        "code": "09",
        "name": "Pilas."
    },
    {
        "neabord_id": "751",
        "district_id": "62",
        "code": "01",
        "name": "Paso Machete (parte)"
    },
    {
        "neabord_id": "752",
        "district_id": "62",
        "code": "02",
        "name": "Robalillo."
    },
    {
        "neabord_id": "753",
        "district_id": "62",
        "code": "03",
        "name": "Alto Raicero"
    },
    {
        "neabord_id": "754",
        "district_id": "62",
        "code": "04",
        "name": "Chirracal"
    },
    {
        "neabord_id": "755",
        "district_id": "62",
        "code": "05",
        "name": "Matinilla"
    },
    {
        "neabord_id": "756",
        "district_id": "62",
        "code": "06",
        "name": "Pabellón"
    },
    {
        "neabord_id": "757",
        "district_id": "62",
        "code": "07",
        "name": "Perico."
    },
    {
        "neabord_id": "758",
        "district_id": "63",
        "code": "01",
        "name": "Alto Palomas"
    },
    {
        "neabord_id": "759",
        "district_id": "63",
        "code": "02",
        "name": "Concepción"
    },
    {
        "neabord_id": "760",
        "district_id": "63",
        "code": "03",
        "name": "Cuevas"
    },
    {
        "neabord_id": "761",
        "district_id": "63",
        "code": "04",
        "name": "Chispa"
    },
    {
        "neabord_id": "762",
        "district_id": "63",
        "code": "05",
        "name": "Gavilanes"
    },
    {
        "neabord_id": "763",
        "district_id": "63",
        "code": "06",
        "name": "Honduras"
    },
    {
        "neabord_id": "764",
        "district_id": "63",
        "code": "07",
        "name": "Lajas (parte)"
    },
    {
        "neabord_id": "765",
        "district_id": "63",
        "code": "08",
        "name": "Lindora"
    },
    {
        "neabord_id": "766",
        "district_id": "63",
        "code": "09",
        "name": "Manantial"
    },
    {
        "neabord_id": "767",
        "district_id": "63",
        "code": "10",
        "name": "Real de Pereira (parte)"
    },
    {
        "neabord_id": "768",
        "district_id": "63",
        "code": "11",
        "name": "Valle del sol."
    },
    {
        "neabord_id": "769",
        "district_id": "64",
        "code": "01",
        "name": "Chimba"
    },
    {
        "neabord_id": "770",
        "district_id": "64",
        "code": "02",
        "name": "Guapinol"
    },
    {
        "neabord_id": "771",
        "district_id": "64",
        "code": "03",
        "name": "Mata Grande"
    },
    {
        "neabord_id": "772",
        "district_id": "64",
        "code": "04",
        "name": "Mina"
    },
    {
        "neabord_id": "773",
        "district_id": "64",
        "code": "05",
        "name": "Paso Machete (parte)"
    },
    {
        "neabord_id": "774",
        "district_id": "64",
        "code": "06",
        "name": "Ri­o Uruca."
    },
    {
        "neabord_id": "775",
        "district_id": "65",
        "code": "01",
        "name": "Caraña"
    },
    {
        "neabord_id": "776",
        "district_id": "65",
        "code": "02",
        "name": "Cebadilla"
    },
    {
        "neabord_id": "777",
        "district_id": "65",
        "code": "03",
        "name": "Finquitas"
    },
    {
        "neabord_id": "778",
        "district_id": "65",
        "code": "04",
        "name": "Montaña del Sol"
    },
    {
        "neabord_id": "779",
        "district_id": "65",
        "code": "05",
        "name": "Rincón San Marcos"
    },
    {
        "neabord_id": "780",
        "district_id": "65",
        "code": "06",
        "name": "Triunfo."
    },
    {
        "neabord_id": "781",
        "district_id": "66",
        "code": "01",
        "name": "Canjel"
    },
    {
        "neabord_id": "782",
        "district_id": "66",
        "code": "02",
        "name": "Copey."
    },
    {
        "neabord_id": "783",
        "district_id": "67",
        "code": "01",
        "name": "Bellavista"
    },
    {
        "neabord_id": "784",
        "district_id": "67",
        "code": "02",
        "name": "Chorotega"
    },
    {
        "neabord_id": "785",
        "district_id": "67",
        "code": "03",
        "name": "Lagunilla"
    },
    {
        "neabord_id": "786",
        "district_id": "67",
        "code": "04",
        "name": "Macha"
    },
    {
        "neabord_id": "787",
        "district_id": "67",
        "code": "05",
        "name": "Madrigal."
    },
    {
        "neabord_id": "788",
        "district_id": "68",
        "code": "01",
        "name": "Aguilar Machado"
    },
    {
        "neabord_id": "789",
        "district_id": "68",
        "code": "02",
        "name": "Cochea"
    },
    {
        "neabord_id": "790",
        "district_id": "68",
        "code": "03",
        "name": "El Alto"
    },
    {
        "neabord_id": "791",
        "district_id": "68",
        "code": "04",
        "name": "Faro del Suroeste"
    },
    {
        "neabord_id": "792",
        "district_id": "68",
        "code": "05",
        "name": "Filtros"
    },
    {
        "neabord_id": "793",
        "district_id": "68",
        "code": "06",
        "name": "Pueblo Escondido"
    },
    {
        "neabord_id": "794",
        "district_id": "68",
        "code": "07",
        "name": "Vistas de Alajuelita."
    },
    {
        "neabord_id": "795",
        "district_id": "69",
        "code": "01",
        "name": "Caracas"
    },
    {
        "neabord_id": "796",
        "district_id": "69",
        "code": "02",
        "name": "Cascabela"
    },
    {
        "neabord_id": "797",
        "district_id": "69",
        "code": "03",
        "name": "Llano"
    },
    {
        "neabord_id": "798",
        "district_id": "69",
        "code": "04",
        "name": "Piedra de fuego."
    },
    {
        "neabord_id": "799",
        "district_id": "69",
        "code": "05",
        "name": "Lamparas."
    },
    {
        "neabord_id": "800",
        "district_id": "70",
        "code": "01",
        "name": "Almendros"
    },
    {
        "neabord_id": "801",
        "district_id": "70",
        "code": "02",
        "name": "Boca del Monte"
    },
    {
        "neabord_id": "802",
        "district_id": "70",
        "code": "03",
        "name": "Chirivico"
    },
    {
        "neabord_id": "803",
        "district_id": "70",
        "code": "04",
        "name": "Monte Alto"
    },
    {
        "neabord_id": "804",
        "district_id": "70",
        "code": "05",
        "name": "Once de Abril"
    },
    {
        "neabord_id": "805",
        "district_id": "70",
        "code": "06",
        "name": "Progreso"
    },
    {
        "neabord_id": "806",
        "district_id": "70",
        "code": "07",
        "name": "Tejar (parte)"
    },
    {
        "neabord_id": "807",
        "district_id": "70",
        "code": "08",
        "name": "Vista de San Jose"
    },
    {
        "neabord_id": "808",
        "district_id": "70",
        "code": "09",
        "name": "Vista Real."
    },
    {
        "neabord_id": "809",
        "district_id": "71",
        "code": "01",
        "name": "Aurora"
    },
    {
        "neabord_id": "810",
        "district_id": "71",
        "code": "02",
        "name": "Corina Rodri­guez"
    },
    {
        "neabord_id": "811",
        "district_id": "71",
        "code": "03",
        "name": "Esquipulas Dos"
    },
    {
        "neabord_id": "812",
        "district_id": "71",
        "code": "04",
        "name": "La Guapil"
    },
    {
        "neabord_id": "813",
        "district_id": "71",
        "code": "05",
        "name": "Peralta"
    },
    {
        "neabord_id": "814",
        "district_id": "71",
        "code": "06",
        "name": "Verbena."
    },
    {
        "neabord_id": "815",
        "district_id": "71",
        "code": "07",
        "name": "Palo Campano."
    },
    {
        "neabord_id": "816",
        "district_id": "72",
        "code": "01",
        "name": "Alamos"
    },
    {
        "neabord_id": "817",
        "district_id": "72",
        "code": "02",
        "name": "Alpes"
    },
    {
        "neabord_id": "818",
        "district_id": "72",
        "code": "03",
        "name": "Arias"
    },
    {
        "neabord_id": "819",
        "district_id": "72",
        "code": "04",
        "name": "Brisa"
    },
    {
        "neabord_id": "820",
        "district_id": "72",
        "code": "05",
        "name": "Cedros"
    },
    {
        "neabord_id": "821",
        "district_id": "72",
        "code": "06",
        "name": "Corazón de Jesus"
    },
    {
        "neabord_id": "822",
        "district_id": "72",
        "code": "07",
        "name": "Durazno"
    },
    {
        "neabord_id": "823",
        "district_id": "72",
        "code": "08",
        "name": "Girasoles (parte)"
    },
    {
        "neabord_id": "824",
        "district_id": "72",
        "code": "09",
        "name": "Huacas"
    },
    {
        "neabord_id": "825",
        "district_id": "72",
        "code": "10",
        "name": "Magnolias"
    },
    {
        "neabord_id": "826",
        "district_id": "72",
        "code": "11",
        "name": "Mercedes"
    },
    {
        "neabord_id": "827",
        "district_id": "72",
        "code": "12",
        "name": "Monte Azul"
    },
    {
        "neabord_id": "828",
        "district_id": "72",
        "code": "13",
        "name": "San Francisco"
    },
    {
        "neabord_id": "829",
        "district_id": "72",
        "code": "14",
        "name": "San Marti­n"
    },
    {
        "neabord_id": "830",
        "district_id": "72",
        "code": "15",
        "name": "Villa Solidarista."
    },
    {
        "neabord_id": "831",
        "district_id": "73",
        "code": "01",
        "name": "Fanguillo"
    },
    {
        "neabord_id": "832",
        "district_id": "73",
        "code": "02",
        "name": "I Griega"
    },
    {
        "neabord_id": "833",
        "district_id": "73",
        "code": "03",
        "name": "Loma Bonita"
    },
    {
        "neabord_id": "834",
        "district_id": "73",
        "code": "04",
        "name": "Nubes"
    },
    {
        "neabord_id": "835",
        "district_id": "73",
        "code": "05",
        "name": "Patio de Agua"
    },
    {
        "neabord_id": "836",
        "district_id": "73",
        "code": "06",
        "name": "Villa Emaus."
    },
    {
        "neabord_id": "837",
        "district_id": "74",
        "code": "01",
        "name": "Calera"
    },
    {
        "neabord_id": "838",
        "district_id": "74",
        "code": "02",
        "name": "Carmen"
    },
    {
        "neabord_id": "839",
        "district_id": "74",
        "code": "03",
        "name": "Gemelas"
    },
    {
        "neabord_id": "840",
        "district_id": "74",
        "code": "04",
        "name": "Josue"
    },
    {
        "neabord_id": "841",
        "district_id": "74",
        "code": "05",
        "name": "Manzanos"
    },
    {
        "neabord_id": "842",
        "district_id": "74",
        "code": "06",
        "name": "Murtal"
    },
    {
        "neabord_id": "843",
        "district_id": "74",
        "code": "07",
        "name": "Sitrae"
    },
    {
        "neabord_id": "844",
        "district_id": "74",
        "code": "08",
        "name": "Valle Feli­z."
    },
    {
        "neabord_id": "845",
        "district_id": "74",
        "code": "09",
        "name": "Alto Palma (parte)"
    },
    {
        "neabord_id": "846",
        "district_id": "74",
        "code": "10",
        "name": "Platanares"
    },
    {
        "neabord_id": "847",
        "district_id": "74",
        "code": "11",
        "name": "Rodeo (parte)."
    },
    {
        "neabord_id": "848",
        "district_id": "75",
        "code": "01",
        "name": "Cornelia"
    },
    {
        "neabord_id": "849",
        "district_id": "75",
        "code": "02",
        "name": "Girasoles (parte)"
    },
    {
        "neabord_id": "850",
        "district_id": "75",
        "code": "03",
        "name": "Horizontes"
    },
    {
        "neabord_id": "851",
        "district_id": "75",
        "code": "04",
        "name": "Irazu"
    },
    {
        "neabord_id": "852",
        "district_id": "75",
        "code": "05",
        "name": "Jardines"
    },
    {
        "neabord_id": "853",
        "district_id": "75",
        "code": "06",
        "name": "Labrador"
    },
    {
        "neabord_id": "854",
        "district_id": "75",
        "code": "07",
        "name": "Patalillo"
    },
    {
        "neabord_id": "855",
        "district_id": "75",
        "code": "08",
        "name": "Santa Marta"
    },
    {
        "neabord_id": "856",
        "district_id": "75",
        "code": "09",
        "name": "Trapiche"
    },
    {
        "neabord_id": "857",
        "district_id": "75",
        "code": "10",
        "name": "Villalinda"
    },
    {
        "neabord_id": "858",
        "district_id": "75",
        "code": "11",
        "name": "Villanova."
    },
    {
        "neabord_id": "859",
        "district_id": "76",
        "code": "01",
        "name": "Aviles"
    },
    {
        "neabord_id": "860",
        "district_id": "76",
        "code": "02",
        "name": "Cerro Indio"
    },
    {
        "neabord_id": "861",
        "district_id": "76",
        "code": "03",
        "name": "Guaba"
    },
    {
        "neabord_id": "862",
        "district_id": "76",
        "code": "04",
        "name": "Rojizo"
    },
    {
        "neabord_id": "863",
        "district_id": "76",
        "code": "05",
        "name": "Sinai­."
    },
    {
        "neabord_id": "864",
        "district_id": "76",
        "code": "06",
        "name": "Canoa"
    },
    {
        "neabord_id": "865",
        "district_id": "76",
        "code": "07",
        "name": "Cascajal"
    },
    {
        "neabord_id": "866",
        "district_id": "76",
        "code": "08",
        "name": "Choco"
    },
    {
        "neabord_id": "867",
        "district_id": "76",
        "code": "09",
        "name": "Isla"
    },
    {
        "neabord_id": "868",
        "district_id": "76",
        "code": "10",
        "name": "Monserrat"
    },
    {
        "neabord_id": "869",
        "district_id": "76",
        "code": "11",
        "name": "Patillos"
    },
    {
        "neabord_id": "870",
        "district_id": "76",
        "code": "12",
        "name": "Rodeo (parte)"
    },
    {
        "neabord_id": "871",
        "district_id": "76",
        "code": "13",
        "name": "Santa Rita de Casia"
    },
    {
        "neabord_id": "872",
        "district_id": "76",
        "code": "14",
        "name": "Tierras Morenas"
    },
    {
        "neabord_id": "873",
        "district_id": "76",
        "code": "15",
        "name": "Vegas de Cajón"
    },
    {
        "neabord_id": "874",
        "district_id": "76",
        "code": "16",
        "name": "Venita."
    },
    {
        "neabord_id": "875",
        "district_id": "77",
        "code": "01",
        "name": "Abarca"
    },
    {
        "neabord_id": "876",
        "district_id": "77",
        "code": "02",
        "name": "Corral"
    },
    {
        "neabord_id": "877",
        "district_id": "77",
        "code": "03",
        "name": "Mari­a Auxiliadora"
    },
    {
        "neabord_id": "878",
        "district_id": "77",
        "code": "04",
        "name": "Ortiga"
    },
    {
        "neabord_id": "879",
        "district_id": "77",
        "code": "05",
        "name": "Pozos"
    },
    {
        "neabord_id": "880",
        "district_id": "77",
        "code": "06",
        "name": "San Marti­n (San Gerardo)"
    },
    {
        "neabord_id": "881",
        "district_id": "77",
        "code": "07",
        "name": "San Luis"
    },
    {
        "neabord_id": "882",
        "district_id": "77",
        "code": "08",
        "name": "Turrujal"
    },
    {
        "neabord_id": "883",
        "district_id": "77",
        "code": "09",
        "name": "Vereda."
    },
    {
        "neabord_id": "884",
        "district_id": "77",
        "code": "10",
        "name": "Aguablanca (parte)"
    },
    {
        "neabord_id": "885",
        "district_id": "77",
        "code": "11",
        "name": "Alto Escalera"
    },
    {
        "neabord_id": "886",
        "district_id": "77",
        "code": "12",
        "name": "Alto Los Mora"
    },
    {
        "neabord_id": "887",
        "district_id": "77",
        "code": "13",
        "name": "angeles"
    },
    {
        "neabord_id": "888",
        "district_id": "77",
        "code": "14",
        "name": "Chirraca (parte)"
    },
    {
        "neabord_id": "889",
        "district_id": "77",
        "code": "15",
        "name": "Esperanza"
    },
    {
        "neabord_id": "890",
        "district_id": "77",
        "code": "16",
        "name": "Potrerillos"
    },
    {
        "neabord_id": "891",
        "district_id": "77",
        "code": "17",
        "name": "Resbalón"
    },
    {
        "neabord_id": "892",
        "district_id": "77",
        "code": "18",
        "name": "Tablazo."
    },
    {
        "neabord_id": "893",
        "district_id": "78",
        "code": "01",
        "name": "Alto Sierra"
    },
    {
        "neabord_id": "894",
        "district_id": "78",
        "code": "02",
        "name": "Alto Vigi­a"
    },
    {
        "neabord_id": "895",
        "district_id": "78",
        "code": "03",
        "name": "Bajo Arias"
    },
    {
        "neabord_id": "896",
        "district_id": "78",
        "code": "04",
        "name": "Bajo Bermudez"
    },
    {
        "neabord_id": "897",
        "district_id": "78",
        "code": "05",
        "name": "Bajo Calvo"
    },
    {
        "neabord_id": "898",
        "district_id": "78",
        "code": "06",
        "name": "Bajo Cardenas"
    },
    {
        "neabord_id": "899",
        "district_id": "78",
        "code": "07",
        "name": "Bajo Moras"
    },
    {
        "neabord_id": "900",
        "district_id": "78",
        "code": "08",
        "name": "Coyolar"
    },
    {
        "neabord_id": "901",
        "district_id": "78",
        "code": "09",
        "name": "Hondonada"
    },
    {
        "neabord_id": "902",
        "district_id": "78",
        "code": "10",
        "name": "La Cruz"
    },
    {
        "neabord_id": "903",
        "district_id": "78",
        "code": "11",
        "name": "Lagunillas (parte)"
    },
    {
        "neabord_id": "904",
        "district_id": "78",
        "code": "12",
        "name": "Ococa"
    },
    {
        "neabord_id": "905",
        "district_id": "78",
        "code": "13",
        "name": "Toledo"
    },
    {
        "neabord_id": "906",
        "district_id": "78",
        "code": "14",
        "name": "Zapote."
    },
    {
        "neabord_id": "907",
        "district_id": "79",
        "code": "01",
        "name": "San Pablo"
    },
    {
        "neabord_id": "908",
        "district_id": "79",
        "code": "02",
        "name": "Agua Blanca (parte)"
    },
    {
        "neabord_id": "909",
        "district_id": "79",
        "code": "03",
        "name": "Bajo Cerdas"
    },
    {
        "neabord_id": "910",
        "district_id": "79",
        "code": "04",
        "name": "Bajos de Jorco"
    },
    {
        "neabord_id": "911",
        "district_id": "79",
        "code": "05",
        "name": "Boli­var"
    },
    {
        "neabord_id": "912",
        "district_id": "79",
        "code": "06",
        "name": "Cañadas"
    },
    {
        "neabord_id": "913",
        "district_id": "79",
        "code": "07",
        "name": "Caragral"
    },
    {
        "neabord_id": "914",
        "district_id": "79",
        "code": "08",
        "name": "Corazón de Jesus"
    },
    {
        "neabord_id": "915",
        "district_id": "79",
        "code": "09",
        "name": "Charcalillo"
    },
    {
        "neabord_id": "916",
        "district_id": "79",
        "code": "10",
        "name": "Chirraca (parte)"
    },
    {
        "neabord_id": "917",
        "district_id": "79",
        "code": "11",
        "name": "Fila"
    },
    {
        "neabord_id": "918",
        "district_id": "79",
        "code": "12",
        "name": "Jaular"
    },
    {
        "neabord_id": "919",
        "district_id": "79",
        "code": "13",
        "name": "Lagunillas (parte)"
    },
    {
        "neabord_id": "920",
        "district_id": "79",
        "code": "14",
        "name": "La Mina"
    },
    {
        "neabord_id": "921",
        "district_id": "79",
        "code": "15",
        "name": "La Pita"
    },
    {
        "neabord_id": "922",
        "district_id": "79",
        "code": "16",
        "name": "Los Monge"
    },
    {
        "neabord_id": "923",
        "district_id": "79",
        "code": "17",
        "name": "Playa"
    },
    {
        "neabord_id": "924",
        "district_id": "79",
        "code": "18",
        "name": "San Pablo"
    },
    {
        "neabord_id": "925",
        "district_id": "79",
        "code": "19",
        "name": "Sevilla."
    },
    {
        "neabord_id": "926",
        "district_id": "80",
        "code": "01",
        "name": "Bajo Los Cruces"
    },
    {
        "neabord_id": "927",
        "district_id": "80",
        "code": "02",
        "name": "Ceiba Alta (parte)"
    },
    {
        "neabord_id": "928",
        "district_id": "80",
        "code": "03",
        "name": "Ceiba Baja"
    },
    {
        "neabord_id": "929",
        "district_id": "80",
        "code": "04",
        "name": "Ceiba Este"
    },
    {
        "neabord_id": "930",
        "district_id": "80",
        "code": "05",
        "name": "Escuadra"
    },
    {
        "neabord_id": "931",
        "district_id": "80",
        "code": "06",
        "name": "Gravilias"
    },
    {
        "neabord_id": "932",
        "district_id": "80",
        "code": "07",
        "name": "Lindavista"
    },
    {
        "neabord_id": "933",
        "district_id": "80",
        "code": "08",
        "name": "Llano Bonito"
    },
    {
        "neabord_id": "934",
        "district_id": "80",
        "code": "09",
        "name": "Mesa"
    },
    {
        "neabord_id": "935",
        "district_id": "80",
        "code": "10",
        "name": "Naranjal"
    },
    {
        "neabord_id": "936",
        "district_id": "80",
        "code": "11",
        "name": "Perpetuo Socorro"
    },
    {
        "neabord_id": "937",
        "district_id": "80",
        "code": "12",
        "name": "Tejar"
    },
    {
        "neabord_id": "938",
        "district_id": "80",
        "code": "13",
        "name": "Tiquires."
    },
    {
        "neabord_id": "939",
        "district_id": "81",
        "code": "01",
        "name": "Alto Parritón"
    },
    {
        "neabord_id": "940",
        "district_id": "81",
        "code": "02",
        "name": "Bajo Palma"
    },
    {
        "neabord_id": "941",
        "district_id": "81",
        "code": "03",
        "name": "Bajo Perez"
    },
    {
        "neabord_id": "942",
        "district_id": "81",
        "code": "04",
        "name": "Bijagual"
    },
    {
        "neabord_id": "943",
        "district_id": "81",
        "code": "05",
        "name": "Breñón"
    },
    {
        "neabord_id": "944",
        "district_id": "81",
        "code": "06",
        "name": "Caspirola"
    },
    {
        "neabord_id": "945",
        "district_id": "81",
        "code": "07",
        "name": "Colorado"
    },
    {
        "neabord_id": "946",
        "district_id": "81",
        "code": "08",
        "name": "Cuesta Aguacate"
    },
    {
        "neabord_id": "947",
        "district_id": "81",
        "code": "09",
        "name": "Limas"
    },
    {
        "neabord_id": "948",
        "district_id": "81",
        "code": "10",
        "name": "Parritón"
    },
    {
        "neabord_id": "949",
        "district_id": "81",
        "code": "11",
        "name": "Plomo"
    },
    {
        "neabord_id": "950",
        "district_id": "81",
        "code": "12",
        "name": "Sabanas"
    },
    {
        "neabord_id": "951",
        "district_id": "81",
        "code": "13",
        "name": "San Jerónimo"
    },
    {
        "neabord_id": "952",
        "district_id": "81",
        "code": "14",
        "name": "Soledad"
    },
    {
        "neabord_id": "953",
        "district_id": "81",
        "code": "15",
        "name": "Teruel"
    },
    {
        "neabord_id": "954",
        "district_id": "81",
        "code": "16",
        "name": "Tiquiritos"
    },
    {
        "neabord_id": "955",
        "district_id": "81",
        "code": "17",
        "name": "Uruca"
    },
    {
        "neabord_id": "956",
        "district_id": "81",
        "code": "18",
        "name": "Zoncuano."
    },
    {
        "neabord_id": "957",
        "district_id": "82",
        "code": "01",
        "name": "Acacias"
    },
    {
        "neabord_id": "958",
        "district_id": "82",
        "code": "02",
        "name": "Arboleda"
    },
    {
        "neabord_id": "959",
        "district_id": "82",
        "code": "03",
        "name": "Asturias"
    },
    {
        "neabord_id": "960",
        "district_id": "82",
        "code": "04",
        "name": "Estudiantes"
    },
    {
        "neabord_id": "961",
        "district_id": "82",
        "code": "05",
        "name": "Florida"
    },
    {
        "neabord_id": "962",
        "district_id": "82",
        "code": "06",
        "name": "Gonzalez Truque"
    },
    {
        "neabord_id": "963",
        "district_id": "82",
        "code": "07",
        "name": "Jesus Jimenez Zamora"
    },
    {
        "neabord_id": "964",
        "district_id": "82",
        "code": "08",
        "name": "Lindavista"
    },
    {
        "neabord_id": "965",
        "district_id": "82",
        "code": "09",
        "name": "Rosas"
    },
    {
        "neabord_id": "966",
        "district_id": "82",
        "code": "10",
        "name": "San Jerónimo"
    },
    {
        "neabord_id": "967",
        "district_id": "82",
        "code": "11",
        "name": "Santa Eduvigis"
    },
    {
        "neabord_id": "968",
        "district_id": "82",
        "code": "12",
        "name": "Valle"
    },
    {
        "neabord_id": "969",
        "district_id": "82",
        "code": "13",
        "name": "Versalles"
    },
    {
        "neabord_id": "970",
        "district_id": "82",
        "code": "14",
        "name": "Villafranca"
    },
    {
        "neabord_id": "971",
        "district_id": "82",
        "code": "15",
        "name": "Virginia."
    },
    {
        "neabord_id": "972",
        "district_id": "83",
        "code": "01",
        "name": "Bajo Piuses"
    },
    {
        "neabord_id": "973",
        "district_id": "83",
        "code": "02",
        "name": "Copey"
    },
    {
        "neabord_id": "974",
        "district_id": "83",
        "code": "03",
        "name": "Leiva Urcuyo"
    },
    {
        "neabord_id": "975",
        "district_id": "83",
        "code": "04",
        "name": "Lilas"
    },
    {
        "neabord_id": "976",
        "district_id": "83",
        "code": "05",
        "name": "Lomas del Pinar"
    },
    {
        "neabord_id": "977",
        "district_id": "83",
        "code": "06",
        "name": "Montecarlo"
    },
    {
        "neabord_id": "978",
        "district_id": "83",
        "code": "07",
        "name": "Santa Teresa."
    },
    {
        "neabord_id": "979",
        "district_id": "84",
        "code": "01",
        "name": "Apolo"
    },
    {
        "neabord_id": "980",
        "district_id": "84",
        "code": "02",
        "name": "Dalia"
    },
    {
        "neabord_id": "981",
        "district_id": "84",
        "code": "03",
        "name": "Estancia"
    },
    {
        "neabord_id": "982",
        "district_id": "84",
        "code": "04",
        "name": "Fletcher"
    },
    {
        "neabord_id": "983",
        "district_id": "84",
        "code": "05",
        "name": "Franjo"
    },
    {
        "neabord_id": "984",
        "district_id": "84",
        "code": "06",
        "name": "Jardines de Tibas"
    },
    {
        "neabord_id": "985",
        "district_id": "84",
        "code": "07",
        "name": "Jardines La Trinidad"
    },
    {
        "neabord_id": "986",
        "district_id": "84",
        "code": "08",
        "name": "Monterreal"
    },
    {
        "neabord_id": "987",
        "district_id": "84",
        "code": "09",
        "name": "Palmeras"
    },
    {
        "neabord_id": "988",
        "district_id": "84",
        "code": "10",
        "name": "Santa Mónica"
    },
    {
        "neabord_id": "989",
        "district_id": "84",
        "code": "11",
        "name": "Talamanca"
    },
    {
        "neabord_id": "990",
        "district_id": "84",
        "code": "12",
        "name": "Vergel."
    },
    {
        "neabord_id": "991",
        "district_id": "85",
        "code": "01",
        "name": "Doña Fabiola"
    },
    {
        "neabord_id": "992",
        "district_id": "85",
        "code": "02",
        "name": "Garabito."
    },
    {
        "neabord_id": "993",
        "district_id": "86",
        "code": "01",
        "name": "Anselmo Alvarado"
    },
    {
        "neabord_id": "994",
        "district_id": "86",
        "code": "02",
        "name": "Balsa"
    },
    {
        "neabord_id": "995",
        "district_id": "86",
        "code": "03",
        "name": "Cuatro Reinas"
    },
    {
        "neabord_id": "996",
        "district_id": "86",
        "code": "04",
        "name": "Orqui­deas"
    },
    {
        "neabord_id": "997",
        "district_id": "86",
        "code": "05",
        "name": "Rey"
    },
    {
        "neabord_id": "998",
        "district_id": "86",
        "code": "06",
        "name": "San Agusti­n."
    },
    {
        "neabord_id": "999",
        "district_id": "87",
        "code": "01",
        "name": "Alondra"
    },
    {
        "neabord_id": "1000",
        "district_id": "87",
        "code": "02",
        "name": "Americano"
    },
    {
        "neabord_id": "1001",
        "district_id": "87",
        "code": "03",
        "name": "Americas"
    },
    {
        "neabord_id": "1002",
        "district_id": "87",
        "code": "04",
        "name": "Bajo Isla"
    },
    {
        "neabord_id": "1003",
        "district_id": "87",
        "code": "05",
        "name": "Bajo Varelas"
    },
    {
        "neabord_id": "1004",
        "district_id": "87",
        "code": "06",
        "name": "Barro de Olla"
    },
    {
        "neabord_id": "1005",
        "district_id": "87",
        "code": "07",
        "name": "Caragua"
    },
    {
        "neabord_id": "1006",
        "district_id": "87",
        "code": "08",
        "name": "Carmen"
    },
    {
        "neabord_id": "1007",
        "district_id": "87",
        "code": "09",
        "name": "Colegios"
    },
    {
        "neabord_id": "1008",
        "district_id": "87",
        "code": "10",
        "name": "Colegios Norte"
    },
    {
        "neabord_id": "1009",
        "district_id": "87",
        "code": "11",
        "name": "Chaves"
    },
    {
        "neabord_id": "1010",
        "district_id": "87",
        "code": "12",
        "name": "El Alto (parte)"
    },
    {
        "neabord_id": "1011",
        "district_id": "87",
        "code": "13",
        "name": "Flor"
    },
    {
        "neabord_id": "1012",
        "district_id": "87",
        "code": "14",
        "name": "Florencia"
    },
    {
        "neabord_id": "1013",
        "district_id": "87",
        "code": "15",
        "name": "Guaria"
    },
    {
        "neabord_id": "1014",
        "district_id": "87",
        "code": "16",
        "name": "Guaria Oriental"
    },
    {
        "neabord_id": "1015",
        "district_id": "87",
        "code": "17",
        "name": "Isla"
    },
    {
        "neabord_id": "1016",
        "district_id": "87",
        "code": "18",
        "name": "Jardines de Moravia"
    },
    {
        "neabord_id": "1017",
        "district_id": "87",
        "code": "19",
        "name": "La Casa"
    },
    {
        "neabord_id": "1018",
        "district_id": "87",
        "code": "20",
        "name": "Ladrillera"
    },
    {
        "neabord_id": "1019",
        "district_id": "87",
        "code": "21",
        "name": "Robles"
    },
    {
        "neabord_id": "1020",
        "district_id": "87",
        "code": "22",
        "name": "Romeral"
    },
    {
        "neabord_id": "1021",
        "district_id": "87",
        "code": "23",
        "name": "Sagrado Corazón"
    },
    {
        "neabord_id": "1022",
        "district_id": "87",
        "code": "24",
        "name": "San Blas"
    },
    {
        "neabord_id": "1023",
        "district_id": "87",
        "code": "25",
        "name": "San Jorge"
    },
    {
        "neabord_id": "1024",
        "district_id": "87",
        "code": "26",
        "name": "San Marti­n"
    },
    {
        "neabord_id": "1025",
        "district_id": "87",
        "code": "27",
        "name": "San Rafael"
    },
    {
        "neabord_id": "1026",
        "district_id": "87",
        "code": "28",
        "name": "Santa Clara (parte)"
    },
    {
        "neabord_id": "1027",
        "district_id": "87",
        "code": "29",
        "name": "Santo Tomas"
    },
    {
        "neabord_id": "1028",
        "district_id": "87",
        "code": "30",
        "name": "Saprissa."
    },
    {
        "neabord_id": "1029",
        "district_id": "88",
        "code": "01",
        "name": "Alto Palma (parte)"
    },
    {
        "neabord_id": "1030",
        "district_id": "88",
        "code": "02",
        "name": "Platanares"
    },
    {
        "neabord_id": "1031",
        "district_id": "88",
        "code": "03",
        "name": "Tornillal"
    },
    {
        "neabord_id": "1032",
        "district_id": "88",
        "code": "04",
        "name": "Torre."
    },
    {
        "neabord_id": "1033",
        "district_id": "89",
        "code": "01",
        "name": "Altos de Trinidad"
    },
    {
        "neabord_id": "1034",
        "district_id": "89",
        "code": "02",
        "name": "Cipreses"
    },
    {
        "neabord_id": "1035",
        "district_id": "89",
        "code": "03",
        "name": "Colonia"
    },
    {
        "neabord_id": "1036",
        "district_id": "89",
        "code": "04",
        "name": "Moral"
    },
    {
        "neabord_id": "1037",
        "district_id": "89",
        "code": "05",
        "name": "Ni­spero"
    },
    {
        "neabord_id": "1038",
        "district_id": "89",
        "code": "06",
        "name": "Rosal"
    },
    {
        "neabord_id": "1039",
        "district_id": "89",
        "code": "07",
        "name": "Ruano"
    },
    {
        "neabord_id": "1040",
        "district_id": "89",
        "code": "08",
        "name": "Sitios"
    },
    {
        "neabord_id": "1041",
        "district_id": "89",
        "code": "09",
        "name": "Tanques"
    },
    {
        "neabord_id": "1042",
        "district_id": "89",
        "code": "10",
        "name": "Virilla."
    },
    {
        "neabord_id": "1043",
        "district_id": "90",
        "code": "01",
        "name": "Alhambra"
    },
    {
        "neabord_id": "1044",
        "district_id": "90",
        "code": "02",
        "name": "Azaleas"
    },
    {
        "neabord_id": "1045",
        "district_id": "90",
        "code": "03",
        "name": "Carmiol"
    },
    {
        "neabord_id": "1046",
        "district_id": "90",
        "code": "04",
        "name": "Cedral"
    },
    {
        "neabord_id": "1047",
        "district_id": "90",
        "code": "05",
        "name": "Dent (parte)"
    },
    {
        "neabord_id": "1048",
        "district_id": "90",
        "code": "06",
        "name": "Francisco Peralta (parte)"
    },
    {
        "neabord_id": "1049",
        "district_id": "90",
        "code": "07",
        "name": "Fuentes"
    },
    {
        "neabord_id": "1050",
        "district_id": "90",
        "code": "08",
        "name": "Granja"
    },
    {
        "neabord_id": "1051",
        "district_id": "90",
        "code": "09",
        "name": "Kezia"
    },
    {
        "neabord_id": "1052",
        "district_id": "90",
        "code": "10",
        "name": "Lourdes"
    },
    {
        "neabord_id": "1053",
        "district_id": "90",
        "code": "11",
        "name": "Monterrey"
    },
    {
        "neabord_id": "1054",
        "district_id": "90",
        "code": "12",
        "name": "Nadori"
    },
    {
        "neabord_id": "1055",
        "district_id": "90",
        "code": "13",
        "name": "Oriente"
    },
    {
        "neabord_id": "1056",
        "district_id": "90",
        "code": "14",
        "name": "Pinto"
    },
    {
        "neabord_id": "1057",
        "district_id": "90",
        "code": "15",
        "name": "Prados del Este"
    },
    {
        "neabord_id": "1058",
        "district_id": "90",
        "code": "16",
        "name": "Roosevelt"
    },
    {
        "neabord_id": "1059",
        "district_id": "90",
        "code": "17",
        "name": "San Gerardo (parte)"
    },
    {
        "neabord_id": "1060",
        "district_id": "90",
        "code": "18",
        "name": "Santa Marta"
    },
    {
        "neabord_id": "1061",
        "district_id": "90",
        "code": "19",
        "name": "Saprissa"
    },
    {
        "neabord_id": "1062",
        "district_id": "90",
        "code": "20",
        "name": "Vargas Araya"
    },
    {
        "neabord_id": "1063",
        "district_id": "90",
        "code": "21",
        "name": "Yoses."
    },
    {
        "neabord_id": "1064",
        "district_id": "91",
        "code": "01",
        "name": "Arboleda"
    },
    {
        "neabord_id": "1065",
        "district_id": "91",
        "code": "02",
        "name": "Bloquera"
    },
    {
        "neabord_id": "1066",
        "district_id": "91",
        "code": "03",
        "name": "Cedros"
    },
    {
        "neabord_id": "1067",
        "district_id": "91",
        "code": "04",
        "name": "El Cristo (parte)"
    },
    {
        "neabord_id": "1068",
        "district_id": "91",
        "code": "05",
        "name": "Españolita"
    },
    {
        "neabord_id": "1069",
        "district_id": "91",
        "code": "06",
        "name": "Luciana"
    },
    {
        "neabord_id": "1070",
        "district_id": "91",
        "code": "07",
        "name": "Marsella"
    },
    {
        "neabord_id": "1071",
        "district_id": "91",
        "code": "08",
        "name": "Maravilla"
    },
    {
        "neabord_id": "1072",
        "district_id": "91",
        "code": "09",
        "name": "Rodeo"
    },
    {
        "neabord_id": "1073",
        "district_id": "91",
        "code": "10",
        "name": "Rosales"
    },
    {
        "neabord_id": "1074",
        "district_id": "91",
        "code": "11",
        "name": "San Marino."
    },
    {
        "neabord_id": "1075",
        "district_id": "92",
        "code": "01",
        "name": "Alma Mater"
    },
    {
        "neabord_id": "1076",
        "district_id": "92",
        "code": "02",
        "name": "Damiana"
    },
    {
        "neabord_id": "1077",
        "district_id": "92",
        "code": "03",
        "name": "Dent (parte)"
    },
    {
        "neabord_id": "1078",
        "district_id": "92",
        "code": "04",
        "name": "Guaymi­"
    },
    {
        "neabord_id": "1079",
        "district_id": "92",
        "code": "05",
        "name": "Paso Hondo"
    },
    {
        "neabord_id": "1080",
        "district_id": "92",
        "code": "06",
        "name": "Paulina."
    },
    {
        "neabord_id": "1081",
        "district_id": "93",
        "code": "01",
        "name": "Alameda"
    },
    {
        "neabord_id": "1082",
        "district_id": "93",
        "code": "02",
        "name": "Andrómeda"
    },
    {
        "neabord_id": "1083",
        "district_id": "93",
        "code": "03",
        "name": "Begonia"
    },
    {
        "neabord_id": "1084",
        "district_id": "93",
        "code": "04",
        "name": "Cuesta Grande (parte)"
    },
    {
        "neabord_id": "1085",
        "district_id": "93",
        "code": "05",
        "name": "El Cristo (parte)"
    },
    {
        "neabord_id": "1086",
        "district_id": "93",
        "code": "06",
        "name": "Estefana (parte)"
    },
    {
        "neabord_id": "1087",
        "district_id": "93",
        "code": "07",
        "name": "Europa"
    },
    {
        "neabord_id": "1088",
        "district_id": "93",
        "code": "08",
        "name": "Liburgia"
    },
    {
        "neabord_id": "1089",
        "district_id": "93",
        "code": "09",
        "name": "Mansiones (parte)"
    },
    {
        "neabord_id": "1090",
        "district_id": "93",
        "code": "10",
        "name": "Maruz"
    },
    {
        "neabord_id": "1091",
        "district_id": "93",
        "code": "11",
        "name": "Salitrillos."
    },
    {
        "neabord_id": "1092",
        "district_id": "94",
        "code": "01",
        "name": "Alto Poró"
    },
    {
        "neabord_id": "1093",
        "district_id": "94",
        "code": "02",
        "name": "Bolsón"
    },
    {
        "neabord_id": "1094",
        "district_id": "94",
        "code": "03",
        "name": "Purires."
    },
    {
        "neabord_id": "1095",
        "district_id": "95",
        "code": "01",
        "name": "Alto Limón"
    },
    {
        "neabord_id": "1096",
        "district_id": "95",
        "code": "02",
        "name": "Florecilla"
    },
    {
        "neabord_id": "1097",
        "district_id": "95",
        "code": "03",
        "name": "Limón"
    },
    {
        "neabord_id": "1098",
        "district_id": "95",
        "code": "04",
        "name": "Palmar"
    },
    {
        "neabord_id": "1099",
        "district_id": "95",
        "code": "05",
        "name": "Pita Villa Colina."
    },
    {
        "neabord_id": "1100",
        "district_id": "96",
        "code": "01",
        "name": "Bajo Laguna"
    },
    {
        "neabord_id": "1101",
        "district_id": "96",
        "code": "02",
        "name": "El Barro"
    },
    {
        "neabord_id": "1102",
        "district_id": "96",
        "code": "03",
        "name": "Llano Bonito (San Juan de Mata)"
    },
    {
        "neabord_id": "1103",
        "district_id": "96",
        "code": "04",
        "name": "Molenillo"
    },
    {
        "neabord_id": "1104",
        "district_id": "96",
        "code": "05",
        "name": "Paso Agres"
    },
    {
        "neabord_id": "1105",
        "district_id": "96",
        "code": "06",
        "name": "Surtubal"
    },
    {
        "neabord_id": "1106",
        "district_id": "96",
        "code": "07",
        "name": "Tronco Negro."
    },
    {
        "neabord_id": "1107",
        "district_id": "97",
        "code": "01",
        "name": "Pital"
    },
    {
        "neabord_id": "1108",
        "district_id": "97",
        "code": "02",
        "name": "Potenciana Arriba"
    },
    {
        "neabord_id": "1109",
        "district_id": "97",
        "code": "03",
        "name": "Quebrada Azul"
    },
    {
        "neabord_id": "1110",
        "district_id": "97",
        "code": "04",
        "name": "San Francisco"
    },
    {
        "neabord_id": "1111",
        "district_id": "97",
        "code": "05",
        "name": "San Rafael."
    },
    {
        "neabord_id": "1112",
        "district_id": "98",
        "code": "01",
        "name": "Alto Espavel"
    },
    {
        "neabord_id": "1113",
        "district_id": "98",
        "code": "02",
        "name": "Angostura (parte)"
    },
    {
        "neabord_id": "1114",
        "district_id": "98",
        "code": "03",
        "name": "Bijagualito"
    },
    {
        "neabord_id": "1115",
        "district_id": "98",
        "code": "04",
        "name": "Bola"
    },
    {
        "neabord_id": "1116",
        "district_id": "98",
        "code": "05",
        "name": "Carara"
    },
    {
        "neabord_id": "1117",
        "district_id": "98",
        "code": "06",
        "name": "Cima"
    },
    {
        "neabord_id": "1118",
        "district_id": "98",
        "code": "07",
        "name": "Delicias"
    },
    {
        "neabord_id": "1119",
        "district_id": "98",
        "code": "08",
        "name": "El Sur"
    },
    {
        "neabord_id": "1120",
        "district_id": "98",
        "code": "09",
        "name": "Esperanza"
    },
    {
        "neabord_id": "1121",
        "district_id": "98",
        "code": "10",
        "name": "Fila Negra"
    },
    {
        "neabord_id": "1122",
        "district_id": "98",
        "code": "11",
        "name": "Galan"
    },
    {
        "neabord_id": "1123",
        "district_id": "98",
        "code": "12",
        "name": "La Trampa"
    },
    {
        "neabord_id": "1124",
        "district_id": "98",
        "code": "13",
        "name": "Lajas"
    },
    {
        "neabord_id": "1125",
        "district_id": "98",
        "code": "14",
        "name": "Mata de Platano"
    },
    {
        "neabord_id": "1126",
        "district_id": "98",
        "code": "15",
        "name": "Montelimar"
    },
    {
        "neabord_id": "1127",
        "district_id": "98",
        "code": "16",
        "name": "Pacayal"
    },
    {
        "neabord_id": "1128",
        "district_id": "98",
        "code": "17",
        "name": "Pavona"
    },
    {
        "neabord_id": "1129",
        "district_id": "98",
        "code": "18",
        "name": "Quina"
    },
    {
        "neabord_id": "1130",
        "district_id": "98",
        "code": "19",
        "name": "Ri­o Negro"
    },
    {
        "neabord_id": "1131",
        "district_id": "98",
        "code": "20",
        "name": "Ri­o Seco"
    },
    {
        "neabord_id": "1132",
        "district_id": "98",
        "code": "21",
        "name": "San Franci­sco"
    },
    {
        "neabord_id": "1133",
        "district_id": "98",
        "code": "22",
        "name": "San Gabriel"
    },
    {
        "neabord_id": "1134",
        "district_id": "98",
        "code": "23",
        "name": "San Isidro"
    },
    {
        "neabord_id": "1135",
        "district_id": "98",
        "code": "24",
        "name": "San Jerónimo"
    },
    {
        "neabord_id": "1136",
        "district_id": "98",
        "code": "25",
        "name": "Tuli­n."
    },
    {
        "neabord_id": "1137",
        "district_id": "99",
        "code": "01",
        "name": "Bandera"
    },
    {
        "neabord_id": "1138",
        "district_id": "99",
        "code": "02",
        "name": "Higueronal"
    },
    {
        "neabord_id": "1139",
        "district_id": "99",
        "code": "03",
        "name": "Llano"
    },
    {
        "neabord_id": "1140",
        "district_id": "99",
        "code": "04",
        "name": "Nubes"
    },
    {
        "neabord_id": "1141",
        "district_id": "99",
        "code": "05",
        "name": "San Rafael."
    },
    {
        "neabord_id": "1142",
        "district_id": "99",
        "code": "06",
        "name": "Botella"
    },
    {
        "neabord_id": "1143",
        "district_id": "99",
        "code": "07",
        "name": "Cedral"
    },
    {
        "neabord_id": "1144",
        "district_id": "99",
        "code": "08",
        "name": "Guaria"
    },
    {
        "neabord_id": "1145",
        "district_id": "99",
        "code": "09",
        "name": "Naranjo"
    },
    {
        "neabord_id": "1146",
        "district_id": "99",
        "code": "10",
        "name": "Quebrada Grande (parte)"
    },
    {
        "neabord_id": "1147",
        "district_id": "99",
        "code": "11",
        "name": "Reyes"
    },
    {
        "neabord_id": "1148",
        "district_id": "99",
        "code": "12",
        "name": "San Joaqui­n"
    },
    {
        "neabord_id": "1149",
        "district_id": "99",
        "code": "13",
        "name": "San Lucas"
    },
    {
        "neabord_id": "1150",
        "district_id": "99",
        "code": "14",
        "name": "Sukia"
    },
    {
        "neabord_id": "1151",
        "district_id": "99",
        "code": "15",
        "name": "Vapor."
    },
    {
        "neabord_id": "1152",
        "district_id": "100",
        "code": "01",
        "name": "Cabeceras de Tarrazu"
    },
    {
        "neabord_id": "1153",
        "district_id": "100",
        "code": "02",
        "name": "Chonta (parte)"
    },
    {
        "neabord_id": "1154",
        "district_id": "100",
        "code": "03",
        "name": "Quebradillas."
    },
    {
        "neabord_id": "1155",
        "district_id": "101",
        "code": "01",
        "name": "Bernardo Ureña."
    },
    {
        "neabord_id": "1156",
        "district_id": "101",
        "code": "02",
        "name": "Alto Cañazo"
    },
    {
        "neabord_id": "1157",
        "district_id": "101",
        "code": "03",
        "name": "Alto indio"
    },
    {
        "neabord_id": "1158",
        "district_id": "101",
        "code": "04",
        "name": "Alto Miramar"
    },
    {
        "neabord_id": "1159",
        "district_id": "101",
        "code": "05",
        "name": "Cañón (parte)"
    },
    {
        "neabord_id": "1160",
        "district_id": "101",
        "code": "06",
        "name": "Cima"
    },
    {
        "neabord_id": "1161",
        "district_id": "101",
        "code": "07",
        "name": "Cruce Chinchilla"
    },
    {
        "neabord_id": "1162",
        "district_id": "101",
        "code": "08",
        "name": "Florida"
    },
    {
        "neabord_id": "1163",
        "district_id": "101",
        "code": "09",
        "name": "Garrafa"
    },
    {
        "neabord_id": "1164",
        "district_id": "101",
        "code": "10",
        "name": "Jaboncillo"
    },
    {
        "neabord_id": "1165",
        "district_id": "101",
        "code": "11",
        "name": "Madreselva"
    },
    {
        "neabord_id": "1166",
        "district_id": "101",
        "code": "12",
        "name": "Ojo de Agua (parte)"
    },
    {
        "neabord_id": "1167",
        "district_id": "101",
        "code": "13",
        "name": "Paso Macho (parte)"
    },
    {
        "neabord_id": "1168",
        "district_id": "101",
        "code": "14",
        "name": "Pedregoso"
    },
    {
        "neabord_id": "1169",
        "district_id": "101",
        "code": "15",
        "name": "Providencia"
    },
    {
        "neabord_id": "1170",
        "district_id": "101",
        "code": "16",
        "name": "Quebrada Grande (parte)"
    },
    {
        "neabord_id": "1171",
        "district_id": "101",
        "code": "17",
        "name": "Quebrador"
    },
    {
        "neabord_id": "1172",
        "district_id": "101",
        "code": "18",
        "name": "Ri­o Blanco"
    },
    {
        "neabord_id": "1173",
        "district_id": "101",
        "code": "19",
        "name": "Salsipuedes (parte)"
    },
    {
        "neabord_id": "1174",
        "district_id": "101",
        "code": "20",
        "name": "San Carlos"
    },
    {
        "neabord_id": "1175",
        "district_id": "101",
        "code": "21",
        "name": "San Gerardo"
    },
    {
        "neabord_id": "1176",
        "district_id": "101",
        "code": "22",
        "name": "Trinidad"
    },
    {
        "neabord_id": "1177",
        "district_id": "101",
        "code": "23",
        "name": "Vueltas."
    },
    {
        "neabord_id": "1178",
        "district_id": "102",
        "code": "01",
        "name": "Ahogados (parte)"
    },
    {
        "neabord_id": "1179",
        "district_id": "102",
        "code": "02",
        "name": "Aromatico"
    },
    {
        "neabord_id": "1180",
        "district_id": "102",
        "code": "03",
        "name": "Cipreses"
    },
    {
        "neabord_id": "1181",
        "district_id": "102",
        "code": "04",
        "name": "Chapultepec"
    },
    {
        "neabord_id": "1182",
        "district_id": "102",
        "code": "05",
        "name": "Dorados"
    },
    {
        "neabord_id": "1183",
        "district_id": "102",
        "code": "06",
        "name": "Guayabos"
    },
    {
        "neabord_id": "1184",
        "district_id": "102",
        "code": "07",
        "name": "Hacienda Vieja"
    },
    {
        "neabord_id": "1185",
        "district_id": "102",
        "code": "08",
        "name": "Hogar"
    },
    {
        "neabord_id": "1186",
        "district_id": "102",
        "code": "09",
        "name": "Jose Mari­a Zeledón"
    },
    {
        "neabord_id": "1187",
        "district_id": "102",
        "code": "10",
        "name": "Laguna"
    },
    {
        "neabord_id": "1188",
        "district_id": "102",
        "code": "11",
        "name": "La Li­a"
    },
    {
        "neabord_id": "1189",
        "district_id": "102",
        "code": "12",
        "name": "Mallorca"
    },
    {
        "neabord_id": "1190",
        "district_id": "102",
        "code": "13",
        "name": "Mari­a Auxiliadora"
    },
    {
        "neabord_id": "1191",
        "district_id": "102",
        "code": "14",
        "name": "Miramontes"
    },
    {
        "neabord_id": "1192",
        "district_id": "102",
        "code": "15",
        "name": "Nopalera"
    },
    {
        "neabord_id": "1193",
        "district_id": "102",
        "code": "16",
        "name": "Plaza del Sol"
    },
    {
        "neabord_id": "1194",
        "district_id": "102",
        "code": "17",
        "name": "Prado"
    },
    {
        "neabord_id": "1195",
        "district_id": "102",
        "code": "18",
        "name": "San Jose"
    },
    {
        "neabord_id": "1196",
        "district_id": "102",
        "code": "19",
        "name": "Santa Cecilia"
    },
    {
        "neabord_id": "1197",
        "district_id": "102",
        "code": "20",
        "name": "Tacaco."
    },
    {
        "neabord_id": "1198",
        "district_id": "103",
        "code": "01",
        "name": "Biarquiria"
    },
    {
        "neabord_id": "1199",
        "district_id": "103",
        "code": "02",
        "name": "Eucalipto"
    },
    {
        "neabord_id": "1200",
        "district_id": "103",
        "code": "03",
        "name": "Freses"
    },
    {
        "neabord_id": "1201",
        "district_id": "103",
        "code": "04",
        "name": "Granadilla Norte"
    },
    {
        "neabord_id": "1202",
        "district_id": "103",
        "code": "05",
        "name": "Granadilla Sur"
    },
    {
        "neabord_id": "1203",
        "district_id": "103",
        "code": "06",
        "name": "Montaña Rusa (parte)."
    },
    {
        "neabord_id": "1204",
        "district_id": "104",
        "code": "01",
        "name": "Araucauria (parte)"
    },
    {
        "neabord_id": "1205",
        "district_id": "104",
        "code": "02",
        "name": "Lomas de Ayarco"
    },
    {
        "neabord_id": "1206",
        "district_id": "104",
        "code": "03",
        "name": "Pinares."
    },
    {
        "neabord_id": "1207",
        "district_id": "105",
        "code": "01",
        "name": "Colina"
    },
    {
        "neabord_id": "1208",
        "district_id": "105",
        "code": "02",
        "name": "Lomas de San Pancracio"
    },
    {
        "neabord_id": "1209",
        "district_id": "105",
        "code": "03",
        "name": "Ponderosa"
    },
    {
        "neabord_id": "1210",
        "district_id": "105",
        "code": "04",
        "name": "Quince de Agosto."
    },
    {
        "neabord_id": "1211",
        "district_id": "106",
        "code": "01",
        "name": "Aeropuerto"
    },
    {
        "neabord_id": "1212",
        "district_id": "106",
        "code": "02",
        "name": "Alto Alonso"
    },
    {
        "neabord_id": "1213",
        "district_id": "106",
        "code": "03",
        "name": "Boruca"
    },
    {
        "neabord_id": "1214",
        "district_id": "106",
        "code": "04",
        "name": "Boston"
    },
    {
        "neabord_id": "1215",
        "district_id": "106",
        "code": "05",
        "name": "Cementerio"
    },
    {
        "neabord_id": "1216",
        "district_id": "106",
        "code": "06",
        "name": "Cooperativa"
    },
    {
        "neabord_id": "1217",
        "district_id": "106",
        "code": "07",
        "name": "Cristo Rey"
    },
    {
        "neabord_id": "1218",
        "district_id": "106",
        "code": "08",
        "name": "Doce de Marzo"
    },
    {
        "neabord_id": "1219",
        "district_id": "106",
        "code": "09",
        "name": "Dorotea"
    },
    {
        "neabord_id": "1220",
        "district_id": "106",
        "code": "10",
        "name": "Duran Picado"
    },
    {
        "neabord_id": "1221",
        "district_id": "106",
        "code": "11",
        "name": "España"
    },
    {
        "neabord_id": "1222",
        "district_id": "106",
        "code": "12",
        "name": "Estadio"
    },
    {
        "neabord_id": "1223",
        "district_id": "106",
        "code": "13",
        "name": "Evans Gordon Wilson"
    },
    {
        "neabord_id": "1224",
        "district_id": "106",
        "code": "14",
        "name": "Gonzalez"
    },
    {
        "neabord_id": "1225",
        "district_id": "106",
        "code": "15",
        "name": "Hospital"
    },
    {
        "neabord_id": "1226",
        "district_id": "106",
        "code": "16",
        "name": "Hoyón"
    },
    {
        "neabord_id": "1227",
        "district_id": "106",
        "code": "17",
        "name": "I Griega"
    },
    {
        "neabord_id": "1228",
        "district_id": "106",
        "code": "18",
        "name": "Las Americas"
    },
    {
        "neabord_id": "1229",
        "district_id": "106",
        "code": "19",
        "name": "Lomas de Cocori­"
    },
    {
        "neabord_id": "1230",
        "district_id": "106",
        "code": "20",
        "name": "Luis Monge"
    },
    {
        "neabord_id": "1231",
        "district_id": "106",
        "code": "21",
        "name": "Morazan"
    },
    {
        "neabord_id": "1232",
        "district_id": "106",
        "code": "22",
        "name": "Pavones"
    },
    {
        "neabord_id": "1233",
        "district_id": "106",
        "code": "23",
        "name": "Pedregoso"
    },
    {
        "neabord_id": "1234",
        "district_id": "106",
        "code": "24",
        "name": "Pocito"
    },
    {
        "neabord_id": "1235",
        "district_id": "106",
        "code": "25",
        "name": "Prado"
    },
    {
        "neabord_id": "1236",
        "district_id": "106",
        "code": "26",
        "name": "Romero"
    },
    {
        "neabord_id": "1237",
        "district_id": "106",
        "code": "27",
        "name": "Sagrada Familia"
    },
    {
        "neabord_id": "1238",
        "district_id": "106",
        "code": "28",
        "name": "San Andres"
    },
    {
        "neabord_id": "1239",
        "district_id": "106",
        "code": "29",
        "name": "San Luis"
    },
    {
        "neabord_id": "1240",
        "district_id": "106",
        "code": "30",
        "name": "San Rafael Sur"
    },
    {
        "neabord_id": "1241",
        "district_id": "106",
        "code": "31",
        "name": "San Vicente"
    },
    {
        "neabord_id": "1242",
        "district_id": "106",
        "code": "32",
        "name": "Santa Cecilia"
    },
    {
        "neabord_id": "1243",
        "district_id": "106",
        "code": "33",
        "name": "Sinai­"
    },
    {
        "neabord_id": "1244",
        "district_id": "106",
        "code": "34",
        "name": "Tierra Prometida"
    },
    {
        "neabord_id": "1245",
        "district_id": "106",
        "code": "35",
        "name": "Tormenta"
    },
    {
        "neabord_id": "1246",
        "district_id": "106",
        "code": "36",
        "name": "Unesco"
    },
    {
        "neabord_id": "1247",
        "district_id": "106",
        "code": "37",
        "name": "Valverde."
    },
    {
        "neabord_id": "1248",
        "district_id": "106",
        "code": "38",
        "name": "Alto Ceibo"
    },
    {
        "neabord_id": "1249",
        "district_id": "106",
        "code": "39",
        "name": "Alto Huacas"
    },
    {
        "neabord_id": "1250",
        "district_id": "106",
        "code": "40",
        "name": "Alto Sajaral"
    },
    {
        "neabord_id": "1251",
        "district_id": "106",
        "code": "41",
        "name": "Alto San Juan"
    },
    {
        "neabord_id": "1252",
        "district_id": "106",
        "code": "42",
        "name": "Alto Tumbas"
    },
    {
        "neabord_id": "1253",
        "district_id": "106",
        "code": "43",
        "name": "Angostura"
    },
    {
        "neabord_id": "1254",
        "district_id": "106",
        "code": "44",
        "name": "Bajo Ceibo"
    },
    {
        "neabord_id": "1255",
        "district_id": "106",
        "code": "45",
        "name": "Bajo Esperanzas"
    },
    {
        "neabord_id": "1256",
        "district_id": "106",
        "code": "46",
        "name": "Bajo Mora"
    },
    {
        "neabord_id": "1257",
        "district_id": "106",
        "code": "47",
        "name": "Bijaguales"
    },
    {
        "neabord_id": "1258",
        "district_id": "106",
        "code": "48",
        "name": "Bocana"
    },
    {
        "neabord_id": "1259",
        "district_id": "106",
        "code": "49",
        "name": "Bonita"
    },
    {
        "neabord_id": "1260",
        "district_id": "106",
        "code": "50",
        "name": "Ceibo"
    },
    {
        "neabord_id": "1261",
        "district_id": "106",
        "code": "51",
        "name": "Ceniza"
    },
    {
        "neabord_id": "1262",
        "district_id": "106",
        "code": "52",
        "name": "Dorado"
    },
    {
        "neabord_id": "1263",
        "district_id": "106",
        "code": "53",
        "name": "Esperanzas"
    },
    {
        "neabord_id": "1264",
        "district_id": "106",
        "code": "54",
        "name": "Guadalupe"
    },
    {
        "neabord_id": "1265",
        "district_id": "106",
        "code": "55",
        "name": "Guaria"
    },
    {
        "neabord_id": "1266",
        "district_id": "106",
        "code": "56",
        "name": "Higuerones"
    },
    {
        "neabord_id": "1267",
        "district_id": "106",
        "code": "57",
        "name": "Jilguero"
    },
    {
        "neabord_id": "1268",
        "district_id": "106",
        "code": "58",
        "name": "Jilguero Sur"
    },
    {
        "neabord_id": "1269",
        "district_id": "106",
        "code": "59",
        "name": "Los Guayabos"
    },
    {
        "neabord_id": "1270",
        "district_id": "106",
        "code": "60",
        "name": "Mari­a Auxiliadora"
    },
    {
        "neabord_id": "1271",
        "district_id": "106",
        "code": "61",
        "name": "Miravalles"
    },
    {
        "neabord_id": "1272",
        "district_id": "106",
        "code": "62",
        "name": "Morete"
    },
    {
        "neabord_id": "1273",
        "district_id": "106",
        "code": "63",
        "name": "Ojo de Agua"
    },
    {
        "neabord_id": "1274",
        "district_id": "106",
        "code": "64",
        "name": "Ocho de Diciembre"
    },
    {
        "neabord_id": "1275",
        "district_id": "106",
        "code": "65",
        "name": "Pacuarito"
    },
    {
        "neabord_id": "1276",
        "district_id": "106",
        "code": "66",
        "name": "Palma"
    },
    {
        "neabord_id": "1277",
        "district_id": "106",
        "code": "67",
        "name": "Paso Beita"
    },
    {
        "neabord_id": "1278",
        "district_id": "106",
        "code": "68",
        "name": "Paso Lagarto"
    },
    {
        "neabord_id": "1279",
        "district_id": "106",
        "code": "69",
        "name": "Quebrada Honda (parte)"
    },
    {
        "neabord_id": "1280",
        "district_id": "106",
        "code": "70",
        "name": "Quebrada Vueltas"
    },
    {
        "neabord_id": "1281",
        "district_id": "106",
        "code": "71",
        "name": "Quebradas"
    },
    {
        "neabord_id": "1282",
        "district_id": "106",
        "code": "72",
        "name": "Roble"
    },
    {
        "neabord_id": "1283",
        "district_id": "106",
        "code": "73",
        "name": "Rosario"
    },
    {
        "neabord_id": "1284",
        "district_id": "106",
        "code": "74",
        "name": "San Agusti­n"
    },
    {
        "neabord_id": "1285",
        "district_id": "106",
        "code": "75",
        "name": "San Jorge"
    },
    {
        "neabord_id": "1286",
        "district_id": "106",
        "code": "76",
        "name": "San Juan de Miramar"
    },
    {
        "neabord_id": "1287",
        "district_id": "106",
        "code": "77",
        "name": "San Lorenzo"
    },
    {
        "neabord_id": "1288",
        "district_id": "106",
        "code": "78",
        "name": "San Rafael Norte"
    },
    {
        "neabord_id": "1289",
        "district_id": "106",
        "code": "79",
        "name": "Santa Fe"
    },
    {
        "neabord_id": "1290",
        "district_id": "106",
        "code": "80",
        "name": "Santa Marta"
    },
    {
        "neabord_id": "1291",
        "district_id": "106",
        "code": "81",
        "name": "Suiza (parte)"
    },
    {
        "neabord_id": "1292",
        "district_id": "106",
        "code": "82",
        "name": "Tajo"
    },
    {
        "neabord_id": "1293",
        "district_id": "106",
        "code": "83",
        "name": "Toledo"
    },
    {
        "neabord_id": "1294",
        "district_id": "106",
        "code": "84",
        "name": "Tronconales"
    },
    {
        "neabord_id": "1295",
        "district_id": "106",
        "code": "85",
        "name": "Tuis"
    },
    {
        "neabord_id": "1296",
        "district_id": "106",
        "code": "86",
        "name": "Villanueva."
    },
    {
        "neabord_id": "1297",
        "district_id": "107",
        "code": "01",
        "name": "Arepa"
    },
    {
        "neabord_id": "1298",
        "district_id": "107",
        "code": "02",
        "name": "Carmen"
    },
    {
        "neabord_id": "1299",
        "district_id": "107",
        "code": "03",
        "name": "Chanchos"
    },
    {
        "neabord_id": "1300",
        "district_id": "107",
        "code": "04",
        "name": "Hermosa"
    },
    {
        "neabord_id": "1301",
        "district_id": "107",
        "code": "05",
        "name": "Linda"
    },
    {
        "neabord_id": "1302",
        "district_id": "107",
        "code": "06",
        "name": "Linda Arriba"
    },
    {
        "neabord_id": "1303",
        "district_id": "107",
        "code": "07",
        "name": "Miraflores"
    },
    {
        "neabord_id": "1304",
        "district_id": "107",
        "code": "08",
        "name": "Parai­so de la Tierra"
    },
    {
        "neabord_id": "1305",
        "district_id": "107",
        "code": "09",
        "name": "Peñas Blancas"
    },
    {
        "neabord_id": "1306",
        "district_id": "107",
        "code": "10",
        "name": "Quizarra (parte)"
    },
    {
        "neabord_id": "1307",
        "district_id": "107",
        "code": "11",
        "name": "San Blas"
    },
    {
        "neabord_id": "1308",
        "district_id": "107",
        "code": "12",
        "name": "San Luis"
    },
    {
        "neabord_id": "1309",
        "district_id": "107",
        "code": "13",
        "name": "Santa Cruz"
    },
    {
        "neabord_id": "1310",
        "district_id": "107",
        "code": "14",
        "name": "Santa Elena"
    },
    {
        "neabord_id": "1311",
        "district_id": "107",
        "code": "15",
        "name": "Trinidad."
    },
    {
        "neabord_id": "1312",
        "district_id": "108",
        "code": "01",
        "name": "Alto Brisas"
    },
    {
        "neabord_id": "1313",
        "district_id": "108",
        "code": "02",
        "name": "angeles"
    },
    {
        "neabord_id": "1314",
        "district_id": "108",
        "code": "03",
        "name": "Aurora"
    },
    {
        "neabord_id": "1315",
        "district_id": "108",
        "code": "04",
        "name": "Chiles"
    },
    {
        "neabord_id": "1316",
        "district_id": "108",
        "code": "05",
        "name": "Crematorio"
    },
    {
        "neabord_id": "1317",
        "district_id": "108",
        "code": "06",
        "name": "Daniel Flores"
    },
    {
        "neabord_id": "1318",
        "district_id": "108",
        "code": "07",
        "name": "Laboratorio"
    },
    {
        "neabord_id": "1319",
        "district_id": "108",
        "code": "08",
        "name": "Los Pinos"
    },
    {
        "neabord_id": "1320",
        "district_id": "108",
        "code": "09",
        "name": "Loma Verde"
    },
    {
        "neabord_id": "1321",
        "district_id": "108",
        "code": "10",
        "name": "Lourdes"
    },
    {
        "neabord_id": "1322",
        "district_id": "108",
        "code": "11",
        "name": "Rosas"
    },
    {
        "neabord_id": "1323",
        "district_id": "108",
        "code": "12",
        "name": "Rosa Iris"
    },
    {
        "neabord_id": "1324",
        "district_id": "108",
        "code": "13",
        "name": "San Francisco"
    },
    {
        "neabord_id": "1325",
        "district_id": "108",
        "code": "14",
        "name": "Santa Margarita"
    },
    {
        "neabord_id": "1326",
        "district_id": "108",
        "code": "15",
        "name": "Trocha"
    },
    {
        "neabord_id": "1327",
        "district_id": "108",
        "code": "16",
        "name": "Villa Ligia."
    },
    {
        "neabord_id": "1328",
        "district_id": "108",
        "code": "17",
        "name": "Aguas Buenas (parte)"
    },
    {
        "neabord_id": "1329",
        "district_id": "108",
        "code": "18",
        "name": "Bajos de Pacuar"
    },
    {
        "neabord_id": "1330",
        "district_id": "108",
        "code": "19",
        "name": "Concepción (parte)"
    },
    {
        "neabord_id": "1331",
        "district_id": "108",
        "code": "20",
        "name": "Corazón de Jesus"
    },
    {
        "neabord_id": "1332",
        "district_id": "108",
        "code": "21",
        "name": "Juntas de Pacuar"
    },
    {
        "neabord_id": "1333",
        "district_id": "108",
        "code": "22",
        "name": "Paso Bote"
    },
    {
        "neabord_id": "1334",
        "district_id": "108",
        "code": "23",
        "name": "Patio de Agua"
    },
    {
        "neabord_id": "1335",
        "district_id": "108",
        "code": "24",
        "name": "Peje"
    },
    {
        "neabord_id": "1336",
        "district_id": "108",
        "code": "25",
        "name": "Percal"
    },
    {
        "neabord_id": "1337",
        "district_id": "108",
        "code": "26",
        "name": "Pinar del Ri­o"
    },
    {
        "neabord_id": "1338",
        "district_id": "108",
        "code": "27",
        "name": "Quebrada Honda (parte)"
    },
    {
        "neabord_id": "1339",
        "district_id": "108",
        "code": "28",
        "name": "Repunta"
    },
    {
        "neabord_id": "1340",
        "district_id": "108",
        "code": "29",
        "name": "Reyes"
    },
    {
        "neabord_id": "1341",
        "district_id": "108",
        "code": "30",
        "name": "Ribera"
    },
    {
        "neabord_id": "1342",
        "district_id": "108",
        "code": "31",
        "name": "Suiza (parte)."
    },
    {
        "neabord_id": "1343",
        "district_id": "109",
        "code": "01",
        "name": "Linda Vista"
    },
    {
        "neabord_id": "1344",
        "district_id": "109",
        "code": "02",
        "name": "Lourdes."
    },
    {
        "neabord_id": "1345",
        "district_id": "109",
        "code": "03",
        "name": "Alaska"
    },
    {
        "neabord_id": "1346",
        "district_id": "109",
        "code": "04",
        "name": "Altamira"
    },
    {
        "neabord_id": "1347",
        "district_id": "109",
        "code": "05",
        "name": "Alto Jaular"
    },
    {
        "neabord_id": "1348",
        "district_id": "109",
        "code": "06",
        "name": "angeles"
    },
    {
        "neabord_id": "1349",
        "district_id": "109",
        "code": "07",
        "name": "Boquete"
    },
    {
        "neabord_id": "1350",
        "district_id": "109",
        "code": "08",
        "name": "Buenavista"
    },
    {
        "neabord_id": "1351",
        "district_id": "109",
        "code": "09",
        "name": "Canaan"
    },
    {
        "neabord_id": "1352",
        "district_id": "109",
        "code": "10",
        "name": "Chimirol"
    },
    {
        "neabord_id": "1353",
        "district_id": "109",
        "code": "11",
        "name": "Chispa"
    },
    {
        "neabord_id": "1354",
        "district_id": "109",
        "code": "12",
        "name": "Chuma"
    },
    {
        "neabord_id": "1355",
        "district_id": "109",
        "code": "13",
        "name": "División (parte)"
    },
    {
        "neabord_id": "1356",
        "district_id": "109",
        "code": "14",
        "name": "Guadalupe"
    },
    {
        "neabord_id": "1357",
        "district_id": "109",
        "code": "15",
        "name": "Herradura"
    },
    {
        "neabord_id": "1358",
        "district_id": "109",
        "code": "16",
        "name": "La Bambu"
    },
    {
        "neabord_id": "1359",
        "district_id": "109",
        "code": "17",
        "name": "Los Monges"
    },
    {
        "neabord_id": "1360",
        "district_id": "109",
        "code": "18",
        "name": "Monterrey"
    },
    {
        "neabord_id": "1361",
        "district_id": "109",
        "code": "19",
        "name": "Palmital"
    },
    {
        "neabord_id": "1362",
        "district_id": "109",
        "code": "20",
        "name": "Piedra Alta"
    },
    {
        "neabord_id": "1363",
        "district_id": "109",
        "code": "21",
        "name": "Playa Quesada"
    },
    {
        "neabord_id": "1364",
        "district_id": "109",
        "code": "22",
        "name": "Playas"
    },
    {
        "neabord_id": "1365",
        "district_id": "109",
        "code": "23",
        "name": "Pueblo Nuevo"
    },
    {
        "neabord_id": "1366",
        "district_id": "109",
        "code": "24",
        "name": "Ri­o Blanco"
    },
    {
        "neabord_id": "1367",
        "district_id": "109",
        "code": "25",
        "name": "San Antonio"
    },
    {
        "neabord_id": "1368",
        "district_id": "109",
        "code": "26",
        "name": "San Gerardo"
    },
    {
        "neabord_id": "1369",
        "district_id": "109",
        "code": "27",
        "name": "San Jose"
    },
    {
        "neabord_id": "1370",
        "district_id": "109",
        "code": "28",
        "name": "San Juan Norte"
    },
    {
        "neabord_id": "1371",
        "district_id": "109",
        "code": "29",
        "name": "Siberia (parte)"
    },
    {
        "neabord_id": "1372",
        "district_id": "109",
        "code": "30",
        "name": "Tirra"
    },
    {
        "neabord_id": "1373",
        "district_id": "109",
        "code": "31",
        "name": "Zapotal."
    },
    {
        "neabord_id": "1374",
        "district_id": "110",
        "code": "01",
        "name": "Cruz Roja."
    },
    {
        "neabord_id": "1375",
        "district_id": "110",
        "code": "02",
        "name": "Arenilla (Junta)"
    },
    {
        "neabord_id": "1376",
        "district_id": "110",
        "code": "03",
        "name": "Alto Calderón"
    },
    {
        "neabord_id": "1377",
        "district_id": "110",
        "code": "04",
        "name": "Cedral (parte)"
    },
    {
        "neabord_id": "1378",
        "district_id": "110",
        "code": "05",
        "name": "Fatima"
    },
    {
        "neabord_id": "1379",
        "district_id": "110",
        "code": "06",
        "name": "Fortuna"
    },
    {
        "neabord_id": "1380",
        "district_id": "110",
        "code": "07",
        "name": "Guaria"
    },
    {
        "neabord_id": "1381",
        "district_id": "110",
        "code": "08",
        "name": "Laguna"
    },
    {
        "neabord_id": "1382",
        "district_id": "110",
        "code": "09",
        "name": "Rinconada Vega"
    },
    {
        "neabord_id": "1383",
        "district_id": "110",
        "code": "10",
        "name": "San Jerónimo"
    },
    {
        "neabord_id": "1384",
        "district_id": "110",
        "code": "11",
        "name": "San Juan"
    },
    {
        "neabord_id": "1385",
        "district_id": "110",
        "code": "12",
        "name": "San Juancito"
    },
    {
        "neabord_id": "1386",
        "district_id": "110",
        "code": "13",
        "name": "San Rafael"
    },
    {
        "neabord_id": "1387",
        "district_id": "110",
        "code": "14",
        "name": "Santa Ana"
    },
    {
        "neabord_id": "1388",
        "district_id": "110",
        "code": "15",
        "name": "Santo Domingo"
    },
    {
        "neabord_id": "1389",
        "district_id": "110",
        "code": "16",
        "name": "Tambor"
    },
    {
        "neabord_id": "1390",
        "district_id": "110",
        "code": "17",
        "name": "Unión"
    },
    {
        "neabord_id": "1391",
        "district_id": "110",
        "code": "18",
        "name": "Zapotal."
    },
    {
        "neabord_id": "1392",
        "district_id": "111",
        "code": "01",
        "name": "Aguas Buenas (parte)"
    },
    {
        "neabord_id": "1393",
        "district_id": "111",
        "code": "02",
        "name": "Bajo Bonitas"
    },
    {
        "neabord_id": "1394",
        "district_id": "111",
        "code": "03",
        "name": "Bajo Espinoza"
    },
    {
        "neabord_id": "1395",
        "district_id": "111",
        "code": "04",
        "name": "Bolivia"
    },
    {
        "neabord_id": "1396",
        "district_id": "111",
        "code": "05",
        "name": "Bonitas"
    },
    {
        "neabord_id": "1397",
        "district_id": "111",
        "code": "06",
        "name": "Buenos Aires"
    },
    {
        "neabord_id": "1398",
        "district_id": "111",
        "code": "07",
        "name": "Concepción (parte)"
    },
    {
        "neabord_id": "1399",
        "district_id": "111",
        "code": "08",
        "name": "Cristo Rey"
    },
    {
        "neabord_id": "1400",
        "district_id": "111",
        "code": "09",
        "name": "La Sierra"
    },
    {
        "neabord_id": "1401",
        "district_id": "111",
        "code": "10",
        "name": "Lourdes"
    },
    {
        "neabord_id": "1402",
        "district_id": "111",
        "code": "11",
        "name": "Mastatal"
    },
    {
        "neabord_id": "1403",
        "district_id": "111",
        "code": "12",
        "name": "Mollejoncito"
    },
    {
        "neabord_id": "1404",
        "district_id": "111",
        "code": "13",
        "name": "Mollejones"
    },
    {
        "neabord_id": "1405",
        "district_id": "111",
        "code": "14",
        "name": "Naranjos"
    },
    {
        "neabord_id": "1406",
        "district_id": "111",
        "code": "15",
        "name": "Oratorio"
    },
    {
        "neabord_id": "1407",
        "district_id": "111",
        "code": "16",
        "name": "San Carlos"
    },
    {
        "neabord_id": "1408",
        "district_id": "111",
        "code": "17",
        "name": "San Pablito"
    },
    {
        "neabord_id": "1409",
        "district_id": "111",
        "code": "18",
        "name": "San Pablo"
    },
    {
        "neabord_id": "1410",
        "district_id": "111",
        "code": "19",
        "name": "San Roque (parte)"
    },
    {
        "neabord_id": "1411",
        "district_id": "111",
        "code": "20",
        "name": "Socorro"
    },
    {
        "neabord_id": "1412",
        "district_id": "111",
        "code": "21",
        "name": "Surtubal (parte)"
    },
    {
        "neabord_id": "1413",
        "district_id": "111",
        "code": "22",
        "name": "Villa Argentina"
    },
    {
        "neabord_id": "1414",
        "district_id": "111",
        "code": "23",
        "name": "Villa Flor"
    },
    {
        "neabord_id": "1415",
        "district_id": "111",
        "code": "24",
        "name": "Vista de Mar."
    },
    {
        "neabord_id": "1416",
        "district_id": "112",
        "code": "01",
        "name": "Achiotal"
    },
    {
        "neabord_id": "1417",
        "district_id": "112",
        "code": "02",
        "name": "Aguila"
    },
    {
        "neabord_id": "1418",
        "district_id": "112",
        "code": "03",
        "name": "Alto Trinidad (Puñal)"
    },
    {
        "neabord_id": "1419",
        "district_id": "112",
        "code": "04",
        "name": "Bajo Caliente"
    },
    {
        "neabord_id": "1420",
        "district_id": "112",
        "code": "05",
        "name": "Bajo Minas"
    },
    {
        "neabord_id": "1421",
        "district_id": "112",
        "code": "06",
        "name": "Barrionuevo"
    },
    {
        "neabord_id": "1422",
        "district_id": "112",
        "code": "07",
        "name": "Bellavista"
    },
    {
        "neabord_id": "1423",
        "district_id": "112",
        "code": "08",
        "name": "Calientillo"
    },
    {
        "neabord_id": "1424",
        "district_id": "112",
        "code": "09",
        "name": "Corralillo"
    },
    {
        "neabord_id": "1425",
        "district_id": "112",
        "code": "10",
        "name": "China Kicha"
    },
    {
        "neabord_id": "1426",
        "district_id": "112",
        "code": "11",
        "name": "Delicias"
    },
    {
        "neabord_id": "1427",
        "district_id": "112",
        "code": "12",
        "name": "Desamparados"
    },
    {
        "neabord_id": "1428",
        "district_id": "112",
        "code": "13",
        "name": "El Progreso"
    },
    {
        "neabord_id": "1429",
        "district_id": "112",
        "code": "14",
        "name": "Gibre"
    },
    {
        "neabord_id": "1430",
        "district_id": "112",
        "code": "15",
        "name": "Guadalupe"
    },
    {
        "neabord_id": "1431",
        "district_id": "112",
        "code": "16",
        "name": "Las Cruces"
    },
    {
        "neabord_id": "1432",
        "district_id": "112",
        "code": "17",
        "name": "Mesas"
    },
    {
        "neabord_id": "1433",
        "district_id": "112",
        "code": "18",
        "name": "Minas"
    },
    {
        "neabord_id": "1434",
        "district_id": "112",
        "code": "19",
        "name": "Montezuma"
    },
    {
        "neabord_id": "1435",
        "district_id": "112",
        "code": "20",
        "name": "Paraiso"
    },
    {
        "neabord_id": "1436",
        "district_id": "112",
        "code": "21",
        "name": "San Antonio"
    },
    {
        "neabord_id": "1437",
        "district_id": "112",
        "code": "22",
        "name": "San Gabriel"
    },
    {
        "neabord_id": "1438",
        "district_id": "112",
        "code": "23",
        "name": "San Marcos"
    },
    {
        "neabord_id": "1439",
        "district_id": "112",
        "code": "24",
        "name": "San Marti­n"
    },
    {
        "neabord_id": "1440",
        "district_id": "112",
        "code": "25",
        "name": "San Miguel"
    },
    {
        "neabord_id": "1441",
        "district_id": "112",
        "code": "26",
        "name": "San Roque (parte)"
    },
    {
        "neabord_id": "1442",
        "district_id": "112",
        "code": "27",
        "name": "Santa Cecilia"
    },
    {
        "neabord_id": "1443",
        "district_id": "112",
        "code": "28",
        "name": "Santa Fe"
    },
    {
        "neabord_id": "1444",
        "district_id": "112",
        "code": "29",
        "name": "Santa Luisa"
    },
    {
        "neabord_id": "1445",
        "district_id": "112",
        "code": "30",
        "name": "Surtubal (parte)"
    },
    {
        "neabord_id": "1446",
        "district_id": "112",
        "code": "31",
        "name": "Trinidad"
    },
    {
        "neabord_id": "1447",
        "district_id": "112",
        "code": "32",
        "name": "Veracruz"
    },
    {
        "neabord_id": "1448",
        "district_id": "112",
        "code": "33",
        "name": "Zapote."
    },
    {
        "neabord_id": "1449",
        "district_id": "113",
        "code": "01",
        "name": "Cedral (parte)"
    },
    {
        "neabord_id": "1450",
        "district_id": "113",
        "code": "02",
        "name": "El Quemado"
    },
    {
        "neabord_id": "1451",
        "district_id": "113",
        "code": "03",
        "name": "Gloria"
    },
    {
        "neabord_id": "1452",
        "district_id": "113",
        "code": "04",
        "name": "Las Brisas"
    },
    {
        "neabord_id": "1453",
        "district_id": "113",
        "code": "05",
        "name": "Las Vegas"
    },
    {
        "neabord_id": "1454",
        "district_id": "113",
        "code": "06",
        "name": "Mercedes"
    },
    {
        "neabord_id": "1455",
        "district_id": "113",
        "code": "07",
        "name": "Montecarlo"
    },
    {
        "neabord_id": "1456",
        "district_id": "113",
        "code": "08",
        "name": "Navajuelar"
    },
    {
        "neabord_id": "1457",
        "district_id": "113",
        "code": "09",
        "name": "Nubes"
    },
    {
        "neabord_id": "1458",
        "district_id": "113",
        "code": "10",
        "name": "Parai­so"
    },
    {
        "neabord_id": "1459",
        "district_id": "113",
        "code": "11",
        "name": "Pilar"
    },
    {
        "neabord_id": "1460",
        "district_id": "113",
        "code": "12",
        "name": "Pueblo Nuevo"
    },
    {
        "neabord_id": "1461",
        "district_id": "113",
        "code": "13",
        "name": "Quizarra (parte)"
    },
    {
        "neabord_id": "1462",
        "district_id": "113",
        "code": "14",
        "name": "Salitrales"
    },
    {
        "neabord_id": "1463",
        "district_id": "113",
        "code": "15",
        "name": "San Francisco"
    },
    {
        "neabord_id": "1464",
        "district_id": "113",
        "code": "16",
        "name": "San Ignacio"
    },
    {
        "neabord_id": "1465",
        "district_id": "113",
        "code": "17",
        "name": "San Pedrito"
    },
    {
        "neabord_id": "1466",
        "district_id": "113",
        "code": "18",
        "name": "Santa Mari­a"
    },
    {
        "neabord_id": "1467",
        "district_id": "113",
        "code": "19",
        "name": "Santa Teresa."
    },
    {
        "neabord_id": "1468",
        "district_id": "114",
        "code": "01",
        "name": "Alfombra"
    },
    {
        "neabord_id": "1469",
        "district_id": "114",
        "code": "02",
        "name": "Alto Perla"
    },
    {
        "neabord_id": "1470",
        "district_id": "114",
        "code": "03",
        "name": "Bajos"
    },
    {
        "neabord_id": "1471",
        "district_id": "114",
        "code": "04",
        "name": "Bajos de Zapotal"
    },
    {
        "neabord_id": "1472",
        "district_id": "114",
        "code": "05",
        "name": "Baru"
    },
    {
        "neabord_id": "1473",
        "district_id": "114",
        "code": "06",
        "name": "Barucito"
    },
    {
        "neabord_id": "1474",
        "district_id": "114",
        "code": "07",
        "name": "Cacao"
    },
    {
        "neabord_id": "1475",
        "district_id": "114",
        "code": "08",
        "name": "Camarones"
    },
    {
        "neabord_id": "1476",
        "district_id": "114",
        "code": "09",
        "name": "Cañablanca"
    },
    {
        "neabord_id": "1477",
        "district_id": "114",
        "code": "10",
        "name": "Ceiba"
    },
    {
        "neabord_id": "1478",
        "district_id": "114",
        "code": "11",
        "name": "Chontales"
    },
    {
        "neabord_id": "1479",
        "district_id": "114",
        "code": "12",
        "name": "Farallas"
    },
    {
        "neabord_id": "1480",
        "district_id": "114",
        "code": "13",
        "name": "Florida"
    },
    {
        "neabord_id": "1481",
        "district_id": "114",
        "code": "14",
        "name": "San Juan de Dios (Guabo)"
    },
    {
        "neabord_id": "1482",
        "district_id": "114",
        "code": "15",
        "name": "Li­bano"
    },
    {
        "neabord_id": "1483",
        "district_id": "114",
        "code": "16",
        "name": "Magnolia"
    },
    {
        "neabord_id": "1484",
        "district_id": "114",
        "code": "17",
        "name": "Pozos"
    },
    {
        "neabord_id": "1485",
        "district_id": "114",
        "code": "18",
        "name": "Reina"
    },
    {
        "neabord_id": "1486",
        "district_id": "114",
        "code": "19",
        "name": "San Marcos"
    },
    {
        "neabord_id": "1487",
        "district_id": "114",
        "code": "20",
        "name": "San Salvador"
    },
    {
        "neabord_id": "1488",
        "district_id": "114",
        "code": "21",
        "name": "Santa Juana"
    },
    {
        "neabord_id": "1489",
        "district_id": "114",
        "code": "22",
        "name": "Santo Cristo"
    },
    {
        "neabord_id": "1490",
        "district_id": "114",
        "code": "23",
        "name": "Tinamaste (San Cristobal)"
    },
    {
        "neabord_id": "1491",
        "district_id": "114",
        "code": "24",
        "name": "Torito"
    },
    {
        "neabord_id": "1492",
        "district_id": "114",
        "code": "25",
        "name": "Tres Piedras (parte)"
    },
    {
        "neabord_id": "1493",
        "district_id": "114",
        "code": "26",
        "name": "Tumbas"
    },
    {
        "neabord_id": "1494",
        "district_id": "114",
        "code": "27",
        "name": "Villabonita Vista Mar."
    },
    {
        "neabord_id": "1495",
        "district_id": "115",
        "code": "01",
        "name": "Alto Mena"
    },
    {
        "neabord_id": "1496",
        "district_id": "115",
        "code": "02",
        "name": "Brujo"
    },
    {
        "neabord_id": "1497",
        "district_id": "115",
        "code": "03",
        "name": "Calle Los Mora"
    },
    {
        "neabord_id": "1498",
        "district_id": "115",
        "code": "04",
        "name": "Chiricano"
    },
    {
        "neabord_id": "1499",
        "district_id": "115",
        "code": "05",
        "name": "Gloria"
    },
    {
        "neabord_id": "1500",
        "district_id": "115",
        "code": "06",
        "name": "Loma Guacal"
    },
    {
        "neabord_id": "1501",
        "district_id": "115",
        "code": "07",
        "name": "Llano"
    },
    {
        "neabord_id": "1502",
        "district_id": "115",
        "code": "08",
        "name": "Parai­so"
    },
    {
        "neabord_id": "1503",
        "district_id": "115",
        "code": "09",
        "name": "Providencia (Parte)"
    },
    {
        "neabord_id": "1504",
        "district_id": "115",
        "code": "10",
        "name": "Purruja"
    },
    {
        "neabord_id": "1505",
        "district_id": "115",
        "code": "11",
        "name": "Ri­o Nuevo"
    },
    {
        "neabord_id": "1506",
        "district_id": "115",
        "code": "12",
        "name": "San Antonio"
    },
    {
        "neabord_id": "1507",
        "district_id": "115",
        "code": "13",
        "name": "Santa Marta"
    },
    {
        "neabord_id": "1508",
        "district_id": "115",
        "code": "14",
        "name": "Savegre Abajo"
    },
    {
        "neabord_id": "1509",
        "district_id": "115",
        "code": "15",
        "name": "Viento Fresco."
    },
    {
        "neabord_id": "1510",
        "district_id": "116",
        "code": "01",
        "name": "Alto Macho Mora"
    },
    {
        "neabord_id": "1511",
        "district_id": "116",
        "code": "02",
        "name": "angeles"
    },
    {
        "neabord_id": "1512",
        "district_id": "116",
        "code": "03",
        "name": "Berli­n"
    },
    {
        "neabord_id": "1513",
        "district_id": "116",
        "code": "04",
        "name": "Chanchera"
    },
    {
        "neabord_id": "1514",
        "district_id": "116",
        "code": "05",
        "name": "División (parte)"
    },
    {
        "neabord_id": "1515",
        "district_id": "116",
        "code": "06",
        "name": "Fortuna"
    },
    {
        "neabord_id": "1516",
        "district_id": "116",
        "code": "07",
        "name": "Hortensia"
    },
    {
        "neabord_id": "1517",
        "district_id": "116",
        "code": "08",
        "name": "La Ese"
    },
    {
        "neabord_id": "1518",
        "district_id": "116",
        "code": "09",
        "name": "La Piedra"
    },
    {
        "neabord_id": "1519",
        "district_id": "116",
        "code": "10",
        "name": "Lira"
    },
    {
        "neabord_id": "1520",
        "district_id": "116",
        "code": "11",
        "name": "Matasanos"
    },
    {
        "neabord_id": "1521",
        "district_id": "116",
        "code": "12",
        "name": "Palma"
    },
    {
        "neabord_id": "1522",
        "district_id": "116",
        "code": "13",
        "name": "Pedregosito"
    },
    {
        "neabord_id": "1523",
        "district_id": "116",
        "code": "14",
        "name": "Providencia (Parte)"
    },
    {
        "neabord_id": "1524",
        "district_id": "116",
        "code": "15",
        "name": "San Ramón Norte"
    },
    {
        "neabord_id": "1525",
        "district_id": "116",
        "code": "16",
        "name": "Santa Eduvigis"
    },
    {
        "neabord_id": "1526",
        "district_id": "116",
        "code": "17",
        "name": "Santo Tomas"
    },
    {
        "neabord_id": "1527",
        "district_id": "116",
        "code": "18",
        "name": "Siberia (parte)"
    },
    {
        "neabord_id": "1528",
        "district_id": "116",
        "code": "19",
        "name": "Valencia."
    },
    {
        "neabord_id": "1529",
        "district_id": "117",
        "code": "01",
        "name": "Estadio"
    },
    {
        "neabord_id": "1530",
        "district_id": "117",
        "code": "02",
        "name": "La Clara"
    },
    {
        "neabord_id": "1531",
        "district_id": "117",
        "code": "03",
        "name": "La Virgen"
    },
    {
        "neabord_id": "1532",
        "district_id": "117",
        "code": "04",
        "name": "Los angeles"
    },
    {
        "neabord_id": "1533",
        "district_id": "117",
        "code": "05",
        "name": "Sagrada Familia."
    },
    {
        "neabord_id": "1534",
        "district_id": "117",
        "code": "06",
        "name": "Abejonal"
    },
    {
        "neabord_id": "1535",
        "district_id": "117",
        "code": "07",
        "name": "Carrizales"
    },
    {
        "neabord_id": "1536",
        "district_id": "117",
        "code": "08",
        "name": "Los Navarro"
    },
    {
        "neabord_id": "1537",
        "district_id": "117",
        "code": "09",
        "name": "Montes de Oro"
    },
    {
        "neabord_id": "1538",
        "district_id": "117",
        "code": "10",
        "name": "Rosario."
    },
    {
        "neabord_id": "1539",
        "district_id": "118",
        "code": "01",
        "name": "Angostura (parte)"
    },
    {
        "neabord_id": "1540",
        "district_id": "118",
        "code": "02",
        "name": "Bajo Gamboa"
    },
    {
        "neabord_id": "1541",
        "district_id": "118",
        "code": "03",
        "name": "Higuerón"
    },
    {
        "neabord_id": "1542",
        "district_id": "118",
        "code": "04",
        "name": "Llano Grande"
    },
    {
        "neabord_id": "1543",
        "district_id": "118",
        "code": "05",
        "name": "Ojo de Agua (parte)"
    },
    {
        "neabord_id": "1544",
        "district_id": "118",
        "code": "06",
        "name": "Rastrojales."
    },
    {
        "neabord_id": "1545",
        "district_id": "119",
        "code": "01",
        "name": "Bajo Mora"
    },
    {
        "neabord_id": "1546",
        "district_id": "119",
        "code": "02",
        "name": "Bajo Venegas (parte)"
    },
    {
        "neabord_id": "1547",
        "district_id": "119",
        "code": "03",
        "name": "Concepción"
    },
    {
        "neabord_id": "1548",
        "district_id": "119",
        "code": "04",
        "name": "San Francisco"
    },
    {
        "neabord_id": "1549",
        "district_id": "119",
        "code": "05",
        "name": "San Luis"
    },
    {
        "neabord_id": "1550",
        "district_id": "119",
        "code": "06",
        "name": "San Rafael Abajo"
    },
    {
        "neabord_id": "1551",
        "district_id": "119",
        "code": "07",
        "name": "Santa Juana"
    },
    {
        "neabord_id": "1552",
        "district_id": "119",
        "code": "08",
        "name": "Santa Rosa (parte)."
    },
    {
        "neabord_id": "1553",
        "district_id": "120",
        "code": "01",
        "name": "Alto Carrizal"
    },
    {
        "neabord_id": "1554",
        "district_id": "120",
        "code": "02",
        "name": "Loma de la Altura"
    },
    {
        "neabord_id": "1555",
        "district_id": "120",
        "code": "03",
        "name": "Santa Rosa (parte)"
    },
    {
        "neabord_id": "1556",
        "district_id": "120",
        "code": "04",
        "name": "Trinidad."
    },
    {
        "neabord_id": "1557",
        "district_id": "121",
        "code": "01",
        "name": "Cedral (parte)"
    },
    {
        "neabord_id": "1558",
        "district_id": "121",
        "code": "02",
        "name": "Lucha (parte)"
    },
    {
        "neabord_id": "1559",
        "district_id": "121",
        "code": "03",
        "name": "San Marti­n"
    },
    {
        "neabord_id": "1560",
        "district_id": "121",
        "code": "04",
        "name": "Rincón Gamboa."
    },
    {
        "neabord_id": "1561",
        "district_id": "122",
        "code": "01",
        "name": "Angostura (parte)"
    },
    {
        "neabord_id": "1562",
        "district_id": "122",
        "code": "02",
        "name": "Cuesta."
    },
    {
        "neabord_id": "1563",
        "district_id": "123",
        "code": "01",
        "name": "Acequia Grande (parte)"
    },
    {
        "neabord_id": "1564",
        "district_id": "123",
        "code": "02",
        "name": "Agoni­a"
    },
    {
        "neabord_id": "1565",
        "district_id": "123",
        "code": "03",
        "name": "Arroyo"
    },
    {
        "neabord_id": "1566",
        "district_id": "123",
        "code": "04",
        "name": "Bajo Cornizal"
    },
    {
        "neabord_id": "1567",
        "district_id": "123",
        "code": "05",
        "name": "Brasil (parte)"
    },
    {
        "neabord_id": "1568",
        "district_id": "123",
        "code": "06",
        "name": "Cafetal"
    },
    {
        "neabord_id": "1569",
        "district_id": "123",
        "code": "07",
        "name": "Canoas"
    },
    {
        "neabord_id": "1570",
        "district_id": "123",
        "code": "08",
        "name": "Carmen"
    },
    {
        "neabord_id": "1571",
        "district_id": "123",
        "code": "09",
        "name": "Cementerio"
    },
    {
        "neabord_id": "1572",
        "district_id": "123",
        "code": "10",
        "name": "Concepción"
    },
    {
        "neabord_id": "1573",
        "district_id": "123",
        "code": "11",
        "name": "Ciruelas"
    },
    {
        "neabord_id": "1574",
        "district_id": "123",
        "code": "12",
        "name": "Corazón de Jesus"
    },
    {
        "neabord_id": "1575",
        "district_id": "123",
        "code": "13",
        "name": "Cristo Rey"
    },
    {
        "neabord_id": "1576",
        "district_id": "123",
        "code": "14",
        "name": "Gregorio Jose Rami­rez"
    },
    {
        "neabord_id": "1577",
        "district_id": "123",
        "code": "15",
        "name": "Guadalupe"
    },
    {
        "neabord_id": "1578",
        "district_id": "123",
        "code": "16",
        "name": "Higuerones"
    },
    {
        "neabord_id": "1579",
        "district_id": "123",
        "code": "17",
        "name": "Hospital"
    },
    {
        "neabord_id": "1580",
        "district_id": "123",
        "code": "18",
        "name": "Llano"
    },
    {
        "neabord_id": "1581",
        "district_id": "123",
        "code": "19",
        "name": "Llobet"
    },
    {
        "neabord_id": "1582",
        "district_id": "123",
        "code": "20",
        "name": "Molinos"
    },
    {
        "neabord_id": "1583",
        "district_id": "123",
        "code": "21",
        "name": "Montecillos (parte)"
    },
    {
        "neabord_id": "1584",
        "district_id": "123",
        "code": "22",
        "name": "Montenegro"
    },
    {
        "neabord_id": "1585",
        "district_id": "123",
        "code": "23",
        "name": "Monserrat (parte)"
    },
    {
        "neabord_id": "1586",
        "district_id": "123",
        "code": "24",
        "name": "Paso Flores"
    },
    {
        "neabord_id": "1587",
        "district_id": "123",
        "code": "25",
        "name": "Providencia"
    },
    {
        "neabord_id": "1588",
        "district_id": "123",
        "code": "26",
        "name": "Retiro"
    },
    {
        "neabord_id": "1589",
        "district_id": "123",
        "code": "27",
        "name": "San Luis"
    },
    {
        "neabord_id": "1590",
        "district_id": "123",
        "code": "28",
        "name": "Tomas Guardia"
    },
    {
        "neabord_id": "1591",
        "district_id": "123",
        "code": "29",
        "name": "Tropicana"
    },
    {
        "neabord_id": "1592",
        "district_id": "123",
        "code": "30",
        "name": "Villabonita (parte)"
    },
    {
        "neabord_id": "1593",
        "district_id": "123",
        "code": "31",
        "name": "Villahermosa."
    },
    {
        "neabord_id": "1594",
        "district_id": "124",
        "code": "01",
        "name": "Amistad"
    },
    {
        "neabord_id": "1595",
        "district_id": "124",
        "code": "02",
        "name": "Botanica"
    },
    {
        "neabord_id": "1596",
        "district_id": "124",
        "code": "03",
        "name": "Copablanca"
    },
    {
        "neabord_id": "1597",
        "district_id": "124",
        "code": "04",
        "name": "Flores"
    },
    {
        "neabord_id": "1598",
        "district_id": "124",
        "code": "05",
        "name": "Jardines"
    },
    {
        "neabord_id": "1599",
        "district_id": "124",
        "code": "06",
        "name": "Jocote"
    },
    {
        "neabord_id": "1600",
        "district_id": "124",
        "code": "07",
        "name": "Juan Santamari­a"
    },
    {
        "neabord_id": "1601",
        "district_id": "124",
        "code": "08",
        "name": "Lagunilla"
    },
    {
        "neabord_id": "1602",
        "district_id": "124",
        "code": "09",
        "name": "Mandarina (parte)"
    },
    {
        "neabord_id": "1603",
        "district_id": "124",
        "code": "10",
        "name": "Maravilla (parte)"
    },
    {
        "neabord_id": "1604",
        "district_id": "124",
        "code": "11",
        "name": "Montesol (parte)"
    },
    {
        "neabord_id": "1605",
        "district_id": "124",
        "code": "12",
        "name": "Pueblo Nuevo"
    },
    {
        "neabord_id": "1606",
        "district_id": "124",
        "code": "13",
        "name": "San Rafael"
    },
    {
        "neabord_id": "1607",
        "district_id": "124",
        "code": "14",
        "name": "Santa Rita"
    },
    {
        "neabord_id": "1608",
        "district_id": "124",
        "code": "15",
        "name": "Tigra"
    },
    {
        "neabord_id": "1609",
        "district_id": "124",
        "code": "16",
        "name": "Torre"
    },
    {
        "neabord_id": "1610",
        "district_id": "124",
        "code": "17",
        "name": "Trinidad"
    },
    {
        "neabord_id": "1611",
        "district_id": "124",
        "code": "18",
        "name": "Tuetal Sur."
    },
    {
        "neabord_id": "1612",
        "district_id": "124",
        "code": "19",
        "name": "Coyol"
    },
    {
        "neabord_id": "1613",
        "district_id": "124",
        "code": "20",
        "name": "Flores."
    },
    {
        "neabord_id": "1614",
        "district_id": "125",
        "code": "01",
        "name": "Alto Pavas"
    },
    {
        "neabord_id": "1615",
        "district_id": "125",
        "code": "02",
        "name": "Bambu"
    },
    {
        "neabord_id": "1616",
        "district_id": "125",
        "code": "03",
        "name": "Cinco Esquinas"
    },
    {
        "neabord_id": "1617",
        "district_id": "125",
        "code": "04",
        "name": "Concordia"
    },
    {
        "neabord_id": "1618",
        "district_id": "125",
        "code": "05",
        "name": "Domingas"
    },
    {
        "neabord_id": "1619",
        "district_id": "125",
        "code": "06",
        "name": "El Plan."
    },
    {
        "neabord_id": "1620",
        "district_id": "126",
        "code": "01",
        "name": "Acequia Grande (parte)"
    },
    {
        "neabord_id": "1621",
        "district_id": "126",
        "code": "02",
        "name": "Bajo Monge"
    },
    {
        "neabord_id": "1622",
        "district_id": "126",
        "code": "03",
        "name": "Cañada"
    },
    {
        "neabord_id": "1623",
        "district_id": "126",
        "code": "04",
        "name": "Montecillos (parte)"
    },
    {
        "neabord_id": "1624",
        "district_id": "126",
        "code": "05",
        "name": "Monserrat (parte)"
    },
    {
        "neabord_id": "1625",
        "district_id": "126",
        "code": "06",
        "name": "Puente Arena (parte)"
    },
    {
        "neabord_id": "1626",
        "district_id": "126",
        "code": "07",
        "name": "Tejar"
    },
    {
        "neabord_id": "1627",
        "district_id": "126",
        "code": "08",
        "name": "Vegas"
    },
    {
        "neabord_id": "1628",
        "district_id": "126",
        "code": "09",
        "name": "Villabonita (parte)."
    },
    {
        "neabord_id": "1629",
        "district_id": "126",
        "code": "10",
        "name": "Ciruelas"
    },
    {
        "neabord_id": "1630",
        "district_id": "126",
        "code": "11",
        "name": "Roble"
    },
    {
        "neabord_id": "1631",
        "district_id": "126",
        "code": "12",
        "name": "Sanchez."
    },
    {
        "neabord_id": "1632",
        "district_id": "127",
        "code": "01",
        "name": "Bajo Tejar"
    },
    {
        "neabord_id": "1633",
        "district_id": "127",
        "code": "02",
        "name": "Cacao"
    },
    {
        "neabord_id": "1634",
        "district_id": "127",
        "code": "03",
        "name": "Cañada"
    },
    {
        "neabord_id": "1635",
        "district_id": "127",
        "code": "04",
        "name": "Coco"
    },
    {
        "neabord_id": "1636",
        "district_id": "127",
        "code": "05",
        "name": "El Bajo"
    },
    {
        "neabord_id": "1637",
        "district_id": "127",
        "code": "06",
        "name": "Hacienda Los Reyes"
    },
    {
        "neabord_id": "1638",
        "district_id": "127",
        "code": "07",
        "name": "Nuestro Amo"
    },
    {
        "neabord_id": "1639",
        "district_id": "127",
        "code": "08",
        "name": "Rincón Chiquito"
    },
    {
        "neabord_id": "1640",
        "district_id": "127",
        "code": "09",
        "name": "Rincón de Herrera"
    },
    {
        "neabord_id": "1641",
        "district_id": "127",
        "code": "10",
        "name": "Rincón de Monge"
    },
    {
        "neabord_id": "1642",
        "district_id": "127",
        "code": "11",
        "name": "Ventanas"
    },
    {
        "neabord_id": "1643",
        "district_id": "127",
        "code": "12",
        "name": "Vueltas."
    },
    {
        "neabord_id": "1644",
        "district_id": "128",
        "code": "01",
        "name": "Barrios (Alajuela): Aguilar"
    },
    {
        "neabord_id": "1645",
        "district_id": "128",
        "code": "02",
        "name": "Ceiba"
    },
    {
        "neabord_id": "1646",
        "district_id": "128",
        "code": "03",
        "name": "San Marti­n."
    },
    {
        "neabord_id": "1647",
        "district_id": "128",
        "code": "04",
        "name": "Alto Pilas"
    },
    {
        "neabord_id": "1648",
        "district_id": "128",
        "code": "05",
        "name": "Buri­os"
    },
    {
        "neabord_id": "1649",
        "district_id": "128",
        "code": "06",
        "name": "Carbonal"
    },
    {
        "neabord_id": "1650",
        "district_id": "128",
        "code": "07",
        "name": "Cerrillal"
    },
    {
        "neabord_id": "1651",
        "district_id": "128",
        "code": "08",
        "name": "Dulce Nombre"
    },
    {
        "neabord_id": "1652",
        "district_id": "128",
        "code": "09",
        "name": "Espino (parte)"
    },
    {
        "neabord_id": "1653",
        "district_id": "128",
        "code": "10",
        "name": "Itiqui­s"
    },
    {
        "neabord_id": "1654",
        "district_id": "128",
        "code": "11",
        "name": "Laguna"
    },
    {
        "neabord_id": "1655",
        "district_id": "128",
        "code": "12",
        "name": "Lori­a"
    },
    {
        "neabord_id": "1656",
        "district_id": "128",
        "code": "13",
        "name": "Maravilla (parte)"
    },
    {
        "neabord_id": "1657",
        "district_id": "128",
        "code": "14",
        "name": "Montaña"
    },
    {
        "neabord_id": "1658",
        "district_id": "128",
        "code": "15",
        "name": "Pilas"
    },
    {
        "neabord_id": "1659",
        "district_id": "128",
        "code": "16",
        "name": "Potrerillos"
    },
    {
        "neabord_id": "1660",
        "district_id": "128",
        "code": "17",
        "name": "San Jerónimo"
    },
    {
        "neabord_id": "1661",
        "district_id": "128",
        "code": "18",
        "name": "San Rafael"
    },
    {
        "neabord_id": "1662",
        "district_id": "128",
        "code": "19",
        "name": "Tacacori­"
    },
    {
        "neabord_id": "1663",
        "district_id": "128",
        "code": "20",
        "name": "Tuetal Norte (parte)"
    },
    {
        "neabord_id": "1664",
        "district_id": "128",
        "code": "21",
        "name": "Villas de la Ceiba."
    },
    {
        "neabord_id": "1665",
        "district_id": "129",
        "code": "01",
        "name": "Alto del Desengaño"
    },
    {
        "neabord_id": "1666",
        "district_id": "129",
        "code": "02",
        "name": "angeles"
    },
    {
        "neabord_id": "1667",
        "district_id": "129",
        "code": "03",
        "name": "Bajo Santa Barbara"
    },
    {
        "neabord_id": "1668",
        "district_id": "129",
        "code": "04",
        "name": "Cerro"
    },
    {
        "neabord_id": "1669",
        "district_id": "129",
        "code": "05",
        "name": "Doka"
    },
    {
        "neabord_id": "1670",
        "district_id": "129",
        "code": "06",
        "name": "Espino (parte)"
    },
    {
        "neabord_id": "1671",
        "district_id": "129",
        "code": "07",
        "name": "Fraijanes"
    },
    {
        "neabord_id": "1672",
        "district_id": "129",
        "code": "08",
        "name": "Lajas"
    },
    {
        "neabord_id": "1673",
        "district_id": "129",
        "code": "09",
        "name": "Poasito"
    },
    {
        "neabord_id": "1674",
        "district_id": "129",
        "code": "10",
        "name": "San Luis"
    },
    {
        "neabord_id": "1675",
        "district_id": "129",
        "code": "11",
        "name": "San Rafael"
    },
    {
        "neabord_id": "1676",
        "district_id": "129",
        "code": "12",
        "name": "Vargas (parte)."
    },
    {
        "neabord_id": "1677",
        "district_id": "130",
        "code": "01",
        "name": "La Paz"
    },
    {
        "neabord_id": "1678",
        "district_id": "130",
        "code": "02",
        "name": "Perla."
    },
    {
        "neabord_id": "1679",
        "district_id": "130",
        "code": "03",
        "name": "Cañada"
    },
    {
        "neabord_id": "1680",
        "district_id": "130",
        "code": "04",
        "name": "Ojo de Agua"
    },
    {
        "neabord_id": "1681",
        "district_id": "130",
        "code": "05",
        "name": "Paires"
    },
    {
        "neabord_id": "1682",
        "district_id": "130",
        "code": "06",
        "name": "Potrerillos"
    },
    {
        "neabord_id": "1683",
        "district_id": "130",
        "code": "07",
        "name": "Rincón Venegas."
    },
    {
        "neabord_id": "1684",
        "district_id": "131",
        "code": "01",
        "name": "angeles"
    },
    {
        "neabord_id": "1685",
        "district_id": "131",
        "code": "02",
        "name": "Bajo Cañas (parte)"
    },
    {
        "neabord_id": "1686",
        "district_id": "131",
        "code": "03",
        "name": "Bajo La Sorda"
    },
    {
        "neabord_id": "1687",
        "district_id": "131",
        "code": "04",
        "name": "Cacique"
    },
    {
        "neabord_id": "1688",
        "district_id": "131",
        "code": "05",
        "name": "California"
    },
    {
        "neabord_id": "1689",
        "district_id": "131",
        "code": "06",
        "name": "Cañas (parte)"
    },
    {
        "neabord_id": "1690",
        "district_id": "131",
        "code": "07",
        "name": "Guayabo"
    },
    {
        "neabord_id": "1691",
        "district_id": "131",
        "code": "08",
        "name": "Monserrat (parte)"
    },
    {
        "neabord_id": "1692",
        "district_id": "131",
        "code": "09",
        "name": "Puente Arena (parte)"
    },
    {
        "neabord_id": "1693",
        "district_id": "131",
        "code": "10",
        "name": "Villalobos"
    },
    {
        "neabord_id": "1694",
        "district_id": "131",
        "code": "11",
        "name": "Vi­quez."
    },
    {
        "neabord_id": "1695",
        "district_id": "132",
        "code": "01",
        "name": "Bajo Cañas (parte)"
    },
    {
        "neabord_id": "1696",
        "district_id": "132",
        "code": "02",
        "name": "Bellavista"
    },
    {
        "neabord_id": "1697",
        "district_id": "132",
        "code": "03",
        "name": "Brasil (parte)"
    },
    {
        "neabord_id": "1698",
        "district_id": "132",
        "code": "04",
        "name": "Calicanto"
    },
    {
        "neabord_id": "1699",
        "district_id": "132",
        "code": "05",
        "name": "Cañas (parte)"
    },
    {
        "neabord_id": "1700",
        "district_id": "132",
        "code": "06",
        "name": "Erizo"
    },
    {
        "neabord_id": "1701",
        "district_id": "132",
        "code": "07",
        "name": "Mojón"
    },
    {
        "neabord_id": "1702",
        "district_id": "132",
        "code": "08",
        "name": "Pasito"
    },
    {
        "neabord_id": "1703",
        "district_id": "132",
        "code": "09",
        "name": "Rincón"
    },
    {
        "neabord_id": "1704",
        "district_id": "132",
        "code": "10",
        "name": "Rosales (parte)"
    },
    {
        "neabord_id": "1705",
        "district_id": "132",
        "code": "11",
        "name": "Targuases"
    },
    {
        "neabord_id": "1706",
        "district_id": "132",
        "code": "12",
        "name": "Tres Piedras."
    },
    {
        "neabord_id": "1707",
        "district_id": "133",
        "code": "01",
        "name": "Bajo Pita"
    },
    {
        "neabord_id": "1708",
        "district_id": "133",
        "code": "02",
        "name": "Granja"
    },
    {
        "neabord_id": "1709",
        "district_id": "133",
        "code": "03",
        "name": "Morera"
    },
    {
        "neabord_id": "1710",
        "district_id": "133",
        "code": "04",
        "name": "San Marti­n"
    },
    {
        "neabord_id": "1711",
        "district_id": "133",
        "code": "05",
        "name": "Santa Rita"
    },
    {
        "neabord_id": "1712",
        "district_id": "133",
        "code": "06",
        "name": "Turrucareña"
    },
    {
        "neabord_id": "1713",
        "district_id": "133",
        "code": "07",
        "name": "Villacares."
    },
    {
        "neabord_id": "1714",
        "district_id": "133",
        "code": "08",
        "name": "Bajo San Miguel"
    },
    {
        "neabord_id": "1715",
        "district_id": "133",
        "code": "09",
        "name": "Candelaria"
    },
    {
        "neabord_id": "1716",
        "district_id": "133",
        "code": "10",
        "name": "Carrera Buena"
    },
    {
        "neabord_id": "1717",
        "district_id": "133",
        "code": "11",
        "name": "Cebadilla"
    },
    {
        "neabord_id": "1718",
        "district_id": "133",
        "code": "12",
        "name": "Cerrillos (San Miguel)"
    },
    {
        "neabord_id": "1719",
        "district_id": "133",
        "code": "13",
        "name": "Conejo"
    },
    {
        "neabord_id": "1720",
        "district_id": "133",
        "code": "14",
        "name": "Juntas"
    },
    {
        "neabord_id": "1721",
        "district_id": "133",
        "code": "15",
        "name": "Siquiares"
    },
    {
        "neabord_id": "1722",
        "district_id": "133",
        "code": "16",
        "name": "Tamarindo."
    },
    {
        "neabord_id": "1723",
        "district_id": "134",
        "code": "01",
        "name": "Cacao"
    },
    {
        "neabord_id": "1724",
        "district_id": "134",
        "code": "02",
        "name": "Calle Liles"
    },
    {
        "neabord_id": "1725",
        "district_id": "134",
        "code": "03",
        "name": "Gonzalez"
    },
    {
        "neabord_id": "1726",
        "district_id": "134",
        "code": "04",
        "name": "Quebradas"
    },
    {
        "neabord_id": "1727",
        "district_id": "134",
        "code": "05",
        "name": "Rincón Cacao"
    },
    {
        "neabord_id": "1728",
        "district_id": "134",
        "code": "06",
        "name": "Tuetal Norte (parte)"
    },
    {
        "neabord_id": "1729",
        "district_id": "134",
        "code": "07",
        "name": "Vargas (parte)."
    },
    {
        "neabord_id": "1730",
        "district_id": "135",
        "code": "01",
        "name": "Animas"
    },
    {
        "neabord_id": "1731",
        "district_id": "135",
        "code": "02",
        "name": "Cuesta Colorada"
    },
    {
        "neabord_id": "1732",
        "district_id": "135",
        "code": "03",
        "name": "Copeyal"
    },
    {
        "neabord_id": "1733",
        "district_id": "135",
        "code": "04",
        "name": "Horcones"
    },
    {
        "neabord_id": "1734",
        "district_id": "135",
        "code": "05",
        "name": "Lagos del Coyol"
    },
    {
        "neabord_id": "1735",
        "district_id": "135",
        "code": "06",
        "name": "Llanos"
    },
    {
        "neabord_id": "1736",
        "district_id": "135",
        "code": "07",
        "name": "Mandarina (parte)"
    },
    {
        "neabord_id": "1737",
        "district_id": "135",
        "code": "08",
        "name": "Manolos"
    },
    {
        "neabord_id": "1738",
        "district_id": "135",
        "code": "09",
        "name": "Mina"
    },
    {
        "neabord_id": "1739",
        "district_id": "135",
        "code": "10",
        "name": "Montesol (parte)"
    },
    {
        "neabord_id": "1740",
        "district_id": "135",
        "code": "11",
        "name": "Monticel"
    },
    {
        "neabord_id": "1741",
        "district_id": "135",
        "code": "12",
        "name": "Saltillo."
    },
    {
        "neabord_id": "1742",
        "district_id": "136",
        "code": "01",
        "name": "Bajo Latas"
    },
    {
        "neabord_id": "1743",
        "district_id": "136",
        "code": "02",
        "name": "Cariblanco"
    },
    {
        "neabord_id": "1744",
        "district_id": "136",
        "code": "03",
        "name": "Corazón de Jesus"
    },
    {
        "neabord_id": "1745",
        "district_id": "136",
        "code": "04",
        "name": "Isla Bonita"
    },
    {
        "neabord_id": "1746",
        "district_id": "136",
        "code": "05",
        "name": "Nueva Cinchona"
    },
    {
        "neabord_id": "1747",
        "district_id": "136",
        "code": "06",
        "name": "San Antonio"
    },
    {
        "neabord_id": "1748",
        "district_id": "136",
        "code": "07",
        "name": "Parai­so"
    },
    {
        "neabord_id": "1749",
        "district_id": "136",
        "code": "08",
        "name": "Punta Mala"
    },
    {
        "neabord_id": "1750",
        "district_id": "136",
        "code": "09",
        "name": "Ujarras"
    },
    {
        "neabord_id": "1751",
        "district_id": "136",
        "code": "10",
        "name": "Virgen del Socorro (parte)."
    },
    {
        "neabord_id": "1752",
        "district_id": "137",
        "code": "01",
        "name": "Bajo Ladrillera"
    },
    {
        "neabord_id": "1753",
        "district_id": "137",
        "code": "02",
        "name": "Cachera"
    },
    {
        "neabord_id": "1754",
        "district_id": "137",
        "code": "03",
        "name": "Lisi­maco Chavarri­a"
    },
    {
        "neabord_id": "1755",
        "district_id": "137",
        "code": "04",
        "name": "Sabana (parte)"
    },
    {
        "neabord_id": "1756",
        "district_id": "137",
        "code": "05",
        "name": "San Jose"
    },
    {
        "neabord_id": "1757",
        "district_id": "137",
        "code": "06",
        "name": "Tremedal (parte)."
    },
    {
        "neabord_id": "1758",
        "district_id": "138",
        "code": "01",
        "name": "Arias"
    },
    {
        "neabord_id": "1759",
        "district_id": "138",
        "code": "02",
        "name": "Montserrat."
    },
    {
        "neabord_id": "1760",
        "district_id": "138",
        "code": "03",
        "name": "Alto Santiago"
    },
    {
        "neabord_id": "1761",
        "district_id": "138",
        "code": "04",
        "name": "Alto Salas"
    },
    {
        "neabord_id": "1762",
        "district_id": "138",
        "code": "05",
        "name": "Angostura"
    },
    {
        "neabord_id": "1763",
        "district_id": "138",
        "code": "06",
        "name": "Balboa"
    },
    {
        "neabord_id": "1764",
        "district_id": "138",
        "code": "07",
        "name": "Cambronero"
    },
    {
        "neabord_id": "1765",
        "district_id": "138",
        "code": "08",
        "name": "Constancia"
    },
    {
        "neabord_id": "1766",
        "district_id": "138",
        "code": "09",
        "name": "Cuesta del Toro"
    },
    {
        "neabord_id": "1767",
        "district_id": "138",
        "code": "10",
        "name": "Empalme"
    },
    {
        "neabord_id": "1768",
        "district_id": "138",
        "code": "11",
        "name": "La Ese"
    },
    {
        "neabord_id": "1769",
        "district_id": "138",
        "code": "12",
        "name": "León"
    },
    {
        "neabord_id": "1770",
        "district_id": "138",
        "code": "13",
        "name": "Magallanes"
    },
    {
        "neabord_id": "1771",
        "district_id": "138",
        "code": "14",
        "name": "Moncada"
    },
    {
        "neabord_id": "1772",
        "district_id": "138",
        "code": "15",
        "name": "Ri­o Jesus."
    },
    {
        "neabord_id": "1773",
        "district_id": "139",
        "code": "01",
        "name": "Americana"
    },
    {
        "neabord_id": "1774",
        "district_id": "139",
        "code": "02",
        "name": "Bajo Tajos"
    },
    {
        "neabord_id": "1775",
        "district_id": "139",
        "code": "03",
        "name": "Belen"
    },
    {
        "neabord_id": "1776",
        "district_id": "139",
        "code": "04",
        "name": "Cipreses"
    },
    {
        "neabord_id": "1777",
        "district_id": "139",
        "code": "05",
        "name": "Lirios"
    },
    {
        "neabord_id": "1778",
        "district_id": "139",
        "code": "06",
        "name": "Llamarón"
    },
    {
        "neabord_id": "1779",
        "district_id": "139",
        "code": "07",
        "name": "Pueblo Nuevo"
    },
    {
        "neabord_id": "1780",
        "district_id": "139",
        "code": "08",
        "name": "Tanque"
    },
    {
        "neabord_id": "1781",
        "district_id": "139",
        "code": "09",
        "name": "Tejar"
    },
    {
        "neabord_id": "1782",
        "district_id": "139",
        "code": "10",
        "name": "Vicente Badilla."
    },
    {
        "neabord_id": "1783",
        "district_id": "139",
        "code": "11",
        "name": "Juntas (parte)."
    },
    {
        "neabord_id": "1784",
        "district_id": "140",
        "code": "01",
        "name": "Copan."
    },
    {
        "neabord_id": "1785",
        "district_id": "140",
        "code": "02",
        "name": "Araya"
    },
    {
        "neabord_id": "1786",
        "district_id": "140",
        "code": "03",
        "name": "Bajo Matamoros (parte)"
    },
    {
        "neabord_id": "1787",
        "district_id": "140",
        "code": "04",
        "name": "Boli­var"
    },
    {
        "neabord_id": "1788",
        "district_id": "140",
        "code": "05",
        "name": "Campos"
    },
    {
        "neabord_id": "1789",
        "district_id": "140",
        "code": "06",
        "name": "Esperanza"
    },
    {
        "neabord_id": "1790",
        "district_id": "140",
        "code": "07",
        "name": "La Paz"
    },
    {
        "neabord_id": "1791",
        "district_id": "140",
        "code": "08",
        "name": "Lomas"
    },
    {
        "neabord_id": "1792",
        "district_id": "140",
        "code": "09",
        "name": "Piedades Noroeste."
    },
    {
        "neabord_id": "1793",
        "district_id": "141",
        "code": "01",
        "name": "Bajo Barranca"
    },
    {
        "neabord_id": "1794",
        "district_id": "141",
        "code": "02",
        "name": "Barranca"
    },
    {
        "neabord_id": "1795",
        "district_id": "141",
        "code": "03",
        "name": "Bureal"
    },
    {
        "neabord_id": "1796",
        "district_id": "141",
        "code": "04",
        "name": "Carmen"
    },
    {
        "neabord_id": "1797",
        "district_id": "141",
        "code": "05",
        "name": "Chassoul"
    },
    {
        "neabord_id": "1798",
        "district_id": "141",
        "code": "06",
        "name": "Guaria"
    },
    {
        "neabord_id": "1799",
        "district_id": "141",
        "code": "07",
        "name": "Nagatac"
    },
    {
        "neabord_id": "1800",
        "district_id": "141",
        "code": "08",
        "name": "Palma"
    },
    {
        "neabord_id": "1801",
        "district_id": "141",
        "code": "09",
        "name": "Potrerillos"
    },
    {
        "neabord_id": "1802",
        "district_id": "141",
        "code": "10",
        "name": "Quebradillas"
    },
    {
        "neabord_id": "1803",
        "district_id": "141",
        "code": "11",
        "name": "Salvador"
    },
    {
        "neabord_id": "1804",
        "district_id": "141",
        "code": "12",
        "name": "San Bosco"
    },
    {
        "neabord_id": "1805",
        "district_id": "141",
        "code": "13",
        "name": "San Francisco"
    },
    {
        "neabord_id": "1806",
        "district_id": "141",
        "code": "14",
        "name": "San Miguel"
    },
    {
        "neabord_id": "1807",
        "district_id": "141",
        "code": "15",
        "name": "Sardinal"
    },
    {
        "neabord_id": "1808",
        "district_id": "141",
        "code": "16",
        "name": "Socorro."
    },
    {
        "neabord_id": "1809",
        "district_id": "142",
        "code": "01",
        "name": "Tres Mari­as"
    },
    {
        "neabord_id": "1810",
        "district_id": "142",
        "code": "02",
        "name": "Unión."
    },
    {
        "neabord_id": "1811",
        "district_id": "142",
        "code": "03",
        "name": "Alto Llano"
    },
    {
        "neabord_id": "1812",
        "district_id": "142",
        "code": "04",
        "name": "Berli­n"
    },
    {
        "neabord_id": "1813",
        "district_id": "142",
        "code": "05",
        "name": "Calera"
    },
    {
        "neabord_id": "1814",
        "district_id": "142",
        "code": "06",
        "name": "Chavarri­a"
    },
    {
        "neabord_id": "1815",
        "district_id": "142",
        "code": "07",
        "name": "Llano Brenes"
    },
    {
        "neabord_id": "1816",
        "district_id": "142",
        "code": "08",
        "name": "Orlich"
    },
    {
        "neabord_id": "1817",
        "district_id": "142",
        "code": "09",
        "name": "Orozco"
    },
    {
        "neabord_id": "1818",
        "district_id": "142",
        "code": "10",
        "name": "Pata de Gallo"
    },
    {
        "neabord_id": "1819",
        "district_id": "142",
        "code": "11",
        "name": "Rincón de Mora"
    },
    {
        "neabord_id": "1820",
        "district_id": "142",
        "code": "12",
        "name": "Rincón Orozco"
    },
    {
        "neabord_id": "1821",
        "district_id": "142",
        "code": "13",
        "name": "San Joaqui­n"
    },
    {
        "neabord_id": "1822",
        "district_id": "142",
        "code": "14",
        "name": "Zamora."
    },
    {
        "neabord_id": "1823",
        "district_id": "143",
        "code": "01",
        "name": "Progreso"
    },
    {
        "neabord_id": "1824",
        "district_id": "143",
        "code": "02",
        "name": "Bajo Rami­rez"
    },
    {
        "neabord_id": "1825",
        "district_id": "143",
        "code": "03",
        "name": "Fernandez"
    },
    {
        "neabord_id": "1826",
        "district_id": "143",
        "code": "04",
        "name": "Guaria"
    },
    {
        "neabord_id": "1827",
        "district_id": "143",
        "code": "05",
        "name": "Varela."
    },
    {
        "neabord_id": "1828",
        "district_id": "144",
        "code": "01",
        "name": "Los Jardines"
    },
    {
        "neabord_id": "1829",
        "district_id": "144",
        "code": "02",
        "name": "Ranchera."
    },
    {
        "neabord_id": "1830",
        "district_id": "144",
        "code": "03",
        "name": "angeles Norte"
    },
    {
        "neabord_id": "1831",
        "district_id": "144",
        "code": "04",
        "name": "Bajo Córdoba"
    },
    {
        "neabord_id": "1832",
        "district_id": "144",
        "code": "05",
        "name": "Bajo Rodri­guez"
    },
    {
        "neabord_id": "1833",
        "district_id": "144",
        "code": "06",
        "name": "Balsa"
    },
    {
        "neabord_id": "1834",
        "district_id": "144",
        "code": "07",
        "name": "Cataratas"
    },
    {
        "neabord_id": "1835",
        "district_id": "144",
        "code": "08",
        "name": "Colonia Palmareña"
    },
    {
        "neabord_id": "1836",
        "district_id": "144",
        "code": "09",
        "name": "Coopezamora"
    },
    {
        "neabord_id": "1837",
        "district_id": "144",
        "code": "10",
        "name": "Criques"
    },
    {
        "neabord_id": "1838",
        "district_id": "144",
        "code": "11",
        "name": "Juntas (parte)"
    },
    {
        "neabord_id": "1839",
        "district_id": "144",
        "code": "12",
        "name": "Kooper"
    },
    {
        "neabord_id": "1840",
        "district_id": "144",
        "code": "13",
        "name": "Lagos"
    },
    {
        "neabord_id": "1841",
        "district_id": "144",
        "code": "14",
        "name": "Rocas"
    },
    {
        "neabord_id": "1842",
        "district_id": "144",
        "code": "15",
        "name": "San Jorge"
    },
    {
        "neabord_id": "1843",
        "district_id": "144",
        "code": "16",
        "name": "Silencio"
    },
    {
        "neabord_id": "1844",
        "district_id": "144",
        "code": "17",
        "name": "Valle Azul"
    },
    {
        "neabord_id": "1845",
        "district_id": "144",
        "code": "18",
        "name": "Zuñiga."
    },
    {
        "neabord_id": "1846",
        "district_id": "145",
        "code": "01",
        "name": "Badilla Alpizar"
    },
    {
        "neabord_id": "1847",
        "district_id": "145",
        "code": "02",
        "name": "Sabana (parte)"
    },
    {
        "neabord_id": "1848",
        "district_id": "145",
        "code": "03",
        "name": "Tremedal (parte)."
    },
    {
        "neabord_id": "1849",
        "district_id": "145",
        "code": "04",
        "name": "Bajo Matamoros (parte)"
    },
    {
        "neabord_id": "1850",
        "district_id": "145",
        "code": "05",
        "name": "Catarata"
    },
    {
        "neabord_id": "1851",
        "district_id": "145",
        "code": "06",
        "name": "San Pedro"
    },
    {
        "neabord_id": "1852",
        "district_id": "145",
        "code": "07",
        "name": "Valverde."
    },
    {
        "neabord_id": "1853",
        "district_id": "146",
        "code": "01",
        "name": "Alto Villegas"
    },
    {
        "neabord_id": "1854",
        "district_id": "146",
        "code": "02",
        "name": "Bajo Tejares"
    },
    {
        "neabord_id": "1855",
        "district_id": "146",
        "code": "03",
        "name": "Dulce Nombre"
    },
    {
        "neabord_id": "1856",
        "district_id": "146",
        "code": "04",
        "name": "Sifón."
    },
    {
        "neabord_id": "1857",
        "district_id": "147",
        "code": "01",
        "name": "Cañuela"
    },
    {
        "neabord_id": "1858",
        "district_id": "147",
        "code": "02",
        "name": "Concepción Arriba"
    },
    {
        "neabord_id": "1859",
        "district_id": "147",
        "code": "03",
        "name": "Chaparral"
    },
    {
        "neabord_id": "1860",
        "district_id": "147",
        "code": "04",
        "name": "Perez."
    },
    {
        "neabord_id": "1861",
        "district_id": "148",
        "code": "01",
        "name": "Bajo Castillo"
    },
    {
        "neabord_id": "1862",
        "district_id": "148",
        "code": "02",
        "name": "Bajos"
    },
    {
        "neabord_id": "1863",
        "district_id": "148",
        "code": "03",
        "name": "Barranquilla"
    },
    {
        "neabord_id": "1864",
        "district_id": "148",
        "code": "04",
        "name": "Carrera Buena"
    },
    {
        "neabord_id": "1865",
        "district_id": "148",
        "code": "05",
        "name": "Jabonal"
    },
    {
        "neabord_id": "1866",
        "district_id": "148",
        "code": "06",
        "name": "Jabonalito"
    },
    {
        "neabord_id": "1867",
        "district_id": "148",
        "code": "07",
        "name": "Rincón Chaves"
    },
    {
        "neabord_id": "1868",
        "district_id": "148",
        "code": "08",
        "name": "Victoria"
    },
    {
        "neabord_id": "1869",
        "district_id": "148",
        "code": "09",
        "name": "Zapotal (parte)."
    },
    {
        "neabord_id": "1870",
        "district_id": "149",
        "code": "01",
        "name": "Abanico"
    },
    {
        "neabord_id": "1871",
        "district_id": "149",
        "code": "02",
        "name": "Altura"
    },
    {
        "neabord_id": "1872",
        "district_id": "149",
        "code": "03",
        "name": "Bosque"
    },
    {
        "neabord_id": "1873",
        "district_id": "149",
        "code": "04",
        "name": "Burrito"
    },
    {
        "neabord_id": "1874",
        "district_id": "149",
        "code": "05",
        "name": "Cairo"
    },
    {
        "neabord_id": "1875",
        "district_id": "149",
        "code": "06",
        "name": "Castillo (parte)"
    },
    {
        "neabord_id": "1876",
        "district_id": "149",
        "code": "07",
        "name": "Castillo Nuevo"
    },
    {
        "neabord_id": "1877",
        "district_id": "149",
        "code": "08",
        "name": "Colonia Trinidad"
    },
    {
        "neabord_id": "1878",
        "district_id": "149",
        "code": "09",
        "name": "Chachagua"
    },
    {
        "neabord_id": "1879",
        "district_id": "149",
        "code": "10",
        "name": "La Cruz"
    },
    {
        "neabord_id": "1880",
        "district_id": "149",
        "code": "11",
        "name": "Pocosol"
    },
    {
        "neabord_id": "1881",
        "district_id": "149",
        "code": "12",
        "name": "San Carlos"
    },
    {
        "neabord_id": "1882",
        "district_id": "149",
        "code": "13",
        "name": "San Rafael"
    },
    {
        "neabord_id": "1883",
        "district_id": "149",
        "code": "14",
        "name": "Sector angeles."
    },
    {
        "neabord_id": "1884",
        "district_id": "150",
        "code": "01",
        "name": "Carmona"
    },
    {
        "neabord_id": "1885",
        "district_id": "150",
        "code": "02",
        "name": "Chavarri­a"
    },
    {
        "neabord_id": "1886",
        "district_id": "150",
        "code": "03",
        "name": "Colón"
    },
    {
        "neabord_id": "1887",
        "district_id": "150",
        "code": "04",
        "name": "Jimenez"
    },
    {
        "neabord_id": "1888",
        "district_id": "150",
        "code": "05",
        "name": "Pinos"
    },
    {
        "neabord_id": "1889",
        "district_id": "150",
        "code": "06",
        "name": "Rincón de Arias"
    },
    {
        "neabord_id": "1890",
        "district_id": "150",
        "code": "07",
        "name": "San Antonio"
    },
    {
        "neabord_id": "1891",
        "district_id": "150",
        "code": "08",
        "name": "San Vicente."
    },
    {
        "neabord_id": "1892",
        "district_id": "150",
        "code": "09",
        "name": "Celina."
    },
    {
        "neabord_id": "1893",
        "district_id": "151",
        "code": "01",
        "name": "Barrio (Grecia): Primavera."
    },
    {
        "neabord_id": "1894",
        "district_id": "151",
        "code": "02",
        "name": "Alfaro"
    },
    {
        "neabord_id": "1895",
        "district_id": "151",
        "code": "03",
        "name": "Bajo Achiote"
    },
    {
        "neabord_id": "1896",
        "district_id": "151",
        "code": "04",
        "name": "Camejo"
    },
    {
        "neabord_id": "1897",
        "district_id": "151",
        "code": "05",
        "name": "Coopevictoria"
    },
    {
        "neabord_id": "1898",
        "district_id": "151",
        "code": "06",
        "name": "Corinto"
    },
    {
        "neabord_id": "1899",
        "district_id": "151",
        "code": "07",
        "name": "Higuerones"
    },
    {
        "neabord_id": "1900",
        "district_id": "151",
        "code": "08",
        "name": "Mesón"
    },
    {
        "neabord_id": "1901",
        "district_id": "151",
        "code": "09",
        "name": "Mojón"
    },
    {
        "neabord_id": "1902",
        "district_id": "151",
        "code": "10",
        "name": "Quizarrazal."
    },
    {
        "neabord_id": "1903",
        "district_id": "152",
        "code": "01",
        "name": "Arena"
    },
    {
        "neabord_id": "1904",
        "district_id": "152",
        "code": "02",
        "name": "Cedro"
    },
    {
        "neabord_id": "1905",
        "district_id": "152",
        "code": "03",
        "name": "Delicias (parte)"
    },
    {
        "neabord_id": "1906",
        "district_id": "152",
        "code": "04",
        "name": "Guayabal (parte)"
    },
    {
        "neabord_id": "1907",
        "district_id": "152",
        "code": "05",
        "name": "Loma"
    },
    {
        "neabord_id": "1908",
        "district_id": "152",
        "code": "06",
        "name": "Rodri­guez"
    },
    {
        "neabord_id": "1909",
        "district_id": "152",
        "code": "07",
        "name": "Santa Gertrudis Norte"
    },
    {
        "neabord_id": "1910",
        "district_id": "152",
        "code": "08",
        "name": "Santa Gertrudis Sur."
    },
    {
        "neabord_id": "1911",
        "district_id": "153",
        "code": "01",
        "name": "Agualote"
    },
    {
        "neabord_id": "1912",
        "district_id": "153",
        "code": "02",
        "name": "Bajo Sapera"
    },
    {
        "neabord_id": "1913",
        "district_id": "153",
        "code": "03",
        "name": "Casillas"
    },
    {
        "neabord_id": "1914",
        "district_id": "153",
        "code": "04",
        "name": "Latino"
    },
    {
        "neabord_id": "1915",
        "district_id": "153",
        "code": "05",
        "name": "San Miguel Arriba."
    },
    {
        "neabord_id": "1916",
        "district_id": "153",
        "code": "06",
        "name": "Cabuyal"
    },
    {
        "neabord_id": "1917",
        "district_id": "153",
        "code": "07",
        "name": "Carbonal"
    },
    {
        "neabord_id": "1918",
        "district_id": "153",
        "code": "08",
        "name": "Coyotera"
    },
    {
        "neabord_id": "1919",
        "district_id": "153",
        "code": "09",
        "name": "San Miguel."
    },
    {
        "neabord_id": "1920",
        "district_id": "154",
        "code": "01",
        "name": "Pinto."
    },
    {
        "neabord_id": "1921",
        "district_id": "154",
        "code": "02",
        "name": "Bodegas"
    },
    {
        "neabord_id": "1922",
        "district_id": "154",
        "code": "03",
        "name": "Cataluña"
    },
    {
        "neabord_id": "1923",
        "district_id": "154",
        "code": "04",
        "name": "Cerdas"
    },
    {
        "neabord_id": "1924",
        "district_id": "154",
        "code": "05",
        "name": "Delicias (parte)"
    },
    {
        "neabord_id": "1925",
        "district_id": "154",
        "code": "06",
        "name": "Flores"
    },
    {
        "neabord_id": "1926",
        "district_id": "154",
        "code": "07",
        "name": "Guayabal (parte)"
    },
    {
        "neabord_id": "1927",
        "district_id": "154",
        "code": "08",
        "name": "Pilas"
    },
    {
        "neabord_id": "1928",
        "district_id": "154",
        "code": "09",
        "name": "Planta"
    },
    {
        "neabord_id": "1929",
        "district_id": "154",
        "code": "10",
        "name": "Porvenir"
    },
    {
        "neabord_id": "1930",
        "district_id": "154",
        "code": "11",
        "name": "Yoses."
    },
    {
        "neabord_id": "1931",
        "district_id": "155",
        "code": "01",
        "name": "angeles Norte"
    },
    {
        "neabord_id": "1932",
        "district_id": "155",
        "code": "02",
        "name": "Bolaños"
    },
    {
        "neabord_id": "1933",
        "district_id": "155",
        "code": "03",
        "name": "Bosque Alegre"
    },
    {
        "neabord_id": "1934",
        "district_id": "155",
        "code": "04",
        "name": "Caño Negro"
    },
    {
        "neabord_id": "1935",
        "district_id": "155",
        "code": "05",
        "name": "Carmen"
    },
    {
        "neabord_id": "1936",
        "district_id": "155",
        "code": "06",
        "name": "Carrizal"
    },
    {
        "neabord_id": "1937",
        "district_id": "155",
        "code": "07",
        "name": "Colonia del Toro"
    },
    {
        "neabord_id": "1938",
        "district_id": "155",
        "code": "08",
        "name": "Crucero"
    },
    {
        "neabord_id": "1939",
        "district_id": "155",
        "code": "09",
        "name": "Flor"
    },
    {
        "neabord_id": "1940",
        "district_id": "155",
        "code": "10",
        "name": "Hule"
    },
    {
        "neabord_id": "1941",
        "district_id": "155",
        "code": "11",
        "name": "La Trinidad"
    },
    {
        "neabord_id": "1942",
        "district_id": "155",
        "code": "12",
        "name": "Laguna"
    },
    {
        "neabord_id": "1943",
        "district_id": "155",
        "code": "13",
        "name": "Lagos"
    },
    {
        "neabord_id": "1944",
        "district_id": "155",
        "code": "14",
        "name": "Merced"
    },
    {
        "neabord_id": "1945",
        "district_id": "155",
        "code": "15",
        "name": "Montelirio"
    },
    {
        "neabord_id": "1946",
        "district_id": "155",
        "code": "16",
        "name": "Naranjales"
    },
    {
        "neabord_id": "1947",
        "district_id": "155",
        "code": "17",
        "name": "Palmar"
    },
    {
        "neabord_id": "1948",
        "district_id": "155",
        "code": "18",
        "name": "Palmera"
    },
    {
        "neabord_id": "1949",
        "district_id": "155",
        "code": "19",
        "name": "Pata de Gallo"
    },
    {
        "neabord_id": "1950",
        "district_id": "155",
        "code": "20",
        "name": "Peoresnada"
    },
    {
        "neabord_id": "1951",
        "district_id": "155",
        "code": "21",
        "name": "Pinar"
    },
    {
        "neabord_id": "1952",
        "district_id": "155",
        "code": "22",
        "name": "Pueblo Nuevo"
    },
    {
        "neabord_id": "1953",
        "district_id": "155",
        "code": "23",
        "name": "San Fernando"
    },
    {
        "neabord_id": "1954",
        "district_id": "155",
        "code": "24",
        "name": "San Gerardo (parte)"
    },
    {
        "neabord_id": "1955",
        "district_id": "155",
        "code": "25",
        "name": "San Jorge"
    },
    {
        "neabord_id": "1956",
        "district_id": "155",
        "code": "26",
        "name": "San Jose"
    },
    {
        "neabord_id": "1957",
        "district_id": "155",
        "code": "27",
        "name": "San Rafael"
    },
    {
        "neabord_id": "1958",
        "district_id": "155",
        "code": "28",
        "name": "San Vicente"
    },
    {
        "neabord_id": "1959",
        "district_id": "155",
        "code": "29",
        "name": "Santa Isabel"
    },
    {
        "neabord_id": "1960",
        "district_id": "155",
        "code": "30",
        "name": "Santa Rita"
    },
    {
        "neabord_id": "1961",
        "district_id": "155",
        "code": "31",
        "name": "Tabla."
    },
    {
        "neabord_id": "1962",
        "district_id": "156",
        "code": "01",
        "name": "(Grecia): Poró"
    },
    {
        "neabord_id": "1963",
        "district_id": "156",
        "code": "02",
        "name": "Sevilla."
    },
    {
        "neabord_id": "1964",
        "district_id": "156",
        "code": "03",
        "name": "Altos de Peralta"
    },
    {
        "neabord_id": "1965",
        "district_id": "156",
        "code": "04",
        "name": "Argentina"
    },
    {
        "neabord_id": "1966",
        "district_id": "156",
        "code": "05",
        "name": "Bajo Cedros"
    },
    {
        "neabord_id": "1967",
        "district_id": "156",
        "code": "06",
        "name": "Lomas"
    },
    {
        "neabord_id": "1968",
        "district_id": "156",
        "code": "07",
        "name": "Montezuma"
    },
    {
        "neabord_id": "1969",
        "district_id": "156",
        "code": "08",
        "name": "Puerto Escondido"
    },
    {
        "neabord_id": "1970",
        "district_id": "156",
        "code": "09",
        "name": "Raiceros"
    },
    {
        "neabord_id": "1971",
        "district_id": "156",
        "code": "10",
        "name": "Rincón de Salas"
    },
    {
        "neabord_id": "1972",
        "district_id": "156",
        "code": "11",
        "name": "Rosales."
    },
    {
        "neabord_id": "1973",
        "district_id": "157",
        "code": "01",
        "name": "Cajón"
    },
    {
        "neabord_id": "1974",
        "district_id": "157",
        "code": "02",
        "name": "Cocobolo"
    },
    {
        "neabord_id": "1975",
        "district_id": "157",
        "code": "03",
        "name": "Murillo"
    },
    {
        "neabord_id": "1976",
        "district_id": "157",
        "code": "04",
        "name": "San Juan"
    },
    {
        "neabord_id": "1977",
        "district_id": "157",
        "code": "05",
        "name": "San Luis"
    },
    {
        "neabord_id": "1978",
        "district_id": "157",
        "code": "06",
        "name": "Virgencita."
    },
    {
        "neabord_id": "1979",
        "district_id": "158",
        "code": "01",
        "name": "Agua Agria"
    },
    {
        "neabord_id": "1980",
        "district_id": "158",
        "code": "02",
        "name": "Calera"
    },
    {
        "neabord_id": "1981",
        "district_id": "158",
        "code": "03",
        "name": "Ceni­zaro"
    },
    {
        "neabord_id": "1982",
        "district_id": "158",
        "code": "04",
        "name": "Centeno"
    },
    {
        "neabord_id": "1983",
        "district_id": "158",
        "code": "05",
        "name": "Desamparados"
    },
    {
        "neabord_id": "1984",
        "district_id": "158",
        "code": "06",
        "name": "Dulce Nombre"
    },
    {
        "neabord_id": "1985",
        "district_id": "158",
        "code": "07",
        "name": "Higuito"
    },
    {
        "neabord_id": "1986",
        "district_id": "158",
        "code": "08",
        "name": "Izarco"
    },
    {
        "neabord_id": "1987",
        "district_id": "158",
        "code": "09",
        "name": "Maderal"
    },
    {
        "neabord_id": "1988",
        "district_id": "158",
        "code": "10",
        "name": "Ramadas"
    },
    {
        "neabord_id": "1989",
        "district_id": "158",
        "code": "11",
        "name": "San Juan de Dios."
    },
    {
        "neabord_id": "1990",
        "district_id": "159",
        "code": "01",
        "name": "Cuesta Colorada"
    },
    {
        "neabord_id": "1991",
        "district_id": "159",
        "code": "02",
        "name": "Libertad"
    },
    {
        "neabord_id": "1992",
        "district_id": "159",
        "code": "03",
        "name": "Quebrada Honda"
    },
    {
        "neabord_id": "1993",
        "district_id": "159",
        "code": "04",
        "name": "Limón"
    },
    {
        "neabord_id": "1994",
        "district_id": "159",
        "code": "05",
        "name": "Patio de Agua Norte"
    },
    {
        "neabord_id": "1995",
        "district_id": "159",
        "code": "06",
        "name": "Sacra Familia"
    },
    {
        "neabord_id": "1996",
        "district_id": "159",
        "code": "07",
        "name": "San Juan Uno"
    },
    {
        "neabord_id": "1997",
        "district_id": "159",
        "code": "08",
        "name": "Zapote."
    },
    {
        "neabord_id": "1998",
        "district_id": "160",
        "code": "01",
        "name": "Garabito"
    },
    {
        "neabord_id": "1999",
        "district_id": "160",
        "code": "02",
        "name": "Quebrada Grande (parte)"
    },
    {
        "neabord_id": "2000",
        "district_id": "160",
        "code": "03",
        "name": "Quinta."
    },
    {
        "neabord_id": "2001",
        "district_id": "161",
        "code": "01",
        "name": "Altamira"
    },
    {
        "neabord_id": "2002",
        "district_id": "161",
        "code": "02",
        "name": "Oricuajo"
    },
    {
        "neabord_id": "2003",
        "district_id": "161",
        "code": "03",
        "name": "Poza Redonda"
    },
    {
        "neabord_id": "2004",
        "district_id": "161",
        "code": "04",
        "name": "Quebrada Grande (parte)."
    },
    {
        "neabord_id": "2005",
        "district_id": "162",
        "code": "01",
        "name": "angeles"
    },
    {
        "neabord_id": "2006",
        "district_id": "162",
        "code": "02",
        "name": "Atenea"
    },
    {
        "neabord_id": "2007",
        "district_id": "162",
        "code": "03",
        "name": "Boquerón"
    },
    {
        "neabord_id": "2008",
        "district_id": "162",
        "code": "04",
        "name": "Escorpio"
    },
    {
        "neabord_id": "2009",
        "district_id": "162",
        "code": "05",
        "name": "Güizaro"
    },
    {
        "neabord_id": "2010",
        "district_id": "162",
        "code": "06",
        "name": "Oasis"
    },
    {
        "neabord_id": "2011",
        "district_id": "162",
        "code": "07",
        "name": "Olivo."
    },
    {
        "neabord_id": "2012",
        "district_id": "162",
        "code": "08",
        "name": "Mati­as."
    },
    {
        "neabord_id": "2013",
        "district_id": "163",
        "code": "01",
        "name": "Guacalillo"
    },
    {
        "neabord_id": "2014",
        "district_id": "163",
        "code": "02",
        "name": "Sabanalarga"
    },
    {
        "neabord_id": "2015",
        "district_id": "163",
        "code": "03",
        "name": "San Vicente."
    },
    {
        "neabord_id": "2016",
        "district_id": "163",
        "code": "04",
        "name": "Barroeta"
    },
    {
        "neabord_id": "2017",
        "district_id": "163",
        "code": "05",
        "name": "Boca del Monte"
    },
    {
        "neabord_id": "2018",
        "district_id": "163",
        "code": "06",
        "name": "Cuajiniquil"
    },
    {
        "neabord_id": "2019",
        "district_id": "163",
        "code": "07",
        "name": "Estanquillo"
    },
    {
        "neabord_id": "2020",
        "district_id": "163",
        "code": "08",
        "name": "Pato de Agua (parte)."
    },
    {
        "neabord_id": "2021",
        "district_id": "164",
        "code": "01",
        "name": "Cajón."
    },
    {
        "neabord_id": "2022",
        "district_id": "164",
        "code": "02",
        "name": "Callao"
    },
    {
        "neabord_id": "2023",
        "district_id": "164",
        "code": "03",
        "name": "Plancillo"
    },
    {
        "neabord_id": "2024",
        "district_id": "164",
        "code": "04",
        "name": "Plazoleta."
    },
    {
        "neabord_id": "2025",
        "district_id": "165",
        "code": "01",
        "name": "Alto Naranjo"
    },
    {
        "neabord_id": "2026",
        "district_id": "165",
        "code": "02",
        "name": "Bajo Cacao"
    },
    {
        "neabord_id": "2027",
        "district_id": "165",
        "code": "03",
        "name": "Morazan"
    },
    {
        "neabord_id": "2028",
        "district_id": "165",
        "code": "04",
        "name": "Pato de Agua (parte)"
    },
    {
        "neabord_id": "2029",
        "district_id": "165",
        "code": "05",
        "name": "Pavas"
    },
    {
        "neabord_id": "2030",
        "district_id": "165",
        "code": "06",
        "name": "Rincón."
    },
    {
        "neabord_id": "2031",
        "district_id": "166",
        "code": "01",
        "name": "Ri­o Grande"
    },
    {
        "neabord_id": "2032",
        "district_id": "166",
        "code": "02",
        "name": "Balsa"
    },
    {
        "neabord_id": "2033",
        "district_id": "166",
        "code": "03",
        "name": "Calle Garita"
    },
    {
        "neabord_id": "2034",
        "district_id": "166",
        "code": "04",
        "name": "Coyoles"
    },
    {
        "neabord_id": "2035",
        "district_id": "166",
        "code": "05",
        "name": "Pan de Azucar"
    },
    {
        "neabord_id": "2036",
        "district_id": "166",
        "code": "06",
        "name": "Tornos."
    },
    {
        "neabord_id": "2037",
        "district_id": "167",
        "code": "01",
        "name": "Alto Cima"
    },
    {
        "neabord_id": "2038",
        "district_id": "167",
        "code": "02",
        "name": "Alto López"
    },
    {
        "neabord_id": "2039",
        "district_id": "167",
        "code": "03",
        "name": "Legua"
    },
    {
        "neabord_id": "2040",
        "district_id": "167",
        "code": "04",
        "name": "San Jose Norte"
    },
    {
        "neabord_id": "2041",
        "district_id": "167",
        "code": "05",
        "name": "Torunes"
    },
    {
        "neabord_id": "2042",
        "district_id": "167",
        "code": "06",
        "name": "Vainilla."
    },
    {
        "neabord_id": "2043",
        "district_id": "168",
        "code": "01",
        "name": "Rincón Rodri­guez."
    },
    {
        "neabord_id": "2044",
        "district_id": "169",
        "code": "01",
        "name": "Cerrillo"
    },
    {
        "neabord_id": "2045",
        "district_id": "169",
        "code": "02",
        "name": "Guacimos"
    },
    {
        "neabord_id": "2046",
        "district_id": "169",
        "code": "03",
        "name": "Kilómetro 51"
    },
    {
        "neabord_id": "2047",
        "district_id": "169",
        "code": "04",
        "name": "Lapas"
    },
    {
        "neabord_id": "2048",
        "district_id": "169",
        "code": "05",
        "name": "Mangos"
    },
    {
        "neabord_id": "2049",
        "district_id": "169",
        "code": "06",
        "name": "Quebradas"
    },
    {
        "neabord_id": "2050",
        "district_id": "169",
        "code": "07",
        "name": "Vuelta Herrera."
    },
    {
        "neabord_id": "2051",
        "district_id": "170",
        "code": "01",
        "name": "Bajo Pilas"
    },
    {
        "neabord_id": "2052",
        "district_id": "170",
        "code": "02",
        "name": "Belen"
    },
    {
        "neabord_id": "2053",
        "district_id": "170",
        "code": "03",
        "name": "Caña Dura"
    },
    {
        "neabord_id": "2054",
        "district_id": "170",
        "code": "04",
        "name": "Gradas"
    },
    {
        "neabord_id": "2055",
        "district_id": "170",
        "code": "05",
        "name": "Mari­a Auxiliadora"
    },
    {
        "neabord_id": "2056",
        "district_id": "170",
        "code": "06",
        "name": "Muro"
    },
    {
        "neabord_id": "2057",
        "district_id": "170",
        "code": "07",
        "name": "Pueblo Nuevo"
    },
    {
        "neabord_id": "2058",
        "district_id": "170",
        "code": "08",
        "name": "Sacramento"
    },
    {
        "neabord_id": "2059",
        "district_id": "170",
        "code": "09",
        "name": "San Lucas (Carmen)"
    },
    {
        "neabord_id": "2060",
        "district_id": "170",
        "code": "10",
        "name": "San Rafael."
    },
    {
        "neabord_id": "2061",
        "district_id": "170",
        "code": "11",
        "name": "Candelaria"
    },
    {
        "neabord_id": "2062",
        "district_id": "170",
        "code": "12",
        "name": "Cantarrana (parte)"
    },
    {
        "neabord_id": "2063",
        "district_id": "170",
        "code": "13",
        "name": "Cinco Esquinas (parte)"
    },
    {
        "neabord_id": "2064",
        "district_id": "170",
        "code": "14",
        "name": "Cipres"
    },
    {
        "neabord_id": "2065",
        "district_id": "170",
        "code": "15",
        "name": "Comun"
    },
    {
        "neabord_id": "2066",
        "district_id": "170",
        "code": "16",
        "name": "Dulce Nombre."
    },
    {
        "neabord_id": "2067",
        "district_id": "171",
        "code": "01",
        "name": "Planes."
    },
    {
        "neabord_id": "2068",
        "district_id": "171",
        "code": "02",
        "name": "Bajo Seevers"
    },
    {
        "neabord_id": "2069",
        "district_id": "171",
        "code": "03",
        "name": "Bajos"
    },
    {
        "neabord_id": "2070",
        "district_id": "171",
        "code": "04",
        "name": "Palmas"
    },
    {
        "neabord_id": "2071",
        "district_id": "171",
        "code": "05",
        "name": "Quesera"
    },
    {
        "neabord_id": "2072",
        "district_id": "171",
        "code": "06",
        "name": "San Francisco"
    },
    {
        "neabord_id": "2073",
        "district_id": "171",
        "code": "07",
        "name": "San Miguel Oeste."
    },
    {
        "neabord_id": "2074",
        "district_id": "172",
        "code": "01",
        "name": "Barranca"
    },
    {
        "neabord_id": "2075",
        "district_id": "172",
        "code": "02",
        "name": "Cañuela Arriba"
    },
    {
        "neabord_id": "2076",
        "district_id": "172",
        "code": "03",
        "name": "Cuesta Venada"
    },
    {
        "neabord_id": "2077",
        "district_id": "172",
        "code": "04",
        "name": "Desamparados"
    },
    {
        "neabord_id": "2078",
        "district_id": "172",
        "code": "05",
        "name": "Isla"
    },
    {
        "neabord_id": "2079",
        "district_id": "172",
        "code": "06",
        "name": "San Antonio de Barranca"
    },
    {
        "neabord_id": "2080",
        "district_id": "172",
        "code": "07",
        "name": "San Pedro"
    },
    {
        "neabord_id": "2081",
        "district_id": "172",
        "code": "08",
        "name": "Soli­s (parte)"
    },
    {
        "neabord_id": "2082",
        "district_id": "172",
        "code": "09",
        "name": "Vuelta San Gerardo."
    },
    {
        "neabord_id": "2083",
        "district_id": "173",
        "code": "01",
        "name": "Bajo Arrieta"
    },
    {
        "neabord_id": "2084",
        "district_id": "173",
        "code": "02",
        "name": "Bajo Valverde"
    },
    {
        "neabord_id": "2085",
        "district_id": "173",
        "code": "03",
        "name": "Bajo Zuñiga"
    },
    {
        "neabord_id": "2086",
        "district_id": "173",
        "code": "04",
        "name": "Cruce"
    },
    {
        "neabord_id": "2087",
        "district_id": "173",
        "code": "05",
        "name": "Isla Cocora"
    },
    {
        "neabord_id": "2088",
        "district_id": "173",
        "code": "06",
        "name": "Lourdes"
    },
    {
        "neabord_id": "2089",
        "district_id": "173",
        "code": "07",
        "name": "Llano Bonito"
    },
    {
        "neabord_id": "2090",
        "district_id": "173",
        "code": "08",
        "name": "Llano Bonito Sur"
    },
    {
        "neabord_id": "2091",
        "district_id": "173",
        "code": "09",
        "name": "Palmita"
    },
    {
        "neabord_id": "2092",
        "district_id": "173",
        "code": "10",
        "name": "Quebrada Honda"
    },
    {
        "neabord_id": "2093",
        "district_id": "173",
        "code": "11",
        "name": "Rincón"
    },
    {
        "neabord_id": "2094",
        "district_id": "173",
        "code": "12",
        "name": "Soli­s (parte)"
    },
    {
        "neabord_id": "2095",
        "district_id": "173",
        "code": "13",
        "name": "Zapote."
    },
    {
        "neabord_id": "2096",
        "district_id": "174",
        "code": "01",
        "name": "Puebla"
    },
    {
        "neabord_id": "2097",
        "district_id": "174",
        "code": "02",
        "name": "Robles"
    },
    {
        "neabord_id": "2098",
        "district_id": "174",
        "code": "03",
        "name": "Tacacal."
    },
    {
        "neabord_id": "2099",
        "district_id": "175",
        "code": "01",
        "name": "Bajo Murcielago"
    },
    {
        "neabord_id": "2100",
        "district_id": "175",
        "code": "02",
        "name": "Cueva"
    },
    {
        "neabord_id": "2101",
        "district_id": "175",
        "code": "03",
        "name": "Guarumal"
    },
    {
        "neabord_id": "2102",
        "district_id": "175",
        "code": "04",
        "name": "Rincón Elizondo"
    },
    {
        "neabord_id": "2103",
        "district_id": "175",
        "code": "05",
        "name": "San Antonio"
    },
    {
        "neabord_id": "2104",
        "district_id": "175",
        "code": "06",
        "name": "Yoses."
    },
    {
        "neabord_id": "2105",
        "district_id": "176",
        "code": "01",
        "name": "Perez"
    },
    {
        "neabord_id": "2106",
        "district_id": "176",
        "code": "02",
        "name": "Hornos"
    },
    {
        "neabord_id": "2107",
        "district_id": "176",
        "code": "03",
        "name": "Llano"
    },
    {
        "neabord_id": "2108",
        "district_id": "176",
        "code": "04",
        "name": "Santa Margarita"
    },
    {
        "neabord_id": "2109",
        "district_id": "176",
        "code": "05",
        "name": "Vistas del Valle."
    },
    {
        "neabord_id": "2110",
        "district_id": "177",
        "code": "01",
        "name": "Alto Murillo"
    },
    {
        "neabord_id": "2111",
        "district_id": "177",
        "code": "02",
        "name": "Alto Palmas"
    },
    {
        "neabord_id": "2112",
        "district_id": "177",
        "code": "03",
        "name": "Cantarrana (parte)"
    },
    {
        "neabord_id": "2113",
        "district_id": "177",
        "code": "04",
        "name": "Cinco Esquinas (parte)"
    },
    {
        "neabord_id": "2114",
        "district_id": "177",
        "code": "05",
        "name": "Concepción"
    },
    {
        "neabord_id": "2115",
        "district_id": "177",
        "code": "06",
        "name": "Roquillo"
    },
    {
        "neabord_id": "2116",
        "district_id": "177",
        "code": "07",
        "name": "San Roque."
    },
    {
        "neabord_id": "2117",
        "district_id": "178",
        "code": "01",
        "name": "Santa Fe"
    },
    {
        "neabord_id": "2118",
        "district_id": "178",
        "code": "02",
        "name": "San Vicente."
    },
    {
        "neabord_id": "2119",
        "district_id": "179",
        "code": "01",
        "name": "Cocaleca (parte)"
    },
    {
        "neabord_id": "2120",
        "district_id": "179",
        "code": "02",
        "name": "Quebrada"
    },
    {
        "neabord_id": "2121",
        "district_id": "179",
        "code": "03",
        "name": "Rincón (Quebrada)"
    },
    {
        "neabord_id": "2122",
        "district_id": "179",
        "code": "04",
        "name": "Rincón de Zaragoza"
    },
    {
        "neabord_id": "2123",
        "district_id": "179",
        "code": "05",
        "name": "Vargas"
    },
    {
        "neabord_id": "2124",
        "district_id": "179",
        "code": "06",
        "name": "Vasquez."
    },
    {
        "neabord_id": "2125",
        "district_id": "180",
        "code": "01",
        "name": "Bajo Cabra"
    },
    {
        "neabord_id": "2126",
        "district_id": "180",
        "code": "02",
        "name": "Barreal"
    },
    {
        "neabord_id": "2127",
        "district_id": "180",
        "code": "03",
        "name": "Tres Mari­as"
    },
    {
        "neabord_id": "2128",
        "district_id": "180",
        "code": "04",
        "name": "Valle"
    },
    {
        "neabord_id": "2129",
        "district_id": "180",
        "code": "05",
        "name": "Victoria."
    },
    {
        "neabord_id": "2130",
        "district_id": "180",
        "code": "06",
        "name": "Calle Rami­rez."
    },
    {
        "neabord_id": "2131",
        "district_id": "181",
        "code": "01",
        "name": "Pinos (parte)."
    },
    {
        "neabord_id": "2132",
        "district_id": "182",
        "code": "01",
        "name": "Pinos (parte)."
    },
    {
        "neabord_id": "2133",
        "district_id": "183",
        "code": "01",
        "name": "Calle Roble"
    },
    {
        "neabord_id": "2134",
        "district_id": "183",
        "code": "02",
        "name": "Cocaleca (parte)"
    },
    {
        "neabord_id": "2135",
        "district_id": "183",
        "code": "03",
        "name": "Peraza"
    },
    {
        "neabord_id": "2136",
        "district_id": "183",
        "code": "04",
        "name": "Rincón de Salas."
    },
    {
        "neabord_id": "2137",
        "district_id": "184",
        "code": "01",
        "name": "Amistad."
    },
    {
        "neabord_id": "2138",
        "district_id": "185",
        "code": "01",
        "name": "Santa Cecilia (Bajo Piedras)"
    },
    {
        "neabord_id": "2139",
        "district_id": "185",
        "code": "02",
        "name": "Rastro."
    },
    {
        "neabord_id": "2140",
        "district_id": "185",
        "code": "03",
        "name": "Cerro"
    },
    {
        "neabord_id": "2141",
        "district_id": "185",
        "code": "04",
        "name": "Chilamate"
    },
    {
        "neabord_id": "2142",
        "district_id": "185",
        "code": "05",
        "name": "Hilda"
    },
    {
        "neabord_id": "2143",
        "district_id": "185",
        "code": "06",
        "name": "Sitio (parte)"
    },
    {
        "neabord_id": "2144",
        "district_id": "185",
        "code": "07",
        "name": "Zamora."
    },
    {
        "neabord_id": "2145",
        "district_id": "186",
        "code": "01",
        "name": "Altura (parte)"
    },
    {
        "neabord_id": "2146",
        "district_id": "186",
        "code": "02",
        "name": "Corazón de Jesus"
    },
    {
        "neabord_id": "2147",
        "district_id": "186",
        "code": "03",
        "name": "Guapinol"
    },
    {
        "neabord_id": "2148",
        "district_id": "186",
        "code": "04",
        "name": "Mastate"
    },
    {
        "neabord_id": "2149",
        "district_id": "186",
        "code": "05",
        "name": "San Juan Norte"
    },
    {
        "neabord_id": "2150",
        "district_id": "186",
        "code": "06",
        "name": "Tablones (parte)."
    },
    {
        "neabord_id": "2151",
        "district_id": "187",
        "code": "01",
        "name": "Bajo Zamora"
    },
    {
        "neabord_id": "2152",
        "district_id": "187",
        "code": "02",
        "name": "Churuca"
    },
    {
        "neabord_id": "2153",
        "district_id": "187",
        "code": "03",
        "name": "Guatuza"
    },
    {
        "neabord_id": "2154",
        "district_id": "187",
        "code": "04",
        "name": "Monte"
    },
    {
        "neabord_id": "2155",
        "district_id": "187",
        "code": "05",
        "name": "Potrero Chiquito"
    },
    {
        "neabord_id": "2156",
        "district_id": "187",
        "code": "06",
        "name": "Santa Rosa"
    },
    {
        "neabord_id": "2157",
        "district_id": "187",
        "code": "07",
        "name": "Sitio (parte)"
    },
    {
        "neabord_id": "2158",
        "district_id": "187",
        "code": "08",
        "name": "Soli­s"
    },
    {
        "neabord_id": "2159",
        "district_id": "187",
        "code": "09",
        "name": "Tablones (parte)"
    },
    {
        "neabord_id": "2160",
        "district_id": "187",
        "code": "10",
        "name": "Volcan."
    },
    {
        "neabord_id": "2161",
        "district_id": "188",
        "code": "01",
        "name": "Bajo Barahona"
    },
    {
        "neabord_id": "2162",
        "district_id": "188",
        "code": "02",
        "name": "Cuatro Esquinas"
    },
    {
        "neabord_id": "2163",
        "district_id": "188",
        "code": "03",
        "name": "Santi­sima Trinidad."
    },
    {
        "neabord_id": "2164",
        "district_id": "188",
        "code": "04",
        "name": "Carrillos Alto"
    },
    {
        "neabord_id": "2165",
        "district_id": "188",
        "code": "05",
        "name": "Senda"
    },
    {
        "neabord_id": "2166",
        "district_id": "188",
        "code": "06",
        "name": "Sonora."
    },
    {
        "neabord_id": "2167",
        "district_id": "189",
        "code": "01",
        "name": "Altura (parte)"
    },
    {
        "neabord_id": "2168",
        "district_id": "189",
        "code": "02",
        "name": "Bajos del Tigre."
    },
    {
        "neabord_id": "2169",
        "district_id": "190",
        "code": "01",
        "name": "Aguacate"
    },
    {
        "neabord_id": "2170",
        "district_id": "190",
        "code": "02",
        "name": "Arboleda"
    },
    {
        "neabord_id": "2171",
        "district_id": "190",
        "code": "03",
        "name": "Carmen"
    },
    {
        "neabord_id": "2172",
        "district_id": "190",
        "code": "04",
        "name": "Cortezal"
    },
    {
        "neabord_id": "2173",
        "district_id": "190",
        "code": "05",
        "name": "Cuatro Esquinas Norte"
    },
    {
        "neabord_id": "2174",
        "district_id": "190",
        "code": "06",
        "name": "Jesus"
    },
    {
        "neabord_id": "2175",
        "district_id": "190",
        "code": "07",
        "name": "Kilómetro"
    },
    {
        "neabord_id": "2176",
        "district_id": "190",
        "code": "08",
        "name": "López"
    },
    {
        "neabord_id": "2177",
        "district_id": "190",
        "code": "09",
        "name": "Miraflores"
    },
    {
        "neabord_id": "2178",
        "district_id": "190",
        "code": "10",
        "name": "Rastro Viejo"
    },
    {
        "neabord_id": "2179",
        "district_id": "190",
        "code": "11",
        "name": "San Rafael"
    },
    {
        "neabord_id": "2180",
        "district_id": "190",
        "code": "12",
        "name": "San Vicente"
    },
    {
        "neabord_id": "2181",
        "district_id": "190",
        "code": "13",
        "name": "Tres Mari­as"
    },
    {
        "neabord_id": "2182",
        "district_id": "190",
        "code": "14",
        "name": "Villa los Reyes."
    },
    {
        "neabord_id": "2183",
        "district_id": "190",
        "code": "15",
        "name": "Alto Vindas"
    },
    {
        "neabord_id": "2184",
        "district_id": "190",
        "code": "16",
        "name": "Esperanza"
    },
    {
        "neabord_id": "2185",
        "district_id": "190",
        "code": "17",
        "name": "Tigre."
    },
    {
        "neabord_id": "2186",
        "district_id": "191",
        "code": "01",
        "name": "Cuatro Esquinas Este"
    },
    {
        "neabord_id": "2187",
        "district_id": "191",
        "code": "02",
        "name": "Piedra Azul."
    },
    {
        "neabord_id": "2188",
        "district_id": "191",
        "code": "03",
        "name": "Guayabal."
    },
    {
        "neabord_id": "2189",
        "district_id": "192",
        "code": "01",
        "name": "Marichal"
    },
    {
        "neabord_id": "2190",
        "district_id": "192",
        "code": "02",
        "name": "Concepción"
    },
    {
        "neabord_id": "2191",
        "district_id": "192",
        "code": "03",
        "name": "Dantas."
    },
    {
        "neabord_id": "2192",
        "district_id": "193",
        "code": "01",
        "name": "Corazón de Mari­a."
    },
    {
        "neabord_id": "2193",
        "district_id": "193",
        "code": "02",
        "name": "Bajos del Coyote"
    },
    {
        "neabord_id": "2194",
        "district_id": "193",
        "code": "03",
        "name": "Cebadilla"
    },
    {
        "neabord_id": "2195",
        "district_id": "193",
        "code": "04",
        "name": "Guapiles"
    },
    {
        "neabord_id": "2196",
        "district_id": "193",
        "code": "05",
        "name": "Limonal"
    },
    {
        "neabord_id": "2197",
        "district_id": "193",
        "code": "06",
        "name": "Mangos"
    },
    {
        "neabord_id": "2198",
        "district_id": "193",
        "code": "07",
        "name": "Mollejones"
    },
    {
        "neabord_id": "2199",
        "district_id": "193",
        "code": "08",
        "name": "Piedras de Fuego"
    },
    {
        "neabord_id": "2200",
        "district_id": "193",
        "code": "09",
        "name": "Pozón"
    },
    {
        "neabord_id": "2201",
        "district_id": "193",
        "code": "10",
        "name": "San Jerónimo"
    },
    {
        "neabord_id": "2202",
        "district_id": "193",
        "code": "11",
        "name": "Santa Rita."
    },
    {
        "neabord_id": "2203",
        "district_id": "194",
        "code": "01",
        "name": "Angostura Matamoros"
    },
    {
        "neabord_id": "2204",
        "district_id": "194",
        "code": "02",
        "name": "Cascajal"
    },
    {
        "neabord_id": "2205",
        "district_id": "194",
        "code": "03",
        "name": "Cuesta Pitahaya"
    },
    {
        "neabord_id": "2206",
        "district_id": "194",
        "code": "04",
        "name": "Guacimo"
    },
    {
        "neabord_id": "2207",
        "district_id": "194",
        "code": "05",
        "name": "Hidalgo"
    },
    {
        "neabord_id": "2208",
        "district_id": "194",
        "code": "06",
        "name": "Kilómetro 81"
    },
    {
        "neabord_id": "2209",
        "district_id": "194",
        "code": "07",
        "name": "Machuca"
    },
    {
        "neabord_id": "2210",
        "district_id": "194",
        "code": "08",
        "name": "Matamoros"
    },
    {
        "neabord_id": "2211",
        "district_id": "194",
        "code": "09",
        "name": "Tunel"
    },
    {
        "neabord_id": "2212",
        "district_id": "194",
        "code": "10",
        "name": "Uvita"
    },
    {
        "neabord_id": "2213",
        "district_id": "194",
        "code": "11",
        "name": "Zapote."
    },
    {
        "neabord_id": "2214",
        "district_id": "195",
        "code": "01",
        "name": "Alto Cruz"
    },
    {
        "neabord_id": "2215",
        "district_id": "195",
        "code": "02",
        "name": "Ana Mercedes"
    },
    {
        "neabord_id": "2216",
        "district_id": "195",
        "code": "03",
        "name": "angeles"
    },
    {
        "neabord_id": "2217",
        "district_id": "195",
        "code": "04",
        "name": "Arco Iris"
    },
    {
        "neabord_id": "2218",
        "district_id": "195",
        "code": "05",
        "name": "Bajo Los Arce"
    },
    {
        "neabord_id": "2219",
        "district_id": "195",
        "code": "06",
        "name": "Bajo Lourdes"
    },
    {
        "neabord_id": "2220",
        "district_id": "195",
        "code": "07",
        "name": "Baltazar Quesada"
    },
    {
        "neabord_id": "2221",
        "district_id": "195",
        "code": "08",
        "name": "Bellavista"
    },
    {
        "neabord_id": "2222",
        "district_id": "195",
        "code": "09",
        "name": "Carmen"
    },
    {
        "neabord_id": "2223",
        "district_id": "195",
        "code": "10",
        "name": "Casilda Matamoros"
    },
    {
        "neabord_id": "2224",
        "district_id": "195",
        "code": "11",
        "name": "Cementerio"
    },
    {
        "neabord_id": "2225",
        "district_id": "195",
        "code": "12",
        "name": "Coocique"
    },
    {
        "neabord_id": "2226",
        "district_id": "195",
        "code": "13",
        "name": "Colina 1"
    },
    {
        "neabord_id": "2227",
        "district_id": "195",
        "code": "14",
        "name": "Colina 2"
    },
    {
        "neabord_id": "2228",
        "district_id": "195",
        "code": "15",
        "name": "Corazón de Jesus"
    },
    {
        "neabord_id": "2229",
        "district_id": "195",
        "code": "16",
        "name": "Corobici­"
    },
    {
        "neabord_id": "2230",
        "district_id": "195",
        "code": "17",
        "name": "Don Victorino"
    },
    {
        "neabord_id": "2231",
        "district_id": "195",
        "code": "18",
        "name": "El Campo"
    },
    {
        "neabord_id": "2232",
        "district_id": "195",
        "code": "19",
        "name": "Gamonales"
    },
    {
        "neabord_id": "2233",
        "district_id": "195",
        "code": "20",
        "name": "Guadalupe"
    },
    {
        "neabord_id": "2234",
        "district_id": "195",
        "code": "21",
        "name": "La Cruz"
    },
    {
        "neabord_id": "2235",
        "district_id": "195",
        "code": "22",
        "name": "La Leila"
    },
    {
        "neabord_id": "2236",
        "district_id": "195",
        "code": "23",
        "name": "La Margarita"
    },
    {
        "neabord_id": "2237",
        "district_id": "195",
        "code": "24",
        "name": "La Roca"
    },
    {
        "neabord_id": "2238",
        "district_id": "195",
        "code": "25",
        "name": "La Torre"
    },
    {
        "neabord_id": "2239",
        "district_id": "195",
        "code": "26",
        "name": "Los Abuelos"
    },
    {
        "neabord_id": "2240",
        "district_id": "195",
        "code": "27",
        "name": "Lomas del Norte"
    },
    {
        "neabord_id": "2241",
        "district_id": "195",
        "code": "28",
        "name": "Lutz"
    },
    {
        "neabord_id": "2242",
        "district_id": "195",
        "code": "29",
        "name": "Meco"
    },
    {
        "neabord_id": "2243",
        "district_id": "195",
        "code": "30",
        "name": "Mercedes"
    },
    {
        "neabord_id": "2244",
        "district_id": "195",
        "code": "31",
        "name": "Peje"
    },
    {
        "neabord_id": "2245",
        "district_id": "195",
        "code": "32",
        "name": "San Antonio"
    },
    {
        "neabord_id": "2246",
        "district_id": "195",
        "code": "33",
        "name": "San Gerardo"
    },
    {
        "neabord_id": "2247",
        "district_id": "195",
        "code": "34",
        "name": "San Marti­n"
    },
    {
        "neabord_id": "2248",
        "district_id": "195",
        "code": "35",
        "name": "San Pablo"
    },
    {
        "neabord_id": "2249",
        "district_id": "195",
        "code": "36",
        "name": "San Roque"
    },
    {
        "neabord_id": "2250",
        "district_id": "195",
        "code": "37",
        "name": "Santa Fe"
    },
    {
        "neabord_id": "2251",
        "district_id": "195",
        "code": "38",
        "name": "Selva Verde"
    },
    {
        "neabord_id": "2252",
        "district_id": "195",
        "code": "39",
        "name": "Unión"
    },
    {
        "neabord_id": "2253",
        "district_id": "195",
        "code": "40",
        "name": "Villarreal."
    },
    {
        "neabord_id": "2254",
        "district_id": "195",
        "code": "41",
        "name": "Abundancia"
    },
    {
        "neabord_id": "2255",
        "district_id": "195",
        "code": "42",
        "name": "Brumas"
    },
    {
        "neabord_id": "2256",
        "district_id": "195",
        "code": "43",
        "name": "Calle Guerrero"
    },
    {
        "neabord_id": "2257",
        "district_id": "195",
        "code": "44",
        "name": "San Ramón (Cariblanca)"
    },
    {
        "neabord_id": "2258",
        "district_id": "195",
        "code": "45",
        "name": "Cedral Norte"
    },
    {
        "neabord_id": "2259",
        "district_id": "195",
        "code": "46",
        "name": "Cedral Sur"
    },
    {
        "neabord_id": "2260",
        "district_id": "195",
        "code": "47",
        "name": "Colón"
    },
    {
        "neabord_id": "2261",
        "district_id": "195",
        "code": "48",
        "name": "Dulce Nombre"
    },
    {
        "neabord_id": "2262",
        "district_id": "195",
        "code": "49",
        "name": "Leones"
    },
    {
        "neabord_id": "2263",
        "district_id": "195",
        "code": "50",
        "name": "Lindavista"
    },
    {
        "neabord_id": "2264",
        "district_id": "195",
        "code": "51",
        "name": "Manzanos"
    },
    {
        "neabord_id": "2265",
        "district_id": "195",
        "code": "52",
        "name": "Montañitas"
    },
    {
        "neabord_id": "2266",
        "district_id": "195",
        "code": "53",
        "name": "Palmas"
    },
    {
        "neabord_id": "2267",
        "district_id": "195",
        "code": "54",
        "name": "Porvenir"
    },
    {
        "neabord_id": "2268",
        "district_id": "195",
        "code": "55",
        "name": "San Juan (Quebrada Palo)"
    },
    {
        "neabord_id": "2269",
        "district_id": "195",
        "code": "56",
        "name": "Ronrón Abajo"
    },
    {
        "neabord_id": "2270",
        "district_id": "195",
        "code": "57",
        "name": "Ronrón Arriba"
    },
    {
        "neabord_id": "2271",
        "district_id": "195",
        "code": "58",
        "name": "San Isidro"
    },
    {
        "neabord_id": "2272",
        "district_id": "195",
        "code": "59",
        "name": "San Jose de la Montaña"
    },
    {
        "neabord_id": "2273",
        "district_id": "195",
        "code": "60",
        "name": "San Luis"
    },
    {
        "neabord_id": "2274",
        "district_id": "195",
        "code": "61",
        "name": "San Rafael"
    },
    {
        "neabord_id": "2275",
        "district_id": "195",
        "code": "62",
        "name": "San Vicente"
    },
    {
        "neabord_id": "2276",
        "district_id": "195",
        "code": "63",
        "name": "Sucre"
    },
    {
        "neabord_id": "2277",
        "district_id": "195",
        "code": "64",
        "name": "Tesalia."
    },
    {
        "neabord_id": "2278",
        "district_id": "196",
        "code": "01",
        "name": "Alto Gloria"
    },
    {
        "neabord_id": "2279",
        "district_id": "196",
        "code": "02",
        "name": "Aquilea (San Francisco)"
    },
    {
        "neabord_id": "2280",
        "district_id": "196",
        "code": "03",
        "name": "Bonanza"
    },
    {
        "neabord_id": "2281",
        "district_id": "196",
        "code": "04",
        "name": "Caimitos"
    },
    {
        "neabord_id": "2282",
        "district_id": "196",
        "code": "05",
        "name": "Chaparral"
    },
    {
        "neabord_id": "2283",
        "district_id": "196",
        "code": "06",
        "name": "Cuestillas"
    },
    {
        "neabord_id": "2284",
        "district_id": "196",
        "code": "07",
        "name": "Jabillos (parte)"
    },
    {
        "neabord_id": "2285",
        "district_id": "196",
        "code": "08",
        "name": "Molino"
    },
    {
        "neabord_id": "2286",
        "district_id": "196",
        "code": "09",
        "name": "Muelle de San Carlos"
    },
    {
        "neabord_id": "2287",
        "district_id": "196",
        "code": "10",
        "name": "Pejeviejo"
    },
    {
        "neabord_id": "2288",
        "district_id": "196",
        "code": "11",
        "name": "Penjamo"
    },
    {
        "neabord_id": "2289",
        "district_id": "196",
        "code": "12",
        "name": "Platanar"
    },
    {
        "neabord_id": "2290",
        "district_id": "196",
        "code": "13",
        "name": "Puente Casa"
    },
    {
        "neabord_id": "2291",
        "district_id": "196",
        "code": "14",
        "name": "Puerto Escondido"
    },
    {
        "neabord_id": "2292",
        "district_id": "196",
        "code": "15",
        "name": "Quebrada Azul"
    },
    {
        "neabord_id": "2293",
        "district_id": "196",
        "code": "16",
        "name": "San Juan"
    },
    {
        "neabord_id": "2294",
        "district_id": "196",
        "code": "17",
        "name": "San Luis"
    },
    {
        "neabord_id": "2295",
        "district_id": "196",
        "code": "18",
        "name": "San Rafael"
    },
    {
        "neabord_id": "2296",
        "district_id": "196",
        "code": "19",
        "name": "Santa Clara"
    },
    {
        "neabord_id": "2297",
        "district_id": "196",
        "code": "20",
        "name": "Santa Mari­a"
    },
    {
        "neabord_id": "2298",
        "district_id": "196",
        "code": "21",
        "name": "Santa Rita"
    },
    {
        "neabord_id": "2299",
        "district_id": "196",
        "code": "22",
        "name": "Sapera"
    },
    {
        "neabord_id": "2300",
        "district_id": "196",
        "code": "23",
        "name": "Ulima"
    },
    {
        "neabord_id": "2301",
        "district_id": "196",
        "code": "24",
        "name": "Vega"
    },
    {
        "neabord_id": "2302",
        "district_id": "196",
        "code": "25",
        "name": "Vieja."
    },
    {
        "neabord_id": "2303",
        "district_id": "197",
        "code": "01",
        "name": "Culebra"
    },
    {
        "neabord_id": "2304",
        "district_id": "197",
        "code": "02",
        "name": "Quina (parte)"
    },
    {
        "neabord_id": "2305",
        "district_id": "197",
        "code": "03",
        "name": "San Antonio"
    },
    {
        "neabord_id": "2306",
        "district_id": "197",
        "code": "04",
        "name": "San Bosco."
    },
    {
        "neabord_id": "2307",
        "district_id": "198",
        "code": "01",
        "name": "Latino"
    },
    {
        "neabord_id": "2308",
        "district_id": "198",
        "code": "02",
        "name": "Manantial"
    },
    {
        "neabord_id": "2309",
        "district_id": "198",
        "code": "03",
        "name": "Montecristo"
    },
    {
        "neabord_id": "2310",
        "district_id": "198",
        "code": "04",
        "name": "Nazareth"
    },
    {
        "neabord_id": "2311",
        "district_id": "198",
        "code": "05",
        "name": "San Bosco"
    },
    {
        "neabord_id": "2312",
        "district_id": "198",
        "code": "06",
        "name": "San Gerardo Viento Fresco"
    },
    {
        "neabord_id": "2313",
        "district_id": "198",
        "code": "07",
        "name": "Vistas de la Llanura."
    },
    {
        "neabord_id": "2314",
        "district_id": "198",
        "code": "08",
        "name": "Altamira"
    },
    {
        "neabord_id": "2315",
        "district_id": "198",
        "code": "09",
        "name": "Alto Jimenez (Montecristo)"
    },
    {
        "neabord_id": "2316",
        "district_id": "198",
        "code": "10",
        "name": "Bijagual"
    },
    {
        "neabord_id": "2317",
        "district_id": "198",
        "code": "11",
        "name": "Boca los Chiles"
    },
    {
        "neabord_id": "2318",
        "district_id": "198",
        "code": "12",
        "name": "Cantarrana (Santa Fe)"
    },
    {
        "neabord_id": "2319",
        "district_id": "198",
        "code": "13",
        "name": "Coopesanjuan"
    },
    {
        "neabord_id": "2320",
        "district_id": "198",
        "code": "14",
        "name": "Caño Negro"
    },
    {
        "neabord_id": "2321",
        "district_id": "198",
        "code": "15",
        "name": "Cerrito"
    },
    {
        "neabord_id": "2322",
        "district_id": "198",
        "code": "16",
        "name": "Cerro Cortes"
    },
    {
        "neabord_id": "2323",
        "district_id": "198",
        "code": "17",
        "name": "Concepción"
    },
    {
        "neabord_id": "2324",
        "district_id": "198",
        "code": "18",
        "name": "Chiles"
    },
    {
        "neabord_id": "2325",
        "district_id": "198",
        "code": "19",
        "name": "Danta"
    },
    {
        "neabord_id": "2326",
        "district_id": "198",
        "code": "20",
        "name": "Delicias"
    },
    {
        "neabord_id": "2327",
        "district_id": "198",
        "code": "21",
        "name": "Faroles"
    },
    {
        "neabord_id": "2328",
        "district_id": "198",
        "code": "22",
        "name": "Gloria"
    },
    {
        "neabord_id": "2329",
        "district_id": "198",
        "code": "23",
        "name": "Guabo"
    },
    {
        "neabord_id": "2330",
        "district_id": "198",
        "code": "24",
        "name": "Llanos de Altamirita"
    },
    {
        "neabord_id": "2331",
        "district_id": "198",
        "code": "25",
        "name": "Pitalito Norte (Esquipulas)"
    },
    {
        "neabord_id": "2332",
        "district_id": "198",
        "code": "26",
        "name": "Pitalito"
    },
    {
        "neabord_id": "2333",
        "district_id": "198",
        "code": "27",
        "name": "San Jose"
    },
    {
        "neabord_id": "2334",
        "district_id": "198",
        "code": "28",
        "name": "Valle Hermoso"
    },
    {
        "neabord_id": "2335",
        "district_id": "198",
        "code": "29",
        "name": "Vasconia"
    },
    {
        "neabord_id": "2336",
        "district_id": "198",
        "code": "30",
        "name": "Vuelta de Kooper."
    },
    {
        "neabord_id": "2337",
        "district_id": "199",
        "code": "01",
        "name": "Carmen"
    },
    {
        "neabord_id": "2338",
        "district_id": "199",
        "code": "02",
        "name": "Corazón de Jesus"
    },
    {
        "neabord_id": "2339",
        "district_id": "199",
        "code": "03",
        "name": "El Ceibo"
    },
    {
        "neabord_id": "2340",
        "district_id": "199",
        "code": "04",
        "name": "Jardi­n"
    },
    {
        "neabord_id": "2341",
        "district_id": "199",
        "code": "05",
        "name": "La Gloria."
    },
    {
        "neabord_id": "2342",
        "district_id": "199",
        "code": "06",
        "name": "Alpes"
    },
    {
        "neabord_id": "2343",
        "district_id": "199",
        "code": "07",
        "name": "Brisas"
    },
    {
        "neabord_id": "2344",
        "district_id": "199",
        "code": "08",
        "name": "Buenos Aires"
    },
    {
        "neabord_id": "2345",
        "district_id": "199",
        "code": "09",
        "name": "Guayabo"
    },
    {
        "neabord_id": "2346",
        "district_id": "199",
        "code": "10",
        "name": "Latas"
    },
    {
        "neabord_id": "2347",
        "district_id": "199",
        "code": "11",
        "name": "Marsella"
    },
    {
        "neabord_id": "2348",
        "district_id": "199",
        "code": "12",
        "name": "Mesen"
    },
    {
        "neabord_id": "2349",
        "district_id": "199",
        "code": "13",
        "name": "Nazareth"
    },
    {
        "neabord_id": "2350",
        "district_id": "199",
        "code": "14",
        "name": "Negritos"
    },
    {
        "neabord_id": "2351",
        "district_id": "199",
        "code": "15",
        "name": "Parai­so"
    },
    {
        "neabord_id": "2352",
        "district_id": "199",
        "code": "16",
        "name": "Pueblo Viejo"
    },
    {
        "neabord_id": "2353",
        "district_id": "199",
        "code": "17",
        "name": "San Cayetano"
    },
    {
        "neabord_id": "2354",
        "district_id": "199",
        "code": "18",
        "name": "San Marti­n"
    },
    {
        "neabord_id": "2355",
        "district_id": "199",
        "code": "19",
        "name": "Unión."
    },
    {
        "neabord_id": "2356",
        "district_id": "200",
        "code": "01",
        "name": "Bosque"
    },
    {
        "neabord_id": "2357",
        "district_id": "200",
        "code": "02",
        "name": "Comarca"
    },
    {
        "neabord_id": "2358",
        "district_id": "200",
        "code": "03",
        "name": "San Cristóbal."
    },
    {
        "neabord_id": "2359",
        "district_id": "200",
        "code": "04",
        "name": "angeles"
    },
    {
        "neabord_id": "2360",
        "district_id": "200",
        "code": "05",
        "name": "Boca Sahi­no"
    },
    {
        "neabord_id": "2361",
        "district_id": "200",
        "code": "06",
        "name": "Boca Tapada"
    },
    {
        "neabord_id": "2362",
        "district_id": "200",
        "code": "07",
        "name": "Boca Tres Amigos"
    },
    {
        "neabord_id": "2363",
        "district_id": "200",
        "code": "08",
        "name": "Cabra"
    },
    {
        "neabord_id": "2364",
        "district_id": "200",
        "code": "09",
        "name": "Canacas"
    },
    {
        "neabord_id": "2365",
        "district_id": "200",
        "code": "10",
        "name": "Caño Chu"
    },
    {
        "neabord_id": "2366",
        "district_id": "200",
        "code": "11",
        "name": "Cerro Blanco (San Marcos)"
    },
    {
        "neabord_id": "2367",
        "district_id": "200",
        "code": "12",
        "name": "Cuatro Esquinas"
    },
    {
        "neabord_id": "2368",
        "district_id": "200",
        "code": "13",
        "name": "Chaparrón"
    },
    {
        "neabord_id": "2369",
        "district_id": "200",
        "code": "14",
        "name": "Chirivico (Coopeisabel)"
    },
    {
        "neabord_id": "2370",
        "district_id": "200",
        "code": "15",
        "name": "Encanto"
    },
    {
        "neabord_id": "2371",
        "district_id": "200",
        "code": "16",
        "name": "Fama (Carmen)"
    },
    {
        "neabord_id": "2372",
        "district_id": "200",
        "code": "17",
        "name": "Flor"
    },
    {
        "neabord_id": "2373",
        "district_id": "200",
        "code": "18",
        "name": "I Griega"
    },
    {
        "neabord_id": "2374",
        "district_id": "200",
        "code": "19",
        "name": "Josefina"
    },
    {
        "neabord_id": "2375",
        "district_id": "200",
        "code": "20",
        "name": "Legua"
    },
    {
        "neabord_id": "2376",
        "district_id": "200",
        "code": "21",
        "name": "Ojoche"
    },
    {
        "neabord_id": "2377",
        "district_id": "200",
        "code": "22",
        "name": "Ojochito"
    },
    {
        "neabord_id": "2378",
        "district_id": "200",
        "code": "23",
        "name": "Palmar"
    },
    {
        "neabord_id": "2379",
        "district_id": "200",
        "code": "24",
        "name": "Pegón"
    },
    {
        "neabord_id": "2380",
        "district_id": "200",
        "code": "25",
        "name": "Piedra Alegre"
    },
    {
        "neabord_id": "2381",
        "district_id": "200",
        "code": "26",
        "name": "Puerto Escondido"
    },
    {
        "neabord_id": "2382",
        "district_id": "200",
        "code": "27",
        "name": "Quebrada Grande"
    },
    {
        "neabord_id": "2383",
        "district_id": "200",
        "code": "28",
        "name": "Sahi­no"
    },
    {
        "neabord_id": "2384",
        "district_id": "200",
        "code": "29",
        "name": "San Luis"
    },
    {
        "neabord_id": "2385",
        "district_id": "200",
        "code": "30",
        "name": "Santa Elena"
    },
    {
        "neabord_id": "2386",
        "district_id": "200",
        "code": "31",
        "name": "Tigre"
    },
    {
        "neabord_id": "2387",
        "district_id": "200",
        "code": "32",
        "name": "Trinchera"
    },
    {
        "neabord_id": "2388",
        "district_id": "200",
        "code": "33",
        "name": "Vegas"
    },
    {
        "neabord_id": "2389",
        "district_id": "200",
        "code": "34",
        "name": "Veracruz"
    },
    {
        "neabord_id": "2390",
        "district_id": "200",
        "code": "35",
        "name": "Vuelta Bolsón (parte)"
    },
    {
        "neabord_id": "2391",
        "district_id": "200",
        "code": "36",
        "name": "Vuelta Tablón"
    },
    {
        "neabord_id": "2392",
        "district_id": "200",
        "code": "37",
        "name": "Yucatan."
    },
    {
        "neabord_id": "2393",
        "district_id": "201",
        "code": "01",
        "name": "Agua Azul"
    },
    {
        "neabord_id": "2394",
        "district_id": "201",
        "code": "02",
        "name": "Alamo"
    },
    {
        "neabord_id": "2395",
        "district_id": "201",
        "code": "03",
        "name": "angeles"
    },
    {
        "neabord_id": "2396",
        "district_id": "201",
        "code": "04",
        "name": "Buri­o"
    },
    {
        "neabord_id": "2397",
        "district_id": "201",
        "code": "05",
        "name": "Castillo (parte)"
    },
    {
        "neabord_id": "2398",
        "district_id": "201",
        "code": "06",
        "name": "Guaria"
    },
    {
        "neabord_id": "2399",
        "district_id": "201",
        "code": "07",
        "name": "El Campo (Guayabal)"
    },
    {
        "neabord_id": "2400",
        "district_id": "201",
        "code": "08",
        "name": "Jilguero"
    },
    {
        "neabord_id": "2401",
        "district_id": "201",
        "code": "09",
        "name": "Llano Verde"
    },
    {
        "neabord_id": "2402",
        "district_id": "201",
        "code": "10",
        "name": "Orqui­deas"
    },
    {
        "neabord_id": "2403",
        "district_id": "201",
        "code": "11",
        "name": "Palma"
    },
    {
        "neabord_id": "2404",
        "district_id": "201",
        "code": "12",
        "name": "Perla"
    },
    {
        "neabord_id": "2405",
        "district_id": "201",
        "code": "13",
        "name": "San Isidro"
    },
    {
        "neabord_id": "2406",
        "district_id": "201",
        "code": "14",
        "name": "San Jorge"
    },
    {
        "neabord_id": "2407",
        "district_id": "201",
        "code": "15",
        "name": "Santa Eduviges"
    },
    {
        "neabord_id": "2408",
        "district_id": "201",
        "code": "16",
        "name": "Sonafluca"
    },
    {
        "neabord_id": "2409",
        "district_id": "201",
        "code": "17",
        "name": "Tanque"
    },
    {
        "neabord_id": "2410",
        "district_id": "201",
        "code": "18",
        "name": "Tres Esquinas"
    },
    {
        "neabord_id": "2411",
        "district_id": "201",
        "code": "19",
        "name": "Zeta Trece."
    },
    {
        "neabord_id": "2412",
        "district_id": "202",
        "code": "01",
        "name": "angeles"
    },
    {
        "neabord_id": "2413",
        "district_id": "202",
        "code": "02",
        "name": "Palmas."
    },
    {
        "neabord_id": "2414",
        "district_id": "202",
        "code": "03",
        "name": "Cerritos"
    },
    {
        "neabord_id": "2415",
        "district_id": "202",
        "code": "04",
        "name": "Esperanza"
    },
    {
        "neabord_id": "2416",
        "district_id": "202",
        "code": "05",
        "name": "Futuro"
    },
    {
        "neabord_id": "2417",
        "district_id": "202",
        "code": "06",
        "name": "Jabillos (parte)"
    },
    {
        "neabord_id": "2418",
        "district_id": "202",
        "code": "07",
        "name": "Lucha"
    },
    {
        "neabord_id": "2419",
        "district_id": "202",
        "code": "08",
        "name": "San Gerardo"
    },
    {
        "neabord_id": "2420",
        "district_id": "202",
        "code": "09",
        "name": "San Isidro"
    },
    {
        "neabord_id": "2421",
        "district_id": "202",
        "code": "10",
        "name": "San Jose"
    },
    {
        "neabord_id": "2422",
        "district_id": "202",
        "code": "11",
        "name": "San Miguel"
    },
    {
        "neabord_id": "2423",
        "district_id": "202",
        "code": "12",
        "name": "San Pedro"
    },
    {
        "neabord_id": "2424",
        "district_id": "202",
        "code": "13",
        "name": "San Rafael."
    },
    {
        "neabord_id": "2425",
        "district_id": "203",
        "code": "01",
        "name": "Altura"
    },
    {
        "neabord_id": "2426",
        "district_id": "203",
        "code": "02",
        "name": "Calle Damas"
    },
    {
        "neabord_id": "2427",
        "district_id": "203",
        "code": "03",
        "name": "Corea (Concepción)"
    },
    {
        "neabord_id": "2428",
        "district_id": "203",
        "code": "04",
        "name": "Corte"
    },
    {
        "neabord_id": "2429",
        "district_id": "203",
        "code": "05",
        "name": "Loma"
    },
    {
        "neabord_id": "2430",
        "district_id": "203",
        "code": "06",
        "name": "Lourdes"
    },
    {
        "neabord_id": "2431",
        "district_id": "203",
        "code": "07",
        "name": "Marina"
    },
    {
        "neabord_id": "2432",
        "district_id": "203",
        "code": "08",
        "name": "Marinita"
    },
    {
        "neabord_id": "2433",
        "district_id": "203",
        "code": "09",
        "name": "San Rafael"
    },
    {
        "neabord_id": "2434",
        "district_id": "203",
        "code": "10",
        "name": "San Rafael Sur"
    },
    {
        "neabord_id": "2435",
        "district_id": "203",
        "code": "11",
        "name": "Santa Rosa"
    },
    {
        "neabord_id": "2436",
        "district_id": "203",
        "code": "12",
        "name": "Surtubal"
    },
    {
        "neabord_id": "2437",
        "district_id": "203",
        "code": "13",
        "name": "Unión"
    },
    {
        "neabord_id": "2438",
        "district_id": "203",
        "code": "14",
        "name": "Vacablanca (San Francisco)"
    },
    {
        "neabord_id": "2439",
        "district_id": "203",
        "code": "15",
        "name": "Villa Mari­a."
    },
    {
        "neabord_id": "2440",
        "district_id": "204",
        "code": "01",
        "name": "Altamirita"
    },
    {
        "neabord_id": "2441",
        "district_id": "204",
        "code": "02",
        "name": "Alto Blanca Luci­a"
    },
    {
        "neabord_id": "2442",
        "district_id": "204",
        "code": "03",
        "name": "Buri­o"
    },
    {
        "neabord_id": "2443",
        "district_id": "204",
        "code": "04",
        "name": "Cacao"
    },
    {
        "neabord_id": "2444",
        "district_id": "204",
        "code": "05",
        "name": "Delicias"
    },
    {
        "neabord_id": "2445",
        "district_id": "204",
        "code": "06",
        "name": "Esperanza"
    },
    {
        "neabord_id": "2446",
        "district_id": "204",
        "code": "07",
        "name": "Jicarito"
    },
    {
        "neabord_id": "2447",
        "district_id": "204",
        "code": "08",
        "name": "Lindavista"
    },
    {
        "neabord_id": "2448",
        "district_id": "204",
        "code": "09",
        "name": "Poma (parte)"
    },
    {
        "neabord_id": "2449",
        "district_id": "204",
        "code": "10",
        "name": "Puerto Seco"
    },
    {
        "neabord_id": "2450",
        "district_id": "204",
        "code": "11",
        "name": "San Isidro"
    },
    {
        "neabord_id": "2451",
        "district_id": "204",
        "code": "12",
        "name": "Santa Eulalia (parte)"
    },
    {
        "neabord_id": "2452",
        "district_id": "204",
        "code": "13",
        "name": "Santa Luci­a"
    },
    {
        "neabord_id": "2453",
        "district_id": "204",
        "code": "14",
        "name": "Tigra."
    },
    {
        "neabord_id": "2454",
        "district_id": "205",
        "code": "01",
        "name": "Almendros"
    },
    {
        "neabord_id": "2455",
        "district_id": "205",
        "code": "02",
        "name": "Bellavista"
    },
    {
        "neabord_id": "2456",
        "district_id": "205",
        "code": "03",
        "name": "Betania"
    },
    {
        "neabord_id": "2457",
        "district_id": "205",
        "code": "04",
        "name": "Boca de San Carlos"
    },
    {
        "neabord_id": "2458",
        "district_id": "205",
        "code": "05",
        "name": "Boca Providencia (parte)"
    },
    {
        "neabord_id": "2459",
        "district_id": "205",
        "code": "06",
        "name": "Cabeceras de Aguas Zarquitas"
    },
    {
        "neabord_id": "2460",
        "district_id": "205",
        "code": "07",
        "name": "Carmen"
    },
    {
        "neabord_id": "2461",
        "district_id": "205",
        "code": "08",
        "name": "Cascada"
    },
    {
        "neabord_id": "2462",
        "district_id": "205",
        "code": "09",
        "name": "Castelmare"
    },
    {
        "neabord_id": "2463",
        "district_id": "205",
        "code": "10",
        "name": "Cocobolo"
    },
    {
        "neabord_id": "2464",
        "district_id": "205",
        "code": "11",
        "name": "Coopevega"
    },
    {
        "neabord_id": "2465",
        "district_id": "205",
        "code": "12",
        "name": "Corazón de Jesus"
    },
    {
        "neabord_id": "2466",
        "district_id": "205",
        "code": "13",
        "name": "Crucitas"
    },
    {
        "neabord_id": "2467",
        "district_id": "205",
        "code": "14",
        "name": "Chamorrito"
    },
    {
        "neabord_id": "2468",
        "district_id": "205",
        "code": "15",
        "name": "Chamorro"
    },
    {
        "neabord_id": "2469",
        "district_id": "205",
        "code": "16",
        "name": "Chorreras"
    },
    {
        "neabord_id": "2470",
        "district_id": "205",
        "code": "17",
        "name": "Hebrón"
    },
    {
        "neabord_id": "2471",
        "district_id": "205",
        "code": "18",
        "name": "Isla del Cura"
    },
    {
        "neabord_id": "2472",
        "district_id": "205",
        "code": "19",
        "name": "Isla Pobres"
    },
    {
        "neabord_id": "2473",
        "district_id": "205",
        "code": "20",
        "name": "Isla Sabalo"
    },
    {
        "neabord_id": "2474",
        "district_id": "205",
        "code": "21",
        "name": "Jardi­n"
    },
    {
        "neabord_id": "2475",
        "district_id": "205",
        "code": "22",
        "name": "Kopper"
    },
    {
        "neabord_id": "2476",
        "district_id": "205",
        "code": "23",
        "name": "La Cajeta"
    },
    {
        "neabord_id": "2477",
        "district_id": "205",
        "code": "24",
        "name": "Laurel Galan"
    },
    {
        "neabord_id": "2478",
        "district_id": "205",
        "code": "25",
        "name": "Limoncito"
    },
    {
        "neabord_id": "2479",
        "district_id": "205",
        "code": "26",
        "name": "Moravia"
    },
    {
        "neabord_id": "2480",
        "district_id": "205",
        "code": "27",
        "name": "Patastillo"
    },
    {
        "neabord_id": "2481",
        "district_id": "205",
        "code": "28",
        "name": "Pueblo Nuevo"
    },
    {
        "neabord_id": "2482",
        "district_id": "205",
        "code": "29",
        "name": "Recreo"
    },
    {
        "neabord_id": "2483",
        "district_id": "205",
        "code": "30",
        "name": "Ri­o Tico"
    },
    {
        "neabord_id": "2484",
        "district_id": "205",
        "code": "31",
        "name": "Roble"
    },
    {
        "neabord_id": "2485",
        "district_id": "205",
        "code": "32",
        "name": "San Antonio"
    },
    {
        "neabord_id": "2486",
        "district_id": "205",
        "code": "33",
        "name": "San Fernando"
    },
    {
        "neabord_id": "2487",
        "district_id": "205",
        "code": "34",
        "name": "San Francisco"
    },
    {
        "neabord_id": "2488",
        "district_id": "205",
        "code": "35",
        "name": "San Joaqui­n"
    },
    {
        "neabord_id": "2489",
        "district_id": "205",
        "code": "36",
        "name": "San Jorge"
    },
    {
        "neabord_id": "2490",
        "district_id": "205",
        "code": "37",
        "name": "San Jose"
    },
    {
        "neabord_id": "2491",
        "district_id": "205",
        "code": "38",
        "name": "San Marcos"
    },
    {
        "neabord_id": "2492",
        "district_id": "205",
        "code": "39",
        "name": "Santa Rita"
    },
    {
        "neabord_id": "2493",
        "district_id": "205",
        "code": "40",
        "name": "Santa Teresa"
    },
    {
        "neabord_id": "2494",
        "district_id": "205",
        "code": "41",
        "name": "San Vito"
    },
    {
        "neabord_id": "2495",
        "district_id": "205",
        "code": "42",
        "name": "Tabla Grande (San Pedro)"
    },
    {
        "neabord_id": "2496",
        "district_id": "205",
        "code": "43",
        "name": "Terrón Colorado (parte)"
    },
    {
        "neabord_id": "2497",
        "district_id": "205",
        "code": "44",
        "name": "Ventanas"
    },
    {
        "neabord_id": "2498",
        "district_id": "205",
        "code": "45",
        "name": "Vuelta Bolsón (parte)"
    },
    {
        "neabord_id": "2499",
        "district_id": "205",
        "code": "46",
        "name": "Vuelta Millonarios"
    },
    {
        "neabord_id": "2500",
        "district_id": "205",
        "code": "47",
        "name": "Vuelta Ruedas."
    },
    {
        "neabord_id": "2501",
        "district_id": "206",
        "code": "01",
        "name": "Pericos."
    },
    {
        "neabord_id": "2502",
        "district_id": "206",
        "code": "02",
        "name": "Bajillo"
    },
    {
        "neabord_id": "2503",
        "district_id": "206",
        "code": "03",
        "name": "Caño Ciego"
    },
    {
        "neabord_id": "2504",
        "district_id": "206",
        "code": "04",
        "name": "Cedros"
    },
    {
        "neabord_id": "2505",
        "district_id": "206",
        "code": "05",
        "name": "Chambacu"
    },
    {
        "neabord_id": "2506",
        "district_id": "206",
        "code": "06",
        "name": "Delicias"
    },
    {
        "neabord_id": "2507",
        "district_id": "206",
        "code": "07",
        "name": "La Unión"
    },
    {
        "neabord_id": "2508",
        "district_id": "206",
        "code": "08",
        "name": "Maquencal"
    },
    {
        "neabord_id": "2509",
        "district_id": "206",
        "code": "09",
        "name": "Mirador"
    },
    {
        "neabord_id": "2510",
        "district_id": "206",
        "code": "10",
        "name": "Montelimar"
    },
    {
        "neabord_id": "2511",
        "district_id": "206",
        "code": "11",
        "name": "Monterrey"
    },
    {
        "neabord_id": "2512",
        "district_id": "206",
        "code": "12",
        "name": "Orqui­dea"
    },
    {
        "neabord_id": "2513",
        "district_id": "206",
        "code": "13",
        "name": "Pataste Arriba"
    },
    {
        "neabord_id": "2514",
        "district_id": "206",
        "code": "14",
        "name": "Sabalito"
    },
    {
        "neabord_id": "2515",
        "district_id": "206",
        "code": "15",
        "name": "San Andres"
    },
    {
        "neabord_id": "2516",
        "district_id": "206",
        "code": "16",
        "name": "San Antonio"
    },
    {
        "neabord_id": "2517",
        "district_id": "206",
        "code": "17",
        "name": "San Cristóbal"
    },
    {
        "neabord_id": "2518",
        "district_id": "206",
        "code": "18",
        "name": "San Miguel"
    },
    {
        "neabord_id": "2519",
        "district_id": "206",
        "code": "19",
        "name": "Santa Eulalia (parte)"
    },
    {
        "neabord_id": "2520",
        "district_id": "206",
        "code": "20",
        "name": "Santa Marta."
    },
    {
        "neabord_id": "2521",
        "district_id": "207",
        "code": "01",
        "name": "Fatima"
    },
    {
        "neabord_id": "2522",
        "district_id": "207",
        "code": "02",
        "name": "Parajeles"
    },
    {
        "neabord_id": "2523",
        "district_id": "207",
        "code": "03",
        "name": "Tres Perlas"
    },
    {
        "neabord_id": "2524",
        "district_id": "207",
        "code": "04",
        "name": "Valle Hermoso."
    },
    {
        "neabord_id": "2525",
        "district_id": "207",
        "code": "05",
        "name": "Acapulco"
    },
    {
        "neabord_id": "2526",
        "district_id": "207",
        "code": "06",
        "name": "Aldea"
    },
    {
        "neabord_id": "2527",
        "district_id": "207",
        "code": "07",
        "name": "angeles"
    },
    {
        "neabord_id": "2528",
        "district_id": "207",
        "code": "08",
        "name": "Azucena"
    },
    {
        "neabord_id": "2529",
        "district_id": "207",
        "code": "09",
        "name": "Banderas"
    },
    {
        "neabord_id": "2530",
        "district_id": "207",
        "code": "10",
        "name": "Boca Providencia (parte)"
    },
    {
        "neabord_id": "2531",
        "district_id": "207",
        "code": "11",
        "name": "Brisas"
    },
    {
        "neabord_id": "2532",
        "district_id": "207",
        "code": "12",
        "name": "Buenavista"
    },
    {
        "neabord_id": "2533",
        "district_id": "207",
        "code": "13",
        "name": "Buenos Aires"
    },
    {
        "neabord_id": "2534",
        "district_id": "207",
        "code": "14",
        "name": "Carrizal"
    },
    {
        "neabord_id": "2535",
        "district_id": "207",
        "code": "15",
        "name": "Ceiba"
    },
    {
        "neabord_id": "2536",
        "district_id": "207",
        "code": "16",
        "name": "Conchito"
    },
    {
        "neabord_id": "2537",
        "district_id": "207",
        "code": "17",
        "name": "Concho"
    },
    {
        "neabord_id": "2538",
        "district_id": "207",
        "code": "18",
        "name": "Cuatro Esquinas"
    },
    {
        "neabord_id": "2539",
        "district_id": "207",
        "code": "19",
        "name": "Esterito"
    },
    {
        "neabord_id": "2540",
        "district_id": "207",
        "code": "20",
        "name": "Estero"
    },
    {
        "neabord_id": "2541",
        "district_id": "207",
        "code": "21",
        "name": "Estrella"
    },
    {
        "neabord_id": "2542",
        "district_id": "207",
        "code": "22",
        "name": "Guaria"
    },
    {
        "neabord_id": "2543",
        "district_id": "207",
        "code": "23",
        "name": "Jazmi­n"
    },
    {
        "neabord_id": "2544",
        "district_id": "207",
        "code": "24",
        "name": "Jocote"
    },
    {
        "neabord_id": "2545",
        "district_id": "207",
        "code": "25",
        "name": "Juanilama"
    },
    {
        "neabord_id": "2546",
        "district_id": "207",
        "code": "26",
        "name": "Luisa"
    },
    {
        "neabord_id": "2547",
        "district_id": "207",
        "code": "27",
        "name": "Llano Verde"
    },
    {
        "neabord_id": "2548",
        "district_id": "207",
        "code": "28",
        "name": "Morazan"
    },
    {
        "neabord_id": "2549",
        "district_id": "207",
        "code": "29",
        "name": "Nieves"
    },
    {
        "neabord_id": "2550",
        "district_id": "207",
        "code": "30",
        "name": "Parai­so"
    },
    {
        "neabord_id": "2551",
        "district_id": "207",
        "code": "31",
        "name": "Paso Real"
    },
    {
        "neabord_id": "2552",
        "district_id": "207",
        "code": "32",
        "name": "Plomo"
    },
    {
        "neabord_id": "2553",
        "district_id": "207",
        "code": "33",
        "name": "Pocosol"
    },
    {
        "neabord_id": "2554",
        "district_id": "207",
        "code": "34",
        "name": "Providencia (San Luis)"
    },
    {
        "neabord_id": "2555",
        "district_id": "207",
        "code": "35",
        "name": "Pueblo Nuevo"
    },
    {
        "neabord_id": "2556",
        "district_id": "207",
        "code": "36",
        "name": "Pueblo Santo"
    },
    {
        "neabord_id": "2557",
        "district_id": "207",
        "code": "37",
        "name": "Rancho Quemado"
    },
    {
        "neabord_id": "2558",
        "district_id": "207",
        "code": "38",
        "name": "Rubi­"
    },
    {
        "neabord_id": "2559",
        "district_id": "207",
        "code": "39",
        "name": "San Alejo"
    },
    {
        "neabord_id": "2560",
        "district_id": "207",
        "code": "40",
        "name": "San Bosco"
    },
    {
        "neabord_id": "2561",
        "district_id": "207",
        "code": "41",
        "name": "San Cristobal"
    },
    {
        "neabord_id": "2562",
        "district_id": "207",
        "code": "42",
        "name": "San Diego"
    },
    {
        "neabord_id": "2563",
        "district_id": "207",
        "code": "43",
        "name": "San Gerardo"
    },
    {
        "neabord_id": "2564",
        "district_id": "207",
        "code": "44",
        "name": "San Isidro"
    },
    {
        "neabord_id": "2565",
        "district_id": "207",
        "code": "45",
        "name": "San Marti­n"
    },
    {
        "neabord_id": "2566",
        "district_id": "207",
        "code": "46",
        "name": "San Rafael"
    },
    {
        "neabord_id": "2567",
        "district_id": "207",
        "code": "47",
        "name": "Santa Cecilia"
    },
    {
        "neabord_id": "2568",
        "district_id": "207",
        "code": "48",
        "name": "Santa Esperanza"
    },
    {
        "neabord_id": "2569",
        "district_id": "207",
        "code": "49",
        "name": "Santa Mari­a"
    },
    {
        "neabord_id": "2570",
        "district_id": "207",
        "code": "50",
        "name": "Terrón Colorado (parte)"
    },
    {
        "neabord_id": "2571",
        "district_id": "207",
        "code": "51",
        "name": "Tiricias"
    },
    {
        "neabord_id": "2572",
        "district_id": "207",
        "code": "52",
        "name": "Tres y Tres."
    },
    {
        "neabord_id": "2573",
        "district_id": "208",
        "code": "01",
        "name": "Cantarranas"
    },
    {
        "neabord_id": "2574",
        "district_id": "208",
        "code": "02",
        "name": "Santa Teresita."
    },
    {
        "neabord_id": "2575",
        "district_id": "209",
        "code": "01",
        "name": "Peña."
    },
    {
        "neabord_id": "2576",
        "district_id": "210",
        "code": "01",
        "name": "Anateri"
    },
    {
        "neabord_id": "2577",
        "district_id": "210",
        "code": "02",
        "name": "Bellavista"
    },
    {
        "neabord_id": "2578",
        "district_id": "210",
        "code": "03",
        "name": "Morelos."
    },
    {
        "neabord_id": "2579",
        "district_id": "211",
        "code": "01",
        "name": "Picada."
    },
    {
        "neabord_id": "2580",
        "district_id": "212",
        "code": "01",
        "name": "Quina (parte)"
    },
    {
        "neabord_id": "2581",
        "district_id": "212",
        "code": "02",
        "name": "San Juan de Lajas"
    },
    {
        "neabord_id": "2582",
        "district_id": "212",
        "code": "03",
        "name": "Santa Elena."
    },
    {
        "neabord_id": "2583",
        "district_id": "213",
        "code": "01",
        "name": "angeles"
    },
    {
        "neabord_id": "2584",
        "district_id": "213",
        "code": "02",
        "name": "Brisa"
    },
    {
        "neabord_id": "2585",
        "district_id": "213",
        "code": "03",
        "name": "Legua."
    },
    {
        "neabord_id": "2586",
        "district_id": "214",
        "code": "01",
        "name": "angeles"
    },
    {
        "neabord_id": "2587",
        "district_id": "214",
        "code": "02",
        "name": "Bajo Raimundo"
    },
    {
        "neabord_id": "2588",
        "district_id": "214",
        "code": "03",
        "name": "Canto"
    },
    {
        "neabord_id": "2589",
        "district_id": "214",
        "code": "04",
        "name": "Eva"
    },
    {
        "neabord_id": "2590",
        "district_id": "214",
        "code": "05",
        "name": "Luisa"
    },
    {
        "neabord_id": "2591",
        "district_id": "214",
        "code": "06",
        "name": "San Rafael (Rincón Colorado)"
    },
    {
        "neabord_id": "2592",
        "district_id": "214",
        "code": "07",
        "name": "Sahinal."
    },
    {
        "neabord_id": "2593",
        "district_id": "215",
        "code": "01",
        "name": "Alto Castro"
    },
    {
        "neabord_id": "2594",
        "district_id": "215",
        "code": "00",
        "name": "Bajo Trapiche"
    },
    {
        "neabord_id": "2595",
        "district_id": "215",
        "code": "02",
        "name": "Coopeoctava"
    },
    {
        "neabord_id": "2596",
        "district_id": "215",
        "code": "00",
        "name": "Ranera."
    },
    {
        "neabord_id": "2597",
        "district_id": "215",
        "code": "03",
        "name": "Ratoncillal"
    },
    {
        "neabord_id": "2598",
        "district_id": "215",
        "code": "04",
        "name": "Rincón de Alpi­zar"
    },
    {
        "neabord_id": "2599",
        "district_id": "215",
        "code": "05",
        "name": "Rincón de Ulate"
    },
    {
        "neabord_id": "2600",
        "district_id": "215",
        "code": "06",
        "name": "San Miguel."
    },
    {
        "neabord_id": "2601",
        "district_id": "216",
        "code": "01",
        "name": "Alto Palomo."
    },
    {
        "neabord_id": "2602",
        "district_id": "217",
        "code": "01",
        "name": "Castro"
    },
    {
        "neabord_id": "2603",
        "district_id": "217",
        "code": "02",
        "name": "Concha"
    },
    {
        "neabord_id": "2604",
        "district_id": "217",
        "code": "03",
        "name": "Pueblo Seco"
    },
    {
        "neabord_id": "2605",
        "district_id": "217",
        "code": "04",
        "name": "Talolinga"
    },
    {
        "neabord_id": "2606",
        "district_id": "217",
        "code": "05",
        "name": "Trojas."
    },
    {
        "neabord_id": "2607",
        "district_id": "218",
        "code": "01",
        "name": "Bambu"
    },
    {
        "neabord_id": "2608",
        "district_id": "218",
        "code": "02",
        "name": "Sabanilla."
    },
    {
        "neabord_id": "2609",
        "district_id": "219",
        "code": "01",
        "name": "Don Chu"
    },
    {
        "neabord_id": "2610",
        "district_id": "219",
        "code": "02",
        "name": "La Unión"
    },
    {
        "neabord_id": "2611",
        "district_id": "219",
        "code": "03",
        "name": "Las Palmas"
    },
    {
        "neabord_id": "2612",
        "district_id": "219",
        "code": "04",
        "name": "Venecia."
    },
    {
        "neabord_id": "2613",
        "district_id": "219",
        "code": "05",
        "name": "angeles (parte)"
    },
    {
        "neabord_id": "2614",
        "district_id": "219",
        "code": "06",
        "name": "Carmen"
    },
    {
        "neabord_id": "2615",
        "district_id": "219",
        "code": "07",
        "name": "Colonia Puntarenas"
    },
    {
        "neabord_id": "2616",
        "district_id": "219",
        "code": "08",
        "name": "Corteza"
    },
    {
        "neabord_id": "2617",
        "district_id": "219",
        "code": "09",
        "name": "Fósforo"
    },
    {
        "neabord_id": "2618",
        "district_id": "219",
        "code": "10",
        "name": "Jazmines"
    },
    {
        "neabord_id": "2619",
        "district_id": "219",
        "code": "11",
        "name": "Llano Azul"
    },
    {
        "neabord_id": "2620",
        "district_id": "219",
        "code": "12",
        "name": "Maravilla"
    },
    {
        "neabord_id": "2621",
        "district_id": "219",
        "code": "13",
        "name": "Miravalles"
    },
    {
        "neabord_id": "2622",
        "district_id": "219",
        "code": "14",
        "name": "Moreno Cañas"
    },
    {
        "neabord_id": "2623",
        "district_id": "219",
        "code": "15",
        "name": "Recreo"
    },
    {
        "neabord_id": "2624",
        "district_id": "219",
        "code": "16",
        "name": "San Fernando"
    },
    {
        "neabord_id": "2625",
        "district_id": "219",
        "code": "17",
        "name": "San Luis"
    },
    {
        "neabord_id": "2626",
        "district_id": "219",
        "code": "18",
        "name": "San Marti­n"
    },
    {
        "neabord_id": "2627",
        "district_id": "219",
        "code": "19",
        "name": "Santa Cecilia"
    },
    {
        "neabord_id": "2628",
        "district_id": "219",
        "code": "20",
        "name": "Santa Rosa"
    },
    {
        "neabord_id": "2629",
        "district_id": "219",
        "code": "21",
        "name": "Verbena (parte)."
    },
    {
        "neabord_id": "2630",
        "district_id": "220",
        "code": "01",
        "name": "Ceiba"
    },
    {
        "neabord_id": "2631",
        "district_id": "220",
        "code": "02",
        "name": "Golfo"
    },
    {
        "neabord_id": "2632",
        "district_id": "220",
        "code": "03",
        "name": "Porras."
    },
    {
        "neabord_id": "2633",
        "district_id": "220",
        "code": "04",
        "name": "Aguas Claras"
    },
    {
        "neabord_id": "2634",
        "district_id": "220",
        "code": "05",
        "name": "Buenos Aires"
    },
    {
        "neabord_id": "2635",
        "district_id": "220",
        "code": "06",
        "name": "Colonia Blanca"
    },
    {
        "neabord_id": "2636",
        "district_id": "220",
        "code": "07",
        "name": "Colonia Libertad"
    },
    {
        "neabord_id": "2637",
        "district_id": "220",
        "code": "08",
        "name": "Cuatro Bocas"
    },
    {
        "neabord_id": "2638",
        "district_id": "220",
        "code": "09",
        "name": "Chepa (angeles)"
    },
    {
        "neabord_id": "2639",
        "district_id": "220",
        "code": "10",
        "name": "Guayabal"
    },
    {
        "neabord_id": "2640",
        "district_id": "220",
        "code": "11",
        "name": "Guinea"
    },
    {
        "neabord_id": "2641",
        "district_id": "220",
        "code": "12",
        "name": "La Gloria"
    },
    {
        "neabord_id": "2642",
        "district_id": "220",
        "code": "13",
        "name": "Porvenir"
    },
    {
        "neabord_id": "2643",
        "district_id": "220",
        "code": "14",
        "name": "Ri­o Negro"
    },
    {
        "neabord_id": "2644",
        "district_id": "220",
        "code": "15",
        "name": "Tigra"
    },
    {
        "neabord_id": "2645",
        "district_id": "220",
        "code": "16",
        "name": "Torre"
    },
    {
        "neabord_id": "2646",
        "district_id": "220",
        "code": "17",
        "name": "Vuelta San Pedro."
    },
    {
        "neabord_id": "2647",
        "district_id": "221",
        "code": "01",
        "name": "Camelias"
    },
    {
        "neabord_id": "2648",
        "district_id": "221",
        "code": "02",
        "name": "Li­bano (Finanzas)"
    },
    {
        "neabord_id": "2649",
        "district_id": "221",
        "code": "03",
        "name": "Nazareno."
    },
    {
        "neabord_id": "2650",
        "district_id": "221",
        "code": "04",
        "name": "angeles (parte)"
    },
    {
        "neabord_id": "2651",
        "district_id": "221",
        "code": "05",
        "name": "Betania"
    },
    {
        "neabord_id": "2652",
        "district_id": "221",
        "code": "06",
        "name": "Caño Blanco"
    },
    {
        "neabord_id": "2653",
        "district_id": "221",
        "code": "07",
        "name": "Cartagos Norte"
    },
    {
        "neabord_id": "2654",
        "district_id": "221",
        "code": "08",
        "name": "Cartagos Sur"
    },
    {
        "neabord_id": "2655",
        "district_id": "221",
        "code": "09",
        "name": "Copey (Santa Luci­a)"
    },
    {
        "neabord_id": "2656",
        "district_id": "221",
        "code": "10",
        "name": "Delirio"
    },
    {
        "neabord_id": "2657",
        "district_id": "221",
        "code": "11",
        "name": "Fatima"
    },
    {
        "neabord_id": "2658",
        "district_id": "221",
        "code": "12",
        "name": "Jesus Mari­a"
    },
    {
        "neabord_id": "2659",
        "district_id": "221",
        "code": "13",
        "name": "Linda Vista"
    },
    {
        "neabord_id": "2660",
        "district_id": "221",
        "code": "14",
        "name": "Mango"
    },
    {
        "neabord_id": "2661",
        "district_id": "221",
        "code": "15",
        "name": "Papagayo"
    },
    {
        "neabord_id": "2662",
        "district_id": "221",
        "code": "16",
        "name": "Pinol"
    },
    {
        "neabord_id": "2663",
        "district_id": "221",
        "code": "17",
        "name": "Pizotillo"
    },
    {
        "neabord_id": "2664",
        "district_id": "221",
        "code": "18",
        "name": "Popoyuapa"
    },
    {
        "neabord_id": "2665",
        "district_id": "221",
        "code": "19",
        "name": "Progreso"
    },
    {
        "neabord_id": "2666",
        "district_id": "221",
        "code": "20",
        "name": "Pueblo Nuevo"
    },
    {
        "neabord_id": "2667",
        "district_id": "221",
        "code": "21",
        "name": "San Bosco"
    },
    {
        "neabord_id": "2668",
        "district_id": "221",
        "code": "22",
        "name": "San Pedro"
    },
    {
        "neabord_id": "2669",
        "district_id": "221",
        "code": "23",
        "name": "San Ramón"
    },
    {
        "neabord_id": "2670",
        "district_id": "221",
        "code": "24",
        "name": "Santa Clara Norte (parte)"
    },
    {
        "neabord_id": "2671",
        "district_id": "221",
        "code": "25",
        "name": "Unión"
    },
    {
        "neabord_id": "2672",
        "district_id": "221",
        "code": "26",
        "name": "Valle"
    },
    {
        "neabord_id": "2673",
        "district_id": "221",
        "code": "27",
        "name": "Valle Bonito"
    },
    {
        "neabord_id": "2674",
        "district_id": "221",
        "code": "28",
        "name": "Victoria (parte)"
    },
    {
        "neabord_id": "2675",
        "district_id": "221",
        "code": "29",
        "name": "Villahermosa"
    },
    {
        "neabord_id": "2676",
        "district_id": "221",
        "code": "30",
        "name": "Villanueva."
    },
    {
        "neabord_id": "2677",
        "district_id": "222",
        "code": "01",
        "name": "Altamira"
    },
    {
        "neabord_id": "2678",
        "district_id": "222",
        "code": "02",
        "name": "Carlos Vargas."
    },
    {
        "neabord_id": "2679",
        "district_id": "222",
        "code": "03",
        "name": "angeles"
    },
    {
        "neabord_id": "2680",
        "district_id": "222",
        "code": "04",
        "name": "Achiote"
    },
    {
        "neabord_id": "2681",
        "district_id": "222",
        "code": "05",
        "name": "Cuesta Pichardo"
    },
    {
        "neabord_id": "2682",
        "district_id": "222",
        "code": "06",
        "name": "Chorros"
    },
    {
        "neabord_id": "2683",
        "district_id": "222",
        "code": "07",
        "name": "Florecitas"
    },
    {
        "neabord_id": "2684",
        "district_id": "222",
        "code": "08",
        "name": "Flores"
    },
    {
        "neabord_id": "2685",
        "district_id": "222",
        "code": "09",
        "name": "Higuerón"
    },
    {
        "neabord_id": "2686",
        "district_id": "222",
        "code": "10",
        "name": "Jardi­n"
    },
    {
        "neabord_id": "2687",
        "district_id": "222",
        "code": "11",
        "name": "Macho"
    },
    {
        "neabord_id": "2688",
        "district_id": "222",
        "code": "12",
        "name": "Pata de Gallo (San Cristobal) (parte)"
    },
    {
        "neabord_id": "2689",
        "district_id": "222",
        "code": "13",
        "name": "Pueblo Nuevo"
    },
    {
        "neabord_id": "2690",
        "district_id": "222",
        "code": "14",
        "name": "Reserva"
    },
    {
        "neabord_id": "2691",
        "district_id": "222",
        "code": "15",
        "name": "San Miguel"
    },
    {
        "neabord_id": "2692",
        "district_id": "222",
        "code": "16",
        "name": "Santo Domingo"
    },
    {
        "neabord_id": "2693",
        "district_id": "222",
        "code": "17",
        "name": "Zapote."
    },
    {
        "neabord_id": "2694",
        "district_id": "223",
        "code": "01",
        "name": "Camelias"
    },
    {
        "neabord_id": "2695",
        "district_id": "223",
        "code": "02",
        "name": "La Cruz"
    },
    {
        "neabord_id": "2696",
        "district_id": "223",
        "code": "03",
        "name": "Mexico"
    },
    {
        "neabord_id": "2697",
        "district_id": "223",
        "code": "04",
        "name": "Mocorón"
    },
    {
        "neabord_id": "2698",
        "district_id": "223",
        "code": "05",
        "name": "Pavas"
    },
    {
        "neabord_id": "2699",
        "district_id": "223",
        "code": "06",
        "name": "Perla"
    },
    {
        "neabord_id": "2700",
        "district_id": "223",
        "code": "07",
        "name": "Quebradón"
    },
    {
        "neabord_id": "2701",
        "district_id": "223",
        "code": "08",
        "name": "Santa Clara Norte (parte)"
    },
    {
        "neabord_id": "2702",
        "district_id": "223",
        "code": "09",
        "name": "Santa Clara Sur"
    },
    {
        "neabord_id": "2703",
        "district_id": "223",
        "code": "10",
        "name": "Trapiche"
    },
    {
        "neabord_id": "2704",
        "district_id": "223",
        "code": "11",
        "name": "Victoria (parte)."
    },
    {
        "neabord_id": "2705",
        "district_id": "224",
        "code": "01",
        "name": "Birmania"
    },
    {
        "neabord_id": "2706",
        "district_id": "224",
        "code": "02",
        "name": "Brasilia"
    },
    {
        "neabord_id": "2707",
        "district_id": "224",
        "code": "03",
        "name": "Colonia"
    },
    {
        "neabord_id": "2708",
        "district_id": "224",
        "code": "04",
        "name": "Gavilan"
    },
    {
        "neabord_id": "2709",
        "district_id": "224",
        "code": "05",
        "name": "Jabalina"
    },
    {
        "neabord_id": "2710",
        "district_id": "224",
        "code": "06",
        "name": "Progreso"
    },
    {
        "neabord_id": "2711",
        "district_id": "224",
        "code": "07",
        "name": "San Luis."
    },
    {
        "neabord_id": "2712",
        "district_id": "225",
        "code": "01",
        "name": "Cabanga"
    },
    {
        "neabord_id": "2713",
        "district_id": "225",
        "code": "02",
        "name": "Campo Verde"
    },
    {
        "neabord_id": "2714",
        "district_id": "225",
        "code": "03",
        "name": "Carmen"
    },
    {
        "neabord_id": "2715",
        "district_id": "225",
        "code": "04",
        "name": "Cinco Esquinas"
    },
    {
        "neabord_id": "2716",
        "district_id": "225",
        "code": "05",
        "name": "Chimurria Abajo"
    },
    {
        "neabord_id": "2717",
        "district_id": "225",
        "code": "06",
        "name": "Flores"
    },
    {
        "neabord_id": "2718",
        "district_id": "225",
        "code": "07",
        "name": "Jobo"
    },
    {
        "neabord_id": "2719",
        "district_id": "225",
        "code": "08",
        "name": "Montecristo"
    },
    {
        "neabord_id": "2720",
        "district_id": "225",
        "code": "09",
        "name": "Nazareth"
    },
    {
        "neabord_id": "2721",
        "district_id": "225",
        "code": "10",
        "name": "Quebrada Grande"
    },
    {
        "neabord_id": "2722",
        "district_id": "225",
        "code": "11",
        "name": "San Gabriel"
    },
    {
        "neabord_id": "2723",
        "district_id": "225",
        "code": "12",
        "name": "San Jorge"
    },
    {
        "neabord_id": "2724",
        "district_id": "225",
        "code": "13",
        "name": "Socorro"
    },
    {
        "neabord_id": "2725",
        "district_id": "225",
        "code": "14",
        "name": "Virgen"
    },
    {
        "neabord_id": "2726",
        "district_id": "225",
        "code": "15",
        "name": "Yolillal (San Antonio)."
    },
    {
        "neabord_id": "2727",
        "district_id": "226",
        "code": "01",
        "name": "Armenias"
    },
    {
        "neabord_id": "2728",
        "district_id": "226",
        "code": "02",
        "name": "Las Brisas"
    },
    {
        "neabord_id": "2729",
        "district_id": "226",
        "code": "03",
        "name": "Buenavista"
    },
    {
        "neabord_id": "2730",
        "district_id": "226",
        "code": "04",
        "name": "Cuatro Cruces"
    },
    {
        "neabord_id": "2731",
        "district_id": "226",
        "code": "05",
        "name": "Guacalito"
    },
    {
        "neabord_id": "2732",
        "district_id": "226",
        "code": "06",
        "name": "Milpas"
    },
    {
        "neabord_id": "2733",
        "district_id": "226",
        "code": "07",
        "name": "Miramar"
    },
    {
        "neabord_id": "2734",
        "district_id": "226",
        "code": "08",
        "name": "Pata de Gallo (San Cristóbal) (parte)"
    },
    {
        "neabord_id": "2735",
        "district_id": "226",
        "code": "09",
        "name": "Rosario"
    },
    {
        "neabord_id": "2736",
        "district_id": "226",
        "code": "10",
        "name": "Verbena (parte)."
    },
    {
        "neabord_id": "2737",
        "district_id": "227",
        "code": "01",
        "name": "Loma"
    },
    {
        "neabord_id": "2738",
        "district_id": "227",
        "code": "02",
        "name": "Portón."
    },
    {
        "neabord_id": "2739",
        "district_id": "227",
        "code": "03",
        "name": "Arco Iris"
    },
    {
        "neabord_id": "2740",
        "district_id": "227",
        "code": "04",
        "name": "Berli­n"
    },
    {
        "neabord_id": "2741",
        "district_id": "227",
        "code": "05",
        "name": "Brisas"
    },
    {
        "neabord_id": "2742",
        "district_id": "227",
        "code": "06",
        "name": "Buenos Aires"
    },
    {
        "neabord_id": "2743",
        "district_id": "227",
        "code": "07",
        "name": "Cabro"
    },
    {
        "neabord_id": "2744",
        "district_id": "227",
        "code": "08",
        "name": "Cachito"
    },
    {
        "neabord_id": "2745",
        "district_id": "227",
        "code": "09",
        "name": "Caña Castilla"
    },
    {
        "neabord_id": "2746",
        "district_id": "227",
        "code": "10",
        "name": "Combate"
    },
    {
        "neabord_id": "2747",
        "district_id": "227",
        "code": "11",
        "name": "Coquital"
    },
    {
        "neabord_id": "2748",
        "district_id": "227",
        "code": "12",
        "name": "Cristo Rey"
    },
    {
        "neabord_id": "2749",
        "district_id": "227",
        "code": "13",
        "name": "Cuacas"
    },
    {
        "neabord_id": "2750",
        "district_id": "227",
        "code": "14",
        "name": "Cuatro Esquinas"
    },
    {
        "neabord_id": "2751",
        "district_id": "227",
        "code": "15",
        "name": "Delicias"
    },
    {
        "neabord_id": "2752",
        "district_id": "227",
        "code": "16",
        "name": "El Cruce"
    },
    {
        "neabord_id": "2753",
        "district_id": "227",
        "code": "17",
        "name": "Escaleras"
    },
    {
        "neabord_id": "2754",
        "district_id": "227",
        "code": "18",
        "name": "Esperanza"
    },
    {
        "neabord_id": "2755",
        "district_id": "227",
        "code": "19",
        "name": "Estrella"
    },
    {
        "neabord_id": "2756",
        "district_id": "227",
        "code": "20",
        "name": "Hernandez"
    },
    {
        "neabord_id": "2757",
        "district_id": "227",
        "code": "21",
        "name": "Isla Chica"
    },
    {
        "neabord_id": "2758",
        "district_id": "227",
        "code": "22",
        "name": "Las Nubes"
    },
    {
        "neabord_id": "2759",
        "district_id": "227",
        "code": "23",
        "name": "Maramba"
    },
    {
        "neabord_id": "2760",
        "district_id": "227",
        "code": "24",
        "name": "Masaya"
    },
    {
        "neabord_id": "2761",
        "district_id": "227",
        "code": "25",
        "name": "Medio Queso"
    },
    {
        "neabord_id": "2762",
        "district_id": "227",
        "code": "26",
        "name": "Parque"
    },
    {
        "neabord_id": "2763",
        "district_id": "227",
        "code": "27",
        "name": "Playuelitas"
    },
    {
        "neabord_id": "2764",
        "district_id": "227",
        "code": "28",
        "name": "Primavera"
    },
    {
        "neabord_id": "2765",
        "district_id": "227",
        "code": "29",
        "name": "Pueblo Nuevo"
    },
    {
        "neabord_id": "2766",
        "district_id": "227",
        "code": "30",
        "name": "Punta Cortes"
    },
    {
        "neabord_id": "2767",
        "district_id": "227",
        "code": "31",
        "name": "Rampla"
    },
    {
        "neabord_id": "2768",
        "district_id": "227",
        "code": "32",
        "name": "Refugio"
    },
    {
        "neabord_id": "2769",
        "district_id": "227",
        "code": "33",
        "name": "Roble"
    },
    {
        "neabord_id": "2770",
        "district_id": "227",
        "code": "34",
        "name": "San Alejandro"
    },
    {
        "neabord_id": "2771",
        "district_id": "227",
        "code": "35",
        "name": "San Gerardo"
    },
    {
        "neabord_id": "2772",
        "district_id": "227",
        "code": "36",
        "name": "San Jerónimo"
    },
    {
        "neabord_id": "2773",
        "district_id": "227",
        "code": "37",
        "name": "San Pablo"
    },
    {
        "neabord_id": "2774",
        "district_id": "227",
        "code": "38",
        "name": "Santa Elena"
    },
    {
        "neabord_id": "2775",
        "district_id": "227",
        "code": "39",
        "name": "Santa Fe"
    },
    {
        "neabord_id": "2776",
        "district_id": "227",
        "code": "40",
        "name": "Santa Rita"
    },
    {
        "neabord_id": "2777",
        "district_id": "227",
        "code": "41",
        "name": "Santa Rosa"
    },
    {
        "neabord_id": "2778",
        "district_id": "227",
        "code": "42",
        "name": "Solanos"
    },
    {
        "neabord_id": "2779",
        "district_id": "227",
        "code": "43",
        "name": "Trocha"
    },
    {
        "neabord_id": "2780",
        "district_id": "227",
        "code": "44",
        "name": "Virgen."
    },
    {
        "neabord_id": "2781",
        "district_id": "228",
        "code": "01",
        "name": "Aguas Negras"
    },
    {
        "neabord_id": "2782",
        "district_id": "228",
        "code": "02",
        "name": "Islas Cubas"
    },
    {
        "neabord_id": "2783",
        "district_id": "228",
        "code": "03",
        "name": "Nueva Esperanza"
    },
    {
        "neabord_id": "2784",
        "district_id": "228",
        "code": "04",
        "name": "Pilones"
    },
    {
        "neabord_id": "2785",
        "district_id": "228",
        "code": "05",
        "name": "Playuelas"
    },
    {
        "neabord_id": "2786",
        "district_id": "228",
        "code": "06",
        "name": "Porvenir"
    },
    {
        "neabord_id": "2787",
        "district_id": "228",
        "code": "07",
        "name": "San Antonio"
    },
    {
        "neabord_id": "2788",
        "district_id": "228",
        "code": "08",
        "name": "San Emilio"
    },
    {
        "neabord_id": "2789",
        "district_id": "228",
        "code": "09",
        "name": "Veracruz."
    },
    {
        "neabord_id": "2790",
        "district_id": "229",
        "code": "01",
        "name": "Alto los Reyes"
    },
    {
        "neabord_id": "2791",
        "district_id": "229",
        "code": "02",
        "name": "Caño Ciego"
    },
    {
        "neabord_id": "2792",
        "district_id": "229",
        "code": "03",
        "name": "Cóbano"
    },
    {
        "neabord_id": "2793",
        "district_id": "229",
        "code": "04",
        "name": "Corozo"
    },
    {
        "neabord_id": "2794",
        "district_id": "229",
        "code": "05",
        "name": "Corrales"
    },
    {
        "neabord_id": "2795",
        "district_id": "229",
        "code": "06",
        "name": "Coyol"
    },
    {
        "neabord_id": "2796",
        "district_id": "229",
        "code": "07",
        "name": "Dos Aguas"
    },
    {
        "neabord_id": "2797",
        "district_id": "229",
        "code": "08",
        "name": "Gallito"
    },
    {
        "neabord_id": "2798",
        "district_id": "229",
        "code": "09",
        "name": "Gallo Pinto (parte)"
    },
    {
        "neabord_id": "2799",
        "district_id": "229",
        "code": "10",
        "name": "Montealegre"
    },
    {
        "neabord_id": "2800",
        "district_id": "229",
        "code": "11",
        "name": "Nueva Lucha"
    },
    {
        "neabord_id": "2801",
        "district_id": "229",
        "code": "12",
        "name": "Pavón"
    },
    {
        "neabord_id": "2802",
        "district_id": "229",
        "code": "13",
        "name": "Quebrada Grande"
    },
    {
        "neabord_id": "2803",
        "district_id": "229",
        "code": "14",
        "name": "Sabogal"
    },
    {
        "neabord_id": "2804",
        "district_id": "229",
        "code": "15",
        "name": "San Antonio"
    },
    {
        "neabord_id": "2805",
        "district_id": "229",
        "code": "16",
        "name": "San Francisco"
    },
    {
        "neabord_id": "2806",
        "district_id": "229",
        "code": "17",
        "name": "San Isidro"
    },
    {
        "neabord_id": "2807",
        "district_id": "229",
        "code": "18",
        "name": "San Jose del Amparo"
    },
    {
        "neabord_id": "2808",
        "district_id": "229",
        "code": "19",
        "name": "San Macario"
    },
    {
        "neabord_id": "2809",
        "district_id": "229",
        "code": "20",
        "name": "Santa Cecilia"
    },
    {
        "neabord_id": "2810",
        "district_id": "229",
        "code": "21",
        "name": "Trinidad"
    },
    {
        "neabord_id": "2811",
        "district_id": "229",
        "code": "22",
        "name": "Vasconia."
    },
    {
        "neabord_id": "2812",
        "district_id": "230",
        "code": "01",
        "name": "Botijo"
    },
    {
        "neabord_id": "2813",
        "district_id": "230",
        "code": "02",
        "name": "Chimurria"
    },
    {
        "neabord_id": "2814",
        "district_id": "230",
        "code": "03",
        "name": "Colonia Pari­s"
    },
    {
        "neabord_id": "2815",
        "district_id": "230",
        "code": "04",
        "name": "Coquitales"
    },
    {
        "neabord_id": "2816",
        "district_id": "230",
        "code": "05",
        "name": "Gallo Pinto (Parte)"
    },
    {
        "neabord_id": "2817",
        "district_id": "230",
        "code": "06",
        "name": "Lirios"
    },
    {
        "neabord_id": "2818",
        "district_id": "230",
        "code": "07",
        "name": "Lucha"
    },
    {
        "neabord_id": "2819",
        "district_id": "230",
        "code": "08",
        "name": "Montealegre (Parte)"
    },
    {
        "neabord_id": "2820",
        "district_id": "230",
        "code": "09",
        "name": "Pueblo Nuevo"
    },
    {
        "neabord_id": "2821",
        "district_id": "230",
        "code": "10",
        "name": "San Humberto"
    },
    {
        "neabord_id": "2822",
        "district_id": "230",
        "code": "11",
        "name": "San Isidro"
    },
    {
        "neabord_id": "2823",
        "district_id": "230",
        "code": "12",
        "name": "San Jorge"
    },
    {
        "neabord_id": "2824",
        "district_id": "230",
        "code": "13",
        "name": "San Rafael"
    },
    {
        "neabord_id": "2825",
        "district_id": "230",
        "code": "14",
        "name": "Terranova"
    },
    {
        "neabord_id": "2826",
        "district_id": "230",
        "code": "15",
        "name": "Tigra"
    },
    {
        "neabord_id": "2827",
        "district_id": "230",
        "code": "16",
        "name": "Zamba."
    },
    {
        "neabord_id": "2828",
        "district_id": "231",
        "code": "01",
        "name": "Cabaña (parte)"
    },
    {
        "neabord_id": "2829",
        "district_id": "231",
        "code": "02",
        "name": "Costa Ana"
    },
    {
        "neabord_id": "2830",
        "district_id": "231",
        "code": "03",
        "name": "El Cruce"
    },
    {
        "neabord_id": "2831",
        "district_id": "231",
        "code": "04",
        "name": "Guayabito"
    },
    {
        "neabord_id": "2832",
        "district_id": "231",
        "code": "05",
        "name": "Mónico"
    },
    {
        "neabord_id": "2833",
        "district_id": "231",
        "code": "06",
        "name": "Samen Abajo"
    },
    {
        "neabord_id": "2834",
        "district_id": "231",
        "code": "07",
        "name": "San Jose"
    },
    {
        "neabord_id": "2835",
        "district_id": "231",
        "code": "08",
        "name": "Thiales"
    },
    {
        "neabord_id": "2836",
        "district_id": "231",
        "code": "09",
        "name": "Valle del Ri­o."
    },
    {
        "neabord_id": "2837",
        "district_id": "232",
        "code": "01",
        "name": "Altagracia"
    },
    {
        "neabord_id": "2838",
        "district_id": "232",
        "code": "02",
        "name": "Alto Sahi­no"
    },
    {
        "neabord_id": "2839",
        "district_id": "232",
        "code": "03",
        "name": "Bajo Cartagos"
    },
    {
        "neabord_id": "2840",
        "district_id": "232",
        "code": "04",
        "name": "Pato"
    },
    {
        "neabord_id": "2841",
        "district_id": "232",
        "code": "05",
        "name": "Pejibaye"
    },
    {
        "neabord_id": "2842",
        "district_id": "232",
        "code": "06",
        "name": "Pimiento"
    },
    {
        "neabord_id": "2843",
        "district_id": "232",
        "code": "07",
        "name": "Quebradón."
    },
    {
        "neabord_id": "2844",
        "district_id": "233",
        "code": "01",
        "name": "Cabaña (parte)"
    },
    {
        "neabord_id": "2845",
        "district_id": "233",
        "code": "02",
        "name": "Colonia Naranjeña"
    },
    {
        "neabord_id": "2846",
        "district_id": "233",
        "code": "03",
        "name": "El Valle"
    },
    {
        "neabord_id": "2847",
        "district_id": "233",
        "code": "04",
        "name": "Florida"
    },
    {
        "neabord_id": "2848",
        "district_id": "233",
        "code": "05",
        "name": "Las Letras"
    },
    {
        "neabord_id": "2849",
        "district_id": "233",
        "code": "06",
        "name": "La Paz"
    },
    {
        "neabord_id": "2850",
        "district_id": "233",
        "code": "07",
        "name": "La Unión"
    },
    {
        "neabord_id": "2851",
        "district_id": "233",
        "code": "08",
        "name": "Llano Bonito 1"
    },
    {
        "neabord_id": "2852",
        "district_id": "233",
        "code": "09",
        "name": "Llano Bonito 2"
    },
    {
        "neabord_id": "2853",
        "district_id": "233",
        "code": "10",
        "name": "Palmera"
    },
    {
        "neabord_id": "2854",
        "district_id": "233",
        "code": "11",
        "name": "Ri­o Celeste"
    },
    {
        "neabord_id": "2855",
        "district_id": "233",
        "code": "12",
        "name": "Tujankir 1"
    },
    {
        "neabord_id": "2856",
        "district_id": "233",
        "code": "13",
        "name": "Tujankir 2."
    },
    {
        "neabord_id": "2857",
        "district_id": "234",
        "code": "01",
        "name": "angeles"
    },
    {
        "neabord_id": "2858",
        "district_id": "234",
        "code": "02",
        "name": "Asi­s"
    },
    {
        "neabord_id": "2859",
        "district_id": "234",
        "code": "03",
        "name": "Brisas"
    },
    {
        "neabord_id": "2860",
        "district_id": "234",
        "code": "04",
        "name": "Calvario"
    },
    {
        "neabord_id": "2861",
        "district_id": "234",
        "code": "05",
        "name": "Cerrillos"
    },
    {
        "neabord_id": "2862",
        "district_id": "234",
        "code": "06",
        "name": "Corazón de Jesus"
    },
    {
        "neabord_id": "2863",
        "district_id": "234",
        "code": "07",
        "name": "Cortinas"
    },
    {
        "neabord_id": "2864",
        "district_id": "234",
        "code": "08",
        "name": "Cruz de Caravaca (parte)"
    },
    {
        "neabord_id": "2865",
        "district_id": "234",
        "code": "09",
        "name": "Estadio"
    },
    {
        "neabord_id": "2866",
        "district_id": "234",
        "code": "10",
        "name": "Galera"
    },
    {
        "neabord_id": "2867",
        "district_id": "234",
        "code": "11",
        "name": "Hospital (parte)"
    },
    {
        "neabord_id": "2868",
        "district_id": "234",
        "code": "12",
        "name": "Istaru"
    },
    {
        "neabord_id": "2869",
        "district_id": "234",
        "code": "13",
        "name": "Jesus Jimenez (parte)"
    },
    {
        "neabord_id": "2870",
        "district_id": "234",
        "code": "14",
        "name": "Matamoros"
    },
    {
        "neabord_id": "2871",
        "district_id": "234",
        "code": "15",
        "name": "Montelimar"
    },
    {
        "neabord_id": "2872",
        "district_id": "234",
        "code": "16",
        "name": "Puebla"
    },
    {
        "neabord_id": "2873",
        "district_id": "234",
        "code": "17",
        "name": "Soledad"
    },
    {
        "neabord_id": "2874",
        "district_id": "234",
        "code": "18",
        "name": "Telles."
    },
    {
        "neabord_id": "2875",
        "district_id": "235",
        "code": "01",
        "name": "Cinco Esquinas"
    },
    {
        "neabord_id": "2876",
        "district_id": "235",
        "code": "02",
        "name": "Fatima"
    },
    {
        "neabord_id": "2877",
        "district_id": "235",
        "code": "03",
        "name": "Hospital (parte)"
    },
    {
        "neabord_id": "2878",
        "district_id": "235",
        "code": "04",
        "name": "Jesus Jimenez (parte)"
    },
    {
        "neabord_id": "2879",
        "district_id": "235",
        "code": "05",
        "name": "Laborio"
    },
    {
        "neabord_id": "2880",
        "district_id": "235",
        "code": "06",
        "name": "Molino"
    },
    {
        "neabord_id": "2881",
        "district_id": "235",
        "code": "07",
        "name": "Murillo"
    },
    {
        "neabord_id": "2882",
        "district_id": "235",
        "code": "08",
        "name": "Palmas"
    },
    {
        "neabord_id": "2883",
        "district_id": "235",
        "code": "09",
        "name": "San Cayetano."
    },
    {
        "neabord_id": "2884",
        "district_id": "236",
        "code": "01",
        "name": "Alpes"
    },
    {
        "neabord_id": "2885",
        "district_id": "236",
        "code": "02",
        "name": "Asilo"
    },
    {
        "neabord_id": "2886",
        "district_id": "236",
        "code": "03",
        "name": "Cruz de Caravaca (parte)"
    },
    {
        "neabord_id": "2887",
        "district_id": "236",
        "code": "04",
        "name": "Diques"
    },
    {
        "neabord_id": "2888",
        "district_id": "236",
        "code": "05",
        "name": "Fontana"
    },
    {
        "neabord_id": "2889",
        "district_id": "236",
        "code": "06",
        "name": "Jora"
    },
    {
        "neabord_id": "2890",
        "district_id": "236",
        "code": "07",
        "name": "López"
    },
    {
        "neabord_id": "2891",
        "district_id": "236",
        "code": "08",
        "name": "San Blas"
    },
    {
        "neabord_id": "2892",
        "district_id": "236",
        "code": "09",
        "name": "Santa Eduvigis"
    },
    {
        "neabord_id": "2893",
        "district_id": "236",
        "code": "10",
        "name": "Santa Fe"
    },
    {
        "neabord_id": "2894",
        "district_id": "236",
        "code": "11",
        "name": "Solano"
    },
    {
        "neabord_id": "2895",
        "district_id": "236",
        "code": "12",
        "name": "Turbina."
    },
    {
        "neabord_id": "2896",
        "district_id": "237",
        "code": "01",
        "name": "Alto de Ochomogo"
    },
    {
        "neabord_id": "2897",
        "district_id": "237",
        "code": "02",
        "name": "Angelina"
    },
    {
        "neabord_id": "2898",
        "district_id": "237",
        "code": "00",
        "name": "Caracol"
    },
    {
        "neabord_id": "2899",
        "district_id": "237",
        "code": "03",
        "name": "Banderilla"
    },
    {
        "neabord_id": "2900",
        "district_id": "237",
        "code": "00",
        "name": "Cooperrosales"
    },
    {
        "neabord_id": "2901",
        "district_id": "237",
        "code": "04",
        "name": "Cruz"
    },
    {
        "neabord_id": "2902",
        "district_id": "237",
        "code": "00",
        "name": "Kerkua"
    },
    {
        "neabord_id": "2903",
        "district_id": "237",
        "code": "05",
        "name": "Espinal"
    },
    {
        "neabord_id": "2904",
        "district_id": "237",
        "code": "00",
        "name": "Molina"
    },
    {
        "neabord_id": "2905",
        "district_id": "237",
        "code": "06",
        "name": "Johnson"
    },
    {
        "neabord_id": "2906",
        "district_id": "237",
        "code": "00",
        "name": "Poroses."
    },
    {
        "neabord_id": "2907",
        "district_id": "237",
        "code": "07",
        "name": "Lima"
    },
    {
        "neabord_id": "2908",
        "district_id": "237",
        "code": "08",
        "name": "Loyola"
    },
    {
        "neabord_id": "2909",
        "district_id": "237",
        "code": "09",
        "name": "Nazareth"
    },
    {
        "neabord_id": "2910",
        "district_id": "237",
        "code": "10",
        "name": "Ochomogo"
    },
    {
        "neabord_id": "2911",
        "district_id": "237",
        "code": "11",
        "name": "Orontes"
    },
    {
        "neabord_id": "2912",
        "district_id": "237",
        "code": "12",
        "name": "Pedregal"
    },
    {
        "neabord_id": "2913",
        "district_id": "237",
        "code": "13",
        "name": "Quircot"
    },
    {
        "neabord_id": "2914",
        "district_id": "237",
        "code": "14",
        "name": "Ronda"
    },
    {
        "neabord_id": "2915",
        "district_id": "237",
        "code": "15",
        "name": "Rosas"
    },
    {
        "neabord_id": "2916",
        "district_id": "237",
        "code": "16",
        "name": "San Nicolas"
    },
    {
        "neabord_id": "2917",
        "district_id": "237",
        "code": "17",
        "name": "Violi­n."
    },
    {
        "neabord_id": "2918",
        "district_id": "238",
        "code": "01",
        "name": "Cocori­"
    },
    {
        "neabord_id": "2919",
        "district_id": "238",
        "code": "02",
        "name": "Coronado"
    },
    {
        "neabord_id": "2920",
        "district_id": "238",
        "code": "03",
        "name": "Guayabal (parte)"
    },
    {
        "neabord_id": "2921",
        "district_id": "238",
        "code": "04",
        "name": "Hervidero"
    },
    {
        "neabord_id": "2922",
        "district_id": "238",
        "code": "05",
        "name": "López"
    },
    {
        "neabord_id": "2923",
        "district_id": "238",
        "code": "06",
        "name": "Lourdes"
    },
    {
        "neabord_id": "2924",
        "district_id": "238",
        "code": "07",
        "name": "Padua"
    },
    {
        "neabord_id": "2925",
        "district_id": "238",
        "code": "08",
        "name": "Pitahaya."
    },
    {
        "neabord_id": "2926",
        "district_id": "238",
        "code": "09",
        "name": "Barro Morado"
    },
    {
        "neabord_id": "2927",
        "district_id": "238",
        "code": "10",
        "name": "Cenicero"
    },
    {
        "neabord_id": "2928",
        "district_id": "238",
        "code": "11",
        "name": "Muñeco"
    },
    {
        "neabord_id": "2929",
        "district_id": "238",
        "code": "12",
        "name": "Navarrito."
    },
    {
        "neabord_id": "2930",
        "district_id": "239",
        "code": "01",
        "name": "Americas"
    },
    {
        "neabord_id": "2931",
        "district_id": "239",
        "code": "02",
        "name": "Higuerón"
    },
    {
        "neabord_id": "2932",
        "district_id": "239",
        "code": "03",
        "name": "Joya"
    },
    {
        "neabord_id": "2933",
        "district_id": "239",
        "code": "04",
        "name": "Mari­as"
    },
    {
        "neabord_id": "2934",
        "district_id": "239",
        "code": "05",
        "name": "Las Palmas."
    },
    {
        "neabord_id": "2935",
        "district_id": "240",
        "code": "01",
        "name": "Alumbre"
    },
    {
        "neabord_id": "2936",
        "district_id": "240",
        "code": "02",
        "name": "Bajo Amador"
    },
    {
        "neabord_id": "2937",
        "district_id": "240",
        "code": "03",
        "name": "Calle Valverdes"
    },
    {
        "neabord_id": "2938",
        "district_id": "240",
        "code": "04",
        "name": "Guaria"
    },
    {
        "neabord_id": "2939",
        "district_id": "240",
        "code": "05",
        "name": "Hortensia"
    },
    {
        "neabord_id": "2940",
        "district_id": "240",
        "code": "06",
        "name": "Loma Larga"
    },
    {
        "neabord_id": "2941",
        "district_id": "240",
        "code": "07",
        "name": "Llano angeles"
    },
    {
        "neabord_id": "2942",
        "district_id": "240",
        "code": "08",
        "name": "Palangana"
    },
    {
        "neabord_id": "2943",
        "district_id": "240",
        "code": "09",
        "name": "Rincón de Abarca"
    },
    {
        "neabord_id": "2944",
        "district_id": "240",
        "code": "10",
        "name": "Ri­o Conejo"
    },
    {
        "neabord_id": "2945",
        "district_id": "240",
        "code": "11",
        "name": "Salitrillo"
    },
    {
        "neabord_id": "2946",
        "district_id": "240",
        "code": "12",
        "name": "San Antonio"
    },
    {
        "neabord_id": "2947",
        "district_id": "240",
        "code": "13",
        "name": "San Joaqui­n"
    },
    {
        "neabord_id": "2948",
        "district_id": "240",
        "code": "14",
        "name": "San Juan Norte"
    },
    {
        "neabord_id": "2949",
        "district_id": "240",
        "code": "15",
        "name": "San Juan Sur"
    },
    {
        "neabord_id": "2950",
        "district_id": "240",
        "code": "16",
        "name": "Santa Elena (parte)"
    },
    {
        "neabord_id": "2951",
        "district_id": "240",
        "code": "17",
        "name": "Santa Elena Arriba."
    },
    {
        "neabord_id": "2952",
        "district_id": "241",
        "code": "01",
        "name": "Cuesta de Piedra"
    },
    {
        "neabord_id": "2953",
        "district_id": "241",
        "code": "02",
        "name": "Misión Norte"
    },
    {
        "neabord_id": "2954",
        "district_id": "241",
        "code": "03",
        "name": "Misión Sur"
    },
    {
        "neabord_id": "2955",
        "district_id": "241",
        "code": "04",
        "name": "Ortiga"
    },
    {
        "neabord_id": "2956",
        "district_id": "241",
        "code": "05",
        "name": "Rodeo"
    },
    {
        "neabord_id": "2957",
        "district_id": "241",
        "code": "06",
        "name": "Sabanilla"
    },
    {
        "neabord_id": "2958",
        "district_id": "241",
        "code": "07",
        "name": "Sabanillas"
    },
    {
        "neabord_id": "2959",
        "district_id": "241",
        "code": "08",
        "name": "Santi­sima Trinidad."
    },
    {
        "neabord_id": "2960",
        "district_id": "242",
        "code": "01",
        "name": "Caballo Blanco (parte)"
    },
    {
        "neabord_id": "2961",
        "district_id": "242",
        "code": "02",
        "name": "San Jose."
    },
    {
        "neabord_id": "2962",
        "district_id": "242",
        "code": "03",
        "name": "Cóncavas"
    },
    {
        "neabord_id": "2963",
        "district_id": "242",
        "code": "04",
        "name": "Navarro"
    },
    {
        "neabord_id": "2964",
        "district_id": "242",
        "code": "05",
        "name": "Perlas"
    },
    {
        "neabord_id": "2965",
        "district_id": "242",
        "code": "06",
        "name": "Ri­o Claro."
    },
    {
        "neabord_id": "2966",
        "district_id": "243",
        "code": "01",
        "name": "Azahar."
    },
    {
        "neabord_id": "2967",
        "district_id": "243",
        "code": "02",
        "name": "Avance"
    },
    {
        "neabord_id": "2968",
        "district_id": "243",
        "code": "03",
        "name": "Barquero"
    },
    {
        "neabord_id": "2969",
        "district_id": "243",
        "code": "04",
        "name": "Cañada"
    },
    {
        "neabord_id": "2970",
        "district_id": "243",
        "code": "05",
        "name": "Laguna"
    },
    {
        "neabord_id": "2971",
        "district_id": "243",
        "code": "06",
        "name": "Penjamo"
    },
    {
        "neabord_id": "2972",
        "district_id": "243",
        "code": "07",
        "name": "Rodeo."
    },
    {
        "neabord_id": "2973",
        "district_id": "244",
        "code": "01",
        "name": "Alto Quebradilla"
    },
    {
        "neabord_id": "2974",
        "district_id": "244",
        "code": "02",
        "name": "Azahar"
    },
    {
        "neabord_id": "2975",
        "district_id": "244",
        "code": "03",
        "name": "Bermejo"
    },
    {
        "neabord_id": "2976",
        "district_id": "244",
        "code": "04",
        "name": "Cañada"
    },
    {
        "neabord_id": "2977",
        "district_id": "244",
        "code": "05",
        "name": "Copalchi­"
    },
    {
        "neabord_id": "2978",
        "district_id": "244",
        "code": "06",
        "name": "Coris"
    },
    {
        "neabord_id": "2979",
        "district_id": "244",
        "code": "07",
        "name": "Garita (parte)"
    },
    {
        "neabord_id": "2980",
        "district_id": "244",
        "code": "08",
        "name": "Rueda"
    },
    {
        "neabord_id": "2981",
        "district_id": "244",
        "code": "09",
        "name": "Valle Verde."
    },
    {
        "neabord_id": "2982",
        "district_id": "245",
        "code": "01",
        "name": "Barro Hondo"
    },
    {
        "neabord_id": "2983",
        "district_id": "245",
        "code": "02",
        "name": "Cruz Roja"
    },
    {
        "neabord_id": "2984",
        "district_id": "245",
        "code": "03",
        "name": "Cucaracho"
    },
    {
        "neabord_id": "2985",
        "district_id": "245",
        "code": "04",
        "name": "Chiverre"
    },
    {
        "neabord_id": "2986",
        "district_id": "245",
        "code": "05",
        "name": "Estación"
    },
    {
        "neabord_id": "2987",
        "district_id": "245",
        "code": "06",
        "name": "Joya"
    },
    {
        "neabord_id": "2988",
        "district_id": "245",
        "code": "07",
        "name": "Pandora"
    },
    {
        "neabord_id": "2989",
        "district_id": "245",
        "code": "08",
        "name": "Piedra Grande"
    },
    {
        "neabord_id": "2990",
        "district_id": "245",
        "code": "09",
        "name": "Solares"
    },
    {
        "neabord_id": "2991",
        "district_id": "245",
        "code": "10",
        "name": "Soledad"
    },
    {
        "neabord_id": "2992",
        "district_id": "245",
        "code": "11",
        "name": "Veintiocho de Diciembre."
    },
    {
        "neabord_id": "2993",
        "district_id": "245",
        "code": "12",
        "name": "Alto Birrisito"
    },
    {
        "neabord_id": "2994",
        "district_id": "245",
        "code": "13",
        "name": "Birrisito"
    },
    {
        "neabord_id": "2995",
        "district_id": "245",
        "code": "14",
        "name": "Chiral"
    },
    {
        "neabord_id": "2996",
        "district_id": "245",
        "code": "15",
        "name": "Luisiana"
    },
    {
        "neabord_id": "2997",
        "district_id": "245",
        "code": "16",
        "name": "Sanchiri­"
    },
    {
        "neabord_id": "2998",
        "district_id": "245",
        "code": "17",
        "name": "Ujarras"
    },
    {
        "neabord_id": "2999",
        "district_id": "245",
        "code": "18",
        "name": "Villa Isabel"
    },
    {
        "neabord_id": "3000",
        "district_id": "245",
        "code": "19",
        "name": "Rincón."
    },
    {
        "neabord_id": "3001",
        "district_id": "246",
        "code": "01",
        "name": "Acevedo"
    },
    {
        "neabord_id": "3002",
        "district_id": "246",
        "code": "02",
        "name": "Ajenjal"
    },
    {
        "neabord_id": "3003",
        "district_id": "246",
        "code": "03",
        "name": "Arrabara"
    },
    {
        "neabord_id": "3004",
        "district_id": "246",
        "code": "04",
        "name": "Birri­s (este)"
    },
    {
        "neabord_id": "3005",
        "district_id": "246",
        "code": "05",
        "name": "Cuscares"
    },
    {
        "neabord_id": "3006",
        "district_id": "246",
        "code": "06",
        "name": "Flor"
    },
    {
        "neabord_id": "3007",
        "district_id": "246",
        "code": "07",
        "name": "Lapuente"
    },
    {
        "neabord_id": "3008",
        "district_id": "246",
        "code": "08",
        "name": "Mesas"
    },
    {
        "neabord_id": "3009",
        "district_id": "246",
        "code": "09",
        "name": "Mesitas"
    },
    {
        "neabord_id": "3010",
        "district_id": "246",
        "code": "10",
        "name": "Nueva Ujarras"
    },
    {
        "neabord_id": "3011",
        "district_id": "246",
        "code": "11",
        "name": "Pedregal"
    },
    {
        "neabord_id": "3012",
        "district_id": "246",
        "code": "12",
        "name": "Piedra Azul"
    },
    {
        "neabord_id": "3013",
        "district_id": "246",
        "code": "13",
        "name": "Puente Fajardo"
    },
    {
        "neabord_id": "3014",
        "district_id": "246",
        "code": "14",
        "name": "Ri­o Regado"
    },
    {
        "neabord_id": "3015",
        "district_id": "246",
        "code": "15",
        "name": "Talolinga"
    },
    {
        "neabord_id": "3016",
        "district_id": "246",
        "code": "16",
        "name": "Yas."
    },
    {
        "neabord_id": "3017",
        "district_id": "247",
        "code": "01",
        "name": "Alegri­a"
    },
    {
        "neabord_id": "3018",
        "district_id": "247",
        "code": "02",
        "name": "Alto Araya"
    },
    {
        "neabord_id": "3019",
        "district_id": "247",
        "code": "03",
        "name": "Calle Jucó"
    },
    {
        "neabord_id": "3020",
        "district_id": "247",
        "code": "04",
        "name": "Hotel"
    },
    {
        "neabord_id": "3021",
        "district_id": "247",
        "code": "05",
        "name": "Nubes"
    },
    {
        "neabord_id": "3022",
        "district_id": "247",
        "code": "06",
        "name": "Palomas"
    },
    {
        "neabord_id": "3023",
        "district_id": "247",
        "code": "07",
        "name": "Palomo"
    },
    {
        "neabord_id": "3024",
        "district_id": "247",
        "code": "08",
        "name": "Patillos"
    },
    {
        "neabord_id": "3025",
        "district_id": "247",
        "code": "09",
        "name": "Puente Negro"
    },
    {
        "neabord_id": "3026",
        "district_id": "247",
        "code": "10",
        "name": "Purisil"
    },
    {
        "neabord_id": "3027",
        "district_id": "247",
        "code": "11",
        "name": "Queveri­"
    },
    {
        "neabord_id": "3028",
        "district_id": "247",
        "code": "12",
        "name": "Ri­o Macho"
    },
    {
        "neabord_id": "3029",
        "district_id": "247",
        "code": "13",
        "name": "San Rafael"
    },
    {
        "neabord_id": "3030",
        "district_id": "247",
        "code": "14",
        "name": "Sitio"
    },
    {
        "neabord_id": "3031",
        "district_id": "247",
        "code": "15",
        "name": "Tapanti­"
    },
    {
        "neabord_id": "3032",
        "district_id": "247",
        "code": "16",
        "name": "Troya"
    },
    {
        "neabord_id": "3033",
        "district_id": "247",
        "code": "17",
        "name": "Villa Mills."
    },
    {
        "neabord_id": "3034",
        "district_id": "248",
        "code": "01",
        "name": "Peñas Blancas"
    },
    {
        "neabord_id": "3035",
        "district_id": "248",
        "code": "02",
        "name": "Pueblo Nuevo."
    },
    {
        "neabord_id": "3036",
        "district_id": "248",
        "code": "03",
        "name": "Bajos de Dorotea"
    },
    {
        "neabord_id": "3037",
        "district_id": "248",
        "code": "04",
        "name": "Bajos de Urasca"
    },
    {
        "neabord_id": "3038",
        "district_id": "248",
        "code": "05",
        "name": "Guabata"
    },
    {
        "neabord_id": "3039",
        "district_id": "248",
        "code": "06",
        "name": "Guatusito"
    },
    {
        "neabord_id": "3040",
        "district_id": "248",
        "code": "07",
        "name": "Hamaca (parte)"
    },
    {
        "neabord_id": "3041",
        "district_id": "248",
        "code": "08",
        "name": "Joyas"
    },
    {
        "neabord_id": "3042",
        "district_id": "248",
        "code": "09",
        "name": "Loaiza"
    },
    {
        "neabord_id": "3043",
        "district_id": "248",
        "code": "10",
        "name": "San Jerónimo"
    },
    {
        "neabord_id": "3044",
        "district_id": "248",
        "code": "11",
        "name": "Urasca"
    },
    {
        "neabord_id": "3045",
        "district_id": "248",
        "code": "12",
        "name": "Volio."
    },
    {
        "neabord_id": "3046",
        "district_id": "249",
        "code": "01",
        "name": "Ayala"
    },
    {
        "neabord_id": "3047",
        "district_id": "249",
        "code": "02",
        "name": "Paez (parte)"
    },
    {
        "neabord_id": "3048",
        "district_id": "249",
        "code": "03",
        "name": "Salvador."
    },
    {
        "neabord_id": "3049",
        "district_id": "250",
        "code": "01",
        "name": "Antigua"
    },
    {
        "neabord_id": "3050",
        "district_id": "250",
        "code": "02",
        "name": "Villas."
    },
    {
        "neabord_id": "3051",
        "district_id": "251",
        "code": "01",
        "name": "Eulalia"
    },
    {
        "neabord_id": "3052",
        "district_id": "251",
        "code": "02",
        "name": "Florencio del Castillo"
    },
    {
        "neabord_id": "3053",
        "district_id": "251",
        "code": "03",
        "name": "Jirales"
    },
    {
        "neabord_id": "3054",
        "district_id": "251",
        "code": "04",
        "name": "Mariana"
    },
    {
        "neabord_id": "3055",
        "district_id": "251",
        "code": "05",
        "name": "Tacora."
    },
    {
        "neabord_id": "3056",
        "district_id": "251",
        "code": "06",
        "name": "Rincón Mesen (parte)"
    },
    {
        "neabord_id": "3057",
        "district_id": "251",
        "code": "07",
        "name": "Santiago del Monte."
    },
    {
        "neabord_id": "3058",
        "district_id": "252",
        "code": "01",
        "name": "Araucarias (parte)"
    },
    {
        "neabord_id": "3059",
        "district_id": "252",
        "code": "02",
        "name": "Danza del Sol"
    },
    {
        "neabord_id": "3060",
        "district_id": "252",
        "code": "03",
        "name": "Herran"
    },
    {
        "neabord_id": "3061",
        "district_id": "252",
        "code": "04",
        "name": "Loma Verde"
    },
    {
        "neabord_id": "3062",
        "district_id": "252",
        "code": "05",
        "name": "Unión"
    },
    {
        "neabord_id": "3063",
        "district_id": "252",
        "code": "06",
        "name": "Villas de Ayarco."
    },
    {
        "neabord_id": "3064",
        "district_id": "253",
        "code": "01",
        "name": "Carpintera"
    },
    {
        "neabord_id": "3065",
        "district_id": "253",
        "code": "02",
        "name": "San Miguel"
    },
    {
        "neabord_id": "3066",
        "district_id": "253",
        "code": "03",
        "name": "San Vicente"
    },
    {
        "neabord_id": "3067",
        "district_id": "253",
        "code": "04",
        "name": "Pilarica."
    },
    {
        "neabord_id": "3068",
        "district_id": "253",
        "code": "05",
        "name": "Quebrada del Fierro"
    },
    {
        "neabord_id": "3069",
        "district_id": "253",
        "code": "06",
        "name": "Fierro"
    },
    {
        "neabord_id": "3070",
        "district_id": "253",
        "code": "07",
        "name": "Yerbabuena."
    },
    {
        "neabord_id": "3071",
        "district_id": "254",
        "code": "01",
        "name": "Cima"
    },
    {
        "neabord_id": "3072",
        "district_id": "254",
        "code": "02",
        "name": "Cuadrante"
    },
    {
        "neabord_id": "3073",
        "district_id": "254",
        "code": "03",
        "name": "Lirios"
    },
    {
        "neabord_id": "3074",
        "district_id": "254",
        "code": "04",
        "name": "Llanos de Concepción"
    },
    {
        "neabord_id": "3075",
        "district_id": "254",
        "code": "05",
        "name": "Naranjal (parte)"
    },
    {
        "neabord_id": "3076",
        "district_id": "254",
        "code": "06",
        "name": "Poró"
    },
    {
        "neabord_id": "3077",
        "district_id": "254",
        "code": "07",
        "name": "Salitrillo"
    },
    {
        "neabord_id": "3078",
        "district_id": "254",
        "code": "08",
        "name": "San Francisco"
    },
    {
        "neabord_id": "3079",
        "district_id": "254",
        "code": "09",
        "name": "San Josecito (parte)."
    },
    {
        "neabord_id": "3080",
        "district_id": "255",
        "code": "01",
        "name": "Alto del Carmen"
    },
    {
        "neabord_id": "3081",
        "district_id": "255",
        "code": "02",
        "name": "Tirra."
    },
    {
        "neabord_id": "3082",
        "district_id": "256",
        "code": "01",
        "name": "Bellomonte"
    },
    {
        "neabord_id": "3083",
        "district_id": "256",
        "code": "02",
        "name": "Cerrillo"
    },
    {
        "neabord_id": "3084",
        "district_id": "256",
        "code": "03",
        "name": "Cumbres"
    },
    {
        "neabord_id": "3085",
        "district_id": "256",
        "code": "04",
        "name": "Holandes"
    },
    {
        "neabord_id": "3086",
        "district_id": "256",
        "code": "05",
        "name": "Mansiones (parte)"
    },
    {
        "neabord_id": "3087",
        "district_id": "256",
        "code": "06",
        "name": "Montaña Rusa (parte)"
    },
    {
        "neabord_id": "3088",
        "district_id": "256",
        "code": "07",
        "name": "Naranjal (parte)"
    },
    {
        "neabord_id": "3089",
        "district_id": "256",
        "code": "08",
        "name": "San Josecito (parte)."
    },
    {
        "neabord_id": "3090",
        "district_id": "257",
        "code": "01",
        "name": "Lindavista (Loma Gobierno)."
    },
    {
        "neabord_id": "3091",
        "district_id": "257",
        "code": "02",
        "name": "Quebradas"
    },
    {
        "neabord_id": "3092",
        "district_id": "257",
        "code": "03",
        "name": "Rincón Mesen (parte)."
    },
    {
        "neabord_id": "3093",
        "district_id": "258",
        "code": "01",
        "name": "Alpes"
    },
    {
        "neabord_id": "3094",
        "district_id": "258",
        "code": "02",
        "name": "Buenos Aires"
    },
    {
        "neabord_id": "3095",
        "district_id": "258",
        "code": "03",
        "name": "Maravilla"
    },
    {
        "neabord_id": "3096",
        "district_id": "258",
        "code": "04",
        "name": "Naranjito"
    },
    {
        "neabord_id": "3097",
        "district_id": "258",
        "code": "05",
        "name": "Naranjo"
    },
    {
        "neabord_id": "3098",
        "district_id": "258",
        "code": "06",
        "name": "San Marti­n."
    },
    {
        "neabord_id": "3099",
        "district_id": "258",
        "code": "07",
        "name": "Duran"
    },
    {
        "neabord_id": "3100",
        "district_id": "258",
        "code": "08",
        "name": "Gloria"
    },
    {
        "neabord_id": "3101",
        "district_id": "258",
        "code": "09",
        "name": "Quebrada Honda"
    },
    {
        "neabord_id": "3102",
        "district_id": "258",
        "code": "10",
        "name": "Santa Elena"
    },
    {
        "neabord_id": "3103",
        "district_id": "258",
        "code": "11",
        "name": "Santa Marta"
    },
    {
        "neabord_id": "3104",
        "district_id": "258",
        "code": "12",
        "name": "Victoria (Alto Victoria)."
    },
    {
        "neabord_id": "3105",
        "district_id": "259",
        "code": "01",
        "name": "Alto Campos"
    },
    {
        "neabord_id": "3106",
        "district_id": "259",
        "code": "02",
        "name": "Bajo Congo"
    },
    {
        "neabord_id": "3107",
        "district_id": "259",
        "code": "03",
        "name": "Congo"
    },
    {
        "neabord_id": "3108",
        "district_id": "259",
        "code": "04",
        "name": "Duan"
    },
    {
        "neabord_id": "3109",
        "district_id": "259",
        "code": "05",
        "name": "Esperanza"
    },
    {
        "neabord_id": "3110",
        "district_id": "259",
        "code": "06",
        "name": "Hamaca (parte)"
    },
    {
        "neabord_id": "3111",
        "district_id": "259",
        "code": "07",
        "name": "Sabanilla"
    },
    {
        "neabord_id": "3112",
        "district_id": "259",
        "code": "08",
        "name": "San Antonio del Monte"
    },
    {
        "neabord_id": "3113",
        "district_id": "259",
        "code": "09",
        "name": "Volconda"
    },
    {
        "neabord_id": "3114",
        "district_id": "259",
        "code": "10",
        "name": "Vueltas."
    },
    {
        "neabord_id": "3115",
        "district_id": "260",
        "code": "01",
        "name": "Alto Humo"
    },
    {
        "neabord_id": "3116",
        "district_id": "260",
        "code": "02",
        "name": "Cacao"
    },
    {
        "neabord_id": "3117",
        "district_id": "260",
        "code": "03",
        "name": "Cantarrana"
    },
    {
        "neabord_id": "3118",
        "district_id": "260",
        "code": "04",
        "name": "Casa de Teja"
    },
    {
        "neabord_id": "3119",
        "district_id": "260",
        "code": "05",
        "name": "Ceiba"
    },
    {
        "neabord_id": "3120",
        "district_id": "260",
        "code": "06",
        "name": "Chucuyo"
    },
    {
        "neabord_id": "3121",
        "district_id": "260",
        "code": "07",
        "name": "Esperanza"
    },
    {
        "neabord_id": "3122",
        "district_id": "260",
        "code": "08",
        "name": "Gato"
    },
    {
        "neabord_id": "3123",
        "district_id": "260",
        "code": "09",
        "name": "Humo"
    },
    {
        "neabord_id": "3124",
        "district_id": "260",
        "code": "10",
        "name": "Joyas"
    },
    {
        "neabord_id": "3125",
        "district_id": "260",
        "code": "11",
        "name": "Juray"
    },
    {
        "neabord_id": "3126",
        "district_id": "260",
        "code": "12",
        "name": "Omega"
    },
    {
        "neabord_id": "3127",
        "district_id": "260",
        "code": "13",
        "name": "Oriente"
    },
    {
        "neabord_id": "3128",
        "district_id": "260",
        "code": "14",
        "name": "San Gerardo"
    },
    {
        "neabord_id": "3129",
        "district_id": "260",
        "code": "15",
        "name": "Selva"
    },
    {
        "neabord_id": "3130",
        "district_id": "260",
        "code": "16",
        "name": "Taus"
    },
    {
        "neabord_id": "3131",
        "district_id": "260",
        "code": "17",
        "name": "Tausito"
    },
    {
        "neabord_id": "3132",
        "district_id": "260",
        "code": "18",
        "name": "Yolanda"
    },
    {
        "neabord_id": "3133",
        "district_id": "260",
        "code": "19",
        "name": "Zapote."
    },
    {
        "neabord_id": "3134",
        "district_id": "261",
        "code": "01",
        "name": "Americas"
    },
    {
        "neabord_id": "3135",
        "district_id": "261",
        "code": "02",
        "name": "angeles"
    },
    {
        "neabord_id": "3136",
        "district_id": "261",
        "code": "03",
        "name": "Cabiria"
    },
    {
        "neabord_id": "3137",
        "district_id": "261",
        "code": "04",
        "name": "Campabadal"
    },
    {
        "neabord_id": "3138",
        "district_id": "261",
        "code": "05",
        "name": "Castro Salazar"
    },
    {
        "neabord_id": "3139",
        "district_id": "261",
        "code": "06",
        "name": "Cementerio"
    },
    {
        "neabord_id": "3140",
        "district_id": "261",
        "code": "07",
        "name": "Clorito Picado"
    },
    {
        "neabord_id": "3141",
        "district_id": "261",
        "code": "08",
        "name": "Dominica"
    },
    {
        "neabord_id": "3142",
        "district_id": "261",
        "code": "09",
        "name": "El Silencio"
    },
    {
        "neabord_id": "3143",
        "district_id": "261",
        "code": "10",
        "name": "Guaria"
    },
    {
        "neabord_id": "3144",
        "district_id": "261",
        "code": "11",
        "name": "Haciendita"
    },
    {
        "neabord_id": "3145",
        "district_id": "261",
        "code": "12",
        "name": "Margot"
    },
    {
        "neabord_id": "3146",
        "district_id": "261",
        "code": "13",
        "name": "Nochebuena"
    },
    {
        "neabord_id": "3147",
        "district_id": "261",
        "code": "14",
        "name": "Numa"
    },
    {
        "neabord_id": "3148",
        "district_id": "261",
        "code": "15",
        "name": "Pastor"
    },
    {
        "neabord_id": "3149",
        "district_id": "261",
        "code": "16",
        "name": "Poró"
    },
    {
        "neabord_id": "3150",
        "district_id": "261",
        "code": "17",
        "name": "Pueblo Nuevo"
    },
    {
        "neabord_id": "3151",
        "district_id": "261",
        "code": "18",
        "name": "Repasto"
    },
    {
        "neabord_id": "3152",
        "district_id": "261",
        "code": "19",
        "name": "San Cayetano"
    },
    {
        "neabord_id": "3153",
        "district_id": "261",
        "code": "20",
        "name": "San Rafael"
    },
    {
        "neabord_id": "3154",
        "district_id": "261",
        "code": "21",
        "name": "Sictaya."
    },
    {
        "neabord_id": "3155",
        "district_id": "261",
        "code": "22",
        "name": "Bajo Barrientos"
    },
    {
        "neabord_id": "3156",
        "district_id": "261",
        "code": "23",
        "name": "Cañaveral"
    },
    {
        "neabord_id": "3157",
        "district_id": "261",
        "code": "24",
        "name": "Colorado"
    },
    {
        "neabord_id": "3158",
        "district_id": "261",
        "code": "25",
        "name": "Chiz"
    },
    {
        "neabord_id": "3159",
        "district_id": "261",
        "code": "26",
        "name": "Esmeralda"
    },
    {
        "neabord_id": "3160",
        "district_id": "261",
        "code": "27",
        "name": "Florencia"
    },
    {
        "neabord_id": "3161",
        "district_id": "261",
        "code": "28",
        "name": "Murcia"
    },
    {
        "neabord_id": "3162",
        "district_id": "261",
        "code": "29",
        "name": "Pavas"
    },
    {
        "neabord_id": "3163",
        "district_id": "261",
        "code": "30",
        "name": "Recreo"
    },
    {
        "neabord_id": "3164",
        "district_id": "261",
        "code": "31",
        "name": "Roncha"
    },
    {
        "neabord_id": "3165",
        "district_id": "261",
        "code": "32",
        "name": "San Juan Norte"
    },
    {
        "neabord_id": "3166",
        "district_id": "261",
        "code": "33",
        "name": "San Juan Sur."
    },
    {
        "neabord_id": "3167",
        "district_id": "262",
        "code": "01",
        "name": "Leona (parte)."
    },
    {
        "neabord_id": "3168",
        "district_id": "262",
        "code": "02",
        "name": "Abelardo Rojas"
    },
    {
        "neabord_id": "3169",
        "district_id": "262",
        "code": "03",
        "name": "Alto Alemania"
    },
    {
        "neabord_id": "3170",
        "district_id": "262",
        "code": "04",
        "name": "Atirro"
    },
    {
        "neabord_id": "3171",
        "district_id": "262",
        "code": "05",
        "name": "Balalaica"
    },
    {
        "neabord_id": "3172",
        "district_id": "262",
        "code": "06",
        "name": "Buenos Aires"
    },
    {
        "neabord_id": "3173",
        "district_id": "262",
        "code": "07",
        "name": "Canada"
    },
    {
        "neabord_id": "3174",
        "district_id": "262",
        "code": "08",
        "name": "Carmen"
    },
    {
        "neabord_id": "3175",
        "district_id": "262",
        "code": "09",
        "name": "Cruzada"
    },
    {
        "neabord_id": "3176",
        "district_id": "262",
        "code": "10",
        "name": "Danta"
    },
    {
        "neabord_id": "3177",
        "district_id": "262",
        "code": "11",
        "name": "Gaviotas"
    },
    {
        "neabord_id": "3178",
        "district_id": "262",
        "code": "12",
        "name": "Guadalupe"
    },
    {
        "neabord_id": "3179",
        "district_id": "262",
        "code": "13",
        "name": "Maquina Vieja"
    },
    {
        "neabord_id": "3180",
        "district_id": "262",
        "code": "14",
        "name": "Margarita"
    },
    {
        "neabord_id": "3181",
        "district_id": "262",
        "code": "15",
        "name": "Mollejones"
    },
    {
        "neabord_id": "3182",
        "district_id": "262",
        "code": "16",
        "name": "Pacayitas"
    },
    {
        "neabord_id": "3183",
        "district_id": "262",
        "code": "17",
        "name": "Pacuare"
    },
    {
        "neabord_id": "3184",
        "district_id": "262",
        "code": "18",
        "name": "Piedra Grande"
    },
    {
        "neabord_id": "3185",
        "district_id": "262",
        "code": "19",
        "name": "Porvenir de la Esperanza"
    },
    {
        "neabord_id": "3186",
        "district_id": "262",
        "code": "20",
        "name": "Puente Alto"
    },
    {
        "neabord_id": "3187",
        "district_id": "262",
        "code": "21",
        "name": "San Vicente"
    },
    {
        "neabord_id": "3188",
        "district_id": "262",
        "code": "22",
        "name": "Selva (parte)"
    },
    {
        "neabord_id": "3189",
        "district_id": "262",
        "code": "23",
        "name": "Silencio"
    },
    {
        "neabord_id": "3190",
        "district_id": "262",
        "code": "24",
        "name": "Sonia."
    },
    {
        "neabord_id": "3191",
        "district_id": "263",
        "code": "01",
        "name": "El Seis."
    },
    {
        "neabord_id": "3192",
        "district_id": "264",
        "code": "01",
        "name": "Bajos de Bonilla"
    },
    {
        "neabord_id": "3193",
        "district_id": "264",
        "code": "02",
        "name": "Bolsón (parte)"
    },
    {
        "neabord_id": "3194",
        "district_id": "264",
        "code": "03",
        "name": "Bonilla"
    },
    {
        "neabord_id": "3195",
        "district_id": "264",
        "code": "04",
        "name": "Buenos Aires"
    },
    {
        "neabord_id": "3196",
        "district_id": "264",
        "code": "05",
        "name": "Calle Vargas"
    },
    {
        "neabord_id": "3197",
        "district_id": "264",
        "code": "06",
        "name": "Carmen (parte)"
    },
    {
        "neabord_id": "3198",
        "district_id": "264",
        "code": "07",
        "name": "Esperanza"
    },
    {
        "neabord_id": "3199",
        "district_id": "264",
        "code": "08",
        "name": "Guayabo Arriba"
    },
    {
        "neabord_id": "3200",
        "district_id": "264",
        "code": "09",
        "name": "La Central"
    },
    {
        "neabord_id": "3201",
        "district_id": "264",
        "code": "10",
        "name": "La Fuente"
    },
    {
        "neabord_id": "3202",
        "district_id": "264",
        "code": "11",
        "name": "Pastora"
    },
    {
        "neabord_id": "3203",
        "district_id": "264",
        "code": "12",
        "name": "Picada"
    },
    {
        "neabord_id": "3204",
        "district_id": "264",
        "code": "13",
        "name": "Raicero"
    },
    {
        "neabord_id": "3205",
        "district_id": "264",
        "code": "14",
        "name": "Reunión"
    },
    {
        "neabord_id": "3206",
        "district_id": "264",
        "code": "15",
        "name": "San Antonio"
    },
    {
        "neabord_id": "3207",
        "district_id": "264",
        "code": "16",
        "name": "San Diego"
    },
    {
        "neabord_id": "3208",
        "district_id": "264",
        "code": "17",
        "name": "Torito (parte)."
    },
    {
        "neabord_id": "3209",
        "district_id": "265",
        "code": "01",
        "name": "Cooperativa."
    },
    {
        "neabord_id": "3210",
        "district_id": "265",
        "code": "02",
        "name": "Bonilla Arriba"
    },
    {
        "neabord_id": "3211",
        "district_id": "265",
        "code": "03",
        "name": "Buenavista"
    },
    {
        "neabord_id": "3212",
        "district_id": "265",
        "code": "04",
        "name": "Cas"
    },
    {
        "neabord_id": "3213",
        "district_id": "265",
        "code": "05",
        "name": "Cimarrones"
    },
    {
        "neabord_id": "3214",
        "district_id": "265",
        "code": "06",
        "name": "Colonia Guayabo"
    },
    {
        "neabord_id": "3215",
        "district_id": "265",
        "code": "07",
        "name": "Colonia San Ramón"
    },
    {
        "neabord_id": "3216",
        "district_id": "265",
        "code": "08",
        "name": "Corralón"
    },
    {
        "neabord_id": "3217",
        "district_id": "265",
        "code": "09",
        "name": "Dulce Nombre"
    },
    {
        "neabord_id": "3218",
        "district_id": "265",
        "code": "10",
        "name": "El Dos"
    },
    {
        "neabord_id": "3219",
        "district_id": "265",
        "code": "11",
        "name": "Fuente"
    },
    {
        "neabord_id": "3220",
        "district_id": "265",
        "code": "12",
        "name": "Guayabo (parte)"
    },
    {
        "neabord_id": "3221",
        "district_id": "265",
        "code": "13",
        "name": "Li­bano"
    },
    {
        "neabord_id": "3222",
        "district_id": "265",
        "code": "14",
        "name": "Nueva Flor"
    },
    {
        "neabord_id": "3223",
        "district_id": "265",
        "code": "15",
        "name": "Palomo"
    },
    {
        "neabord_id": "3224",
        "district_id": "265",
        "code": "16",
        "name": "Pradera"
    },
    {
        "neabord_id": "3225",
        "district_id": "265",
        "code": "17",
        "name": "Sandoval"
    },
    {
        "neabord_id": "3226",
        "district_id": "265",
        "code": "18",
        "name": "Santa Tecla"
    },
    {
        "neabord_id": "3227",
        "district_id": "265",
        "code": "19",
        "name": "Sauce"
    },
    {
        "neabord_id": "3228",
        "district_id": "265",
        "code": "20",
        "name": "Torito (parte)"
    },
    {
        "neabord_id": "3229",
        "district_id": "265",
        "code": "21",
        "name": "Torito (sur)."
    },
    {
        "neabord_id": "3230",
        "district_id": "266",
        "code": "01",
        "name": "Angostura"
    },
    {
        "neabord_id": "3231",
        "district_id": "266",
        "code": "02",
        "name": "Bóveda"
    },
    {
        "neabord_id": "3232",
        "district_id": "266",
        "code": "03",
        "name": "Buenavista"
    },
    {
        "neabord_id": "3233",
        "district_id": "266",
        "code": "04",
        "name": "Chitari­a"
    },
    {
        "neabord_id": "3234",
        "district_id": "266",
        "code": "05",
        "name": "Eslabón"
    },
    {
        "neabord_id": "3235",
        "district_id": "266",
        "code": "06",
        "name": "Isla Bonita (parte)"
    },
    {
        "neabord_id": "3236",
        "district_id": "266",
        "code": "07",
        "name": "Jabillos"
    },
    {
        "neabord_id": "3237",
        "district_id": "266",
        "code": "08",
        "name": "San Rafael"
    },
    {
        "neabord_id": "3238",
        "district_id": "266",
        "code": "09",
        "name": "Sitio Mata"
    },
    {
        "neabord_id": "3239",
        "district_id": "266",
        "code": "10",
        "name": "Yama."
    },
    {
        "neabord_id": "3240",
        "district_id": "267",
        "code": "01",
        "name": "Leona (parte)."
    },
    {
        "neabord_id": "3241",
        "district_id": "267",
        "code": "02",
        "name": "Alto Surtubal"
    },
    {
        "neabord_id": "3242",
        "district_id": "267",
        "code": "03",
        "name": "angeles"
    },
    {
        "neabord_id": "3243",
        "district_id": "267",
        "code": "04",
        "name": "Bajo Pacuare (norte)"
    },
    {
        "neabord_id": "3244",
        "district_id": "267",
        "code": "05",
        "name": "Cabeza de Buey"
    },
    {
        "neabord_id": "3245",
        "district_id": "267",
        "code": "06",
        "name": "Cien Manzanas"
    },
    {
        "neabord_id": "3246",
        "district_id": "267",
        "code": "07",
        "name": "Colonia San Lucas"
    },
    {
        "neabord_id": "3247",
        "district_id": "267",
        "code": "08",
        "name": "Colonia Silencio"
    },
    {
        "neabord_id": "3248",
        "district_id": "267",
        "code": "09",
        "name": "Colonias"
    },
    {
        "neabord_id": "3249",
        "district_id": "267",
        "code": "10",
        "name": "Mata de Guineo"
    },
    {
        "neabord_id": "3250",
        "district_id": "267",
        "code": "11",
        "name": "Nubes"
    },
    {
        "neabord_id": "3251",
        "district_id": "267",
        "code": "12",
        "name": "Paulina"
    },
    {
        "neabord_id": "3252",
        "district_id": "267",
        "code": "13",
        "name": "Sacro"
    },
    {
        "neabord_id": "3253",
        "district_id": "267",
        "code": "14",
        "name": "San Bosco"
    },
    {
        "neabord_id": "3254",
        "district_id": "267",
        "code": "15",
        "name": "Selva (parte)."
    },
    {
        "neabord_id": "3255",
        "district_id": "268",
        "code": "01",
        "name": "Bajo Pacuare (sur)"
    },
    {
        "neabord_id": "3256",
        "district_id": "268",
        "code": "02",
        "name": "Dos Amigos"
    },
    {
        "neabord_id": "3257",
        "district_id": "268",
        "code": "03",
        "name": "Dulce Nombre"
    },
    {
        "neabord_id": "3258",
        "district_id": "268",
        "code": "04",
        "name": "Guineal"
    },
    {
        "neabord_id": "3259",
        "district_id": "268",
        "code": "05",
        "name": "Jicotea"
    },
    {
        "neabord_id": "3260",
        "district_id": "268",
        "code": "06",
        "name": "Mina"
    },
    {
        "neabord_id": "3261",
        "district_id": "268",
        "code": "07",
        "name": "Morado"
    },
    {
        "neabord_id": "3262",
        "district_id": "268",
        "code": "08",
        "name": "Quebradas"
    },
    {
        "neabord_id": "3263",
        "district_id": "268",
        "code": "09",
        "name": "San Marti­n"
    },
    {
        "neabord_id": "3264",
        "district_id": "268",
        "code": "10",
        "name": "San Rafael"
    },
    {
        "neabord_id": "3265",
        "district_id": "268",
        "code": "11",
        "name": "Tacotal."
    },
    {
        "neabord_id": "3266",
        "district_id": "269",
        "code": "01",
        "name": "Aquiares"
    },
    {
        "neabord_id": "3267",
        "district_id": "269",
        "code": "02",
        "name": "Bolsón (parte)"
    },
    {
        "neabord_id": "3268",
        "district_id": "269",
        "code": "03",
        "name": "Carmen (parte)"
    },
    {
        "neabord_id": "3269",
        "district_id": "269",
        "code": "04",
        "name": "Ri­o Claro"
    },
    {
        "neabord_id": "3270",
        "district_id": "269",
        "code": "05",
        "name": "San Rafael"
    },
    {
        "neabord_id": "3271",
        "district_id": "269",
        "code": "06",
        "name": "Verbena Norte"
    },
    {
        "neabord_id": "3272",
        "district_id": "269",
        "code": "07",
        "name": "Verbena Sur."
    },
    {
        "neabord_id": "3273",
        "district_id": "270",
        "code": "01",
        "name": "Alto June"
    },
    {
        "neabord_id": "3274",
        "district_id": "270",
        "code": "02",
        "name": "Corozal"
    },
    {
        "neabord_id": "3275",
        "district_id": "270",
        "code": "03",
        "name": "Flor"
    },
    {
        "neabord_id": "3276",
        "district_id": "270",
        "code": "04",
        "name": "Guanacasteca"
    },
    {
        "neabord_id": "3277",
        "district_id": "270",
        "code": "05",
        "name": "Isla Bonita(parte)"
    },
    {
        "neabord_id": "3278",
        "district_id": "270",
        "code": "06",
        "name": "Pilón de Azucar"
    },
    {
        "neabord_id": "3279",
        "district_id": "270",
        "code": "07",
        "name": "San Pablo"
    },
    {
        "neabord_id": "3280",
        "district_id": "270",
        "code": "08",
        "name": "Sol."
    },
    {
        "neabord_id": "3281",
        "district_id": "271",
        "code": "01",
        "name": "Azul"
    },
    {
        "neabord_id": "3282",
        "district_id": "271",
        "code": "02",
        "name": "animas"
    },
    {
        "neabord_id": "3283",
        "district_id": "271",
        "code": "03",
        "name": "Alto de Varas (Alto Varal)"
    },
    {
        "neabord_id": "3284",
        "district_id": "271",
        "code": "04",
        "name": "Guayabo (parte)"
    },
    {
        "neabord_id": "3285",
        "district_id": "271",
        "code": "05",
        "name": "Jesus Mari­a"
    },
    {
        "neabord_id": "3286",
        "district_id": "271",
        "code": "06",
        "name": "La Isabel"
    },
    {
        "neabord_id": "3287",
        "district_id": "271",
        "code": "07",
        "name": "San Marti­n."
    },
    {
        "neabord_id": "3288",
        "district_id": "272",
        "code": "01",
        "name": "Carolina"
    },
    {
        "neabord_id": "3289",
        "district_id": "272",
        "code": "02",
        "name": "Chirripó Abajo (parte)"
    },
    {
        "neabord_id": "3290",
        "district_id": "272",
        "code": "03",
        "name": "Chirripó Arriba"
    },
    {
        "neabord_id": "3291",
        "district_id": "272",
        "code": "04",
        "name": "Damaris"
    },
    {
        "neabord_id": "3292",
        "district_id": "272",
        "code": "05",
        "name": ""
    },
    {
        "neabord_id": "3293",
        "district_id": "272",
        "code": "06",
        "name": "Fortuna"
    },
    {
        "neabord_id": "3294",
        "district_id": "272",
        "code": "07",
        "name": "Jekui"
    },
    {
        "neabord_id": "3295",
        "district_id": "272",
        "code": "08",
        "name": "Moravia"
    },
    {
        "neabord_id": "3296",
        "district_id": "272",
        "code": "09",
        "name": "Namaldi­"
    },
    {
        "neabord_id": "3297",
        "district_id": "272",
        "code": "10",
        "name": "Pacuare arriba"
    },
    {
        "neabord_id": "3298",
        "district_id": "272",
        "code": "11",
        "name": "Paso Marcos"
    },
    {
        "neabord_id": "3299",
        "district_id": "272",
        "code": "12",
        "name": "Tsipiri (Platanillo)"
    },
    {
        "neabord_id": "3300",
        "district_id": "272",
        "code": "13",
        "name": "Playa Hermosa"
    },
    {
        "neabord_id": "3301",
        "district_id": "272",
        "code": "14",
        "name": "Porvenir"
    },
    {
        "neabord_id": "3302",
        "district_id": "272",
        "code": "15",
        "name": "Rai­z de Hule"
    },
    {
        "neabord_id": "3303",
        "district_id": "272",
        "code": "16",
        "name": "Ri­o Blanco"
    },
    {
        "neabord_id": "3304",
        "district_id": "272",
        "code": "17",
        "name": "Santubal"
    },
    {
        "neabord_id": "3305",
        "district_id": "272",
        "code": "18",
        "name": "Suri­"
    },
    {
        "neabord_id": "3306",
        "district_id": "272",
        "code": "19",
        "name": "Vereh"
    },
    {
        "neabord_id": "3307",
        "district_id": "272",
        "code": "20",
        "name": "Quetzal."
    },
    {
        "neabord_id": "3308",
        "district_id": "273",
        "code": "01",
        "name": "Lourdes"
    },
    {
        "neabord_id": "3309",
        "district_id": "273",
        "code": "02",
        "name": "Patalillo."
    },
    {
        "neabord_id": "3310",
        "district_id": "273",
        "code": "03",
        "name": "Buenavista"
    },
    {
        "neabord_id": "3311",
        "district_id": "273",
        "code": "04",
        "name": "Buenos Aires"
    },
    {
        "neabord_id": "3312",
        "district_id": "273",
        "code": "05",
        "name": "Charcalillos"
    },
    {
        "neabord_id": "3313",
        "district_id": "273",
        "code": "06",
        "name": "Encierrillo"
    },
    {
        "neabord_id": "3314",
        "district_id": "273",
        "code": "07",
        "name": "Los Pinos (Coliblanco)"
    },
    {
        "neabord_id": "3315",
        "district_id": "273",
        "code": "08",
        "name": "Llano Grande"
    },
    {
        "neabord_id": "3316",
        "district_id": "273",
        "code": "09",
        "name": "Pascón"
    },
    {
        "neabord_id": "3317",
        "district_id": "273",
        "code": "10",
        "name": "Pastora"
    },
    {
        "neabord_id": "3318",
        "district_id": "273",
        "code": "11",
        "name": "Plantón"
    },
    {
        "neabord_id": "3319",
        "district_id": "273",
        "code": "12",
        "name": "San Marti­n (Irazu Sur)"
    },
    {
        "neabord_id": "3320",
        "district_id": "273",
        "code": "13",
        "name": "San Rafael de Irazu."
    },
    {
        "neabord_id": "3321",
        "district_id": "274",
        "code": "01",
        "name": "Bajo Malanga"
    },
    {
        "neabord_id": "3322",
        "district_id": "274",
        "code": "02",
        "name": "Aguas (parte)"
    },
    {
        "neabord_id": "3323",
        "district_id": "274",
        "code": "03",
        "name": "Bajo Solano"
    },
    {
        "neabord_id": "3324",
        "district_id": "274",
        "code": "04",
        "name": "Ciudad del Cielo"
    },
    {
        "neabord_id": "3325",
        "district_id": "274",
        "code": "05",
        "name": "Descanso"
    },
    {
        "neabord_id": "3326",
        "district_id": "274",
        "code": "06",
        "name": "El Alto"
    },
    {
        "neabord_id": "3327",
        "district_id": "274",
        "code": "07",
        "name": "Mata de Guineo"
    },
    {
        "neabord_id": "3328",
        "district_id": "274",
        "code": "08",
        "name": "Monticel."
    },
    {
        "neabord_id": "3329",
        "district_id": "275",
        "code": "01",
        "name": "Bajo Abarca"
    },
    {
        "neabord_id": "3330",
        "district_id": "275",
        "code": "02",
        "name": "Lourdes (Callejón)"
    },
    {
        "neabord_id": "3331",
        "district_id": "275",
        "code": "03",
        "name": "Coliblanco"
    },
    {
        "neabord_id": "3332",
        "district_id": "275",
        "code": "04",
        "name": "Santa Teresa."
    },
    {
        "neabord_id": "3333",
        "district_id": "276",
        "code": "01",
        "name": "Alto Cerrillos (Corazón de Jesus)"
    },
    {
        "neabord_id": "3334",
        "district_id": "276",
        "code": "02",
        "name": "Artavia"
    },
    {
        "neabord_id": "3335",
        "district_id": "276",
        "code": "03",
        "name": "Barrial"
    },
    {
        "neabord_id": "3336",
        "district_id": "276",
        "code": "04",
        "name": "Bosque"
    },
    {
        "neabord_id": "3337",
        "district_id": "276",
        "code": "05",
        "name": "Breñas"
    },
    {
        "neabord_id": "3338",
        "district_id": "276",
        "code": "06",
        "name": "Caballo Blanco (parte)"
    },
    {
        "neabord_id": "3339",
        "district_id": "276",
        "code": "07",
        "name": "Chircagre"
    },
    {
        "neabord_id": "3340",
        "district_id": "276",
        "code": "08",
        "name": "Flores"
    },
    {
        "neabord_id": "3341",
        "district_id": "276",
        "code": "09",
        "name": "Gamboa"
    },
    {
        "neabord_id": "3342",
        "district_id": "276",
        "code": "10",
        "name": "Jose Jesus Mendez"
    },
    {
        "neabord_id": "3343",
        "district_id": "276",
        "code": "11",
        "name": "Juan Pablo II"
    },
    {
        "neabord_id": "3344",
        "district_id": "276",
        "code": "12",
        "name": "Sagrada Familia"
    },
    {
        "neabord_id": "3345",
        "district_id": "276",
        "code": "13",
        "name": "Monseñor Sanabria."
    },
    {
        "neabord_id": "3346",
        "district_id": "276",
        "code": "14",
        "name": "Cuesta Chinchilla"
    },
    {
        "neabord_id": "3347",
        "district_id": "276",
        "code": "15",
        "name": "Llano."
    },
    {
        "neabord_id": "3348",
        "district_id": "277",
        "code": "01",
        "name": "Mata de Mora"
    },
    {
        "neabord_id": "3349",
        "district_id": "277",
        "code": "02",
        "name": "Paez (parte)"
    },
    {
        "neabord_id": "3350",
        "district_id": "277",
        "code": "03",
        "name": "Paso Ancho"
    },
    {
        "neabord_id": "3351",
        "district_id": "277",
        "code": "04",
        "name": "San Cayetano."
    },
    {
        "neabord_id": "3352",
        "district_id": "278",
        "code": "01",
        "name": "Maya"
    },
    {
        "neabord_id": "3353",
        "district_id": "278",
        "code": "02",
        "name": "Cruce"
    },
    {
        "neabord_id": "3354",
        "district_id": "278",
        "code": "03",
        "name": "Pisco"
    },
    {
        "neabord_id": "3355",
        "district_id": "278",
        "code": "04",
        "name": "Sanabria"
    },
    {
        "neabord_id": "3356",
        "district_id": "278",
        "code": "05",
        "name": "San Juan de Chicua."
    },
    {
        "neabord_id": "3357",
        "district_id": "279",
        "code": "01",
        "name": "Aguas (parte)"
    },
    {
        "neabord_id": "3358",
        "district_id": "279",
        "code": "02",
        "name": "Barrionuevo"
    },
    {
        "neabord_id": "3359",
        "district_id": "279",
        "code": "03",
        "name": "Boquerón"
    },
    {
        "neabord_id": "3360",
        "district_id": "279",
        "code": "04",
        "name": "Capira"
    },
    {
        "neabord_id": "3361",
        "district_id": "279",
        "code": "05",
        "name": "Oratorio."
    },
    {
        "neabord_id": "3362",
        "district_id": "280",
        "code": "01",
        "name": "Cuesta Quemados"
    },
    {
        "neabord_id": "3363",
        "district_id": "280",
        "code": "02",
        "name": "Pasqui­"
    },
    {
        "neabord_id": "3364",
        "district_id": "280",
        "code": "03",
        "name": "Platanillal"
    },
    {
        "neabord_id": "3365",
        "district_id": "280",
        "code": "04",
        "name": "San Gerardo"
    },
    {
        "neabord_id": "3366",
        "district_id": "280",
        "code": "05",
        "name": "San Juan"
    },
    {
        "neabord_id": "3367",
        "district_id": "280",
        "code": "06",
        "name": "San Marti­n"
    },
    {
        "neabord_id": "3368",
        "district_id": "280",
        "code": "07",
        "name": "San Pablo"
    },
    {
        "neabord_id": "3369",
        "district_id": "280",
        "code": "08",
        "name": "Titoral."
    },
    {
        "neabord_id": "3370",
        "district_id": "281",
        "code": "01",
        "name": "Asunción"
    },
    {
        "neabord_id": "3371",
        "district_id": "281",
        "code": "02",
        "name": "Barahona"
    },
    {
        "neabord_id": "3372",
        "district_id": "281",
        "code": "03",
        "name": "Barrio Nuevo"
    },
    {
        "neabord_id": "3373",
        "district_id": "281",
        "code": "04",
        "name": "Colonia"
    },
    {
        "neabord_id": "3374",
        "district_id": "281",
        "code": "05",
        "name": "Chavarri­a"
    },
    {
        "neabord_id": "3375",
        "district_id": "281",
        "code": "06",
        "name": "Sabana"
    },
    {
        "neabord_id": "3376",
        "district_id": "281",
        "code": "07",
        "name": "Sabana Grande"
    },
    {
        "neabord_id": "3377",
        "district_id": "281",
        "code": "08",
        "name": "San Rafael"
    },
    {
        "neabord_id": "3378",
        "district_id": "281",
        "code": "09",
        "name": "Santa Gertrudis"
    },
    {
        "neabord_id": "3379",
        "district_id": "281",
        "code": "10",
        "name": "Sauces"
    },
    {
        "neabord_id": "3380",
        "district_id": "281",
        "code": "11",
        "name": "Silo"
    },
    {
        "neabord_id": "3381",
        "district_id": "281",
        "code": "12",
        "name": "Viento Fresco."
    },
    {
        "neabord_id": "3382",
        "district_id": "282",
        "code": "01",
        "name": "Guatuso"
    },
    {
        "neabord_id": "3383",
        "district_id": "282",
        "code": "02",
        "name": "Higuito"
    },
    {
        "neabord_id": "3384",
        "district_id": "282",
        "code": "03",
        "name": "Potrerillos."
    },
    {
        "neabord_id": "3385",
        "district_id": "282",
        "code": "04",
        "name": "Altamiradas"
    },
    {
        "neabord_id": "3386",
        "district_id": "282",
        "code": "05",
        "name": "Alto San Francisco"
    },
    {
        "neabord_id": "3387",
        "district_id": "282",
        "code": "06",
        "name": "Bajo Gloria"
    },
    {
        "neabord_id": "3388",
        "district_id": "282",
        "code": "07",
        "name": "Bajos de León"
    },
    {
        "neabord_id": "3389",
        "district_id": "282",
        "code": "08",
        "name": "Barrancas (parte)"
    },
    {
        "neabord_id": "3390",
        "district_id": "282",
        "code": "09",
        "name": "Cangreja"
    },
    {
        "neabord_id": "3391",
        "district_id": "282",
        "code": "10",
        "name": "Cañón (parte)"
    },
    {
        "neabord_id": "3392",
        "district_id": "282",
        "code": "11",
        "name": "Casablanca"
    },
    {
        "neabord_id": "3393",
        "district_id": "282",
        "code": "12",
        "name": "Casamata"
    },
    {
        "neabord_id": "3394",
        "district_id": "282",
        "code": "13",
        "name": "Cascajal"
    },
    {
        "neabord_id": "3395",
        "district_id": "282",
        "code": "14",
        "name": "Conventillo"
    },
    {
        "neabord_id": "3396",
        "district_id": "282",
        "code": "15",
        "name": "Cruces"
    },
    {
        "neabord_id": "3397",
        "district_id": "282",
        "code": "16",
        "name": "Cruz"
    },
    {
        "neabord_id": "3398",
        "district_id": "282",
        "code": "17",
        "name": "Chonta (parte)"
    },
    {
        "neabord_id": "3399",
        "district_id": "282",
        "code": "18",
        "name": "Damita"
    },
    {
        "neabord_id": "3400",
        "district_id": "282",
        "code": "19",
        "name": "Dos Amigos"
    },
    {
        "neabord_id": "3401",
        "district_id": "282",
        "code": "20",
        "name": "Empalme (parte)"
    },
    {
        "neabord_id": "3402",
        "district_id": "282",
        "code": "21",
        "name": "Esperanza"
    },
    {
        "neabord_id": "3403",
        "district_id": "282",
        "code": "22",
        "name": "Estrella"
    },
    {
        "neabord_id": "3404",
        "district_id": "282",
        "code": "23",
        "name": "Guayabal (parte)"
    },
    {
        "neabord_id": "3405",
        "district_id": "282",
        "code": "24",
        "name": "La Luchita"
    },
    {
        "neabord_id": "3406",
        "district_id": "282",
        "code": "25",
        "name": "La Paz"
    },
    {
        "neabord_id": "3407",
        "district_id": "282",
        "code": "26",
        "name": "Macho Gaff"
    },
    {
        "neabord_id": "3408",
        "district_id": "282",
        "code": "27",
        "name": "Montserrat"
    },
    {
        "neabord_id": "3409",
        "district_id": "282",
        "code": "28",
        "name": "Ojo de Agua (parte)"
    },
    {
        "neabord_id": "3410",
        "district_id": "282",
        "code": "29",
        "name": "Palmital"
    },
    {
        "neabord_id": "3411",
        "district_id": "282",
        "code": "30",
        "name": "Palmital Sur"
    },
    {
        "neabord_id": "3412",
        "district_id": "282",
        "code": "31",
        "name": "Palo Verde"
    },
    {
        "neabord_id": "3413",
        "district_id": "282",
        "code": "32",
        "name": "Paso Macho (parte)"
    },
    {
        "neabord_id": "3414",
        "district_id": "282",
        "code": "33",
        "name": "Purires (parte)"
    },
    {
        "neabord_id": "3415",
        "district_id": "282",
        "code": "34",
        "name": "Salsipuedes (parte)"
    },
    {
        "neabord_id": "3416",
        "district_id": "282",
        "code": "35",
        "name": "San Cayetano"
    },
    {
        "neabord_id": "3417",
        "district_id": "282",
        "code": "36",
        "name": "Surtubal"
    },
    {
        "neabord_id": "3418",
        "district_id": "282",
        "code": "37",
        "name": "Tres de Junio"
    },
    {
        "neabord_id": "3419",
        "district_id": "282",
        "code": "38",
        "name": "Vara del Roble."
    },
    {
        "neabord_id": "3420",
        "district_id": "283",
        "code": "01",
        "name": "Achiotillo"
    },
    {
        "neabord_id": "3421",
        "district_id": "283",
        "code": "02",
        "name": "Barrancas (parte)"
    },
    {
        "neabord_id": "3422",
        "district_id": "283",
        "code": "03",
        "name": "Bodocal"
    },
    {
        "neabord_id": "3423",
        "district_id": "283",
        "code": "04",
        "name": "Garita (parte)"
    },
    {
        "neabord_id": "3424",
        "district_id": "283",
        "code": "05",
        "name": "Purires (parte)"
    },
    {
        "neabord_id": "3425",
        "district_id": "283",
        "code": "06",
        "name": "Tablón."
    },
    {
        "neabord_id": "3426",
        "district_id": "284",
        "code": "01",
        "name": "Bajo Zopilote"
    },
    {
        "neabord_id": "3427",
        "district_id": "284",
        "code": "02",
        "name": "Caragral"
    },
    {
        "neabord_id": "3428",
        "district_id": "284",
        "code": "03",
        "name": "Comun."
    },
    {
        "neabord_id": "3429",
        "district_id": "285",
        "code": "01",
        "name": "angeles"
    },
    {
        "neabord_id": "3430",
        "district_id": "285",
        "code": "02",
        "name": "Carmen"
    },
    {
        "neabord_id": "3431",
        "district_id": "285",
        "code": "03",
        "name": "Corazón de Jesus"
    },
    {
        "neabord_id": "3432",
        "district_id": "285",
        "code": "04",
        "name": "Chino"
    },
    {
        "neabord_id": "3433",
        "district_id": "285",
        "code": "05",
        "name": "Estadio"
    },
    {
        "neabord_id": "3434",
        "district_id": "285",
        "code": "06",
        "name": "Fatima"
    },
    {
        "neabord_id": "3435",
        "district_id": "285",
        "code": "07",
        "name": "Guayabal"
    },
    {
        "neabord_id": "3436",
        "district_id": "285",
        "code": "08",
        "name": "La India"
    },
    {
        "neabord_id": "3437",
        "district_id": "285",
        "code": "09",
        "name": "Lourdes"
    },
    {
        "neabord_id": "3438",
        "district_id": "285",
        "code": "10",
        "name": "Hospital"
    },
    {
        "neabord_id": "3439",
        "district_id": "285",
        "code": "11",
        "name": "Mari­a Auxiliadora (parte)"
    },
    {
        "neabord_id": "3440",
        "district_id": "285",
        "code": "12",
        "name": "Oriente"
    },
    {
        "neabord_id": "3441",
        "district_id": "285",
        "code": "13",
        "name": "Pirro"
    },
    {
        "neabord_id": "3442",
        "district_id": "285",
        "code": "14",
        "name": "Puebla (parte)"
    },
    {
        "neabord_id": "3443",
        "district_id": "285",
        "code": "15",
        "name": "Rancho Chico"
    },
    {
        "neabord_id": "3444",
        "district_id": "285",
        "code": "16",
        "name": "San Fernando"
    },
    {
        "neabord_id": "3445",
        "district_id": "285",
        "code": "17",
        "name": "San Vicente."
    },
    {
        "neabord_id": "3446",
        "district_id": "286",
        "code": "01",
        "name": "Buri­o"
    },
    {
        "neabord_id": "3447",
        "district_id": "286",
        "code": "02",
        "name": "Carbonal"
    },
    {
        "neabord_id": "3448",
        "district_id": "286",
        "code": "03",
        "name": "Cubujuqui­"
    },
    {
        "neabord_id": "3449",
        "district_id": "286",
        "code": "04",
        "name": "España"
    },
    {
        "neabord_id": "3450",
        "district_id": "286",
        "code": "05",
        "name": "Labrador"
    },
    {
        "neabord_id": "3451",
        "district_id": "286",
        "code": "06",
        "name": "Mercedes Sur"
    },
    {
        "neabord_id": "3452",
        "district_id": "286",
        "code": "07",
        "name": "Monte Bello"
    },
    {
        "neabord_id": "3453",
        "district_id": "286",
        "code": "08",
        "name": "San Jorge"
    },
    {
        "neabord_id": "3454",
        "district_id": "286",
        "code": "09",
        "name": "Santa Ines."
    },
    {
        "neabord_id": "3455",
        "district_id": "287",
        "code": "01",
        "name": "Aries"
    },
    {
        "neabord_id": "3456",
        "district_id": "287",
        "code": "02",
        "name": "Aurora (parte)"
    },
    {
        "neabord_id": "3457",
        "district_id": "287",
        "code": "03",
        "name": "Bernardo Benavides"
    },
    {
        "neabord_id": "3458",
        "district_id": "287",
        "code": "04",
        "name": "Chucos"
    },
    {
        "neabord_id": "3459",
        "district_id": "287",
        "code": "05",
        "name": "El Cristo (parte)"
    },
    {
        "neabord_id": "3460",
        "district_id": "287",
        "code": "06",
        "name": "Esmeralda"
    },
    {
        "neabord_id": "3461",
        "district_id": "287",
        "code": "07",
        "name": "Esperanza"
    },
    {
        "neabord_id": "3462",
        "district_id": "287",
        "code": "08",
        "name": "Granada"
    },
    {
        "neabord_id": "3463",
        "district_id": "287",
        "code": "09",
        "name": "Gran Samaria"
    },
    {
        "neabord_id": "3464",
        "district_id": "287",
        "code": "10",
        "name": "Guarari­"
    },
    {
        "neabord_id": "3465",
        "district_id": "287",
        "code": "11",
        "name": "Lagos"
    },
    {
        "neabord_id": "3466",
        "district_id": "287",
        "code": "12",
        "name": "Malinches"
    },
    {
        "neabord_id": "3467",
        "district_id": "287",
        "code": "13",
        "name": "Mayorga (parte)"
    },
    {
        "neabord_id": "3468",
        "district_id": "287",
        "code": "14",
        "name": "Ni­speros 3"
    },
    {
        "neabord_id": "3469",
        "district_id": "287",
        "code": "15",
        "name": "Palma"
    },
    {
        "neabord_id": "3470",
        "district_id": "287",
        "code": "16",
        "name": "Trebol"
    },
    {
        "neabord_id": "3471",
        "district_id": "287",
        "code": "17",
        "name": "Tropical."
    },
    {
        "neabord_id": "3472",
        "district_id": "288",
        "code": "01",
        "name": "Arcos"
    },
    {
        "neabord_id": "3473",
        "district_id": "288",
        "code": "02",
        "name": "Aurora (parte)"
    },
    {
        "neabord_id": "3474",
        "district_id": "288",
        "code": "03",
        "name": "Bajos del Virilla (San Rafael)"
    },
    {
        "neabord_id": "3475",
        "district_id": "288",
        "code": "04",
        "name": "Cariari (parte)"
    },
    {
        "neabord_id": "3476",
        "district_id": "288",
        "code": "05",
        "name": "Carpintera"
    },
    {
        "neabord_id": "3477",
        "district_id": "288",
        "code": "06",
        "name": "El Cristo (parte)"
    },
    {
        "neabord_id": "3478",
        "district_id": "288",
        "code": "07",
        "name": "Lagunilla"
    },
    {
        "neabord_id": "3479",
        "district_id": "288",
        "code": "08",
        "name": "Linda del Norte"
    },
    {
        "neabord_id": "3480",
        "district_id": "288",
        "code": "09",
        "name": "Mayorga (parte)"
    },
    {
        "neabord_id": "3481",
        "district_id": "288",
        "code": "10",
        "name": "Monterrey"
    },
    {
        "neabord_id": "3482",
        "district_id": "288",
        "code": "11",
        "name": "Pitahaya"
    },
    {
        "neabord_id": "3483",
        "district_id": "288",
        "code": "12",
        "name": "Pueblo Nuevo"
    },
    {
        "neabord_id": "3484",
        "district_id": "288",
        "code": "13",
        "name": "Valencia (parte)"
    },
    {
        "neabord_id": "3485",
        "district_id": "288",
        "code": "14",
        "name": "Vista Nosara."
    },
    {
        "neabord_id": "3486",
        "district_id": "289",
        "code": "01",
        "name": "Jesus Mari­a"
    },
    {
        "neabord_id": "3487",
        "district_id": "289",
        "code": "02",
        "name": "Legua"
    },
    {
        "neabord_id": "3488",
        "district_id": "289",
        "code": "03",
        "name": "Legua de Barva"
    },
    {
        "neabord_id": "3489",
        "district_id": "289",
        "code": "04",
        "name": "Montaña Azul"
    },
    {
        "neabord_id": "3490",
        "district_id": "289",
        "code": "05",
        "name": "San Rafael"
    },
    {
        "neabord_id": "3491",
        "district_id": "289",
        "code": "06",
        "name": "Virgen del Socorro (parte)."
    },
    {
        "neabord_id": "3492",
        "district_id": "290",
        "code": "01",
        "name": "Don Abraham"
    },
    {
        "neabord_id": "3493",
        "district_id": "290",
        "code": "02",
        "name": "San Bartolome."
    },
    {
        "neabord_id": "3494",
        "district_id": "291",
        "code": "01",
        "name": "Bosque"
    },
    {
        "neabord_id": "3495",
        "district_id": "291",
        "code": "02",
        "name": "Calle Amada"
    },
    {
        "neabord_id": "3496",
        "district_id": "291",
        "code": "03",
        "name": "Calle Los Naranjos"
    },
    {
        "neabord_id": "3497",
        "district_id": "291",
        "code": "04",
        "name": "Espinos"
    },
    {
        "neabord_id": "3498",
        "district_id": "291",
        "code": "05",
        "name": "Maquina"
    },
    {
        "neabord_id": "3499",
        "district_id": "291",
        "code": "06",
        "name": "Mirador"
    },
    {
        "neabord_id": "3500",
        "district_id": "291",
        "code": "07",
        "name": "Morazan"
    },
    {
        "neabord_id": "3501",
        "district_id": "291",
        "code": "08",
        "name": "Puente Salas"
    },
    {
        "neabord_id": "3502",
        "district_id": "291",
        "code": "09",
        "name": "Segura"
    },
    {
        "neabord_id": "3503",
        "district_id": "291",
        "code": "10",
        "name": "Vista Llana."
    },
    {
        "neabord_id": "3504",
        "district_id": "292",
        "code": "01",
        "name": "Barrios (Barva): Cementerio"
    },
    {
        "neabord_id": "3505",
        "district_id": "292",
        "code": "02",
        "name": "Ibi­s."
    },
    {
        "neabord_id": "3506",
        "district_id": "292",
        "code": "03",
        "name": "Buenavista."
    },
    {
        "neabord_id": "3507",
        "district_id": "293",
        "code": "01",
        "name": "Bello Higuerón"
    },
    {
        "neabord_id": "3508",
        "district_id": "293",
        "code": "02",
        "name": "Los Luises"
    },
    {
        "neabord_id": "3509",
        "district_id": "293",
        "code": "03",
        "name": "Plantación"
    },
    {
        "neabord_id": "3510",
        "district_id": "293",
        "code": "04",
        "name": "Pórtico."
    },
    {
        "neabord_id": "3511",
        "district_id": "294",
        "code": "01",
        "name": "Doña Iris"
    },
    {
        "neabord_id": "3512",
        "district_id": "294",
        "code": "02",
        "name": "Jardines del Beneficio"
    },
    {
        "neabord_id": "3513",
        "district_id": "294",
        "code": "03",
        "name": "Paso Viga (parte)"
    },
    {
        "neabord_id": "3514",
        "district_id": "294",
        "code": "04",
        "name": "Pedregal."
    },
    {
        "neabord_id": "3515",
        "district_id": "294",
        "code": "05",
        "name": "Getsemani­ (parte)"
    },
    {
        "neabord_id": "3516",
        "district_id": "294",
        "code": "06",
        "name": "Palmar (parte)."
    },
    {
        "neabord_id": "3517",
        "district_id": "295",
        "code": "01",
        "name": "Gallito"
    },
    {
        "neabord_id": "3518",
        "district_id": "295",
        "code": "02",
        "name": "Monte Alto"
    },
    {
        "neabord_id": "3519",
        "district_id": "295",
        "code": "03",
        "name": "Cipresal"
    },
    {
        "neabord_id": "3520",
        "district_id": "295",
        "code": "04",
        "name": "Doña Blanca"
    },
    {
        "neabord_id": "3521",
        "district_id": "295",
        "code": "05",
        "name": "Doña Elena"
    },
    {
        "neabord_id": "3522",
        "district_id": "295",
        "code": "06",
        "name": "Higuerón"
    },
    {
        "neabord_id": "3523",
        "district_id": "295",
        "code": "07",
        "name": "Huacalillo"
    },
    {
        "neabord_id": "3524",
        "district_id": "295",
        "code": "08",
        "name": "El Collado"
    },
    {
        "neabord_id": "3525",
        "district_id": "295",
        "code": "09",
        "name": "Meseta"
    },
    {
        "neabord_id": "3526",
        "district_id": "295",
        "code": "10",
        "name": "Paso Llano"
    },
    {
        "neabord_id": "3527",
        "district_id": "295",
        "code": "11",
        "name": "Plan de Birri­"
    },
    {
        "neabord_id": "3528",
        "district_id": "295",
        "code": "12",
        "name": "Porrosati­"
    },
    {
        "neabord_id": "3529",
        "district_id": "295",
        "code": "13",
        "name": "Roblealto"
    },
    {
        "neabord_id": "3530",
        "district_id": "295",
        "code": "14",
        "name": "Sacramento"
    },
    {
        "neabord_id": "3531",
        "district_id": "295",
        "code": "15",
        "name": "San Marti­n"
    },
    {
        "neabord_id": "3532",
        "district_id": "295",
        "code": "16",
        "name": "San Miguel"
    },
    {
        "neabord_id": "3533",
        "district_id": "295",
        "code": "17",
        "name": "Santa Clara"
    },
    {
        "neabord_id": "3534",
        "district_id": "295",
        "code": "18",
        "name": "Zapata."
    },
    {
        "neabord_id": "3535",
        "district_id": "296",
        "code": "01",
        "name": "Barro de Olla"
    },
    {
        "neabord_id": "3536",
        "district_id": "296",
        "code": "02",
        "name": "Calle Don Pedro"
    },
    {
        "neabord_id": "3537",
        "district_id": "296",
        "code": "03",
        "name": "Quintana"
    },
    {
        "neabord_id": "3538",
        "district_id": "296",
        "code": "04",
        "name": "Yurusti."
    },
    {
        "neabord_id": "3539",
        "district_id": "297",
        "code": "01",
        "name": "Canoa (parte)"
    },
    {
        "neabord_id": "3540",
        "district_id": "297",
        "code": "02",
        "name": "Castilla"
    },
    {
        "neabord_id": "3541",
        "district_id": "297",
        "code": "03",
        "name": "Cuesta Rojas"
    },
    {
        "neabord_id": "3542",
        "district_id": "297",
        "code": "04",
        "name": "Montero"
    },
    {
        "neabord_id": "3543",
        "district_id": "297",
        "code": "05",
        "name": "Socorro"
    },
    {
        "neabord_id": "3544",
        "district_id": "297",
        "code": "06",
        "name": "Villa Rossi."
    },
    {
        "neabord_id": "3545",
        "district_id": "298",
        "code": "01",
        "name": "Represa."
    },
    {
        "neabord_id": "3546",
        "district_id": "299",
        "code": "01",
        "name": "Barquero"
    },
    {
        "neabord_id": "3547",
        "district_id": "299",
        "code": "02",
        "name": "Higinia"
    },
    {
        "neabord_id": "3548",
        "district_id": "299",
        "code": "03",
        "name": "Paci­fica."
    },
    {
        "neabord_id": "3549",
        "district_id": "300",
        "code": "01",
        "name": "La Cooperativa"
    },
    {
        "neabord_id": "3550",
        "district_id": "300",
        "code": "02",
        "name": "Pedro León"
    },
    {
        "neabord_id": "3551",
        "district_id": "300",
        "code": "03",
        "name": "Primero de Mayo"
    },
    {
        "neabord_id": "3552",
        "district_id": "300",
        "code": "04",
        "name": "Quisqueya"
    },
    {
        "neabord_id": "3553",
        "district_id": "300",
        "code": "05",
        "name": "Rinconada"
    },
    {
        "neabord_id": "3554",
        "district_id": "300",
        "code": "06",
        "name": "Valencia (parte)."
    },
    {
        "neabord_id": "3555",
        "district_id": "301",
        "code": "01",
        "name": "Calle Vieja"
    },
    {
        "neabord_id": "3556",
        "district_id": "301",
        "code": "02",
        "name": "Lourdes"
    },
    {
        "neabord_id": "3557",
        "district_id": "301",
        "code": "03",
        "name": "Quebradas (parte)."
    },
    {
        "neabord_id": "3558",
        "district_id": "302",
        "code": "01",
        "name": "Caballero."
    },
    {
        "neabord_id": "3559",
        "district_id": "302",
        "code": "02",
        "name": "Canoa (parte)."
    },
    {
        "neabord_id": "3560",
        "district_id": "303",
        "code": "01",
        "name": "Trompezón."
    },
    {
        "neabord_id": "3561",
        "district_id": "304",
        "code": "01",
        "name": "Betania"
    },
    {
        "neabord_id": "3562",
        "district_id": "304",
        "code": "02",
        "name": "Rosales (parte)."
    },
    {
        "neabord_id": "3563",
        "district_id": "305",
        "code": "01",
        "name": "Cinco Esquinas"
    },
    {
        "neabord_id": "3564",
        "district_id": "305",
        "code": "02",
        "name": "Lotes Moreira"
    },
    {
        "neabord_id": "3565",
        "district_id": "305",
        "code": "03",
        "name": "San Juan Arriba"
    },
    {
        "neabord_id": "3566",
        "district_id": "306",
        "code": "01",
        "name": "Altagracia"
    },
    {
        "neabord_id": "3567",
        "district_id": "306",
        "code": "02",
        "name": "Birri­"
    },
    {
        "neabord_id": "3568",
        "district_id": "306",
        "code": "03",
        "name": "Calle Quirós (parte)"
    },
    {
        "neabord_id": "3569",
        "district_id": "306",
        "code": "04",
        "name": "Catalina"
    },
    {
        "neabord_id": "3570",
        "district_id": "306",
        "code": "05",
        "name": "Comun (parte)"
    },
    {
        "neabord_id": "3571",
        "district_id": "306",
        "code": "06",
        "name": "Cuesta Colorada"
    },
    {
        "neabord_id": "3572",
        "district_id": "306",
        "code": "07",
        "name": "Guachipelines"
    },
    {
        "neabord_id": "3573",
        "district_id": "306",
        "code": "08",
        "name": "Guaracha"
    },
    {
        "neabord_id": "3574",
        "district_id": "306",
        "code": "09",
        "name": "Ulises."
    },
    {
        "neabord_id": "3575",
        "district_id": "307",
        "code": "01",
        "name": "Amapola"
    },
    {
        "neabord_id": "3576",
        "district_id": "307",
        "code": "02",
        "name": "Cartagos"
    },
    {
        "neabord_id": "3577",
        "district_id": "307",
        "code": "03",
        "name": "Chagüite"
    },
    {
        "neabord_id": "3578",
        "district_id": "307",
        "code": "04",
        "name": "Giralda"
    },
    {
        "neabord_id": "3579",
        "district_id": "307",
        "code": "05",
        "name": "Guarari­"
    },
    {
        "neabord_id": "3580",
        "district_id": "307",
        "code": "06",
        "name": "Tranquera."
    },
    {
        "neabord_id": "3581",
        "district_id": "308",
        "code": "01",
        "name": "Mari­as"
    },
    {
        "neabord_id": "3582",
        "district_id": "308",
        "code": "02",
        "name": "Puraba"
    },
    {
        "neabord_id": "3583",
        "district_id": "308",
        "code": "03",
        "name": "San Bosco."
    },
    {
        "neabord_id": "3584",
        "district_id": "308",
        "code": "04",
        "name": "Calle Quirós (parte)"
    },
    {
        "neabord_id": "3585",
        "district_id": "308",
        "code": "05",
        "name": "Comun (parte)"
    },
    {
        "neabord_id": "3586",
        "district_id": "308",
        "code": "06",
        "name": "Lajas."
    },
    {
        "neabord_id": "3587",
        "district_id": "309",
        "code": "01",
        "name": "Amistad"
    },
    {
        "neabord_id": "3588",
        "district_id": "309",
        "code": "02",
        "name": "Matasano (parte)"
    },
    {
        "neabord_id": "3589",
        "district_id": "309",
        "code": "03",
        "name": "Paso Viga (parte)."
    },
    {
        "neabord_id": "3590",
        "district_id": "310",
        "code": "01",
        "name": "Bajo Molinos"
    },
    {
        "neabord_id": "3591",
        "district_id": "310",
        "code": "02",
        "name": "Joya"
    },
    {
        "neabord_id": "3592",
        "district_id": "310",
        "code": "03",
        "name": "Matasano (parte)"
    },
    {
        "neabord_id": "3593",
        "district_id": "310",
        "code": "04",
        "name": "Peralta"
    },
    {
        "neabord_id": "3594",
        "district_id": "310",
        "code": "05",
        "name": "Santi­sima Trinidad."
    },
    {
        "neabord_id": "3595",
        "district_id": "311",
        "code": "01",
        "name": "Jardines de Roma"
    },
    {
        "neabord_id": "3596",
        "district_id": "311",
        "code": "02",
        "name": "Jardines Universitarios"
    },
    {
        "neabord_id": "3597",
        "district_id": "311",
        "code": "03",
        "name": "Suiza."
    },
    {
        "neabord_id": "3598",
        "district_id": "312",
        "code": "01",
        "name": "Paso Viga (parte)"
    },
    {
        "neabord_id": "3599",
        "district_id": "312",
        "code": "02",
        "name": "Saca."
    },
    {
        "neabord_id": "3600",
        "district_id": "312",
        "code": "03",
        "name": "Calle Hernandez (parte)"
    },
    {
        "neabord_id": "3601",
        "district_id": "312",
        "code": "04",
        "name": "Castillo"
    },
    {
        "neabord_id": "3602",
        "district_id": "312",
        "code": "05",
        "name": "Cerro Redondo"
    },
    {
        "neabord_id": "3603",
        "district_id": "312",
        "code": "06",
        "name": "Getsemani­ (parte)"
    },
    {
        "neabord_id": "3604",
        "district_id": "312",
        "code": "07",
        "name": "Joaquina"
    },
    {
        "neabord_id": "3605",
        "district_id": "312",
        "code": "08",
        "name": "Lobos"
    },
    {
        "neabord_id": "3606",
        "district_id": "312",
        "code": "09",
        "name": "Montecito"
    },
    {
        "neabord_id": "3607",
        "district_id": "312",
        "code": "10",
        "name": "Palmar (parte)"
    },
    {
        "neabord_id": "3608",
        "district_id": "312",
        "code": "11",
        "name": "Puente Piedra (parte)"
    },
    {
        "neabord_id": "3609",
        "district_id": "312",
        "code": "12",
        "name": "Quintanar de la Sierra"
    },
    {
        "neabord_id": "3610",
        "district_id": "312",
        "code": "13",
        "name": "Uvita."
    },
    {
        "neabord_id": "3611",
        "district_id": "313",
        "code": "01",
        "name": "Palenque"
    },
    {
        "neabord_id": "3612",
        "district_id": "313",
        "code": "02",
        "name": "Anonos"
    },
    {
        "neabord_id": "3613",
        "district_id": "313",
        "code": "03",
        "name": "Burial"
    },
    {
        "neabord_id": "3614",
        "district_id": "313",
        "code": "04",
        "name": "Calle Chavez (parte)"
    },
    {
        "neabord_id": "3615",
        "district_id": "313",
        "code": "05",
        "name": "Calle Hernandez (parte)"
    },
    {
        "neabord_id": "3616",
        "district_id": "313",
        "code": "06",
        "name": "Cienagas"
    },
    {
        "neabord_id": "3617",
        "district_id": "313",
        "code": "07",
        "name": "Charquillo"
    },
    {
        "neabord_id": "3618",
        "district_id": "313",
        "code": "08",
        "name": "Mora"
    },
    {
        "neabord_id": "3619",
        "district_id": "313",
        "code": "09",
        "name": "Pilas"
    },
    {
        "neabord_id": "3620",
        "district_id": "313",
        "code": "10",
        "name": "Puente Piedra (parte)"
    },
    {
        "neabord_id": "3621",
        "district_id": "313",
        "code": "11",
        "name": "Tierra Blanca (parte)"
    },
    {
        "neabord_id": "3622",
        "district_id": "313",
        "code": "12",
        "name": "Turu."
    },
    {
        "neabord_id": "3623",
        "district_id": "314",
        "code": "01",
        "name": "Calle Cementerio"
    },
    {
        "neabord_id": "3624",
        "district_id": "314",
        "code": "02",
        "name": "Colonia Isidreña"
    },
    {
        "neabord_id": "3625",
        "district_id": "314",
        "code": "03",
        "name": "Cooperativa"
    },
    {
        "neabord_id": "3626",
        "district_id": "314",
        "code": "04",
        "name": "Cristo Rey"
    },
    {
        "neabord_id": "3627",
        "district_id": "314",
        "code": "05",
        "name": "El Volador"
    },
    {
        "neabord_id": "3628",
        "district_id": "314",
        "code": "06",
        "name": "Villaval."
    },
    {
        "neabord_id": "3629",
        "district_id": "315",
        "code": "01",
        "name": "Santa Cruz."
    },
    {
        "neabord_id": "3630",
        "district_id": "315",
        "code": "02",
        "name": "El Arroyo"
    },
    {
        "neabord_id": "3631",
        "district_id": "315",
        "code": "03",
        "name": "Huacalillos"
    },
    {
        "neabord_id": "3632",
        "district_id": "315",
        "code": "04",
        "name": "Santa Cecilia (parte)"
    },
    {
        "neabord_id": "3633",
        "district_id": "315",
        "code": "05",
        "name": "Santa Elena"
    },
    {
        "neabord_id": "3634",
        "district_id": "315",
        "code": "06",
        "name": "Trapiche"
    },
    {
        "neabord_id": "3635",
        "district_id": "315",
        "code": "07",
        "name": "Yerbabuena."
    },
    {
        "neabord_id": "3636",
        "district_id": "316",
        "code": "01",
        "name": "Alhajas"
    },
    {
        "neabord_id": "3637",
        "district_id": "316",
        "code": "02",
        "name": "Calle Caricias"
    },
    {
        "neabord_id": "3638",
        "district_id": "316",
        "code": "03",
        "name": "Calle Chavez (parte)"
    },
    {
        "neabord_id": "3639",
        "district_id": "316",
        "code": "04",
        "name": "Santa Cecilia"
    },
    {
        "neabord_id": "3640",
        "district_id": "317",
        "code": "01",
        "name": "Aguacate"
    },
    {
        "neabord_id": "3641",
        "district_id": "317",
        "code": "02",
        "name": "Astillero"
    },
    {
        "neabord_id": "3642",
        "district_id": "317",
        "code": "03",
        "name": "Quebradas (parte)"
    },
    {
        "neabord_id": "3643",
        "district_id": "317",
        "code": "04",
        "name": "Rinconada"
    },
    {
        "neabord_id": "3644",
        "district_id": "317",
        "code": "05",
        "name": "Tierra Blanca (parte)"
    },
    {
        "neabord_id": "3645",
        "district_id": "317",
        "code": "06",
        "name": "Vallevistar"
    },
    {
        "neabord_id": "3646",
        "district_id": "317",
        "code": "07",
        "name": "Viento Fresco."
    },
    {
        "neabord_id": "3647",
        "district_id": "318",
        "code": "01",
        "name": "Chompipes (parte)"
    },
    {
        "neabord_id": "3648",
        "district_id": "318",
        "code": "02",
        "name": "Escobal"
    },
    {
        "neabord_id": "3649",
        "district_id": "318",
        "code": "03",
        "name": "Labores (parte)"
    },
    {
        "neabord_id": "3650",
        "district_id": "318",
        "code": "04",
        "name": "San Vicente"
    },
    {
        "neabord_id": "3651",
        "district_id": "318",
        "code": "05",
        "name": "Zaiqui­."
    },
    {
        "neabord_id": "3652",
        "district_id": "319",
        "code": "01",
        "name": "Fuente"
    },
    {
        "neabord_id": "3653",
        "district_id": "319",
        "code": "02",
        "name": "Labores (parte)"
    },
    {
        "neabord_id": "3654",
        "district_id": "319",
        "code": "03",
        "name": "Vista Linda"
    },
    {
        "neabord_id": "3655",
        "district_id": "319",
        "code": "04",
        "name": "Cristo Rey (parte)."
    },
    {
        "neabord_id": "3656",
        "district_id": "319",
        "code": "05",
        "name": "Echeverri­a (parte)."
    },
    {
        "neabord_id": "3657",
        "district_id": "320",
        "code": "01",
        "name": "Arbolito"
    },
    {
        "neabord_id": "3658",
        "district_id": "320",
        "code": "02",
        "name": "Bonanza"
    },
    {
        "neabord_id": "3659",
        "district_id": "320",
        "code": "03",
        "name": "Bosques de Doña Rosa"
    },
    {
        "neabord_id": "3660",
        "district_id": "320",
        "code": "04",
        "name": "Cariari (parte)"
    },
    {
        "neabord_id": "3661",
        "district_id": "320",
        "code": "05",
        "name": "Chompipes (parte)"
    },
    {
        "neabord_id": "3662",
        "district_id": "320",
        "code": "06",
        "name": "Cristo Rey (parte)."
    },
    {
        "neabord_id": "3663",
        "district_id": "321",
        "code": "01",
        "name": "Campanario"
    },
    {
        "neabord_id": "3664",
        "district_id": "321",
        "code": "02",
        "name": "Joaquineños"
    },
    {
        "neabord_id": "3665",
        "district_id": "321",
        "code": "03",
        "name": "Luisiana"
    },
    {
        "neabord_id": "3666",
        "district_id": "321",
        "code": "04",
        "name": "Santa Marta"
    },
    {
        "neabord_id": "3667",
        "district_id": "321",
        "code": "05",
        "name": "Trinidad"
    },
    {
        "neabord_id": "3668",
        "district_id": "321",
        "code": "06",
        "name": "Villa Lico"
    },
    {
        "neabord_id": "3669",
        "district_id": "321",
        "code": "07",
        "name": "Villa Mari­a."
    },
    {
        "neabord_id": "3670",
        "district_id": "322",
        "code": "01",
        "name": "Barrantes"
    },
    {
        "neabord_id": "3671",
        "district_id": "322",
        "code": "02",
        "name": "Ugalde."
    },
    {
        "neabord_id": "3672",
        "district_id": "323",
        "code": "01",
        "name": "angeles"
    },
    {
        "neabord_id": "3673",
        "district_id": "323",
        "code": "02",
        "name": "Año 2000"
    },
    {
        "neabord_id": "3674",
        "district_id": "323",
        "code": "03",
        "name": "Cristo Rey (parte)"
    },
    {
        "neabord_id": "3675",
        "district_id": "323",
        "code": "04",
        "name": "Geranios"
    },
    {
        "neabord_id": "3676",
        "district_id": "323",
        "code": "05",
        "name": "Las Hadas"
    },
    {
        "neabord_id": "3677",
        "district_id": "323",
        "code": "06",
        "name": "Santa Elena"
    },
    {
        "neabord_id": "3678",
        "district_id": "323",
        "code": "07",
        "name": "Siglo Veintiuno."
    },
    {
        "neabord_id": "3679",
        "district_id": "323",
        "code": "08",
        "name": "Echeverri­a (parte)."
    },
    {
        "neabord_id": "3680",
        "district_id": "324",
        "code": "01",
        "name": "Acapulco"
    },
    {
        "neabord_id": "3681",
        "district_id": "324",
        "code": "02",
        "name": "Amada"
    },
    {
        "neabord_id": "3682",
        "district_id": "324",
        "code": "03",
        "name": "Asovigui"
    },
    {
        "neabord_id": "3683",
        "district_id": "324",
        "code": "04",
        "name": "Colonial"
    },
    {
        "neabord_id": "3684",
        "district_id": "324",
        "code": "05",
        "name": "Cruces"
    },
    {
        "neabord_id": "3685",
        "district_id": "324",
        "code": "06",
        "name": "Doña Nina"
    },
    {
        "neabord_id": "3686",
        "district_id": "324",
        "code": "07",
        "name": "Irazu"
    },
    {
        "neabord_id": "3687",
        "district_id": "324",
        "code": "08",
        "name": "Irma"
    },
    {
        "neabord_id": "3688",
        "district_id": "324",
        "code": "09",
        "name": "July"
    },
    {
        "neabord_id": "3689",
        "district_id": "324",
        "code": "10",
        "name": "Mari­a Auxiliadora (parte)"
    },
    {
        "neabord_id": "3690",
        "district_id": "324",
        "code": "11",
        "name": "Nueva Jerusalen"
    },
    {
        "neabord_id": "3691",
        "district_id": "324",
        "code": "12",
        "name": "Pastoras"
    },
    {
        "neabord_id": "3692",
        "district_id": "324",
        "code": "13",
        "name": "Puebla (parte)"
    },
    {
        "neabord_id": "3693",
        "district_id": "324",
        "code": "14",
        "name": "Santa Isabel"
    },
    {
        "neabord_id": "3694",
        "district_id": "324",
        "code": "15",
        "name": "Villa Cortes"
    },
    {
        "neabord_id": "3695",
        "district_id": "324",
        "code": "16",
        "name": "Villa Dolores"
    },
    {
        "neabord_id": "3696",
        "district_id": "324",
        "code": "17",
        "name": "Villa Quintana"
    },
    {
        "neabord_id": "3697",
        "district_id": "324",
        "code": "18",
        "name": "Uriche"
    },
    {
        "neabord_id": "3698",
        "district_id": "324",
        "code": "19",
        "name": "Uruca."
    },
    {
        "neabord_id": "3699",
        "district_id": "324",
        "code": "20",
        "name": "Corobici­"
    },
    {
        "neabord_id": "3700",
        "district_id": "324",
        "code": "21",
        "name": "Estrella"
    },
    {
        "neabord_id": "3701",
        "district_id": "324",
        "code": "22",
        "name": "Rincón de Ricardo"
    },
    {
        "neabord_id": "3702",
        "district_id": "324",
        "code": "23",
        "name": "Santa Fe."
    },
    {
        "neabord_id": "3703",
        "district_id": "325",
        "code": "01",
        "name": "Colina"
    },
    {
        "neabord_id": "3704",
        "district_id": "325",
        "code": "02",
        "name": "Esperanza"
    },
    {
        "neabord_id": "3705",
        "district_id": "325",
        "code": "03",
        "name": "Jardi­n"
    },
    {
        "neabord_id": "3706",
        "district_id": "325",
        "code": "04",
        "name": "Loma Linda"
    },
    {
        "neabord_id": "3707",
        "district_id": "325",
        "code": "05",
        "name": "Progreso."
    },
    {
        "neabord_id": "3708",
        "district_id": "325",
        "code": "06",
        "name": "Achiote"
    },
    {
        "neabord_id": "3709",
        "district_id": "325",
        "code": "07",
        "name": "Ahogados"
    },
    {
        "neabord_id": "3710",
        "district_id": "325",
        "code": "08",
        "name": "Arbolitos (parte)"
    },
    {
        "neabord_id": "3711",
        "district_id": "325",
        "code": "09",
        "name": "Arrepentidos"
    },
    {
        "neabord_id": "3712",
        "district_id": "325",
        "code": "10",
        "name": "Boca Ceiba"
    },
    {
        "neabord_id": "3713",
        "district_id": "325",
        "code": "11",
        "name": "Boca Ri­o Sucio"
    },
    {
        "neabord_id": "3714",
        "district_id": "325",
        "code": "12",
        "name": "Bun"
    },
    {
        "neabord_id": "3715",
        "district_id": "325",
        "code": "13",
        "name": "Cabezas"
    },
    {
        "neabord_id": "3716",
        "district_id": "325",
        "code": "14",
        "name": "Canfi­n"
    },
    {
        "neabord_id": "3717",
        "district_id": "325",
        "code": "15",
        "name": "Caño Negro"
    },
    {
        "neabord_id": "3718",
        "district_id": "325",
        "code": "16",
        "name": "Cerro Negro (Parte)"
    },
    {
        "neabord_id": "3719",
        "district_id": "325",
        "code": "17",
        "name": "Colonia San Jose"
    },
    {
        "neabord_id": "3720",
        "district_id": "325",
        "code": "18",
        "name": "Coyol"
    },
    {
        "neabord_id": "3721",
        "district_id": "325",
        "code": "19",
        "name": "Cristo Rey"
    },
    {
        "neabord_id": "3722",
        "district_id": "325",
        "code": "20",
        "name": "Chilamate"
    },
    {
        "neabord_id": "3723",
        "district_id": "325",
        "code": "21",
        "name": "El Progreso"
    },
    {
        "neabord_id": "3724",
        "district_id": "325",
        "code": "22",
        "name": "Esperanza"
    },
    {
        "neabord_id": "3725",
        "district_id": "325",
        "code": "23",
        "name": "Estrellales"
    },
    {
        "neabord_id": "3726",
        "district_id": "325",
        "code": "24",
        "name": "Guaria"
    },
    {
        "neabord_id": "3727",
        "district_id": "325",
        "code": "25",
        "name": "Jardi­n"
    },
    {
        "neabord_id": "3728",
        "district_id": "325",
        "code": "26",
        "name": "Jormo"
    },
    {
        "neabord_id": "3729",
        "district_id": "325",
        "code": "27",
        "name": "Las Mari­as"
    },
    {
        "neabord_id": "3730",
        "district_id": "325",
        "code": "28",
        "name": "Las Orqui­deas"
    },
    {
        "neabord_id": "3731",
        "district_id": "325",
        "code": "29",
        "name": "Los Lirios"
    },
    {
        "neabord_id": "3732",
        "district_id": "325",
        "code": "30",
        "name": "Malinche"
    },
    {
        "neabord_id": "3733",
        "district_id": "325",
        "code": "31",
        "name": "Media Vuelta"
    },
    {
        "neabord_id": "3734",
        "district_id": "325",
        "code": "32",
        "name": "Medias (parte)"
    },
    {
        "neabord_id": "3735",
        "district_id": "325",
        "code": "33",
        "name": "Muelle"
    },
    {
        "neabord_id": "3736",
        "district_id": "325",
        "code": "34",
        "name": "Naranjal"
    },
    {
        "neabord_id": "3737",
        "district_id": "325",
        "code": "35",
        "name": "Nogal"
    },
    {
        "neabord_id": "3738",
        "district_id": "325",
        "code": "36",
        "name": "Pavas"
    },
    {
        "neabord_id": "3739",
        "district_id": "325",
        "code": "37",
        "name": "Rojomaca"
    },
    {
        "neabord_id": "3740",
        "district_id": "325",
        "code": "38",
        "name": "San Jose"
    },
    {
        "neabord_id": "3741",
        "district_id": "325",
        "code": "39",
        "name": "San Julian"
    },
    {
        "neabord_id": "3742",
        "district_id": "325",
        "code": "40",
        "name": "Tres Rosales"
    },
    {
        "neabord_id": "3743",
        "district_id": "325",
        "code": "41",
        "name": "Vega de Sardinal (parte)"
    },
    {
        "neabord_id": "3744",
        "district_id": "325",
        "code": "42",
        "name": "Zapote."
    },
    {
        "neabord_id": "3745",
        "district_id": "326",
        "code": "01",
        "name": "angeles"
    },
    {
        "neabord_id": "3746",
        "district_id": "326",
        "code": "02",
        "name": "Arbolitos (parte)"
    },
    {
        "neabord_id": "3747",
        "district_id": "326",
        "code": "03",
        "name": "Bajos de Chilamate"
    },
    {
        "neabord_id": "3748",
        "district_id": "326",
        "code": "04",
        "name": "Boca Sardinal"
    },
    {
        "neabord_id": "3749",
        "district_id": "326",
        "code": "05",
        "name": "Bosque"
    },
    {
        "neabord_id": "3750",
        "district_id": "326",
        "code": "06",
        "name": "Bufalo"
    },
    {
        "neabord_id": "3751",
        "district_id": "326",
        "code": "07",
        "name": "Delicias"
    },
    {
        "neabord_id": "3752",
        "district_id": "326",
        "code": "08",
        "name": "El Uno"
    },
    {
        "neabord_id": "3753",
        "district_id": "326",
        "code": "09",
        "name": "Esquipulas"
    },
    {
        "neabord_id": "3754",
        "district_id": "326",
        "code": "10",
        "name": "Las Palmitas"
    },
    {
        "neabord_id": "3755",
        "district_id": "326",
        "code": "11",
        "name": "Laqui­"
    },
    {
        "neabord_id": "3756",
        "district_id": "326",
        "code": "12",
        "name": "Lomas"
    },
    {
        "neabord_id": "3757",
        "district_id": "326",
        "code": "13",
        "name": "Llano Grande"
    },
    {
        "neabord_id": "3758",
        "district_id": "326",
        "code": "14",
        "name": "Magsaysay"
    },
    {
        "neabord_id": "3759",
        "district_id": "326",
        "code": "15",
        "name": "Masaya"
    },
    {
        "neabord_id": "3760",
        "district_id": "326",
        "code": "16",
        "name": "Medias (parte)"
    },
    {
        "neabord_id": "3761",
        "district_id": "326",
        "code": "17",
        "name": "Pangola"
    },
    {
        "neabord_id": "3762",
        "district_id": "326",
        "code": "18",
        "name": "Pozo Azul"
    },
    {
        "neabord_id": "3763",
        "district_id": "326",
        "code": "19",
        "name": "Quebrada Grande"
    },
    {
        "neabord_id": "3764",
        "district_id": "326",
        "code": "20",
        "name": "Ri­o Magdaleno"
    },
    {
        "neabord_id": "3765",
        "district_id": "326",
        "code": "21",
        "name": "Roble"
    },
    {
        "neabord_id": "3766",
        "district_id": "326",
        "code": "22",
        "name": "San Gerardo (parte)"
    },
    {
        "neabord_id": "3767",
        "district_id": "326",
        "code": "23",
        "name": "San Isidro"
    },
    {
        "neabord_id": "3768",
        "district_id": "326",
        "code": "24",
        "name": "San Jose Sur"
    },
    {
        "neabord_id": "3769",
        "district_id": "326",
        "code": "25",
        "name": "San Ramón"
    },
    {
        "neabord_id": "3770",
        "district_id": "326",
        "code": "26",
        "name": "La Delia"
    },
    {
        "neabord_id": "3771",
        "district_id": "326",
        "code": "27",
        "name": "Sardinal"
    },
    {
        "neabord_id": "3772",
        "district_id": "326",
        "code": "28",
        "name": "Tirimbina"
    },
    {
        "neabord_id": "3773",
        "district_id": "326",
        "code": "29",
        "name": "Vega de Sardinal (parte)"
    },
    {
        "neabord_id": "3774",
        "district_id": "326",
        "code": "30",
        "name": "Venados."
    },
    {
        "neabord_id": "3775",
        "district_id": "327",
        "code": "01",
        "name": "Bambuzal"
    },
    {
        "neabord_id": "3776",
        "district_id": "327",
        "code": "02",
        "name": "Cerro Negro (parte)"
    },
    {
        "neabord_id": "3777",
        "district_id": "327",
        "code": "03",
        "name": "Colonia Bambu"
    },
    {
        "neabord_id": "3778",
        "district_id": "327",
        "code": "04",
        "name": "Colonia Colegio"
    },
    {
        "neabord_id": "3779",
        "district_id": "327",
        "code": "05",
        "name": "Colonia Esperanza"
    },
    {
        "neabord_id": "3780",
        "district_id": "327",
        "code": "06",
        "name": "Colonia Huetar"
    },
    {
        "neabord_id": "3781",
        "district_id": "327",
        "code": "07",
        "name": "Colonia Nazareth"
    },
    {
        "neabord_id": "3782",
        "district_id": "327",
        "code": "08",
        "name": "Colonia Victoria"
    },
    {
        "neabord_id": "3783",
        "district_id": "327",
        "code": "09",
        "name": "Colonia Villalobos"
    },
    {
        "neabord_id": "3784",
        "district_id": "327",
        "code": "10",
        "name": "Cubujuqui­"
    },
    {
        "neabord_id": "3785",
        "district_id": "327",
        "code": "11",
        "name": "Chiripa"
    },
    {
        "neabord_id": "3786",
        "district_id": "327",
        "code": "12",
        "name": "Fatima"
    },
    {
        "neabord_id": "3787",
        "district_id": "327",
        "code": "13",
        "name": "Flaminia"
    },
    {
        "neabord_id": "3788",
        "district_id": "327",
        "code": "14",
        "name": "Finca Uno"
    },
    {
        "neabord_id": "3789",
        "district_id": "327",
        "code": "15",
        "name": "Finca Dos"
    },
    {
        "neabord_id": "3790",
        "district_id": "327",
        "code": "16",
        "name": "Finca Tres"
    },
    {
        "neabord_id": "3791",
        "district_id": "327",
        "code": "17",
        "name": "Finca Cinco"
    },
    {
        "neabord_id": "3792",
        "district_id": "327",
        "code": "18",
        "name": "Finca Agua"
    },
    {
        "neabord_id": "3793",
        "district_id": "327",
        "code": "19",
        "name": "Finca Zona Siete"
    },
    {
        "neabord_id": "3794",
        "district_id": "327",
        "code": "20",
        "name": "Finca Zona Ocho"
    },
    {
        "neabord_id": "3795",
        "district_id": "327",
        "code": "21",
        "name": "Finca Zona Diez"
    },
    {
        "neabord_id": "3796",
        "district_id": "327",
        "code": "22",
        "name": "Finca Zona Once"
    },
    {
        "neabord_id": "3797",
        "district_id": "327",
        "code": "23",
        "name": "Isla"
    },
    {
        "neabord_id": "3798",
        "district_id": "327",
        "code": "24",
        "name": "Isla Grande"
    },
    {
        "neabord_id": "3799",
        "district_id": "327",
        "code": "25",
        "name": "Isla Israel"
    },
    {
        "neabord_id": "3800",
        "district_id": "327",
        "code": "26",
        "name": "La Conquista"
    },
    {
        "neabord_id": "3801",
        "district_id": "327",
        "code": "27",
        "name": "La Chavez"
    },
    {
        "neabord_id": "3802",
        "district_id": "327",
        "code": "28",
        "name": "La Vuelta"
    },
    {
        "neabord_id": "3803",
        "district_id": "327",
        "code": "29",
        "name": "Rambla"
    },
    {
        "neabord_id": "3804",
        "district_id": "327",
        "code": "30",
        "name": "Pedernales"
    },
    {
        "neabord_id": "3805",
        "district_id": "327",
        "code": "31",
        "name": "Platanera"
    },
    {
        "neabord_id": "3806",
        "district_id": "327",
        "code": "32",
        "name": "Ri­o Fri­o"
    },
    {
        "neabord_id": "3807",
        "district_id": "327",
        "code": "33",
        "name": "San Bernardino"
    },
    {
        "neabord_id": "3808",
        "district_id": "327",
        "code": "34",
        "name": "San Luis"
    },
    {
        "neabord_id": "3809",
        "district_id": "327",
        "code": "35",
        "name": "Santa Clara"
    },
    {
        "neabord_id": "3810",
        "district_id": "327",
        "code": "36",
        "name": "Tapa Viento"
    },
    {
        "neabord_id": "3811",
        "district_id": "327",
        "code": "37",
        "name": "Ticari­"
    },
    {
        "neabord_id": "3812",
        "district_id": "327",
        "code": "38",
        "name": "Tigre"
    },
    {
        "neabord_id": "3813",
        "district_id": "327",
        "code": "39",
        "name": "Villa Isabel"
    },
    {
        "neabord_id": "3814",
        "district_id": "327",
        "code": "40",
        "name": "Villa Nueva."
    },
    {
        "neabord_id": "3815",
        "district_id": "328",
        "code": "01",
        "name": "Caño San Luis"
    },
    {
        "neabord_id": "3816",
        "district_id": "328",
        "code": "02",
        "name": "Chimurria"
    },
    {
        "neabord_id": "3817",
        "district_id": "328",
        "code": "03",
        "name": "Chirriposito"
    },
    {
        "neabord_id": "3818",
        "district_id": "328",
        "code": "04",
        "name": "Delta"
    },
    {
        "neabord_id": "3819",
        "district_id": "328",
        "code": "05",
        "name": "Gaspar"
    },
    {
        "neabord_id": "3820",
        "district_id": "328",
        "code": "06",
        "name": "Lagunilla"
    },
    {
        "neabord_id": "3821",
        "district_id": "328",
        "code": "07",
        "name": "La Lucha"
    },
    {
        "neabord_id": "3822",
        "district_id": "328",
        "code": "08",
        "name": "Tigra."
    },
    {
        "neabord_id": "3823",
        "district_id": "329",
        "code": "01",
        "name": "Caño Tambor"
    },
    {
        "neabord_id": "3824",
        "district_id": "329",
        "code": "02",
        "name": "Copalchi­"
    },
    {
        "neabord_id": "3825",
        "district_id": "329",
        "code": "03",
        "name": "Cureña"
    },
    {
        "neabord_id": "3826",
        "district_id": "329",
        "code": "04",
        "name": "Paloseco"
    },
    {
        "neabord_id": "3827",
        "district_id": "329",
        "code": "05",
        "name": "Remolinito"
    },
    {
        "neabord_id": "3828",
        "district_id": "329",
        "code": "06",
        "name": "Tambor"
    },
    {
        "neabord_id": "3829",
        "district_id": "329",
        "code": "07",
        "name": "Tierrabuena"
    },
    {
        "neabord_id": "3830",
        "district_id": "329",
        "code": "08",
        "name": "Trinidad"
    },
    {
        "neabord_id": "3831",
        "district_id": "329",
        "code": "09",
        "name": "Unión del Toro"
    },
    {
        "neabord_id": "3832",
        "district_id": "329",
        "code": "10",
        "name": "Vuelta Cabo de Hornos."
    },
    {
        "neabord_id": "3833",
        "district_id": "330",
        "code": "01",
        "name": "Alaska"
    },
    {
        "neabord_id": "3834",
        "district_id": "330",
        "code": "02",
        "name": "angeles"
    },
    {
        "neabord_id": "3835",
        "district_id": "330",
        "code": "03",
        "name": "Buenos Aires"
    },
    {
        "neabord_id": "3836",
        "district_id": "330",
        "code": "04",
        "name": "Capuli­n"
    },
    {
        "neabord_id": "3837",
        "district_id": "330",
        "code": "05",
        "name": "Cerros"
    },
    {
        "neabord_id": "3838",
        "district_id": "330",
        "code": "06",
        "name": "Condega"
    },
    {
        "neabord_id": "3839",
        "district_id": "330",
        "code": "07",
        "name": "Corazón de Jesus"
    },
    {
        "neabord_id": "3840",
        "district_id": "330",
        "code": "08",
        "name": "Curime"
    },
    {
        "neabord_id": "3841",
        "district_id": "330",
        "code": "09",
        "name": "Choricera"
    },
    {
        "neabord_id": "3842",
        "district_id": "330",
        "code": "10",
        "name": "Chorotega"
    },
    {
        "neabord_id": "3843",
        "district_id": "330",
        "code": "11",
        "name": "Gallera"
    },
    {
        "neabord_id": "3844",
        "district_id": "330",
        "code": "12",
        "name": "Guaria"
    },
    {
        "neabord_id": "3845",
        "district_id": "330",
        "code": "13",
        "name": "Ji­caro"
    },
    {
        "neabord_id": "3846",
        "district_id": "330",
        "code": "14",
        "name": "La Carreta"
    },
    {
        "neabord_id": "3847",
        "district_id": "330",
        "code": "15",
        "name": "Llano La Cruz"
    },
    {
        "neabord_id": "3848",
        "district_id": "330",
        "code": "16",
        "name": "Mocho (Santa Luci­a)"
    },
    {
        "neabord_id": "3849",
        "district_id": "330",
        "code": "17",
        "name": "Moracia"
    },
    {
        "neabord_id": "3850",
        "district_id": "330",
        "code": "18",
        "name": "Nazareth"
    },
    {
        "neabord_id": "3851",
        "district_id": "330",
        "code": "19",
        "name": "Pueblo Nuevo"
    },
    {
        "neabord_id": "3852",
        "district_id": "330",
        "code": "20",
        "name": "Sabanero"
    },
    {
        "neabord_id": "3853",
        "district_id": "330",
        "code": "21",
        "name": "San Miguel"
    },
    {
        "neabord_id": "3854",
        "district_id": "330",
        "code": "22",
        "name": "San Roque"
    },
    {
        "neabord_id": "3855",
        "district_id": "330",
        "code": "23",
        "name": "Sitio"
    },
    {
        "neabord_id": "3856",
        "district_id": "330",
        "code": "24",
        "name": "Veinticinco de Julio"
    },
    {
        "neabord_id": "3857",
        "district_id": "330",
        "code": "25",
        "name": "Victoria"
    },
    {
        "neabord_id": "3858",
        "district_id": "330",
        "code": "26",
        "name": "Villanueva."
    },
    {
        "neabord_id": "3859",
        "district_id": "330",
        "code": "27",
        "name": "Arena"
    },
    {
        "neabord_id": "3860",
        "district_id": "330",
        "code": "28",
        "name": "Caraña"
    },
    {
        "neabord_id": "3861",
        "district_id": "330",
        "code": "29",
        "name": "Isleta (parte)"
    },
    {
        "neabord_id": "3862",
        "district_id": "330",
        "code": "30",
        "name": "Juanilama"
    },
    {
        "neabord_id": "3863",
        "district_id": "330",
        "code": "31",
        "name": "Montañita"
    },
    {
        "neabord_id": "3864",
        "district_id": "330",
        "code": "32",
        "name": "Paso Tempisque (parte)"
    },
    {
        "neabord_id": "3865",
        "district_id": "330",
        "code": "33",
        "name": "Pelón de la Bajura"
    },
    {
        "neabord_id": "3866",
        "district_id": "330",
        "code": "34",
        "name": "Polvazales"
    },
    {
        "neabord_id": "3867",
        "district_id": "330",
        "code": "35",
        "name": "Roble de Sabana"
    },
    {
        "neabord_id": "3868",
        "district_id": "330",
        "code": "36",
        "name": "Rodeito"
    },
    {
        "neabord_id": "3869",
        "district_id": "330",
        "code": "37",
        "name": "Salto (parte)"
    },
    {
        "neabord_id": "3870",
        "district_id": "330",
        "code": "38",
        "name": "San Benito"
    },
    {
        "neabord_id": "3871",
        "district_id": "330",
        "code": "39",
        "name": "San Hernan"
    },
    {
        "neabord_id": "3872",
        "district_id": "330",
        "code": "40",
        "name": "San Lucas"
    },
    {
        "neabord_id": "3873",
        "district_id": "330",
        "code": "41",
        "name": "Santa Ana"
    },
    {
        "neabord_id": "3874",
        "district_id": "330",
        "code": "42",
        "name": "Terreros"
    },
    {
        "neabord_id": "3875",
        "district_id": "330",
        "code": "43",
        "name": "Zanjita."
    },
    {
        "neabord_id": "3876",
        "district_id": "331",
        "code": "01",
        "name": "Alcantaro"
    },
    {
        "neabord_id": "3877",
        "district_id": "331",
        "code": "02",
        "name": "Buenavista"
    },
    {
        "neabord_id": "3878",
        "district_id": "331",
        "code": "03",
        "name": "Guayacan"
    },
    {
        "neabord_id": "3879",
        "district_id": "331",
        "code": "04",
        "name": "Pochote."
    },
    {
        "neabord_id": "3880",
        "district_id": "331",
        "code": "05",
        "name": "Brisas"
    },
    {
        "neabord_id": "3881",
        "district_id": "331",
        "code": "06",
        "name": "Cedro"
    },
    {
        "neabord_id": "3882",
        "district_id": "331",
        "code": "07",
        "name": "Congo"
    },
    {
        "neabord_id": "3883",
        "district_id": "331",
        "code": "08",
        "name": "Cueva"
    },
    {
        "neabord_id": "3884",
        "district_id": "331",
        "code": "09",
        "name": "Fortuna"
    },
    {
        "neabord_id": "3885",
        "district_id": "331",
        "code": "10",
        "name": "Irigaray"
    },
    {
        "neabord_id": "3886",
        "district_id": "331",
        "code": "11",
        "name": "Lilas"
    },
    {
        "neabord_id": "3887",
        "district_id": "331",
        "code": "12",
        "name": "Pacayales"
    },
    {
        "neabord_id": "3888",
        "district_id": "331",
        "code": "13",
        "name": "Panamacito"
    },
    {
        "neabord_id": "3889",
        "district_id": "331",
        "code": "14",
        "name": "Pedregal"
    },
    {
        "neabord_id": "3890",
        "district_id": "331",
        "code": "15",
        "name": "Pital"
    },
    {
        "neabord_id": "3891",
        "district_id": "331",
        "code": "16",
        "name": "Pueblo Nuevo."
    },
    {
        "neabord_id": "3892",
        "district_id": "332",
        "code": "01",
        "name": "Lourdes"
    },
    {
        "neabord_id": "3893",
        "district_id": "332",
        "code": "02",
        "name": "San Antonio."
    },
    {
        "neabord_id": "3894",
        "district_id": "332",
        "code": "03",
        "name": "angeles"
    },
    {
        "neabord_id": "3895",
        "district_id": "332",
        "code": "04",
        "name": "Argentina"
    },
    {
        "neabord_id": "3896",
        "district_id": "332",
        "code": "05",
        "name": "Buenavista"
    },
    {
        "neabord_id": "3897",
        "district_id": "332",
        "code": "06",
        "name": "Consuelo."
    },
    {
        "neabord_id": "3898",
        "district_id": "333",
        "code": "01",
        "name": "Bejuco"
    },
    {
        "neabord_id": "3899",
        "district_id": "333",
        "code": "02",
        "name": "Los Lagos"
    },
    {
        "neabord_id": "3900",
        "district_id": "333",
        "code": "03",
        "name": "Nacascolo"
    },
    {
        "neabord_id": "3901",
        "district_id": "333",
        "code": "04",
        "name": "Oratorio"
    },
    {
        "neabord_id": "3902",
        "district_id": "333",
        "code": "05",
        "name": "Puerto Culebra"
    },
    {
        "neabord_id": "3903",
        "district_id": "333",
        "code": "06",
        "name": "Triunfo."
    },
    {
        "neabord_id": "3904",
        "district_id": "334",
        "code": "01",
        "name": "Gallo"
    },
    {
        "neabord_id": "3905",
        "district_id": "334",
        "code": "02",
        "name": "San Rafael."
    },
    {
        "neabord_id": "3906",
        "district_id": "334",
        "code": "03",
        "name": "Colorado"
    },
    {
        "neabord_id": "3907",
        "district_id": "334",
        "code": "04",
        "name": "Curubande"
    },
    {
        "neabord_id": "3908",
        "district_id": "334",
        "code": "05",
        "name": "Porvenir."
    },
    {
        "neabord_id": "3909",
        "district_id": "335",
        "code": "01",
        "name": "Los angeles"
    },
    {
        "neabord_id": "3910",
        "district_id": "335",
        "code": "02",
        "name": "Barro Negro"
    },
    {
        "neabord_id": "3911",
        "district_id": "335",
        "code": "03",
        "name": "Cananga"
    },
    {
        "neabord_id": "3912",
        "district_id": "335",
        "code": "04",
        "name": "Carmen"
    },
    {
        "neabord_id": "3913",
        "district_id": "335",
        "code": "05",
        "name": "Chorotega"
    },
    {
        "neabord_id": "3914",
        "district_id": "335",
        "code": "06",
        "name": "Guadalupe"
    },
    {
        "neabord_id": "3915",
        "district_id": "335",
        "code": "07",
        "name": "Granja"
    },
    {
        "neabord_id": "3916",
        "district_id": "335",
        "code": "08",
        "name": "San Marti­n"
    },
    {
        "neabord_id": "3917",
        "district_id": "335",
        "code": "09",
        "name": "Santa Luci­a"
    },
    {
        "neabord_id": "3918",
        "district_id": "335",
        "code": "10",
        "name": "Virginia."
    },
    {
        "neabord_id": "3919",
        "district_id": "335",
        "code": "11",
        "name": "Cabeceras"
    },
    {
        "neabord_id": "3920",
        "district_id": "335",
        "code": "12",
        "name": "Caimital"
    },
    {
        "neabord_id": "3921",
        "district_id": "335",
        "code": "13",
        "name": "Carreta"
    },
    {
        "neabord_id": "3922",
        "district_id": "335",
        "code": "14",
        "name": "Casitas"
    },
    {
        "neabord_id": "3923",
        "district_id": "335",
        "code": "15",
        "name": "Cerro Verde"
    },
    {
        "neabord_id": "3924",
        "district_id": "335",
        "code": "16",
        "name": "Cerro Redondo"
    },
    {
        "neabord_id": "3925",
        "district_id": "335",
        "code": "17",
        "name": "Cola de Gallo"
    },
    {
        "neabord_id": "3926",
        "district_id": "335",
        "code": "18",
        "name": "Cuesta"
    },
    {
        "neabord_id": "3927",
        "district_id": "335",
        "code": "19",
        "name": "Cuesta Buenos Aires"
    },
    {
        "neabord_id": "3928",
        "district_id": "335",
        "code": "20",
        "name": "Curime"
    },
    {
        "neabord_id": "3929",
        "district_id": "335",
        "code": "21",
        "name": "Chivo"
    },
    {
        "neabord_id": "3930",
        "district_id": "335",
        "code": "22",
        "name": "Dulce Nombre"
    }
]
